export const viaNames: { name: string }[] = [
  {
    name: ""
  },
  {
    name: 'AV A CJ POLAR',
  },
  {
    name: 'AV A CJ JOSE WALTER',
  },
  {
    name: 'RUA DES MANUEL DE SALES ANDRADE',
  },
  {
    name: 'RUA JOR CESAR MAGALHAES',
  },
  {
    name: 'RUA PDE ANTONIO VIEIRA D37',
  },
  {
    name: 'RUA ADOLFO SILVEIRA',
  },
  {
    name: 'RUA ABAIARA',
  },
  {
    name: 'RUA ABEL GARCIA',
  },
  {
    name: 'RUA ABEL RIBEIRO',
  },
  {
    name: 'RUA ABELARDO FERREIRA',
  },
  {
    name: 'RUA ABELARDO MARINHO',
  },
  {
    name: 'PR DR AMAURI',
  },
  {
    name: 'RUA CEL ABELARDO RODRIGUES',
  },
  {
    name: 'RUA ABILIO MARTINS',
  },
  {
    name: 'RUA BOA VIAGEM',
  },
  {
    name: 'AV ABOLICAO',
  },
  {
    name: 'TR VIANA MARTINS',
  },
  {
    name: 'RUA ACACIAS D34',
  },
  {
    name: 'RUA DAS OLIMPIADAS',
  },
  {
    name: 'RUA ACARAU',
  },
  {
    name: 'RUA COM ACIOLI',
  },
  {
    name: 'RUA ACRE',
  },
  {
    name: 'TR ACRE',
  },
  {
    name: 'RUA ACUCENA',
  },
  {
    name: 'AL DAS ACUCENAS',
  },
  {
    name: 'AV PRO ADERBAL NUNES FREIRE',
  },
  {
    name: 'RUA ADEMAR DE BARROS',
  },
  {
    name: 'RUA ARISTIDES B NETO',
  },
  {
    name: 'RUA PEDRO C FERNANDES',
  },
  {
    name: 'RUA ADOLFO CAMINHA',
  },
  {
    name: 'RUA ADOLFO CAMPELO',
  },
  {
    name: 'RUA ADOLFO B DE MENEZES',
  },
  {
    name: 'RUA ADOLFO HERBSTER',
  },
  {
    name: 'RUA ADOLFO PINHEIRO',
  },
  {
    name: 'RUA ADOLFO QUIXADA',
  },
  {
    name: 'RUA ADOLFO SALES D24',
  },
  {
    name: 'RUA ADOLFO SIQUEIRA',
  },
  {
    name: 'RUA ADONIAS LIMA',
  },
  {
    name: 'RUA ADRIANO MARTINS',
  },
  {
    name: 'RUA ADUALDO BATISTA',
  },
  {
    name: 'TR MILITAR',
  },
  {
    name: 'TR AFONSO',
  },
  {
    name: 'RUA AFONSO CELSO',
  },
  {
    name: 'RUA AFONSO HENRIQUE',
  },
  {
    name: 'RUA AFONSO LOPES',
  },
  {
    name: 'RUA AFONSO PENA',
  },
  {
    name: 'RUA AFONSO VISEU',
  },
  {
    name: 'RUA EDUARDO PORTO',
  },
  {
    name: 'RUA AFRANIO PEIXOTO',
  },
  {
    name: 'RUA AFRODISIO GONDIM',
  },
  {
    name: 'RUA AGAMENON',
  },
  {
    name: 'RUA AGAPITO DOS SANTOS',
  },
  {
    name: 'TR IBITINGA',
  },
  {
    name: 'RUA MON AGOSTINHO',
  },
  {
    name: 'RUA MON DANTAS',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'AV AGUANAMBI',
  },
  {
    name: 'RUA AGUAPE',
  },
  {
    name: 'RUA AIRES DA CUNHA',
  },
  {
    name: 'TR ADEMAR DE CASTRO',
  },
  {
    name: 'RUA AJURAMA',
  },
  {
    name: 'RUA ALAGOAS',
  },
  {
    name: 'RUA ALAN KARDEC',
  },
  {
    name: 'RUA DO CATAVENTO',
  },
  {
    name: 'RUA ALBANIA',
  },
  {
    name: 'RUA ALBANO AMARAL',
  },
  {
    name: 'RUA CAP AFRANIO',
  },
  {
    name: 'AV ALBERTO CRAVEIRO',
  },
  {
    name: 'RUA ALBERTO DE OLIVEIRA',
  },
  {
    name: 'RUA DR ALBERTO ELOY COSTA',
  },
  {
    name: 'RUA ALBERTO FERREIRA',
  },
  {
    name: 'RUA ALBERTO LEAL',
  },
  {
    name: 'RUA ALBERTO MAGNO',
  },
  {
    name: 'TR ALBERTO MAGNO',
  },
  {
    name: 'RUA ALBERTO MONTEZUMA',
  },
  {
    name: 'AV ALBERTO NEPOMUCENO',
  },
  {
    name: 'AV ENG ALBERTO SA',
  },
  {
    name: 'RUA ANDRE LUIZ',
  },
  {
    name: 'RUA EMANUEL',
  },
  {
    name: 'RUA ALBERTO TORRES',
  },
  {
    name: 'RUA STO AMBROSIO',
  },
  {
    name: 'RUA ALCANTARA BILHAR',
  },
  {
    name: 'RUA ALCANTARAS',
  },
  {
    name: 'RUA MARIA QUINTELA',
  },
  {
    name: 'RUA ALCIDES SANTOS',
  },
  {
    name: 'RUA ALECRIN',
  },
  {
    name: 'RUA PRA AIDA BALAIO',
  },
  {
    name: 'RUA ALEMANHA',
  },
  {
    name: 'RUA FRE ALEMAO',
  },
  {
    name: 'VL DR ALENCAR',
  },
  {
    name: 'RUA SEN ALENCAR',
  },
  {
    name: 'RUA ALEUDA',
  },
  {
    name: 'TR IBIAPABA D57',
  },
  {
    name: 'RUA ALEXANDRE BARAUNA',
  },
  {
    name: 'RUA CEL ALEXANDRINO',
  },
  {
    name: 'RUA ALFA',
  },
  {
    name: 'RUA ALFEU ABOIM',
  },
  {
    name: 'RUA ALFREDO DE CASTRO',
  },
  {
    name: 'RUA ALFREDO LADISLAU',
  },
  {
    name: 'RUA ALFREDO MAMEDE',
  },
  {
    name: 'RUA ALFREDO PRUDENTE',
  },
  {
    name: 'RUA ALFREDO SALGADO',
  },
  {
    name: 'RUA ALFREDO SEVERO',
  },
  {
    name: 'VL ALIANCA',
  },
  {
    name: 'RUA GAL ALIPIO DOS SANTOS',
  },
  {
    name: 'RUA DR ALMEIDA FILHO',
  },
  {
    name: 'RUA ALMEIDA PRADO',
  },
  {
    name: 'RUA ALMEIDA REGO',
  },
  {
    name: 'TR ALMEIDA REGO',
  },
  {
    name: 'RUA SEN ALMINO',
  },
  {
    name: 'RUA MON JOAO LUIS SANTIAGO',
  },
  {
    name: 'RUA ALTAIR',
  },
  {
    name: 'RUA ALTANEIRA',
  },
  {
    name: 'AV ADENANTERAS',
  },
  {
    name: 'RUA ALTO ALEGRE D49',
  },
  {
    name: 'RUA ALTO SANTO',
  },
  {
    name: 'TR ANA CARTAXO',
  },
  {
    name: 'RUA PDE ALUISIO',
  },
  {
    name: 'RUA ALUISIO AZEVEDO',
  },
  {
    name: 'RUA ALUISIO MAMEDE D41',
  },
  {
    name: 'RUA PEDRO CABRAL',
  },
  {
    name: 'RUA SEN ALVARO ADOLFO',
  },
  {
    name: 'RUA ALVARO DE ALENCAR',
  },
  {
    name: 'RUA ALVARO BOMILCAR',
  },
  {
    name: 'RUA ALVARO CORREIA',
  },
  {
    name: 'RUA PRO ALVARO COSTA',
  },
  {
    name: 'TR ALVARO DE ALENCAR',
  },
  {
    name: 'RUA ALVARO DE ANDRADE',
  },
  {
    name: 'RUA RAIMUNDO FACANHA',
  },
  {
    name: 'RUA ALVARO FERNANDES',
  },
  {
    name: 'RUA ALVARO GARRIDO',
  },
  {
    name: 'RUA RIO PARAGUAI',
  },
  {
    name: 'RUA ALVARO MARTINS',
  },
  {
    name: 'RUA ALVARO MENDES',
  },
  {
    name: 'RUA COS ALVARO DE OLIVEIRA',
  },
  {
    name: 'RUA ALVES LIMA',
  },
  {
    name: 'RUA ALVES RIBEIRO',
  },
  {
    name: 'RUA CEL ALVES TEIXEIRA',
  },
  {
    name: 'RUA AGUAPE D69',
  },
  {
    name: 'RUA AMADEU DE CASTRO',
  },
  {
    name: 'RUA AMADEU FURTADO',
  },
  {
    name: 'RUA CIDADE PALHANO',
  },
  {
    name: 'RUA DR AMADEU SA',
  },
  {
    name: 'RUA ACEGUAR',
  },
  {
    name: 'AL AMALIA MARIA',
  },
  {
    name: 'RUA CEL AMANCIO CAVALCANTE',
  },
  {
    name: 'RUA AMANCIO FILOMENO',
  },
  {
    name: 'TR AMANCIO FILOMENO',
  },
  {
    name: 'RUA AMAPA',
  },
  {
    name: 'RUA AMARELA',
  },
  {
    name: 'RUA DOM AMARO',
  },
  {
    name: 'RUA AMARO CAVALCANTI',
  },
  {
    name: 'RUA TEN AMAURI PIO',
  },
  {
    name: 'RUA AMAZONAS',
  },
  {
    name: 'RUA DR AMBROSIO CARNEIRO',
  },
  {
    name: 'RUA PDE AMBROSIO MACHADO',
  },
  {
    name: 'RUA ISABEL SALES',
  },
  {
    name: 'RUA AMELIA BENEBIEN',
  },
  {
    name: 'TR AMARAL',
  },
  {
    name: 'RUA AMERICO FACO',
  },
  {
    name: 'RUA CAP AMERICO MENEZES',
  },
  {
    name: 'RUA AMERICO ROCHA LIMA',
  },
  {
    name: 'RUA AMERICO VESPUCIO',
  },
  {
    name: 'RUA PEDRO II',
  },
  {
    name: 'RUA AMETISTA',
  },
  {
    name: 'RUA AMOR PERFEITO',
  },
  {
    name: 'TR OLIVEIRA CHAVES',
  },
  {
    name: 'RUA ANA BILHAR',
  },
  {
    name: 'VL AILA',
  },
  {
    name: 'AL ANA ELISA',
  },
  {
    name: 'RUA ANA FACO',
  },
  {
    name: 'RUA ANA FRANK',
  },
  {
    name: 'RUA ANA GONCALVES',
  },
  {
    name: 'RUA ANA JULIAO',
  },
  {
    name: 'RUA ALVARO MACIEL',
  },
  {
    name: 'RUA ANA NERY',
  },
  {
    name: 'RUA PRO ANACLETO',
  },
  {
    name: 'RUA ANAPOLES',
  },
  {
    name: 'RUA ANARIO BRAGA',
  },
  {
    name: 'RUA PDE ANCHIETA',
  },
  {
    name: 'RUA PDE ANDRADE D45',
  },
  {
    name: 'RUA POE ALUISIO DE MEDEIROS',
  },
  {
    name: 'RUA ANDRADE FURTADO',
  },
  {
    name: 'RUA GAVEA',
  },
  {
    name: 'RUA ANDRE CHAVES',
  },
  {
    name: 'TR GUARANI D28',
  },
  {
    name: 'RUA DR LUIS COSTA',
  },
  {
    name: 'RUA STA ANGELA',
  },
  {
    name: 'RUA ANGELICA GURGEL',
  },
  {
    name: 'AL ANGELICAS',
  },
  {
    name: 'RUA ANGELO FIGUEIREDO',
  },
  {
    name: 'RUA ANGELO RATACASO',
  },
  {
    name: 'RUA ANIBAL MASCARENHAS',
  },
  {
    name: 'RUA DO CORRENTE',
  },
  {
    name: 'RUA ANITA GARIBALDI',
  },
  {
    name: 'RUA ANSELMO NOGUEIRA',
  },
  {
    name: 'RUA ANTARES',
  },
  {
    name: 'RUA ANTENOR FROTA WANDERLEY',
  },
  {
    name: 'RUA ANTERO COELHO',
  },
  {
    name: 'RUA MON ANTERO',
  },
  {
    name: 'RUA ANTONELE BEZERRA',
  },
  {
    name: 'RUA ANTONIETA CLOTILDE',
  },
  {
    name: 'RUA ANTONINA DO NORTE',
  },
  {
    name: 'RUA PDE ANTONINO',
  },
  {
    name: 'RUA CHICO MOTA',
  },
  {
    name: 'RUA STO ANTONIO D12',
  },
  {
    name: 'RUA ANTONIO A RODRIGUES',
  },
  {
    name: 'RUA CAP ANTONIO AGUIAR',
  },
  {
    name: 'RUA ANTONIO ARRUDA',
  },
  {
    name: 'RUA ANTONIO AUGUSTO',
  },
  {
    name: 'RUA ANTONIO BANDEIRA D41',
  },
  {
    name: 'RUA ANTONIO BANDEIRA D04',
  },
  {
    name: 'RUA ANTONIO BARROS',
  },
  {
    name: 'RUA DR MARLIO FERNANDES',
  },
  {
    name: 'RUA FRANCISCANO',
  },
  {
    name: 'RUA CLEITON H PIMENTA',
  },
  {
    name: 'RUA ANTONIO BOTELHO',
  },
  {
    name: 'RUA ITATIAIA',
  },
  {
    name: 'RUA MIN ANTONIO COELHO',
  },
  {
    name: 'RUA ANTONIO CORREIA LIMA',
  },
  {
    name: 'RUA CEL ANTONIO CRISTINO',
  },
  {
    name: 'RUA COSME JERONIMO',
  },
  {
    name: 'RUA ANTONIO DE CASTRO',
  },
  {
    name: 'RUA ANTONIO DRUMONT',
  },
  {
    name: 'RUA ANTONIO FIUZA',
  },
  {
    name: 'RUA ANTONIO FONTENELE',
  },
  {
    name: 'RUA JOSE MOREIRA',
  },
  {
    name: 'RUA ANTONIO FURTADO',
  },
  {
    name: 'RUA ANTONIO GENTIL',
  },
  {
    name: 'RUA ANTONIO IVO',
  },
  {
    name: 'TR ANTONIO JOAQUIM',
  },
  {
    name: 'AV ANTONIO JUSTA',
  },
  {
    name: 'RUA ANTONIO LAFAYETTE',
  },
  {
    name: 'RUA ANTONIO LIMA',
  },
  {
    name: 'RUA ANTONIO LOPES',
  },
  {
    name: 'RUA ANTONIO MARTINS',
  },
  {
    name: 'RUA ANTONIO COSTA MENDES (PQ SÃO JOSÉ)',
  },
  {
    name: 'RUA ANTONIO NERY',
  },
  {
    name: 'RUA ANTONIO POMPEU',
  },
  {
    name: 'RUA ANTONIO ROCHA',
  },
  {
    name: 'RUA ANTONIO RODRIGUES',
  },
  {
    name: 'AV ANTONIO SALES',
  },
  {
    name: 'RUA ANTONIO SIMOES',
  },
  {
    name: 'AV PDE ANTONIO TOMAS',
  },
  {
    name: 'RUA ANTONIO CARNEIRO',
  },
  {
    name: 'TR ALVES LIMA',
  },
  {
    name: 'RUA DR CATUNDA GONDIM',
  },
  {
    name: 'RUA APOLO',
  },
  {
    name: 'RUA APUIARES',
  },
  {
    name: 'RUA AQUARIO',
  },
  {
    name: 'AV HIS RAIMUNDO GIRAO',
  },
  {
    name: 'RUA AQUILES BEVILAQUA',
  },
  {
    name: 'RUA AQUILES BORIS',
  },
  {
    name: 'RUA AQUIRAZ',
  },
  {
    name: 'RUA BAR AQUIRAZ',
  },
  {
    name: 'RUA ARACA',
  },
  {
    name: 'RUA ARACAJU',
  },
  {
    name: 'RUA SEN ALMIR PINTO',
  },
  {
    name: 'RUA BAR ARACATI',
  },
  {
    name: 'AV GOV PARSIFAL BARROSO',
  },
  {
    name: 'RUA ARACOIABA',
  },
  {
    name: 'TR CAP ARAGAO',
  },
  {
    name: 'RUA CAP ARAGAO',
  },
  {
    name: 'RUA ARAQUEM SILVA',
  },
  {
    name: 'RUA ARAPONGA',
  },
  {
    name: 'RUA ARAQUEM',
  },
  {
    name: 'RUA BISMARK',
  },
  {
    name: 'RUA ARARIPE MACEDO',
  },
  {
    name: 'RUA ARARIPE PRATA',
  },
  {
    name: 'RUA ARARIUS',
  },
  {
    name: 'TR ARATANHA',
  },
  {
    name: 'RUA BAR ARATANHA',
  },
  {
    name: 'RUA ARATUBA',
  },
  {
    name: 'RUA PRO ARAUJO',
  },
  {
    name: 'RUA COS ARAUJO LIMA',
  },
  {
    name: 'RUA ARAUJO TORREAO',
  },
  {
    name: 'VL ARCOS DE VALDEVEZ',
  },
  {
    name: 'RUA CAR ARCO VERDE',
  },
  {
    name: 'RUA ARGEMIRO CARVALHO',
  },
  {
    name: 'RUA ARACATI D06',
  },
  {
    name: 'RUA ARGEMIRO VALENTE',
  },
  {
    name: 'RUA ARGENTINA',
  },
  {
    name: 'RUA ARI BARROSO',
  },
  {
    name: 'RUA ARI CAVALCANTE',
  },
  {
    name: 'RUA PDE ARIMATEIA D42/71',
  },
  {
    name: 'RUA ARISTIDES BARCELOS',
  },
  {
    name: 'RUA ARISTIDES LOBO',
  },
  {
    name: 'RUA ARISTOTELES BEZERRA',
  },
  {
    name: 'RUA ARMANDO MONTEIRO',
  },
  {
    name: 'RUA ARMANDO OLIVEIRA',
  },
  {
    name: 'RUA ARNALDO OSORIO',
  },
  {
    name: 'RUA ARUEIRAS',
  },
  {
    name: 'RUA ARQUIMEDES MEMORIA',
  },
  {
    name: 'RUA INA BRITO',
  },
  {
    name: 'RUA ARRUDA CAMARA',
  },
  {
    name: 'RUA ARTHUR TEMOTEO',
  },
  {
    name: 'AV PRS ARTUR BERNARDES',
  },
  {
    name: 'RUA PEDRO SAMPAIO',
  },
  {
    name: 'RUA ARTUR DE CARVALHO',
  },
  {
    name: 'RUA ARTUR FERREIRA',
  },
  {
    name: 'RUA PDE ASCENCO GAGO',
  },
  {
    name: 'AV MAJ ASSIS',
  },
  {
    name: 'RUA ASSIS BEZERRA',
  },
  {
    name: 'TR CORREIA LIMA',
  },
  {
    name: 'RUA ASSIS CHATEAUBRIAND',
  },
  {
    name: 'RUA ASSUNCAO',
  },
  {
    name: 'RUA ASTROGILDO FONTOURA',
  },
  {
    name: 'RUA IRACEMA D71',
  },
  {
    name: 'RUA ATAULFO ALVES',
  },
  {
    name: 'RUA PACAVIRA D71',
  },
  {
    name: 'RUA ANTONIO DIOGO',
  },
  {
    name: 'RUA DR ATUALPA (V. ELERY)',
  },
  {
    name: 'RUA AUGUSTO DE ARAUJO',
  },
  {
    name: 'AV AUGUSTO DOS ANJOS',
  },
  {
    name: 'RUA DR FERNANDO AUGUSTO',
  },
  {
    name: 'RUA JOSE VILAR DE ANDRADE',
  },
  {
    name: 'RUA TOMAS RODRIGUES',
  },
  {
    name: 'TR AURELIO LAVOR',
  },
  {
    name: 'RUA TEN AURELIO SAMPAIO',
  },
  {
    name: 'RUA AURORA',
  },
  {
    name: 'RUA AUSTRIA',
  },
  {
    name: 'RUA DES AVELAR',
  },
  {
    name: 'RUA AVELEDO',
  },
  {
    name: 'RUA AVILA GOULART',
  },
  {
    name: 'RUA ESV AZEVEDO',
  },
  {
    name: 'RUA AZEVEDO BARRETO',
  },
  {
    name: 'RUA AZEVEDO BOLAO',
  },
  {
    name: 'RUA PRA HELOISA F LIMA',
  },
  {
    name: 'AV B CJ JOSE WALTER',
  },
  {
    name: 'VL BACHA',
  },
  {
    name: 'RUA BAHIA',
  },
  {
    name: 'RUA BAJE',
  },
  {
    name: 'RUA BALDUINO FREIRE',
  },
  {
    name: 'RUA BANDEIRA DE MELO',
  },
  {
    name: 'RUA BANDEIRANTES',
  },
  {
    name: 'RUA BANGU',
  },
  {
    name: 'RUA BANVAR BEZERRA',
  },
  {
    name: 'RUA BARBA ALARDO',
  },
  {
    name: 'RUA BARBALHA D19',
  },
  {
    name: 'VL SAO BENEDITO',
  },
  {
    name: 'RUA BARBARA DE ALENCAR',
  },
  {
    name: 'RUA TEN BARBOSA D46',
  },
  {
    name: 'RUA BARBOSA DE FREITAS',
  },
  {
    name: 'VL BARBOSA DE FREITAS',
  },
  {
    name: 'RUA PDE BARBOSA DE JESUS',
  },
  {
    name: 'RUA BARROS LEAL',
  },
  {
    name: 'AV ALM BARROSO',
  },
  {
    name: 'RUA BARTOLOMEU DIAS',
  },
  {
    name: 'RUA BARTOLOMEU DE GUSMAO',
  },
  {
    name: 'RUA BATISTA DE OLIVEIRA',
  },
  {
    name: 'RUA BATOQUE',
  },
  {
    name: 'VL BEATRIZ D12',
  },
  {
    name: 'RUA BATURITE',
  },
  {
    name: 'RUA STA BEATRIZ',
  },
  {
    name: 'RUA BAURU',
  },
  {
    name: 'RUA BAUXITA',
  },
  {
    name: 'RUA IRM BAZET',
  },
  {
    name: 'RUA BEBERIBE',
  },
  {
    name: 'AL BEGONIAS',
  },
  {
    name: 'RUA DNA BELA',
  },
  {
    name: 'RUA BELA CRUZ',
  },
  {
    name: 'RUA BELA FLOR',
  },
  {
    name: 'TR BELA VISTA',
  },
  {
    name: 'RUA BELEM',
  },
  {
    name: 'RUA BELEM FIGUEIREDO',
  },
  {
    name: 'RUA BELGICA',
  },
  {
    name: 'RUA BELISARIO TAVORA',
  },
  {
    name: 'VL SENHOR DO BOMFIM D20',
  },
  {
    name: 'RUA CEL BELO',
  },
  {
    name: 'RUA PRO MIRAMAR DA PONTE',
  },
  {
    name: 'RUA LUIZ DE PONTES',
  },
  {
    name: 'RUA BEM AVENTURANCA',
  },
  {
    name: 'AL BENEDITAS',
  },
  {
    name: 'RUA SAO BENEDITO',
  },
  {
    name: 'RUA BENEDITO LACERDA',
  },
  {
    name: 'RUA BENEDITO PRATA',
  },
  {
    name: 'RUA TEN BENEVOLO',
  },
  {
    name: 'RUA BENI DE CARVALHO',
  },
  {
    name: 'RUA FRE BENICIO CRISTINO',
  },
  {
    name: 'AV BENJAMIM BARROSO',
  },
  {
    name: 'AV BENJAMIM BRASIL',
  },
  {
    name: 'RUA BENJAMIM FRANKLIN',
  },
  {
    name: 'RUA BENJAMIM MOURA',
  },
  {
    name: 'TR BENJAMIM TORRES',
  },
  {
    name: 'TR BENTIVI',
  },
  {
    name: 'RUA BENTO ALBUQUERQUE',
  },
  {
    name: 'RUA BENTO LOUSADO',
  },
  {
    name: 'RUA FRE BERNARDINO',
  },
  {
    name: 'RUA BERNARDINO CAMPOS',
  },
  {
    name: 'RUA MAD TEREZA DE CALCUTA',
  },
  {
    name: 'RUA SAO BERNARDO',
  },
  {
    name: 'RUA GAL BERNARDO FIGUEIREDO',
  },
  {
    name: 'RUA BERNARDO MANUEL',
  },
  {
    name: 'RUA BERNARDO PORTO',
  },
  {
    name: 'RUA BERTOLDO MOTA',
  },
  {
    name: 'RUA CON BESSA',
  },
  {
    name: 'RUA BETA',
  },
  {
    name: 'RUA BETEL',
  },
  {
    name: 'TR TEN BEZERRA',
  },
  {
    name: 'AV BEZERRA DE MENEZES',
  },
  {
    name: 'RUA BEZERRA SA',
  },
  {
    name: 'RUA GAL BEZERRIL',
  },
  {
    name: 'RUA DR BEZERRINHA',
  },
  {
    name: 'RUA BIAS MENDES',
  },
  {
    name: 'RUA MAL BITENCOURT',
  },
  {
    name: 'RUA BLUMENAU D36',
  },
  {
    name: 'RUA BOA NOITE',
  },
  {
    name: 'RUA BOA VENTURA',
  },
  {
    name: 'RUA BOA VISTA',
  },
  {
    name: 'AL BOAS NOITES',
  },
  {
    name: 'RUA GAL CORREIA SEABRA',
  },
  {
    name: 'RUA BOGARI',
  },
  {
    name: 'AL BOGARIS',
  },
  {
    name: 'RUA BOGOTA',
  },
  {
    name: 'RUA BOLIVIA',
  },
  {
    name: 'RUA BOM JESUS (BARRA DO CEARA)',
  },
  {
    name: 'RUA BOM SUCESSO',
  },
  {
    name: 'RUA DR AIRTON BEZERRA',
  },
  {
    name: 'VL BARROS',
  },
  {
    name: 'RUA BONFIM SOBRINHO',
  },
  {
    name: 'AL BONINAS',
  },
  {
    name: 'TR BAUXITA',
  },
  {
    name: 'RUA BORBA GATO',
  },
  {
    name: 'AL BORBOLETAS',
  },
  {
    name: 'RUA BORGES DA FONSECA',
  },
  {
    name: 'AV BORGES DE MELO',
  },
  {
    name: 'RUA BORIS',
  },
  {
    name: 'RUA DOM BOSCO',
  },
  {
    name: 'RUA PILOTO D46',
  },
  {
    name: 'RUA TEN BOTELHO',
  },
  {
    name: 'RUA BOTELHO MAGALHAES',
  },
  {
    name: 'RD BR 116',
  },
  {
    name: 'TR SERVILHA',
  },
  {
    name: 'RD BR 020',
  },
  {
    name: 'RUA BRAGA TORRES',
  },
  {
    name: 'RUA BRAGANCA',
  },
  {
    name: 'RUA JUIZ DE FORA',
  },
  {
    name: 'RUA VIS BARBACENA D61',
  },
  {
    name: 'GL PRO BRANDAO',
  },
  {
    name: 'RUA CAP BRASIL',
  },
  {
    name: 'RUA JOAO AMORA',
  },
  {
    name: 'RUA RECANTO SERENO',
  },
  {
    name: 'RUA CON BRAVEZA',
  },
  {
    name: 'RUA ALVES BEZERRA',
  },
  {
    name: 'RUA MON BRUNO',
  },
  {
    name: 'RUA DR SAMUEL L CAVALCANTE',
  },
  {
    name: 'RUA BRUNO VALENTE',
  },
  {
    name: 'RUA BULGARIA',
  },
  {
    name: 'AV C CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA C VL DOS TEN E SGT',
  },
  {
    name: 'RUA C PQ AGUA FRIA',
  },
  {
    name: 'RUA BOTANICA',
  },
  {
    name: 'RUA CABRAL DE ALENCAR',
  },
  {
    name: 'RUA CABRAL VERAS',
  },
  {
    name: 'RUA GUARATINGUETA',
  },
  {
    name: 'RUA CACILDA BECKER',
  },
  {
    name: 'RUA SAO CAETANO',
  },
  {
    name: 'RUA GAL CAIADO DE CASTRO',
  },
  {
    name: 'RUA CAIO CARLOS',
  },
  {
    name: 'RUA CAIO CID',
  },
  {
    name: 'RUA CAIO PRADO',
  },
  {
    name: 'RUA VISAO DAS DUNAS',
  },
  {
    name: 'RUA PARANAGUA',
  },
  {
    name: 'RUA DA FEDERACAO',
  },
  {
    name: 'RUA PASSEIO DOS CAJUEIROS',
  },
  {
    name: 'RUA GALAXIA',
  },
  {
    name: 'RUA CAMBARA',
  },
  {
    name: 'RUA RUBIA SAMPAIO',
  },
  {
    name: 'RUA CAMELIA',
  },
  {
    name: 'AL CAMELIAS',
  },
  {
    name: 'RUA CAMOCIM',
  },
  {
    name: 'RUA DOS CAMPEOES',
  },
  {
    name: 'AV C CJ JOSE WALTER',
  },
  {
    name: 'RUA CAMPO',
  },
  {
    name: 'RUA CAMPO BOM',
  },
  {
    name: 'RUA OZETE FILOMENO',
  },
  {
    name: 'TR CAMPO GRANDE',
  },
  {
    name: 'TR CAMPO VERDE',
  },
  {
    name: 'RUA CAMPO AMOR ROCHA',
  },
  {
    name: 'RUA CAMPOS SALES',
  },
  {
    name: 'RUA CAMPESTRE',
  },
  {
    name: 'RUA PLANALTO DO PICI',
  },
  {
    name: 'RUA BAR CAMOCIM',
  },
  {
    name: 'TR CANADA',
  },
  {
    name: 'RUA BETA CJ VILA VELHA',
  },
  {
    name: 'RUA CANAL',
  },
  {
    name: 'RUA CANARIO',
  },
  {
    name: 'TR CANARIO',
  },
  {
    name: 'RUA CANDIDO CASTELO BRANCO',
  },
  {
    name: 'RUA CANDIDO REGO',
  },
  {
    name: 'RUA CANDIDO HOLANDA',
  },
  {
    name: 'RUA CANDIDO JUCA',
  },
  {
    name: 'RUA CANDIDO MAIA',
  },
  {
    name: 'RUA CANINDE D48',
  },
  {
    name: 'RUA BAR CANINDE',
  },
  {
    name: 'RUA CANOPUS',
  },
  {
    name: 'RUA DR LAUDELINO COELHO',
  },
  {
    name: 'RUA CANUTO DE AGUIAR',
  },
  {
    name: 'RUA CAPANEMA',
  },
  {
    name: 'TR CAPIABA',
  },
  {
    name: 'RUA CAPISTRANO',
  },
  {
    name: 'TR JACOBINA',
  },
  {
    name: 'TR CAMBERRA',
  },
  {
    name: 'RUA CAPRICHO',
  },
  {
    name: 'RUA CARACAS',
  },
  {
    name: 'RUA CARAMURU D45 (ITAPERI)',
  },
  {
    name: 'TR CARAMURU',
  },
  {
    name: 'AV CARAPINIMA',
  },
  {
    name: 'RUA CARDOSO DE BARROS',
  },
  {
    name: 'RUA PORTO PRINCIPE',
  },
  {
    name: 'TR CARIOCA D08',
  },
  {
    name: 'RUA CARIRE',
  },
  {
    name: 'RUA CARIRIACU',
  },
  {
    name: 'RUA CARIRIS',
  },
  {
    name: 'TR BOA VISTA',
  },
  {
    name: 'RUA CARLITO PAMPLONA',
  },
  {
    name: 'RUA LUIS GUEDES',
  },
  {
    name: 'RUA CARLOS A. DE CAMARGO',
  },
  {
    name: 'RUA CARLOS A GALVAO',
  },
  {
    name: 'RUA CARLOS AMORA',
  },
  {
    name: 'RUA CARLOS ARAUJO',
  },
  {
    name: 'RUA CAP CARLOS AUGUSTO',
  },
  {
    name: 'RUA CARLOS BARBOSA',
  },
  {
    name: 'RUA CARLOS CAMARA',
  },
  {
    name: 'RUA CARLOS CHAGAS',
  },
  {
    name: 'RUA CARLOS GOMES',
  },
  {
    name: 'RUA CARLOS GONDIM',
  },
  {
    name: 'AV SEN CARLOS JEREISSATI (AEROPORTO)',
  },
  {
    name: 'RUA CARLOS JUACABA',
  },
  {
    name: 'TR MANUEL MAIA',
  },
  {
    name: 'RUA PDE CARLOS QUIXADA',
  },
  {
    name: 'RUA CARLOS RIBEIRO',
  },
  {
    name: 'RUA DR ATUALPA BARBOSA LIMA (P. IRACEMA)',
  },
  {
    name: 'RUA CARLOS SEVERO',
  },
  {
    name: 'RUA CARLOS STUDART',
  },
  {
    name: 'RUA CARLOS VASCONCELOS',
  },
  {
    name: 'RUA CARLOS WALRAVEN',
  },
  {
    name: 'RUA DOM CARLOTO TAVORA',
  },
  {
    name: 'RUA XAVANTE',
  },
  {
    name: 'RUA CARMEM CINIRA',
  },
  {
    name: 'RUA DOM PEDRO II',
  },
  {
    name: 'RUA CARNAUBAS',
  },
  {
    name: 'RUA MON CARNEIRO DA CUNHA',
  },
  {
    name: 'AV CARNEIRO DE MENDONCA',
  },
  {
    name: 'RUA CAROLINA SUCUPIRA',
  },
  {
    name: 'RUA CAROLINO DE AQUINO',
  },
  {
    name: 'AV CEL CARVALHO',
  },
  {
    name: 'RUA PRO CARVALHO',
  },
  {
    name: 'RUA CARVALHO JUNIOR',
  },
  {
    name: 'RUA CARVALHO LIMA D09',
  },
  {
    name: 'RUA CARVALHO MOTA',
  },
  {
    name: 'RUA CASCAVEL',
  },
  {
    name: 'RUA CASIMIRO DE ABREU',
  },
  {
    name: 'RUA CASIMIRO MONTENEGRO',
  },
  {
    name: 'AV CASTANHOLEIRAS',
  },
  {
    name: 'RUA XXIII CIDADE OESTE',
  },
  {
    name: 'TR CASTELO',
  },
  {
    name: 'RUA 51 CJ JOSE WALTER',
  },
  {
    name: 'RUA GAL CASTELO BRANCO (CID. FUNCIONARIOS)',
  },
  {
    name: 'AV PRS CASTELO BRANCO',
  },
  {
    name: 'RUA PRO CASTELO BRANCO D08',
  },
  {
    name: 'RUA CON DE CASTRO',
  },
  {
    name: 'RUA CASTRO ALVES',
  },
  {
    name: 'TR CASTRO ALVES',
  },
  {
    name: 'RUA ARGENTINO P TORRES',
  },
  {
    name: 'RUA CASTRO E SILVA',
  },
  {
    name: 'RUA CASTRO MONTE',
  },
  {
    name: 'VL SAO CAMILO',
  },
  {
    name: 'RUA MON CATAO',
  },
  {
    name: 'TR MON CATAO',
  },
  {
    name: 'VL CORDEIRO',
  },
  {
    name: 'RUA CATAO MAMEDE',
  },
  {
    name: 'RUA STA CATARINA (BELA VISTA / PAN AMERICANO)',
  },
  {
    name: 'RUA CATARINA LABOURE D20',
  },
  {
    name: 'RUA CATULO CEARENSE',
  },
  {
    name: 'RUA SEN CATUNDA',
  },
  {
    name: 'RUA CAUBI',
  },
  {
    name: 'RUA AUGUSTA BENEVIDES',
  },
  {
    name: 'RUA VIS CAUIPE',
  },
  {
    name: 'RUA DR CARLOS IVO',
  },
  {
    name: 'RUA SAO JUDAS TADEU D43',
  },
  {
    name: 'AV DUQ CAXIAS',
  },
  {
    name: 'AV EDILSON B SOARES',
  },
  {
    name: 'RUA CEARA',
  },
  {
    name: 'RUA CECI',
  },
  {
    name: 'RUA CECIL SALGADO',
  },
  {
    name: 'AL CECILIAS',
  },
  {
    name: 'RUA MAJ CELESTINO',
  },
  {
    name: 'RUA DO COQUEIRO D75',
  },
  {
    name: 'AV CENTRAL ALA LESTE',
  },
  {
    name: 'AV CENTRAL ALA OESTE',
  },
  {
    name: 'AV CESAR CALS',
  },
  {
    name: 'VL CESAR CALS',
  },
  {
    name: 'RUA CESAR CORREIA',
  },
  {
    name: 'RUA CESAR FONSECA',
  },
  {
    name: 'RUA CESAR FONTENELE',
  },
  {
    name: 'RUA CESAR ROSSAS',
  },
  {
    name: 'RUA CESARIO LANGE',
  },
  {
    name: 'RUA CEZIDIO ALBUQUERQUE',
  },
  {
    name: 'RUA PRO SILAS RIBEIRO',
  },
  {
    name: 'AL CHANANAS',
  },
  {
    name: 'RUA CHASTINET GUIMARAES',
  },
  {
    name: 'TR CHAVES',
  },
  {
    name: 'RUA PDE CHEVALIER',
  },
  {
    name: 'RUA 2 CJ T JEREISSATI',
  },
  {
    name: 'RUA CHICO LEMOS',
  },
  {
    name: 'RUA CHILE',
  },
  {
    name: 'RUA CHUI',
  },
  {
    name: 'RUA PDE CICERO',
  },
  {
    name: 'TR CIDAL',
  },
  {
    name: 'RUA CARIUS',
  },
  {
    name: 'RUA BRISAMAR',
  },
  {
    name: 'RUA CIDADE RIO BRANCO',
  },
  {
    name: 'RUA PRO PAULO LOPES',
  },
  {
    name: 'RUA REGINA DE FATIMA',
  },
  {
    name: 'RUA 5',
  },
  {
    name: 'RUA 5 CJ JOSE WALTER',
  },
  {
    name: 'RUA 50 CJ JOSE WALTER',
  },
  {
    name: 'RUA 55 CJ JOSE WALTER',
  },
  {
    name: 'RUA 52 CJ JOSE WALTER',
  },
  {
    name: 'RUA 59 CJ JOSE WALTER',
  },
  {
    name: 'RUA 54 CJ JOSE WALTER',
  },
  {
    name: 'RUA 56 CJ JOSE WALTER',
  },
  {
    name: 'RUA 57 CJ JOSE WALTER',
  },
  {
    name: 'RUA 53 CJ JOSE WALTER',
  },
  {
    name: 'AV FRE CIRILO',
  },
  {
    name: 'RUA ANTONIO GADELHA',
  },
  {
    name: 'RUA CLARIM',
  },
  {
    name: 'RUA CLAUDIO GUIMARAES',
  },
  {
    name: 'RUA GAL CLARINDO DE QUEIROZ',
  },
  {
    name: 'RUA CLAUDIO MANUEL',
  },
  {
    name: 'RUA CLEIA',
  },
  {
    name: 'RUA CEL BENEDITO GOMES',
  },
  {
    name: 'RUA ANTONIO MACIO',
  },
  {
    name: 'RUA CLEMENTE PEREIRA',
  },
  {
    name: 'RUA CLEMENTE SILVA D44',
  },
  {
    name: 'RUA PDE CLIMERIO',
  },
  {
    name: 'RUA CLOVIS FONTENELE D22',
  },
  {
    name: 'RUA CLOVIS FONTENELE D45',
  },
  {
    name: 'RUA CAP CLOVIS MAIA',
  },
  {
    name: 'AV CLOVIS MATOS',
  },
  {
    name: 'RUA CLOVIS METON',
  },
  {
    name: 'RUA COELHO DA FONSECA',
  },
  {
    name: 'RUA COELHO NETO',
  },
  {
    name: 'RUA G (NOVO BARROSO II)',
  },
  {
    name: 'AV MAE LISBOA',
  },
  {
    name: 'RUA GOMES DE FREITAS (PLANALTO AYRTON SENNA)',
  },
  {
    name: 'RUA JABAQUARA',
  },
  {
    name: 'RUA NEZITA PEREIRA',
  },
  {
    name: 'RUA LUIS DO CARMO',
  },
  {
    name: 'RUA LUIZA HELENA',
  },
  {
    name: 'RUA CONDADO',
  },
  {
    name: 'RUA CONEFOR',
  },
  {
    name: 'TR CONEFOR I',
  },
  {
    name: 'RUA CONEGUNDES RODRIGUES',
  },
  {
    name: 'RUA CONFUCIO PAMPLONA',
  },
  {
    name: 'RUA CONRADO CABRAL',
  },
  {
    name: 'RUA HAROLDO BASTOS',
  },
  {
    name: 'RUA PDE CONSTANTINO',
  },
  {
    name: 'RUA CONTORNO DA UNIFOR',
  },
  {
    name: 'RUA TAQUATIARA',
  },
  {
    name: 'RUA COPERNICO',
  },
  {
    name: 'TR CORACAO DE JESUS',
  },
  {
    name: 'VL CORACAO DE JESUS D12',
  },
  {
    name: 'RUA DR MANOEL MOREIRA',
  },
  {
    name: 'RUA COREAU',
  },
  {
    name: 'RUA CORREGO BONITO',
  },
  {
    name: 'RUA CORREGO DAS FLORES',
  },
  {
    name: 'RUA BRI CORREIA DE MELO',
  },
  {
    name: 'RUA CORREIA LIMA D39',
  },
  {
    name: 'RUA NOVA QUIETUDE',
  },
  {
    name: 'RUA COSMONAUTAS D34',
  },
  {
    name: 'RUA COSTA ARAUJO',
  },
  {
    name: 'RUA COSTA BARROS',
  },
  {
    name: 'RUA 5 DE AGOSTO',
  },
  {
    name: 'AV PRS COSTA E SILVA',
  },
  {
    name: 'RUA COSTA FREIRE',
  },
  {
    name: 'RUA PRO COSTA MENDES',
  },
  {
    name: 'TR PRO COSTA MENDES D12',
  },
  {
    name: 'RUA COSTA RICA',
  },
  {
    name: 'RUA COSTA SOUZA',
  },
  {
    name: 'RUA CRATEUS',
  },
  {
    name: 'VL CEARA D13',
  },
  {
    name: 'RUA BAR CRATO',
  },
  {
    name: 'AL CRAVINAS',
  },
  {
    name: 'AL CRAVOS',
  },
  {
    name: 'TR CRETA',
  },
  {
    name: 'AL CRISADALIAS',
  },
  {
    name: 'AL CRISANTEMOS',
  },
  {
    name: 'RUA CRISANTO ARRUDA',
  },
  {
    name: 'RUA CRISANTO M DA ROCHA',
  },
  {
    name: 'RUA CRISTAL',
  },
  {
    name: 'PR CRISTO REDENTOR',
  },
  {
    name: 'VL CRISTO REI',
  },
  {
    name: 'RUA SAO CRISTOVAO D49',
  },
  {
    name: 'RUA CRUZ ABREU',
  },
  {
    name: 'RUA CRUZ SALDANHA',
  },
  {
    name: 'TR CRUZ SALDANHA',
  },
  {
    name: 'RUA CRUZEIRO DO SUL',
  },
  {
    name: 'TR CRUZEIRO DO SUL',
  },
  {
    name: 'RUA CUBA',
  },
  {
    name: 'RUA CUIABA',
  },
  {
    name: 'RUA JOAQUIM MARTINS',
  },
  {
    name: 'RUA CUNHA BARBOSA',
  },
  {
    name: 'RUA CURIO',
  },
  {
    name: 'RUA CURITIBA',
  },
  {
    name: 'AV D CJ JOSE WALTER',
  },
  {
    name: 'AV D CJ BEIRA RIO',
  },
  {
    name: 'RUA ENG PAULO CESAR BARBOSA',
  },
  {
    name: 'RUA CONDE D´EU',
  },
  {
    name: 'RUA CAP DAKIR',
  },
  {
    name: 'AL DALIAS',
  },
  {
    name: 'RUA DAMASCENO GIRAO',
  },
  {
    name: 'RUA SAO DAMIAO',
  },
  {
    name: 'RUA DAMIAO FERNANDES',
  },
  {
    name: 'RUA FRE DAMIAO',
  },
  {
    name: 'RUA DARCY VARGAS',
  },
  {
    name: 'RUA DELMIRO FARIAS',
  },
  {
    name: 'RUA DELMIRO GOUVEIA',
  },
  {
    name: 'RUA DELTA',
  },
  {
    name: 'RUA PRO DEMETRIO CARNEIRO',
  },
  {
    name: 'RUA DEMETRIO MENEZES',
  },
  {
    name: 'RUA DEMOCRITO ROCHA',
  },
  {
    name: 'RUA DEMOSTENES BRIGIDO',
  },
  {
    name: 'RUA DEMOSTENES CARVALHO',
  },
  {
    name: 'RUA MAL DEODORO',
  },
  {
    name: 'RUA 17 DE JUNHO',
  },
  {
    name: 'RUA 10 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 10 CJ JOSE WALTER',
  },
  {
    name: 'RUA TAB FABIAO',
  },
  {
    name: 'RUA 10 DE JUNHO',
  },
  {
    name: 'RUA 10 DE NOVEMBRO',
  },
  {
    name: 'RUA 19 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 19 CJ JOSE WALTER',
  },
  {
    name: 'RUA 19 DE MARCO',
  },
  {
    name: 'RUA 16 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 17 CJ JOSE WALTER',
  },
  {
    name: 'RUA 17 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 18 CJ JOSE WALTER',
  },
  {
    name: 'RUA DIACUY',
  },
  {
    name: 'RUA DIAMANTINA',
  },
  {
    name: 'RUA DIANA',
  },
  {
    name: 'RUA PRO DIAS DA ROCHA',
  },
  {
    name: 'RUA DINAMARCA',
  },
  {
    name: 'VL DIOGO (D04)',
  },
  {
    name: 'RUA DIOGO CORREIA',
  },
  {
    name: 'RUA DIOGO FEIJO',
  },
  {
    name: 'AV DIOGUINHO',
  },
  {
    name: 'RUA MARIA JOSE WEYNE',
  },
  {
    name: 'RUA DIVA',
  },
  {
    name: 'RUA DJALMA PETIT',
  },
  {
    name: 'RUA DO CANAL (TAUAPE)',
  },
  {
    name: 'RUA DO ROSARIO',
  },
  {
    name: 'RUA DOCA SALES',
  },
  {
    name: 'RUA 2 CJ POLAR',
  },
  {
    name: 'RUA 2 DE OUTUBRO',
  },
  {
    name: 'AV DOLOR BARREIRA',
  },
  {
    name: 'RUA SAO DOMINGOS',
  },
  {
    name: 'RUA DOMINGOS A RIBEIRO',
  },
  {
    name: 'RUA PRO DOMINGOS BONIFACIO',
  },
  {
    name: 'RUA DOMINGOS DA VEIGA',
  },
  {
    name: 'RUA DOMINGOS JAGUARIBE',
  },
  {
    name: 'RUA DOMINGOS LOPES',
  },
  {
    name: 'AV DOMINGOS OLIMPIO',
  },
  {
    name: 'RUA DOMINGOS RAIOL',
  },
  {
    name: 'RUA DONATILHA CARVALHO',
  },
  {
    name: 'RUA DONDON FEITOSA',
  },
  {
    name: 'RUA ANTONIO BENTO',
  },
  {
    name: 'RUA BENJAMIM CONSTANT',
  },
  {
    name: 'RUA AGEU ROMERO',
  },
  {
    name: 'RUA DOS POTIGUARAS',
  },
  {
    name: 'RUA 12 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 12 CJ JOSE WALTER',
  },
  {
    name: 'RUA 12 DE JULHO',
  },
  {
    name: 'RUA 2 DE MAIO (PICI)',
  },
  {
    name: 'RUA DRACON BARRETO',
  },
  {
    name: 'RUA DRAGAO DO MAR',
  },
  {
    name: 'RUA DUARTE DA COSTA',
  },
  {
    name: 'RUA DUARTE PIMENTEL',
  },
  {
    name: 'RUA DUAS NACOES',
  },
  {
    name: 'RUA DULCINEIA GONDIM',
  },
  {
    name: 'RUA DUTRA',
  },
  {
    name: 'RUA CEL FRANCISCO PEREIRA (MESSEJANA)',
  },
  {
    name: 'RUA ECA DE QUEIROZ',
  },
  {
    name: 'RUA ECA DE QUEIROZ D71',
  },
  {
    name: 'RUA LIV EDESIO',
  },
  {
    name: 'RUA EDGAR BORGES',
  },
  {
    name: 'RUA EDGAR FALCAO',
  },
  {
    name: 'RUA NITEROI (CANINDEZINHO)',
  },
  {
    name: 'RUA EDILIA REGO BARROS',
  },
  {
    name: 'RUA D VL DOS TEN E SGT',
  },
  {
    name: 'RUA EDITE BRAGA',
  },
  {
    name: 'RUA EDMUNDO FALCAO',
  },
  {
    name: 'RUA MAD ELISA BALDO',
  },
  {
    name: 'RUA EDSON MARTINS',
  },
  {
    name: 'RUA ENG EDMUNDO ALMEIDA FILHO',
  },
  {
    name: 'RUA EDUARDO ANGELIM',
  },
  {
    name: 'TR EDUARDO ANGELIM',
  },
  {
    name: 'RUA EDUARDO BEZERRA',
  },
  {
    name: 'RUA EDUARDO GARCIA',
  },
  {
    name: 'AV EDUARDO GIRAO',
  },
  {
    name: 'RUA EDUARDO MOTA',
  },
  {
    name: 'RUA EDUARDO PERDIGAO',
  },
  {
    name: 'RUA EDUARDO SABOIA',
  },
  {
    name: 'RUA EDUARDO SALGADO',
  },
  {
    name: 'RUA EDUARDO STUDART',
  },
  {
    name: 'RUA EFESIO',
  },
  {
    name: 'RUA STA EFIGENIA',
  },
  {
    name: 'RUA EFREN GONDIM',
  },
  {
    name: 'RUA ELCIAS LOPES',
  },
  {
    name: 'RUA ESPANHA',
  },
  {
    name: 'RUA ELESBAO VELOSO',
  },
  {
    name: 'AL ELIANE LUCIA',
  },
  {
    name: 'RUA PDE ELIAS SARAIVA',
  },
  {
    name: 'RUA TEN ELIEZER COSTA',
  },
  {
    name: 'RUA STA ELISA D21',
  },
  {
    name: 'RUA ELISARIO MENDES',
  },
  {
    name: 'RUA ELISEU ORIA',
  },
  {
    name: 'RUA ELISEU UCHOA BECCO',
  },
  {
    name: 'RUA ELMIRA',
  },
  {
    name: 'RUA ELVIRA PINHO',
  },
  {
    name: 'RUA EMIDIO LOBO',
  },
  {
    name: 'RUA EMILIA FREITAS',
  },
  {
    name: 'RUA EMILIO CONDE',
  },
  {
    name: 'RUA EMILIO DE MENESES',
  },
  {
    name: 'RUA THOMPSON GONCALVES',
  },
  {
    name: 'RUA EMILIA GONCALVES',
  },
  {
    name: 'RUA EMILIO SA',
  },
  {
    name: 'RUA ENOQUE NOGUEIRA',
  },
  {
    name: 'RUA EPAMINONDAS FROTA',
  },
  {
    name: 'RUA EPIFANIO LEITE',
  },
  {
    name: 'RUA EQUADOR',
  },
  {
    name: 'RUA ERETIDES ALENCAR',
  },
  {
    name: 'RUA ERETIDES MARTINS',
  },
  {
    name: 'RUA ERICO MOTA',
  },
  {
    name: 'RUA CEL ERNESTO MATOS',
  },
  {
    name: 'RUA ERNESTO PEDRO SANTOS',
  },
  {
    name: 'RUA ESMERINDA MENDES',
  },
  {
    name: 'RUA ESMERALDA D20',
  },
  {
    name: 'TR ESPANHA',
  },
  {
    name: 'RUA ESPERANTO D14',
  },
  {
    name: 'RUA ESPIRITO SANTO',
  },
  {
    name: 'RUA ESTADO DO RIO',
  },
  {
    name: 'RUA DOS ESTADOS',
  },
  {
    name: 'AV SEN VIRGILIO TAVORA',
  },
  {
    name: 'RUA ESTEFANIA M MOTA',
  },
  {
    name: 'RUA ESTEFANIA SALGADO',
  },
  {
    name: 'RUA COS ESTELITA',
  },
  {
    name: 'RUA ESTEVAO DE CAMPOS',
  },
  {
    name: 'RUA DR QUIXADA FELICIO',
  },
  {
    name: 'TR ESTRELA DO MAR D12',
  },
  {
    name: 'RUA EUCLIDES DA CUNHA',
  },
  {
    name: 'RUA EUDES CARDOSO',
  },
  {
    name: 'RUA EUGENIA',
  },
  {
    name: 'RUA EUGENIO GADELHA',
  },
  {
    name: 'RUA EUNICE',
  },
  {
    name: 'RUA EUNICE WEVER D57',
  },
  {
    name: 'RUA GAL EURICO',
  },
  {
    name: 'RUA EURICO FACO',
  },
  {
    name: 'RUA DES EURICO MONTEIRO',
  },
  {
    name: 'RUA EUSEBIO DE SOUZA',
  },
  {
    name: 'RUA EUZEBIO DE QUEIROS',
  },
  {
    name: 'RUA EVA',
  },
  {
    name: 'RUA EVANDRO LUZ',
  },
  {
    name: 'TR EVANDRO LUZ',
  },
  {
    name: 'RUA EVARISTO DA VEIGA',
  },
  {
    name: 'RUA EVARISTO REIS',
  },
  {
    name: 'RUA OTAVIO LIMA',
  },
  {
    name: 'AV DOS EXPEDICIONARIOS',
  },
  {
    name: 'RUA DOM EXPEDITO LOPES D15 (J. IRACEMA)',
  },
  {
    name: 'AL EXTREMOSAS',
  },
  {
    name: 'AV F CJ JOSE WALTER',
  },
  {
    name: 'RUA CEL FABRICIANO',
  },
  {
    name: 'RUA MAJ FACUNDO',
  },
  {
    name: 'RUA FAGUNDES VARELA',
  },
  {
    name: 'RUA FARIAS LEMOS',
  },
  {
    name: 'AV DES FAUSTINO ALBUQUERQUE',
  },
  {
    name: 'RUA FAUSTO AGUIAR',
  },
  {
    name: 'RUA FAUSTO CABRAL',
  },
  {
    name: 'RUA DA FE',
  },
  {
    name: 'RUA NAT FEIJO',
  },
  {
    name: 'RUA DOM HELIO CAMPOS D21',
  },
  {
    name: 'AV FELINO BARROSO',
  },
  {
    name: 'VL FORTALEZA D08',
  },
  {
    name: 'RUA FELIPE CAMARAO',
  },
  {
    name: 'TR FELIPE CAMARAO D38',
  },
  {
    name: 'RUA FELIPE DOS SANTOS',
  },
  {
    name: 'TR FELIX CANDIDO',
  },
  {
    name: 'RUA DES FELIX CANDIDO',
  },
  {
    name: 'RUA FENELON BOMILCAR',
  },
  {
    name: 'AV SEN FERNANDES TAVORA',
  },
  {
    name: 'RUA FERNANDO BENEVIDES',
  },
  {
    name: 'RUA FERNANDO WEYNE',
  },
  {
    name: 'RUA FERNAO MAGALHAES',
  },
  {
    name: 'RUA CEL FERRAZ',
  },
  {
    name: 'TR DR JOAQUIM CITO',
  },
  {
    name: 'RUA FERREIRA DOS SANTOS',
  },
  {
    name: 'TR FERREIRA DOS SANTOS',
  },
  {
    name: 'ET FERRO SOBRAL',
  },
  {
    name: 'RUA FILADELFIA',
  },
  {
    name: 'RUA FILGUEIRAS LIMA',
  },
  {
    name: 'RUA DES FELISMINO',
  },
  {
    name: 'RUA MESSIAS FILOMENO',
  },
  {
    name: 'AV FILOMENO GOMES',
  },
  {
    name: 'RUA DO FIM',
  },
  {
    name: 'RUA FIUZA DE PONTES',
  },
  {
    name: 'TR FLAMENGO',
  },
  {
    name: 'RUA FLAVIO LIMA',
  },
  {
    name: 'RUA FLOR DE LIS',
  },
  {
    name: 'RUA FLORENCIO ALENCAR',
  },
  {
    name: 'RUA FLORENCIO FONTENELE',
  },
  {
    name: 'RUA FLORIANO PEIXOTO',
  },
  {
    name: 'RUA FLORIANOPOLIS',
  },
  {
    name: 'RUA FLORIDA',
  },
  {
    name: 'RUA FLORO BARTOLOMEU',
  },
  {
    name: 'RUA FONSECA LOBO',
  },
  {
    name: 'VL FRANCISCO GERARDO',
  },
  {
    name: 'RUA FRANCA',
  },
  {
    name: 'RUA FRANCISCA CLOTILDE',
  },
  {
    name: 'RUA FRANCISCA RANGEL',
  },
  {
    name: 'RUA DES LEITE ALBUQUERQUE',
  },
  {
    name: 'TR SAO FRANCISCO D21',
  },
  {
    name: 'RUA SAO FRANCISCO D34',
  },
  {
    name: 'VL SAO FRANCISCO D10',
  },
  {
    name: 'TR SAO FRANCISCO D26',
  },
  {
    name: 'TR SAO FRANCISCO D28',
  },
  {
    name: 'RUA FRANCISCO ALVES D26',
  },
  {
    name: 'RUA FRANCISCO BENTO',
  },
  {
    name: 'RUA FRANCISCO CALACA',
  },
  {
    name: 'RUA FRANCISCO CORDEIRO',
  },
  {
    name: 'RUA SAO FRANCISCO DE ASSIS',
  },
  {
    name: 'RUA FRANCISCO DE SALES',
  },
  {
    name: 'RUA FRANCISCO DOMINGOS',
  },
  {
    name: 'TR FRANCISCO FRANCO',
  },
  {
    name: 'RUA FRANCISCO GLICERIO',
  },
  {
    name: 'RUA PRO FRANCISCO GONCALVES',
  },
  {
    name: 'RUA FRANCISCO HOLANDA',
  },
  {
    name: 'RUA FRANCISCO LORDA',
  },
  {
    name: 'RUA FRANCISCO MARTINS',
  },
  {
    name: 'RUA FRANCISCO MATOS',
  },
  {
    name: 'RUA FRANCISCO MENDES DE OLIVEIRA',
  },
  {
    name: 'RUA FRANCISCO MONTE',
  },
  {
    name: 'RUA FRANCISCO MOREIRA',
  },
  {
    name: 'RUA FRANCISCO P DA PONTE',
  },
  {
    name: 'RUA CAP FRANCISCO PEDRO',
  },
  {
    name: 'RUA PDE FRANCISCO PINTO',
  },
  {
    name: 'RUA PDE FRANCISCO PITA',
  },
  {
    name: 'RUA CEL FRANCISCO RIBEIRO',
  },
  {
    name: 'AV FRANCISCO SA',
  },
  {
    name: 'RUA FRANCISCO SALGADO',
  },
  {
    name: 'RUA FRANCISCO VASCONCELOS',
  },
  {
    name: 'RUA FRANCISCO VILELA',
  },
  {
    name: 'RUA FRANCO ROCHA',
  },
  {
    name: 'RUA FRANCOIS T MENEZES',
  },
  {
    name: 'VL SAO FRANCISCO D06',
  },
  {
    name: 'RUA FRANKLIN MEYER',
  },
  {
    name: 'RUA FRANKLIN TAVORA',
  },
  {
    name: 'RUA FRECHEIRINHA',
  },
  {
    name: 'RUA FREDERICO ANDRADE',
  },
  {
    name: 'RUA FREDERICO BORGES',
  },
  {
    name: 'RUA FREDERICO SEVERO',
  },
  {
    name: 'RUA FREDERICO SEVERO',
  },
  {
    name: 'RUA DES FROTA D71',
  },
  {
    name: 'RUA PDE FROTA',
  },
  {
    name: 'RUA FROTA PESSOA',
  },
  {
    name: 'RUA MON FURTADO',
  },
  {
    name: 'AV G CJ JOSE WALTER',
  },
  {
    name: 'RUA SAO GABRIEL D56',
  },
  {
    name: 'RUA SAO GABRIEL D16 (JOAQUIM TAVORA)',
  },
  {
    name: 'RUA GABRIEL FIUZA',
  },
  {
    name: 'RUA GAGO COUTINHO',
  },
  {
    name: 'RUA OLIMPIO GALDINO DE SOUSA',
  },
  {
    name: 'RUA GALEAO',
  },
  {
    name: 'RUA LUIZA MIRANDA COELHO',
  },
  {
    name: 'RUA GALILEU',
  },
  {
    name: 'RUA COS GALVAO',
  },
  {
    name: 'RUA JOAO DE DEUS D43',
  },
  {
    name: 'RUA JUVENCIO VASCONCELOS',
  },
  {
    name: 'RUA COM GARCIA',
  },
  {
    name: 'RUA DES GARCIA',
  },
  {
    name: 'RUA GARDENIA',
  },
  {
    name: 'RUA GASPAR LEMOS',
  },
  {
    name: 'RUA GASTAO JUSTA',
  },
  {
    name: 'RUA GAUDIOSO CARVALHO',
  },
  {
    name: 'VL GENEZARE',
  },
  {
    name: 'RUA JOAQUIM M DE MACEDO',
  },
  {
    name: 'RUA GENTILANDIA',
  },
  {
    name: 'RUA GEORGE CAVALCANTE',
  },
  {
    name: 'RUA GEORGE PEQUENO',
  },
  {
    name: 'RUA GERALDO BARBOSA',
  },
  {
    name: 'RUA MAJ GERARDO MENDES',
  },
  {
    name: 'RUA SAO GERARDO (C. PORTO)',
  },
  {
    name: 'RUA PDE GERMANO',
  },
  {
    name: 'RUA GERMANO FRANCK',
  },
  {
    name: 'RUA GERSON FARIAS',
  },
  {
    name: 'RUA GERVASIO DE CASTRO',
  },
  {
    name: 'RUA GERVASIO GURGEL',
  },
  {
    name: 'RUA GETULIO VARGAS',
  },
  {
    name: 'RUA GIL AMORA',
  },
  {
    name: 'RUA DR GILBERTO CAMARA',
  },
  {
    name: 'RUA DR GILBERTO STUDART',
  },
  {
    name: 'TR GIRAO',
  },
  {
    name: 'AL GIRASSOIS',
  },
  {
    name: 'RUA GIRASSOL',
  },
  {
    name: 'RUA GIRO',
  },
  {
    name: 'RUA MANUEL DARIO',
  },
  {
    name: 'AV GODOFREDO MACIEL',
  },
  {
    name: 'AV GODOFREDO PIMENTEL',
  },
  {
    name: 'TR GOIABEIRA',
  },
  {
    name: 'RUA GOIABEIRAS',
  },
  {
    name: 'RUA GOIANIA',
  },
  {
    name: 'RUA GOIAS',
  },
  {
    name: 'RUA PARAMBU',
  },
  {
    name: 'RUA GAL GOIS MONTEIRO',
  },
  {
    name: 'VL GOMES D40',
  },
  {
    name: 'RUA PRO GOMES BRASIL',
  },
  {
    name: 'AV PRO GOMES DE MATOS',
  },
  {
    name: 'RUA GOMES PARENTE D20',
  },
  {
    name: 'RUA DES GOMES PARENTE',
  },
  {
    name: 'RUA GOMES PASSOS',
  },
  {
    name: 'RUA CEL GONCALO D46',
  },
  {
    name: 'TR SAO GONCALO D26',
  },
  {
    name: 'RUA GONCALO BEZERRA',
  },
  {
    name: 'RUA GONCALO DE LAGOS',
  },
  {
    name: 'RUA SAO GONCALO DO AMARANTE',
  },
  {
    name: 'RUA GONCALO SOUTO',
  },
  {
    name: 'RUA PAULA FRANCINETE',
  },
  {
    name: 'RUA GONCALVES DIAS',
  },
  {
    name: 'RUA GONCALVES LEDO',
  },
  {
    name: 'VL PRO GONCALVES SANTOS',
  },
  {
    name: 'RUA GANDOLA',
  },
  {
    name: 'RUA OFIR',
  },
  {
    name: 'AV DES GONZAGA',
  },
  {
    name: 'RUA COS GOUVEIA',
  },
  {
    name: 'RUA PDE GRACA',
  },
  {
    name: 'RUA GRACA ARANHA',
  },
  {
    name: 'TR GRACA ARANHA D23',
  },
  {
    name: 'RUA GRACILIANO RAMOS',
  },
  {
    name: 'AL GRACIOLAS',
  },
  {
    name: 'RUA GRACO CARDOSO',
  },
  {
    name: 'RUA GRANJA CASTELO',
  },
  {
    name: 'GR SAO FRANCISCO',
  },
  {
    name: 'TR GREGA',
  },
  {
    name: 'RUA JOAQUIM DE SOUSA',
  },
  {
    name: 'RUA GONTRAN GIFONI',
  },
  {
    name: 'TR GRAVATAI',
  },
  {
    name: 'AV DAS GRAVIOLAS',
  },
  {
    name: 'BC GRAVIOLAS',
  },
  {
    name: 'RUA GRECIA',
  },
  {
    name: 'RUA GREGORIO FRANCA',
  },
  {
    name: 'RUA GRIJALVA COSTA',
  },
  {
    name: 'RUA GROAIRAS',
  },
  {
    name: 'AV CONTORNO DO IPASE',
  },
  {
    name: 'RUA XAVIER DA SILVEIRA',
  },
  {
    name: 'RUA GUAIUBA',
  },
  {
    name: 'TR GRACA ARANHA D26',
  },
  {
    name: 'RUA LIV GUALTER',
  },
  {
    name: 'RUA GUANABARA',
  },
  {
    name: 'TR GUANABARA',
  },
  {
    name: 'RUA GUANACES',
  },
  {
    name: 'RUA GUARA   D41',
  },
  {
    name: 'RUA GUARACI',
  },
  {
    name: 'RUA GUARACIABA DO NORTE',
  },
  {
    name: 'RUA GUARANI D35 (JOAO XXIII)',
  },
  {
    name: 'RUA GUATEMALA',
  },
  {
    name: 'RUA PDE GUERRA',
  },
  {
    name: 'TR PDE GUERRA',
  },
  {
    name: 'RUA GUERRA JUNQUEIRO',
  },
  {
    name: 'RUA PDE GUILHERME',
  },
  {
    name: 'RUA CEL GUILHERME ALENCAR',
  },
  {
    name: 'RUA GUILHERME ASSUNCAO',
  },
  {
    name: 'RUA GUILHERME BLHUM',
  },
  {
    name: 'RUA GUILHERME MENDES',
  },
  {
    name: 'RUA GUILHERME MOREIRA',
  },
  {
    name: 'RUA GUILHERME PERDIGAO',
  },
  {
    name: 'RUA GUILHERME PESSOA',
  },
  {
    name: 'RUA GUILHERME ROCHA',
  },
  {
    name: 'RUA DES GUIMARAES',
  },
  {
    name: 'TR GURUPY',
  },
  {
    name: 'VL TAMBAU',
  },
  {
    name: 'RUA CAP GUSTAVO',
  },
  {
    name: 'RUA GUSTAVO BRAGA',
  },
  {
    name: 'RUA JULIO B DE CARVALHO',
  },
  {
    name: 'RUA GUSTAVO SAMPAIO',
  },
  {
    name: 'AV CAP GUTEMBERG BAUN',
  },
  {
    name: 'AV H CJ JOSE WALTER',
  },
  {
    name: 'RUA PRO HENRIQUE FIRMEZA',
  },
  {
    name: 'RUA JUAREZ BARROSO',
  },
  {
    name: 'RUA ANTONIO G DE SALES',
  },
  {
    name: 'RUA COM HAROLDO ARUEIRA',
  },
  {
    name: 'RUA HAROLDO LEAO',
  },
  {
    name: 'RUA HAROLDO TORRES',
  },
  {
    name: 'RUA HAVAI',
  },
  {
    name: 'RUA HELENA MARIA',
  },
  {
    name: 'RUA PARANAPANEMA',
  },
  {
    name: 'RUA HELIO CARACAS',
  },
  {
    name: 'RUA DR HELIO VIANA',
  },
  {
    name: 'RUA HELVECIO MONTE',
  },
  {
    name: 'RUA DOM HENRIQUE',
  },
  {
    name: 'RUA FRE HENRIQUE D60',
  },
  {
    name: 'RUA HENRIQUE AUTRAN',
  },
  {
    name: 'RUA HENRIQUE DE CASTRO',
  },
  {
    name: 'RUA HENRIQUE DIAS',
  },
  {
    name: 'RUA HENRIQUE ELERY',
  },
  {
    name: 'RUA HENRIQUE JUSTA',
  },
  {
    name: 'RUA HENRIQUE RABELO',
  },
  {
    name: 'RUA HENRIQUETA GALENO',
  },
  {
    name: 'RUA PRO HERACLITO',
  },
  {
    name: 'RUA HERACLITO DOMINGOS',
  },
  {
    name: 'AV HERACLITO GRACA',
  },
  {
    name: 'RUA HERBENE',
  },
  {
    name: 'RUA HERCULANO PENA',
  },
  {
    name: 'RUA HERCULES',
  },
  {
    name: 'RUA DES HERMES PARAHYBA',
  },
  {
    name: 'RUA HERMINIA BONAVIDES',
  },
  {
    name: 'AV SGT HERMINIO SAMPAIO',
  },
  {
    name: 'RUA HERMINIO BARROSO',
  },
  {
    name: 'AV HEROIS DO ACRE',
  },
  {
    name: 'AV HILDEBRANDO DE MELO',
  },
  {
    name: 'RUA CREUSA ROCHA',
  },
  {
    name: 'RUA OSCAR BENEVIDES',
  },
  {
    name: 'RUA ODETE PACHECO',
  },
  {
    name: 'TR HILNETE',
  },
  {
    name: 'RUA HILTON SANTOS',
  },
  {
    name: 'RUA MON HIPOLITO BRASIL',
  },
  {
    name: 'RUA HIPOLITO PAMPLONA',
  },
  {
    name: 'RUA HOLANDA',
  },
  {
    name: 'RUA HOMEM DE MELO',
  },
  {
    name: 'RUA HONDURAS',
  },
  {
    name: 'RUA HONORIO VIEIRA',
  },
  {
    name: 'RUA DR VICENTE ARRUDA',
  },
  {
    name: 'AL HORTENCIAS',
  },
  {
    name: 'TR HOSPEDARIA',
  },
  {
    name: 'VL HOLANDA D13',
  },
  {
    name: 'RUA CAP HUGO BEZERRA',
  },
  {
    name: 'RUA DR HUGO ROCHA',
  },
  {
    name: 'RUA HUGO VITOR',
  },
  {
    name: 'AV MR HULL',
  },
  {
    name: 'RUA MIRTYL MEYER',
  },
  {
    name: 'RUA HUMBERTO DE CAMPOS',
  },
  {
    name: 'RUA HUMBERTO LOMEU',
  },
  {
    name: 'AV ENG HUMBERTO MONTE',
  },
  {
    name: 'RUA HUNGRIA',
  },
  {
    name: 'AV I CJ JOSE WALTER',
  },
  {
    name: 'RUA IARA',
  },
  {
    name: 'RUA BAR IBIAPABA',
  },
  {
    name: 'RUA PDE IBIAPINA',
  },
  {
    name: 'TR ICO  D01',
  },
  {
    name: 'RUA VIS ICO D20',
  },
  {
    name: 'RUA ILDEFONSO ALBANO',
  },
  {
    name: 'RUA IEDA PEREIRA',
  },
  {
    name: 'RUA IGUAPE',
  },
  {
    name: 'RUA IGUATU',
  },
  {
    name: 'RUA ILDEFONSO ARAUJO',
  },
  {
    name: 'RUA ILHA BELA',
  },
  {
    name: 'RUA IMPAR',
  },
  {
    name: 'AV IMPERADOR',
  },
  {
    name: 'RUA STO INACIO D04',
  },
  {
    name: 'RUA GUILHERME ALENCAR',
  },
  {
    name: 'RUA INACIO ORIA',
  },
  {
    name: 'RUA INACIO PARENTE',
  },
  {
    name: 'RUA INACIO VASCONCELOS',
  },
  {
    name: 'AV DA INDEPENDENCIA',
  },
  {
    name: 'RUA STA INES D20',
  },
  {
    name: 'RUA STA INES D22',
  },
  {
    name: 'TR STA INES D20',
  },
  {
    name: 'RUA INGA',
  },
  {
    name: 'RUA INGLATERRA',
  },
  {
    name: 'RUA INSTITUTO DO CEARA',
  },
  {
    name: 'AV GAL MURILO BORGES',
  },
  {
    name: 'RUA FRANCISCO DIAS RIBEIRO',
  },
  {
    name: 'RUA IPE (ALAGADIÇO)',
  },
  {
    name: 'TR IPIRANGA D39',
  },
  {
    name: 'TR IPITANGA',
  },
  {
    name: 'RUA EDGAR DAMASCENO',
  },
  {
    name: 'RUA IRACEMA (JANGURUSSU)',
  },
  {
    name: 'RUA ZEROMAO ARAUJO',
  },
  {
    name: 'RUA IRAPUA',
  },
  {
    name: 'RUA IRAUCUBA',
  },
  {
    name: 'RUA IRINEU DE SOUZA',
  },
  {
    name: 'VL IRIS D08',
  },
  {
    name: 'AL IRIS',
  },
  {
    name: 'TR IRMAOS CARNEIRO',
  },
  {
    name: 'RUA PRC ISABEL',
  },
  {
    name: 'TR STA ISABEL',
  },
  {
    name: 'RUA ISABEL MAIA ALENCAR',
  },
  {
    name: 'RUA ISABEL SIDNEY',
  },
  {
    name: 'RUA ISAC AMARAL',
  },
  {
    name: 'RUA ISAC MEYER',
  },
  {
    name: 'RUA ISAIAS BORIS',
  },
  {
    name: 'RUA ISAIAS D SILVEIRA',
  },
  {
    name: 'RUA ISMAEL PORDEUS',
  },
  {
    name: 'RUA IDELZUITE C LIMA',
  },
  {
    name: 'RUA ISMENIA',
  },
  {
    name: 'RUA ISRAEL BEZERRA',
  },
  {
    name: 'RUA ITAGUAI',
  },
  {
    name: 'RUA ITAICABA',
  },
  {
    name: 'RUA ITALIA D43',
  },
  {
    name: 'RUA ITAMARATI',
  },
  {
    name: 'TR ITAPAJE',
  },
  {
    name: 'RUA ITAPIPOCA',
  },
  {
    name: 'RUA FABIANO DE CRISTO',
  },
  {
    name: 'TR ITAPIUNA',
  },
  {
    name: 'RUA ITATIRA',
  },
  {
    name: 'RUA ITU',
  },
  {
    name: 'AV J CJ NOVA ASSUNCAO',
  },
  {
    name: 'AV J CJ JOSE WALTER',
  },
  {
    name: 'RUA J DA PENHA',
  },
  {
    name: 'RUA JAU',
  },
  {
    name: 'RUA JACANA',
  },
  {
    name: 'TR JOAQUIM PINTO D23',
  },
  {
    name: 'RUA JACAUNA',
  },
  {
    name: 'RUA ALM JACEGUAI',
  },
  {
    name: 'RUA JACI',
  },
  {
    name: 'TR JACINTO',
  },
  {
    name: 'RUA PRO JACINTO BOTELHO',
  },
  {
    name: 'RUA JACINTO MATOS',
  },
  {
    name: 'RUA JAGUARETAMA',
  },
  {
    name: 'RUA JAGUARIBARA',
  },
  {
    name: 'RUA SEN JAGUARIBE',
  },
  {
    name: 'RUA JAGUARUANA',
  },
  {
    name: 'TR JAIME ANDRADE',
  },
  {
    name: 'RUA TEN JAIME ANDRADE',
  },
  {
    name: 'RUA JAIME BENEVOLO',
  },
  {
    name: 'RUA JAIME VASCONCELOS',
  },
  {
    name: 'RUA JANDAIA',
  },
  {
    name: 'RUA JANDIRA',
  },
  {
    name: 'RUA JANGADA',
  },
  {
    name: 'AV JANGADEIROS (MUCURIPE)',
  },
  {
    name: 'RUA CONDE JANUARIO',
  },
  {
    name: 'RUA PDE JANUARIO CAMPOS',
  },
  {
    name: 'RUA EDMUNDO LINHARES',
  },
  {
    name: 'TR JAPAO',
  },
  {
    name: 'RUA JAPI',
  },
  {
    name: 'TR JAQUELINE',
  },
  {
    name: 'RUA JARDIM BOTANICO',
  },
  {
    name: 'TR JATAI D47',
  },
  {
    name: 'VL JD PRINCESA ISABEL',
  },
  {
    name: 'AL JASMINS',
  },
  {
    name: 'RUA JATOBAS  D68',
  },
  {
    name: 'RUA DOM JERONIMO D06',
  },
  {
    name: 'RUA JERONIMO ALBUQUERQUE',
  },
  {
    name: 'RUA SAO JOAO D20',
  },
  {
    name: 'RUA TEN JOAO ALBANO',
  },
  {
    name: 'RUA JOAO ARARIPE',
  },
  {
    name: 'RUA JOAO AREAS',
  },
  {
    name: 'RUA JOAO BARRETO',
  },
  {
    name: 'RUA DR JOAO BEZERRA',
  },
  {
    name: 'RUA PRO JOAO BOSCO',
  },
  {
    name: 'RUA ARQ JOAO BRAGA DE LIMA',
  },
  {
    name: 'RUA JOAO BRIGIDO',
  },
  {
    name: 'RUA JOAO CAMARA',
  },
  {
    name: 'RUA JOAO CAPOTE',
  },
  {
    name: 'RUA GOV JOAO CARLOS',
  },
  {
    name: 'RUA CEL JOAO CARNEIRO',
  },
  {
    name: 'RUA JOAO CARVALHO',
  },
  {
    name: 'RUA CEL JOAO CIDRAO',
  },
  {
    name: 'RUA JOAO CORDEIRO',
  },
  {
    name: 'RUA CEL JOAO CORREIA',
  },
  {
    name: 'RUA JOAO COSTA',
  },
  {
    name: 'RUA GAL JOAO COUTO',
  },
  {
    name: 'RUA DR JOAO DE DEUS D11',
  },
  {
    name: 'RUA SAO JOAO DO JAGUARIBE',
  },
  {
    name: 'RUA JOAO EMIDIO SILVEIRA',
  },
  {
    name: 'TR JOAO FELIPE',
  },
  {
    name: 'RUA JOAO FERREIRA',
  },
  {
    name: 'RUA JOAO FIRMINO',
  },
  {
    name: 'RUA JOAO FONSECA',
  },
  {
    name: 'RUA JOAO GENTIL',
  },
  {
    name: 'RUA DR JOAO GUILHERME',
  },
  {
    name: 'RUA JOAO LOBO FILHO',
  },
  {
    name: 'RUA DEP JOAO LOPES',
  },
  {
    name: 'AV DR JOAO MACIEL FILHO',
  },
  {
    name: 'RUA JOAO MELO',
  },
  {
    name: 'RUA DR JOAO MOREIRA',
  },
  {
    name: 'RUA JOAO NEPOMUCENO',
  },
  {
    name: 'RUA ENG JOAO NOGUEIRA',
  },
  {
    name: 'RUA JOAO NOGUEIRA BORGES',
  },
  {
    name: 'RUA CEL JOAO OLIVEIRA',
  },
  {
    name: 'RUA JOAO PEREIRA',
  },
  {
    name: 'AV JOAO PESSOA',
  },
  {
    name: 'RUA STA FILOMENA',
  },
  {
    name: 'RUA JOAO POMBO',
  },
  {
    name: 'RUA DEP JOAO PONTES',
  },
  {
    name: 'RUA JOAO REGINO',
  },
  {
    name: 'RUA JOAO RIBEIRO',
  },
  {
    name: 'RUA JOAO SALGADO',
  },
  {
    name: 'RUA JOAO SORONGO',
  },
  {
    name: 'TR JOAO TEIXEIRA',
  },
  {
    name: 'RUA JOAO TINOCO',
  },
  {
    name: 'RUA JOAO TOME',
  },
  {
    name: 'RUA JOAO VINTE TRES',
  },
  {
    name: 'RUA PDE JOAO WASSEN',
  },
  {
    name: 'RUA FRANCISCO JOSE A PEREIRA',
  },
  {
    name: 'RUA DOM JOAQUIM',
  },
  {
    name: 'RUA JOAQUIM ALBANO',
  },
  {
    name: 'RUA JOAQUIM A SIQUEIRA',
  },
  {
    name: 'RUA JOAQUIM ALFREDO',
  },
  {
    name: 'TR JOAQUIM ALFREDO',
  },
  {
    name: 'RUA JOAQUIM ALVES',
  },
  {
    name: 'RUA PRO JOAQUIM ANTONIO',
  },
  {
    name: 'AV JOSE LEON',
  },
  {
    name: 'RUA JOAQUIM VIANA BARBOSA',
  },
  {
    name: 'RUA JOAQUIM BARROSO',
  },
  {
    name: 'TR JOAQUIM BARROSO',
  },
  {
    name: 'RUA JOAQUIM B DOS SANTOS',
  },
  {
    name: 'RUA DR JOAQUIM BENTO',
  },
  {
    name: 'RUA CEL JOAQUIM BEZERRA',
  },
  {
    name: 'RUA GAL JOAQUIM DE ANDRADE',
  },
  {
    name: 'RUA DOM JOAQUIM DE MELO',
  },
  {
    name: 'RUA JOAQUIM DEODATO',
  },
  {
    name: 'RUA JOAQUIM EMIDIO DE CASTRO',
  },
  {
    name: 'RUA JOAQUIM FEIJO',
  },
  {
    name: 'RUA JOAQUIM FELICIO',
  },
  {
    name: 'RUA CEL JOAQUIM FRANKLIN',
  },
  {
    name: 'RUA JOAQUIM FROTA',
  },
  {
    name: 'RUA JOAQUIM GENU',
  },
  {
    name: 'RUA JOAQUIM JERONIMO',
  },
  {
    name: 'RUA JOAQUIM LEITAO',
  },
  {
    name: 'RUA JOAQUIM LIMA',
  },
  {
    name: 'RUA JOAQUIM LINO',
  },
  {
    name: 'RUA JOAQUIM MAGALHAES',
  },
  {
    name: 'RUA JOAQUIM MARQUES',
  },
  {
    name: 'RUA JOAQUIM NABUCO',
  },
  {
    name: 'RUA JOAQUIM PIMENTA',
  },
  {
    name: 'RUA JOAQUIM PINTO',
  },
  {
    name: 'RUA JOAQUIM SA',
  },
  {
    name: 'RUA JOAQUIM SIQUEIRA',
  },
  {
    name: 'RUA JOAQUIM TORRES',
  },
  {
    name: 'TR JOEL MONTEIRO',
  },
  {
    name: 'RUA TEN JONAS',
  },
  {
    name: 'RUA JORGE DUMAR',
  },
  {
    name: 'RUA JOCKEY CLUBE',
  },
  {
    name: 'RUA POMAR CARIOCA',
  },
  {
    name: 'RUA JORGE ACURCIO',
  },
  {
    name: 'RUA DR JORGE DA ROCHA',
  },
  {
    name: 'RUA JORGE DE SOUSA',
  },
  {
    name: 'TR JORGE DUMAR',
  },
  {
    name: 'RUA JORGE SEVERIANO',
  },
  {
    name: 'VL SAO GERARDO',
  },
  {
    name: 'RUA JORGE VIEIRA',
  },
  {
    name: 'RUA SAO JOSE D03',
  },
  {
    name: 'TR SAO JOSE D46',
  },
  {
    name: 'RUA JOSE AGOSTINHO',
  },
  {
    name: 'RUA JOSE ALEXANDRE D20',
  },
  {
    name: 'RUA JOSE ALVES DE MORAES',
  },
  {
    name: 'RUA MAJ JOSE ARAUJO AGUIAR',
  },
  {
    name: 'RUA PDE JOSE ARTEIRO',
  },
  {
    name: 'RUA JOSE AVELINO',
  },
  {
    name: 'TR TEN JOSE BARREIRA',
  },
  {
    name: 'RUA TEN JOSE BARREIRA',
  },
  {
    name: 'AV CEL JOSE AURELIO CAMARA',
  },
  {
    name: 'AV JOSE BASTOS',
  },
  {
    name: 'RUA OSCAR BEZERRA ARAUJO',
  },
  {
    name: 'RUA CEL JOSE BEZERRA',
  },
  {
    name: 'RUA PRO JOSE BONIFACIO',
  },
  {
    name: 'RUA JOSE BUSON',
  },
  {
    name: 'RUA JOSE CANDIDO D08',
  },
  {
    name: 'TR JOSE CANDIDO D08',
  },
  {
    name: 'RUA JOSE CARVALHO',
  },
  {
    name: 'VL JOSE CORREIA',
  },
  {
    name: 'TR JOSE DE AGUIAR',
  },
  {
    name: 'TR JOSE DE ALENCAR D25',
  },
  {
    name: 'RUA PRO JOSE DE BARCELOS',
  },
  {
    name: 'RUA JOSE DO NASCIMENTO',
  },
  {
    name: 'AV JOSE DO PATROCINIO',
  },
  {
    name: 'RUA JOSE DUTRA',
  },
  {
    name: 'RUA CEL JOSE EUCLIDES',
  },
  {
    name: 'RUA JOSE FACANHA',
  },
  {
    name: 'RUA DR JOSE FROTA',
  },
  {
    name: 'RUA ELISEU VIANA',
  },
  {
    name: 'RUA DR JOSE GOIANA',
  },
  {
    name: 'TR JOSE GOMES DE MOURA',
  },
  {
    name: 'RUA JOSE GOMES DE MOURA',
  },
  {
    name: 'RUA JOSE GONCALVES LIMA',
  },
  {
    name: 'RUA JOSE HIPOLITO',
  },
  {
    name: 'RUA JOSE JUSTA',
  },
  {
    name: 'RUA PRO JOSE LEITE GONDIM',
  },
  {
    name: 'RUA JOAO LEONEL',
  },
  {
    name: 'AV RAD JOSE LIMA VERDE',
  },
  {
    name: 'RUA DR JOSE LINO',
  },
  {
    name: 'RUA DOM JOSE LOURENCO  D27',
  },
  {
    name: 'TR DOM JOSE LOURENCO  D27',
  },
  {
    name: 'RUA DR JOSE LOURENCO',
  },
  {
    name: 'RUA JOSE LUCAS',
  },
  {
    name: 'RUA FRE JOSE MARIA',
  },
  {
    name: 'RUA JOSE MARIA CARDOSO',
  },
  {
    name: 'RUA JOSE MARROCOS',
  },
  {
    name: 'RUA JOSE MARTINS',
  },
  {
    name: 'RUA PARQUE SUL',
  },
  {
    name: 'RUA JOSE MENELEU D41',
  },
  {
    name: 'RUA JOSE MESSIAS MATOS',
  },
  {
    name: 'RUA JOSE MONTEIRO',
  },
  {
    name: 'RUA JOSE NAPOLEAO',
  },
  {
    name: 'TR JOSE NAPOLEAO',
  },
  {
    name: 'RUA TEN JOSE NEWTON',
  },
  {
    name: 'RUA JOSE O FIGUEIREDO',
  },
  {
    name: 'TR JOSE PEDRA D44',
  },
  {
    name: 'RUA JOSE PEDRA',
  },
  {
    name: 'RUA JOSE PEREIRA',
  },
  {
    name: 'RUA SGT JOSE PINTO',
  },
  {
    name: 'RUA JOSE PINTO DO CARMO',
  },
  {
    name: 'RUA JOSE PONTES',
  },
  {
    name: 'RUA JOSE RANGEL',
  },
  {
    name: 'AV JOSE SABOIA',
  },
  {
    name: 'RUA PRO JOSE SILVEIRA',
  },
  {
    name: 'RUA JOSE SOMBRA',
  },
  {
    name: 'RUA JOSE TEIXEIRA REGO',
  },
  {
    name: 'RUA JOSE TORRES',
  },
  {
    name: 'RUA DOM JOSE TUPINAMBA',
  },
  {
    name: 'RUA JOSE VILAR',
  },
  {
    name: 'RUA DR JOSE VITOR',
  },
  {
    name: 'RUA JOSEFA B DE ALENCAR',
  },
  {
    name: 'RUA JOSELITA PARENTE',
  },
  {
    name: 'RUA PEDRA BRANCA',
  },
  {
    name: 'RUA JOVINO GUEDES',
  },
  {
    name: 'AV JOVITA FEITOSA',
  },
  {
    name: 'RUA CEL JUCA',
  },
  {
    name: 'RUA JUAZEIRO DO NORTE',
  },
  {
    name: 'RUA EST JUCA D45',
  },
  {
    name: 'RUA COM JOSE PEQUENO',
  },
  {
    name: 'RUA SAO JUDAS TADEU D08',
  },
  {
    name: 'RUA STA JULIA',
  },
  {
    name: 'RUA JULIA VASCONCELOS',
  },
  {
    name: 'VL JULIETA',
  },
  {
    name: 'RUA JULIO ABREU',
  },
  {
    name: 'RUA ALCINO GUANABARA',
  },
  {
    name: 'RUA JULIO AZEVEDO',
  },
  {
    name: 'RUA JULIO BRAGA',
  },
  {
    name: 'TR JULIO BRAGA',
  },
  {
    name: 'RUA SAO JOSE D22',
  },
  {
    name: 'RUA JULIO CESAR D12',
  },
  {
    name: 'RUA JULIO CESAR D04',
  },
  {
    name: 'RUA JULIO GASPAR',
  },
  {
    name: 'RUA JULIO IBIAPINA',
  },
  {
    name: 'RUA JULIO LIMA',
  },
  {
    name: 'RUA GUILHERME V DA COSTA',
  },
  {
    name: 'RUA JULIO PINTO D04',
  },
  {
    name: 'TR JULIO RIBEIRO',
  },
  {
    name: 'RUA JUNIOR ROCHA',
  },
  {
    name: 'RUA JULIO SIQUEIRA',
  },
  {
    name: 'TR BEATRIZ SIQUEIRA',
  },
  {
    name: 'RUA JULIO DA SILVEIRA',
  },
  {
    name: 'AV JULIO VENTURA',
  },
  {
    name: 'RUA JULIO VERNE',
  },
  {
    name: 'RUA JUNDIAI',
  },
  {
    name: 'RUA TEN JURANDIR ALENCAR',
  },
  {
    name: 'RUA PRO JUREMA',
  },
  {
    name: 'RUA JURITI',
  },
  {
    name: 'RUA RIO JURUA',
  },
  {
    name: 'RUA DES JUCA FILHO',
  },
  {
    name: 'RUA DR JUSTA ARAUJO D45',
  },
  {
    name: 'RUA JUSTINIANO DE SERPA',
  },
  {
    name: 'RUA PDE JUSTINO',
  },
  {
    name: 'RUA JUVENAL DE CARVALHO',
  },
  {
    name: 'RUA JUVENAL GALENO',
  },
  {
    name: 'RUA JUVENCIO BARROSO',
  },
  {
    name: 'AV K CJ JOSE WALTER',
  },
  {
    name: 'AV BEIRA MAR',
  },
  {
    name: 'AV L CJ JOSE WALTER',
  },
  {
    name: 'AV L CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA COS LAFAYETE',
  },
  {
    name: 'RUA EVILASIO A MIRANDA',
  },
  {
    name: 'PR LAGOINHA',
  },
  {
    name: 'RUA LANDISLAU LOURENCO',
  },
  {
    name: 'RUA LARGA',
  },
  {
    name: 'RUA MAJ LAURINDO',
  },
  {
    name: 'RUA LAURO MAIA',
  },
  {
    name: 'RUA LAURO NOGUEIRA',
  },
  {
    name: 'AV LAURO VIEIRA CHAVES',
  },
  {
    name: 'RUA LAVRAS DA MANGABEIRA',
  },
  {
    name: 'RUA SAO LAZARO',
  },
  {
    name: 'RUA LEANDRO MONTEIRO',
  },
  {
    name: 'AV ENG LEAL LIMA VERDE (SAPIRANGA/COITE)',
  },
  {
    name: 'RUA LEAO DO NORTE',
  },
  {
    name: 'RUA LEAO TREZE',
  },
  {
    name: 'RUA LEAO VELOSO',
  },
  {
    name: 'RUA LEBOM MAIA',
  },
  {
    name: 'RUA LEBRE',
  },
  {
    name: 'RUA LEDA',
  },
  {
    name: 'AV LEITE BARBOSA',
  },
  {
    name: 'RUA CEL LEOCADIO',
  },
  {
    name: 'RUA LEON GRADVOHL',
  },
  {
    name: 'RUA LEONARDO MOTA',
  },
  {
    name: 'RUA LEONCIO TABOSA',
  },
  {
    name: 'RUA LEONEL CHAVES',
  },
  {
    name: 'RUA DNA LEOPOLDINA',
  },
  {
    name: 'RUA MON LEOPOLDO FEITOSA',
  },
  {
    name: 'RUA PDE LEOPOLDO FERNANDES',
  },
  {
    name: 'RUA LERIA DE ANDRADE',
  },
  {
    name: 'VL COS LAFAYETE',
  },
  {
    name: 'RUA MON LIBERATO',
  },
  {
    name: 'RUA LIBERATO BARROSO',
  },
  {
    name: 'PR LIBERTADORES',
  },
  {
    name: 'RUA LIBANIA (SERRINHA)',
  },
  {
    name: 'TR LIDICE',
  },
  {
    name: 'RUA STA LIDUINA D42',
  },
  {
    name: 'RUA STA LIGIA',
  },
  {
    name: 'RUA GAL LIMA E SILVA',
  },
  {
    name: 'RUA CON LIMA SUCUPIRA',
  },
  {
    name: 'RUA LIMOEIRO DO NORTE',
  },
  {
    name: 'RUA LINDOLFO FREIRE',
  },
  {
    name: 'RUA LINEU JUCA',
  },
  {
    name: 'AV LINEU MACHADO',
  },
  {
    name: 'RUA CEL LINHARES',
  },
  {
    name: 'RUA DOM LINO',
  },
  {
    name: 'RUA PRO LINO ENCARNACAO',
  },
  {
    name: 'RUA LINS DO REGO',
  },
  {
    name: 'RUA LIRIO',
  },
  {
    name: 'AL LIRIOS',
  },
  {
    name: 'TR ZUILA GADELHA',
  },
  {
    name: 'AV TEN LISBOA',
  },
  {
    name: 'RUA LITO',
  },
  {
    name: 'RUA LIVINO DE CARVALHO',
  },
  {
    name: 'RUA LIVIO BARRETO',
  },
  {
    name: 'RUA LONDRINA',
  },
  {
    name: 'RUA NERI CAMELO',
  },
  {
    name: 'RUA LOPES FILHO',
  },
  {
    name: 'RUA LOPES TROVAO',
  },
  {
    name: 'RUA LORENA',
  },
  {
    name: 'RUA LOURENCO FEITOSA',
  },
  {
    name: 'RUA STA LUCIA',
  },
  {
    name: 'TR STA LUCIA D20',
  },
  {
    name: 'AV LUCIANO CARNEIRO',
  },
  {
    name: 'RUA VER PEDRO PAULO MOREIRA',
  },
  {
    name: 'RUA LUCIANO DE QUEIROS',
  },
  {
    name: 'RUA LUCIOLA',
  },
  {
    name: 'AV DOM LUIS',
  },
  {
    name: 'VL SAO LUIS D06',
  },
  {
    name: 'RUA SAO LUIZ DO OESTE',
  },
  {
    name: 'TR SAO LUIS D41',
  },
  {
    name: 'RUA SAO LUIS D30',
  },
  {
    name: 'RUA LUIS ALVES MAIA',
  },
  {
    name: 'RD BR 222',
  },
  {
    name: 'RUA LUIS DE CASTRO',
  },
  {
    name: 'RUA LUIS DE MIRANDA',
  },
  {
    name: 'RUA SAO LUIS DO CURU',
  },
  {
    name: 'RUA PDE LUIS FIGUEIRA',
  },
  {
    name: 'RUA LUIS GUIMARAES',
  },
  {
    name: 'TR LUIS GUIMARAES',
  },
  {
    name: 'RUA LUIS HORTENCIO',
  },
  {
    name: 'RUA LUIS MENDES',
  },
  {
    name: 'RUA DES LUIS PAULINO',
  },
  {
    name: 'RUA COM LUIS RIBEIRO',
  },
  {
    name: 'RUA MON LUIS ROCHA',
  },
  {
    name: 'RUA LUIS SARAIVA',
  },
  {
    name: 'RUA LUIS TORRES',
  },
  {
    name: 'RUA LUIS VIEIRA',
  },
  {
    name: 'AV ENG LUIS VIEIRA',
  },
  {
    name: 'RUA LUIS TIBURCIO',
  },
  {
    name: 'RUA LUXEMBURGO',
  },
  {
    name: 'TR JOAO CRISPIM 65',
  },
  {
    name: 'RUA LUZIA MOREIRA',
  },
  {
    name: 'AV M CJ JOSE WALTER',
  },
  {
    name: 'RUA MACAPA',
  },
  {
    name: 'RUA PDE MACEDO',
  },
  {
    name: 'RUA DR LUIS MORAES CORREIA',
  },
  {
    name: 'RUA MACEIO',
  },
  {
    name: 'RUA COM MACHADO D12',
  },
  {
    name: 'RUA SEN MACHADO D48',
  },
  {
    name: 'RUA MACHADO DE ASSIS',
  },
  {
    name: 'TR MAGALHAES',
  },
  {
    name: 'RUA MAGNOLIA',
  },
  {
    name: 'RUA MAGUARI',
  },
  {
    name: 'RUA MALMEQUER',
  },
  {
    name: 'RUA MANACA',
  },
  {
    name: 'RUA MANAUS',
  },
  {
    name: 'RUA MANDACARUS D68',
  },
  {
    name: 'RUA FRE MANSUETO',
  },
  {
    name: 'AV DOM MANUEL',
  },
  {
    name: 'RUA ROSA CRUZ',
  },
  {
    name: 'RUA CEL MANUEL ALBANO',
  },
  {
    name: 'RUA MANUEL CASTELO BRANCO',
  },
  {
    name: 'RUA MANUEL COCO',
  },
  {
    name: 'RUA DOM MANUEL DE MEDEIROS',
  },
  {
    name: 'RUA MANUEL GADELHA',
  },
  {
    name: 'RUA MANUEL JACARE',
  },
  {
    name: 'RUA MANUEL JESUINO',
  },
  {
    name: 'RUA MANUEL MONTEIRO',
  },
  {
    name: 'RUA MANUEL NUNES',
  },
  {
    name: 'TR MANUEL NUNES',
  },
  {
    name: 'RUA MANUEL PADILHA',
  },
  {
    name: 'RUA PDE MANUEL PRIMO',
  },
  {
    name: 'RUA MANUEL DE QUEIROZ',
  },
  {
    name: 'TR MANOEL R MONTEIRO',
  },
  {
    name: 'RUA MANUEL RANGEL',
  },
  {
    name: 'RUA MANUEL RODRIGUES',
  },
  {
    name: 'RUA MANUEL SATIRO',
  },
  {
    name: 'RUA DR MANUEL SOARES',
  },
  {
    name: 'RUA MANUEL TEOFILO',
  },
  {
    name: 'RUA MANUELITO MOREIRA',
  },
  {
    name: 'RUA MARACANA',
  },
  {
    name: 'RUA BENJAMIN CARNEIRO GIRAO',
  },
  {
    name: 'TR MARANGUAPE D01',
  },
  {
    name: 'RUA MARANHAO',
  },
  {
    name: 'RUA MARAVILHA',
  },
  {
    name: 'RUA CAP MANOEL A DE CARVALHO',
  },
  {
    name: 'RUA FRE MARCELINO',
  },
  {
    name: 'RUA TARCISIO BONFIM',
  },
  {
    name: 'RUA MARCILIO DIAS',
  },
  {
    name: 'RUA MARCOS D38',
  },
  {
    name: 'RUA MARCONDES PEREIRA',
  },
  {
    name: 'RUA MARCONI',
  },
  {
    name: 'RUA MARCOS MACEDO',
  },
  {
    name: 'RUA DOM MARCOS TEIXEIRA',
  },
  {
    name: 'RUA STA MARGARIDA',
  },
  {
    name: 'RUA MARGARIDA DE QUEIROZ',
  },
  {
    name: 'RUA MARGARIDA MARIA',
  },
  {
    name: 'AL MARGARIDAS',
  },
  {
    name: 'RUA STA MARIA D11',
  },
  {
    name: 'RUA MARIA CLARA',
  },
  {
    name: 'RUA MARIA DA C PONCIANO',
  },
  {
    name: 'AL MARIA DA GLORIA',
  },
  {
    name: 'VL MARIA DAS GRACAS',
  },
  {
    name: 'RUA MARIA DE SOUSA',
  },
  {
    name: 'AL MARIA DORALICE',
  },
  {
    name: 'RUA MARIA ISABEL',
  },
  {
    name: 'RUA MARIA J. PESSOA',
  },
  {
    name: 'RUA MARIA JOSE TEIXEIRA',
  },
  {
    name: 'RUA MARIA JULIA',
  },
  {
    name: 'RUA MARIA LUIZA',
  },
  {
    name: 'AL MARIA TERESA',
  },
  {
    name: 'RUA MARIA TOMASIA',
  },
  {
    name: 'RUA MARILIA DE DIRCEU',
  },
  {
    name: 'RUA MARIO CAMPOS',
  },
  {
    name: 'RUA MARIO DA SILVEIRA',
  },
  {
    name: 'RUA MARIO DE ANDRADE',
  },
  {
    name: 'RUA MARIO FILHO',
  },
  {
    name: 'RUA GAL MARIO HERMES',
  },
  {
    name: 'AV MARIO LINHARES (SAPIRANGA)',
  },
  {
    name: 'RUA MARIO MAMEDE',
  },
  {
    name: 'RUA DR MARIO MARTINS COELHO',
  },
  {
    name: 'VL MARIA JOSE',
  },
  {
    name: 'RUA MARIO STUDART',
  },
  {
    name: 'RUA MAPIUNGA',
  },
  {
    name: 'RUA DNA MAROQUINHA',
  },
  {
    name: 'RUA TEN MARQUES',
  },
  {
    name: 'RUA MARTINHO RODRIGUES',
  },
  {
    name: 'RUA MARTINOPOLIS',
  },
  {
    name: 'RUA MARTINS NETO',
  },
  {
    name: 'RUA MARVIN',
  },
  {
    name: 'RUA SAO MATEUS D14',
  },
  {
    name: 'RUA MATEUS SOARES',
  },
  {
    name: 'RUA MATIAS ALBUQUERQUE',
  },
  {
    name: 'RUA MATIAS BECK',
  },
  {
    name: 'RUA MATO GROSSO',
  },
  {
    name: 'RUA PDE MATOS SERRA',
  },
  {
    name: 'RUA MATOS VASCONCELOS',
  },
  {
    name: 'RUA DEP MATOSO FILHO',
  },
  {
    name: 'RUA MATOS BELO',
  },
  {
    name: 'RUA VIS MAUA',
  },
  {
    name: 'RUA DOM MAURICIO',
  },
  {
    name: 'RUA MAURITI',
  },
  {
    name: 'TR MAURITI',
  },
  {
    name: 'RUA MAXIMINO BARRETO',
  },
  {
    name: 'RUA PDE MAXIMO FEITOSA',
  },
  {
    name: 'RUA MAXIMO LINHARES',
  },
  {
    name: 'RUA MEXICO',
  },
  {
    name: 'RUA MEDIANEIRA',
  },
  {
    name: 'RUA CAP MELO',
  },
  {
    name: 'RUA MELO CESAR',
  },
  {
    name: 'RUA MELO DE OLIVEIRA',
  },
  {
    name: 'AV ENG MELO NUNES',
  },
  {
    name: 'RUA MELQUIADES PINTO',
  },
  {
    name: 'RUA MELVIN JONES',
  },
  {
    name: 'RUA MEM DE SA',
  },
  {
    name: 'RUA ASP MENDES',
  },
  {
    name: 'RUA MENDES GUIMARAES',
  },
  {
    name: 'RUA DNA MENDINHA',
  },
  {
    name: 'RUA MENEZES DE OLIVEIRA',
  },
  {
    name: 'TR SAO MATEUS D14',
  },
  {
    name: 'RUA MERUOCA',
  },
  {
    name: 'VL MARTA',
  },
  {
    name: 'RUA METON DE ALENCAR',
  },
  {
    name: 'RUA LICURGO MONTENEGRO',
  },
  {
    name: 'RUA MON DOURADO D51',
  },
  {
    name: 'RUA MIGUEL COUTO',
  },
  {
    name: 'AV MIGUEL DIAS',
  },
  {
    name: 'RUA MIGUEL GONCALVES',
  },
  {
    name: 'RUA MIGUEL GUSTAVO',
  },
  {
    name: 'RUA PDE MIGUELINHO',
  },
  {
    name: 'RUA MILAGRES',
  },
  {
    name: 'RUA MIMOSA',
  },
  {
    name: 'RUA MINAS GERAIS',
  },
  {
    name: 'RUA MINERVA',
  },
  {
    name: 'RUA MINERVINO DE CASTRO',
  },
  {
    name: 'RUA SAUDARIA',
  },
  {
    name: 'AL MIOSOTIS',
  },
  {
    name: 'RUA MIRACEMA',
  },
  {
    name: 'RUA GAL MELO MACHADO',
  },
  {
    name: 'RUA MIRTES CORDEIRO',
  },
  {
    name: 'RUA MIRTES ROCHA',
  },
  {
    name: 'RUA MISSAO VELHA',
  },
  {
    name: 'VL MOTA',
  },
  {
    name: 'RUA MOACIR',
  },
  {
    name: 'RUA MOACIR MACHADO',
  },
  {
    name: 'RUA TEN MOACIR MATOS',
  },
  {
    name: 'RUA MUCAMBINHO (MESSEJANA)',
  },
  {
    name: 'RUA MONTE LIBANO',
  },
  {
    name: 'RUA MONACO',
  },
  {
    name: 'RUA MOMBACA',
  },
  {
    name: 'RUA EPAMINONDAS OLIVEIRA',
  },
  {
    name: 'RUA MONICA',
  },
  {
    name: 'AV COS GOMES DE FREITAS (SAPIRANGA/COITE)',
  },
  {
    name: 'RUA MONTE CLARO',
  },
  {
    name: 'RUA MONTE SERRAT',
  },
  {
    name: 'RUA MONTEIRO LOBATO',
  },
  {
    name: 'RUA MAJ MONTENEGRO',
  },
  {
    name: 'RUA MONTEVIDEU',
  },
  {
    name: 'RUA PRO MORAIS CORREIA',
  },
  {
    name: 'RUA MORAUJO',
  },
  {
    name: 'AV DES MOREIRA',
  },
  {
    name: 'RUA MAJ MOREIRA',
  },
  {
    name: 'RUA MOREIRA DA ROCHA',
  },
  {
    name: 'RUA DEP MOREIRA DA ROCHA',
  },
  {
    name: 'RUA MOREIRA DE SOUSA',
  },
  {
    name: 'VL MARIANA',
  },
  {
    name: 'RUA MOREIRA GOMES',
  },
  {
    name: 'RUA MORENINHA IRINEU',
  },
  {
    name: 'RUA PDE MORORO',
  },
  {
    name: 'RUA NONATO FARIAS',
  },
  {
    name: 'RUA DR PEDRO TELES',
  },
  {
    name: 'RUA CON MOURAO',
  },
  {
    name: 'RUA MOZART FIRMEZA',
  },
  {
    name: 'RUA CEL MOZART GONDIM',
  },
  {
    name: 'AV MOZART PINHEIRO DE LUCENA',
  },
  {
    name: 'RUA MOZART PINTO',
  },
  {
    name: 'RUA MUCUNA',
  },
  {
    name: 'RUA MUNDAU',
  },
  {
    name: 'RUA MUNDICA PAULA',
  },
  {
    name: 'RUA GAL MUNIZ ARAGAO',
  },
  {
    name: 'RUA MUNIZ FREIRE',
  },
  {
    name: 'RUA MURILO BORGES',
  },
  {
    name: 'RUA MURITIAPUA',
  },
  {
    name: 'RUA MORUMBI',
  },
  {
    name: 'AV N CJ JOSE WALTER',
  },
  {
    name: 'VL NADIR',
  },
  {
    name: 'AL NADJA',
  },
  {
    name: 'RUA MAL NAPION',
  },
  {
    name: 'VL NESTOR GURGEL',
  },
  {
    name: 'RUA NAPOLEAO LAUREANO',
  },
  {
    name: 'RUA PEDRO MIGUEL',
  },
  {
    name: 'RUA TEN NAPOLEAO RANGEL',
  },
  {
    name: 'RUA NATAL',
  },
  {
    name: 'RUA LIMA DUARTE',
  },
  {
    name: 'TR ITURAMA',
  },
  {
    name: 'VL NAZIRA',
  },
  {
    name: 'RUA PRO NELSON',
  },
  {
    name: 'RUA NELSON MACHADO',
  },
  {
    name: 'RUA NENZINHA PARENTE',
  },
  {
    name: 'RUA NEREIDE',
  },
  {
    name: 'RUA NEREU RAMOS',
  },
  {
    name: 'RUA NERYS NELSON',
  },
  {
    name: 'RUA NESTOR BARBOSA',
  },
  {
    name: 'RUA CAP NESTOR GOIS',
  },
  {
    name: 'RUA NETUNO',
  },
  {
    name: 'RUA NEWTON CRAVEIRO',
  },
  {
    name: 'RUA NICOLAU COELHO',
  },
  {
    name: 'TR NICODEMOS',
  },
  {
    name: 'RUA PRO EDGAR DE ARRUDA',
  },
  {
    name: 'RUA PDE NOBREGA',
  },
  {
    name: 'RUA NOCA BEZERRA',
  },
  {
    name: 'RUA NOEL ROSA',
  },
  {
    name: 'RUA CAP NOGUEIRA',
  },
  {
    name: 'RUA PRO NOGUEIRA',
  },
  {
    name: 'TR PRO NOGUEIRA',
  },
  {
    name: 'RUA NOGUEIRA ACIOLI',
  },
  {
    name: 'TR NOGUEIRA ACIOLI',
  },
  {
    name: 'RUA CEL NOGUEIRA PAES',
  },
  {
    name: 'RUA NORUEGA',
  },
  {
    name: 'RUA NORVINDA PIRES',
  },
  {
    name: 'VL NOSSA SRA DA PIEDADE',
  },
  {
    name: 'RUA NOSSA SRA CONCEICAO',
  },
  {
    name: 'RUA NOSSA SRA DA PIEDADE',
  },
  {
    name: 'RUA DIVINO SALVADOR D26',
  },
  {
    name: 'TR NOSSA SRA DO CARMO',
  },
  {
    name: 'RUA NOSSA SRA REMEDIOS',
  },
  {
    name: 'RUA NOSSA SRA DA PAZ',
  },
  {
    name: 'RUA NOSSA SRA DAS DORES',
  },
  {
    name: 'VL NOSSA SRA DE FATIMA',
  },
  {
    name: 'TR NOSSA SRA DAS GRACAS',
  },
  {
    name: 'RUA NOSSA SRA DAS GRACAS',
  },
  {
    name: 'TR NOSSA SRA DAS GRACAS',
  },
  {
    name: 'RUA NOVA AURORA',
  },
  {
    name: 'TR NOVA BRASILIA',
  },
  {
    name: 'RUA NOVA ESPERANCA',
  },
  {
    name: 'TR NOVA ESPERANCA',
  },
  {
    name: 'TR NOVA OLINDA',
  },
  {
    name: 'RUA NOVA RESENDE',
  },
  {
    name: 'TR NOVA RUSSAS',
  },
  {
    name: 'RUA DES JOSE GIL DE CARVALHO',
  },
  {
    name: 'RUA 9 CJ JOSE WALTER',
  },
  {
    name: 'AL NOVE HORAS',
  },
  {
    name: 'RUA 95 CJ JOSE WALTER',
  },
  {
    name: 'RUA 99 CJ JOSE WALTER',
  },
  {
    name: 'RUA 97 CJ JOSE WALTER',
  },
  {
    name: 'RUA 93 CJ JOSE WALTER',
  },
  {
    name: 'RUA 91 CJ JOSE WALTER',
  },
  {
    name: 'RUA WALDER STUDART',
  },
  {
    name: 'RUA CEL NUNES DE MELO',
  },
  {
    name: 'RUA NUNES VALENTE',
  },
  {
    name: 'AV O CJ JOSE WALTER',
  },
  {
    name: 'RUA FRE ODILON',
  },
  {
    name: 'TR FRE ODILON',
  },
  {
    name: 'RUA ODILON SOARES',
  },
  {
    name: 'RUA ODORICO DE MORAIS',
  },
  {
    name: 'VL ODETE',
  },
  {
    name: 'RUA 85 CJ JOSE WALTER',
  },
  {
    name: 'RUA 89 CJ JOSE WALTER',
  },
  {
    name: 'RUA 87 CJ JOSE WALTER',
  },
  {
    name: 'RUA 83 CJ JOSE WALTER',
  },
  {
    name: 'RUA 81 CJ JOSE WALTER',
  },
  {
    name: 'RUA OITICICAS',
  },
  {
    name: 'RUA OITIS JOSE',
  },
  {
    name: 'RUA 8 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 8 CJ JOSE WALTER',
  },
  {
    name: 'TR 8 DE MAIO',
  },
  {
    name: 'RUA 8 DE SETEMBRO',
  },
  {
    name: 'RUA CAP OLAVO',
  },
  {
    name: 'AV OLAVO BILAC',
  },
  {
    name: 'RUA OLAVO DE ANDRADE',
  },
  {
    name: 'RUA CEL OLEGARIO MEMORIA',
  },
  {
    name: 'RUA OLGA BARROSO',
  },
  {
    name: 'RUA OLIMPIO DE PAIVA',
  },
  {
    name: 'TR OLIMPIO DE PAIVA',
  },
  {
    name: 'RUA OLIMPIO LEITE',
  },
  {
    name: 'RUA ARI DA SILVA MARINHO',
  },
  {
    name: 'RUA 8 DE DEZEMBRO',
  },
  {
    name: 'RUA OLIVEIRA FILHO',
  },
  {
    name: 'AV OLIVEIRA PAIVA',
  },
  {
    name: 'RUA OLIVEIRA SOBRINHO',
  },
  {
    name: 'RUA OLIVEIRA VIANA',
  },
  {
    name: 'RUA OLIVIO CAMARA',
  },
  {
    name: 'RUA ESTRELA DO NORTE',
  },
  {
    name: 'RUA OMAR PAIVA',
  },
  {
    name: 'RUA WALDEMAR ALCANTARA',
  },
  {
    name: 'RUA ONIX',
  },
  {
    name: 'RUA GAL ONOFRE',
  },
  {
    name: 'RUA 11 CJ JOSE WALTER',
  },
  {
    name: 'TR 11 DE JULHO',
  },
  {
    name: 'RUA 11 DE JULHO',
  },
  {
    name: 'RUA ONZE HORAS',
  },
  {
    name: 'AL ONZE HORAS',
  },
  {
    name: 'RUA ORIENTE D21',
  },
  {
    name: 'RUA FRE ORLANDO',
  },
  {
    name: 'RUA ANA BEZERRA',
  },
  {
    name: 'AL ORQUIDEAS',
  },
  {
    name: 'RUA JULIO PINTO D08',
  },
  {
    name: 'RUA OSASCO',
  },
  {
    name: 'RUA OSCAR ARARIPE',
  },
  {
    name: 'RUA OSCAR FRANCA',
  },
  {
    name: 'RUA OSCAR LEITAO',
  },
  {
    name: 'RUA OSCAR LOPES',
  },
  {
    name: 'RUA OSMUNDO CAVALCANTE',
  },
  {
    name: 'AV GAL OSORIO DE PAIVA',
  },
  {
    name: 'RUA OSORIO PALMELLA',
  },
  {
    name: 'RUA OSVALDO ARANHA',
  },
  {
    name: 'RUA OSVALDO CRUZ (ALDEOTA)',
  },
  {
    name: 'RUA OSVALDO FIGUEIREDO',
  },
  {
    name: 'RUA OSVALDO LIMA',
  },
  {
    name: 'RUA DEP OSWALDO STUDART',
  },
  {
    name: 'RUA MON OTAVIO CASTRO',
  },
  {
    name: 'RUA OTAVIO FILOMENO',
  },
  {
    name: 'RUA 8 DE JULHO',
  },
  {
    name: 'RUA OTAVIO JUSTA',
  },
  {
    name: 'RUA PRO OTAVIO LOBO',
  },
  {
    name: 'RUA OTAVIO PARANHOS',
  },
  {
    name: 'RUA OTILIA CARVALHO',
  },
  {
    name: 'RUA OTO DE ALENCAR',
  },
  {
    name: 'RUA OTONI FACANHA DE SA',
  },
  {
    name: 'RUA OURO BRANCO',
  },
  {
    name: 'RUA OUTONO',
  },
  {
    name: 'RUA DOS PACAJUS',
  },
  {
    name: 'RUA PACATUBA',
  },
  {
    name: 'AL PACAVIRAS',
  },
  {
    name: 'RUA PACOTI',
  },
  {
    name: 'RUA PACUJA',
  },
  {
    name: 'AV PRS JUSCELINO KUBITSCHEK (PASSARÉ)',
  },
  {
    name: 'RUA PAIOL',
  },
  {
    name: 'RUA PAJE',
  },
  {
    name: 'AV PALESTINA D68',
  },
  {
    name: 'RUA PALESTINA D65',
  },
  {
    name: 'RUA PALMACIA',
  },
  {
    name: 'RUA PALMIRA',
  },
  {
    name: 'RUA PANAMA',
  },
  {
    name: 'RUA PAPI JUNIOR',
  },
  {
    name: 'AL PAPOULAS',
  },
  {
    name: 'RUA JOSE CARLOS GURGEL NOGUEIRA',
  },
  {
    name: 'RUA PARA',
  },
  {
    name: 'TR PARA',
  },
  {
    name: 'RUA PARACURU',
  },
  {
    name: 'RUA PARAGUACU D45',
  },
  {
    name: 'RUA PARAGUAI',
  },
  {
    name: 'RUA PARAIBA',
  },
  {
    name: 'RUA NENEN G BARREIRA',
  },
  {
    name: 'RUA PARANA',
  },
  {
    name: 'AV DR SILAS MUNGUBA',
  },
  {
    name: 'AV PAROARAS',
  },
  {
    name: 'TR PARQUELANDIA',
  },
  {
    name: 'RUA PASCOAL CASTRO ALVES',
  },
  {
    name: 'AV PASTEUR',
  },
  {
    name: 'RUA PATRIOLINO AGUIAR',
  },
  {
    name: 'RUA PAU BRASIL',
  },
  {
    name: 'RUA PAULA BARROS',
  },
  {
    name: 'RUA PAULA NEI',
  },
  {
    name: 'RUA PAULA RODRIGUES',
  },
  {
    name: 'RUA PDE PAULINO',
  },
  {
    name: 'RUA PAULINO NOGUEIRA',
  },
  {
    name: 'RUA SAO PAULO',
  },
  {
    name: 'RUA PAULO CANDIDO',
  },
  {
    name: 'TR PAULO ARAUJO',
  },
  {
    name: 'RUA CREUSA ROQUE',
  },
  {
    name: 'RUA PAULO FIRMEZA',
  },
  {
    name: 'RUA PAULO DE FRONTIM',
  },
  {
    name: 'RUA DR PAULO MARCELO',
  },
  {
    name: 'RUA PAULO SETUBAL',
  },
  {
    name: 'TR PAULO SEXTO',
  },
  {
    name: 'RUA PAURILO BARROSO',
  },
  {
    name: 'TR PAZ D48',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA SAO PEDRO D40',
  },
  {
    name: 'TR SAO PEDRO D34',
  },
  {
    name: 'RUA PEDRO A ALBUQUERQUE',
  },
  {
    name: 'RUA PEDRO AGUIAR',
  },
  {
    name: 'RUA PEDRO AMERICO',
  },
  {
    name: 'RUA PEDRO ANGELO',
  },
  {
    name: 'RUA PEDRO ARTUR',
  },
  {
    name: 'RUA DR PEDRO BORGES',
  },
  {
    name: 'RUA PEDRO CAMELO',
  },
  {
    name: 'RUA PEDRO DANTAS',
  },
  {
    name: 'RUA PDE PEDRO DE ALENCAR',
  },
  {
    name: 'RUA PEDRO DE ARAUJO',
  },
  {
    name: 'RUA PEDRO FERREIRA',
  },
  {
    name: 'RUA PEDRO FIRMEZA',
  },
  {
    name: 'RUA PEDRO MACHADO',
  },
  {
    name: 'RUA PEDRO MEDEIROS',
  },
  {
    name: 'RUA PEDRO MELO',
  },
  {
    name: 'RUA PEDRO MUNIZ',
  },
  {
    name: 'RUA DR ALFREDO WEYNE D14',
  },
  {
    name: 'RUA PEDRO PEREIRA',
  },
  {
    name: 'RUA PEDRO PONCIANO',
  },
  {
    name: 'RUA PEDRO I',
  },
  {
    name: 'RUA PEDRO DE QUEIROZ',
  },
  {
    name: 'RUA PEDRO RIQUET',
  },
  {
    name: 'RUA DR PEDRO ROCHA',
  },
  {
    name: 'RUA PEDRO RUFINO D48',
  },
  {
    name: 'RUA MAJ PEDRO SAMPAIO',
  },
  {
    name: 'RUA PEDRO VERISSIMO',
  },
  {
    name: 'RUA DR PEDRO WILSON D45',
  },
  {
    name: 'TR CON PENAFORT',
  },
  {
    name: 'RUA CON PENAFORT',
  },
  {
    name: 'RUA PENTECOSTE',
  },
  {
    name: 'RUA PERBOYRE SILVA',
  },
  {
    name: 'RUA FIS PERDIGAO',
  },
  {
    name: 'TR PERDIGAO DE OLIVEIRA',
  },
  {
    name: 'RUA PERDIGAO DE OLIVEIRA',
  },
  {
    name: 'RUA PDE PERDIGAO SAMPAIO',
  },
  {
    name: 'RUA PEREIRA FILGUEIRAS',
  },
  {
    name: 'RUA PEREIRA DE MIRANDA',
  },
  {
    name: 'RUA PEREIRA VALENTE',
  },
  {
    name: 'RUA PEREIRO',
  },
  {
    name: 'RUA PERGENTINO FERREIRA',
  },
  {
    name: 'RUA PERGENTINO MAIA',
  },
  {
    name: 'RUA PERI',
  },
  {
    name: 'RUA DR PERIGUARI',
  },
  {
    name: 'AV PERIMETRAL',
  },
  {
    name: 'RUA PERNAMBUCO',
  },
  {
    name: 'RUA PERO COELHO',
  },
  {
    name: 'RUA DOM PERO FERNANDES',
  },
  {
    name: 'RUA PERO VAZ',
  },
  {
    name: 'RUA JOAO P NOGUEIRA',
  },
  {
    name: 'RUA PERU',
  },
  {
    name: 'TR PERU',
  },
  {
    name: 'RUA PESSOA ANTA',
  },
  {
    name: 'RUA PIAUI',
  },
  {
    name: 'ET PICI',
  },
  {
    name: 'RUA PIERRE LUZ',
  },
  {
    name: 'RUA PINDORAMA',
  },
  {
    name: 'RUA ESV PINHEIRO',
  },
  {
    name: 'RUA PINHEIRO BASTOS',
  },
  {
    name: 'RUA PINHO PESSOA',
  },
  {
    name: 'RUA ENF JOAQUIM PINTO',
  },
  {
    name: 'RUA PINTO MADEIRA',
  },
  {
    name: 'RUA CON PINTO MENDONCA',
  },
  {
    name: 'RUA PENAPOLIS',
  },
  {
    name: 'RUA GAL PIRAGIBE',
  },
  {
    name: 'AV MIN JOSE AMERICO',
  },
  {
    name: 'RUA PDE PITA',
  },
  {
    name: 'TR PITANGA D26',
  },
  {
    name: 'RUA PLACIDO CARVALHO',
  },
  {
    name: 'RUA PLACIDO DE CASTRO',
  },
  {
    name: 'RUA PLANALTINA (PL AYRTON SENNA)',
  },
  {
    name: 'RUA PLINIO SALGADO',
  },
  {
    name: 'RUA PLUTAO',
  },
  {
    name: 'RUA POCINHO',
  },
  {
    name: 'RUA POMAR',
  },
  {
    name: 'RUA POLONIA',
  },
  {
    name: 'RUA SEN POMPEU',
  },
  {
    name: 'RUA POMPEU CAVALCANTE',
  },
  {
    name: 'AV PONTES VIEIRA',
  },
  {
    name: 'RUA MOISES FERREIRA',
  },
  {
    name: 'RUA PORFIRIO SAMPAIO',
  },
  {
    name: 'RUA PORTO ALEGRE',
  },
  {
    name: 'RUA PORTO VELHO',
  },
  {
    name: 'RUA POTENGI D17',
  },
  {
    name: 'RUA POTI',
  },
  {
    name: 'TR POTIGUAR',
  },
  {
    name: 'RUA GAL TERTULIANO POTYGUARA',
  },
  {
    name: 'RUA DES PRAXEDES',
  },
  {
    name: 'RUA PRE NOVE',
  },
  {
    name: 'RUA PINTO MARTINS',
  },
  {
    name: 'RUA PRIMAVERA D40',
  },
  {
    name: 'RUA PRIMEIRO DE JANEIRO',
  },
  {
    name: 'RUA PRIMEIRO DE JUNHO',
  },
  {
    name: 'RUA PRIMEIRO DE MAIO D34',
  },
  {
    name: 'RUA PRIMEIRO DE NOVEMBRO',
  },
  {
    name: 'RUA PROCION',
  },
  {
    name: 'RUA PRS PRUDENTE',
  },
  {
    name: 'AV PRUDENTE BRASIL',
  },
  {
    name: 'TR PRUDENTE DE MORAIS',
  },
  {
    name: 'RUA PUPUNHA',
  },
  {
    name: 'RUA 40 CJ JOSE WALTER',
  },
  {
    name: 'RUA 45 CJ JOSE WALTER',
  },
  {
    name: 'RUA 42 CJ JOSE WALTER',
  },
  {
    name: 'RUA 49 CJ JOSE WALTER',
  },
  {
    name: 'RUA 48 CJ JOSE WALTER',
  },
  {
    name: 'RUA 44 CJ JOSE WALTER',
  },
  {
    name: 'RUA 46 CJ JOSE WALTER',
  },
  {
    name: 'RUA 47 CJ JOSE WALTER',
  },
  {
    name: 'RUA 43 CJ JOSE WALTER',
  },
  {
    name: 'RUA 43 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 41 CJ JOSE WALTER',
  },
  {
    name: 'RUA 41 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 14 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 14 DE MAIO',
  },
  {
    name: 'RUA 4 DE OUTUBRO',
  },
  {
    name: 'RUA QUATRO IRMAOS',
  },
  {
    name: 'RUA TEN QUEIROZ',
  },
  {
    name: 'RUA QUEIROZ RIBEIRO',
  },
  {
    name: 'TR QUEIROZ RIBEIRO',
  },
  {
    name: 'RUA PDE QUINDERE',
  },
  {
    name: 'RUA DOM QUINTINO',
  },
  {
    name: 'RUA QUINTINO BOCAIUVA',
  },
  {
    name: 'RUA QUINTINO CUNHA',
  },
  {
    name: 'TR QUINTINO CUNHA',
  },
  {
    name: 'RUA 15 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 15 CJ JOSE WALTER',
  },
  {
    name: 'RUA CASTRO MEIRELES',
  },
  {
    name: 'RUA 15 DE NOVEMBRO',
  },
  {
    name: 'RUA STA QUITERIA',
  },
  {
    name: 'RUA QUITO',
  },
  {
    name: 'RUA QUIXADA D06',
  },
  {
    name: 'RUA JOR OLAVO ARAUJO',
  },
  {
    name: 'RUA OSCAR PEDREIRA',
  },
  {
    name: 'RD CE-090',
  },
  {
    name: 'RUA COIMBRA',
  },
  {
    name: 'RUA SAO RAIMUNDO (PIRAMBU)',
  },
  {
    name: 'RUA SAO RAIMUNDO D49',
  },
  {
    name: 'RUA PRO RAIMUNDO ARRUDA',
  },
  {
    name: 'RUA RAIMUNDO BIZARRIA',
  },
  {
    name: 'RUA RAIMUNDO BRAZ',
  },
  {
    name: 'RUA RAIMUNDO CORREIA',
  },
  {
    name: 'RUA JOAO CAMINHA MUNIZ',
  },
  {
    name: 'RUA RAIMUNDO FROTA',
  },
  {
    name: 'RUA RAIMUNDO GOMES',
  },
  {
    name: 'TR RAIMUNDO JUNIOR',
  },
  {
    name: 'TR RAIMUNDO LOPES',
  },
  {
    name: 'RUA RAIMUNDO MAGALHAES',
  },
  {
    name: 'RUA RAIMUNDO NERY',
  },
  {
    name: 'RUA RAIMUNDO NOGUEIRA',
  },
  {
    name: 'RUA RAIMUNDO PINHEIRO',
  },
  {
    name: 'RUA RAIMUNDO R. MENEZES',
  },
  {
    name: 'RUA REPUBLICA',
  },
  {
    name: 'RUA RAIMUNDO RIBEIRO',
  },
  {
    name: 'TR RAIMUNDO VENTURA',
  },
  {
    name: 'RUA PRO RAIMUNDO VITOR',
  },
  {
    name: 'RUA RAMOS BOTELHO',
  },
  {
    name: 'RUA RAQUEL HOLANDA',
  },
  {
    name: 'RUA DR RATISBONA',
  },
  {
    name: 'RUA RAUL CABRAL',
  },
  {
    name: 'RUA RAUL POMPEIA',
  },
  {
    name: 'RUA RAUL UCHOA',
  },
  {
    name: 'RUA AUDISIO PINHEIRO',
  },
  {
    name: 'TR RECIFE',
  },
  {
    name: 'RUA REDENCAO',
  },
  {
    name: 'VL REGINA',
  },
  {
    name: 'RUA DOM REGO MEDEIROS',
  },
  {
    name: 'RUA CAB REIS',
  },
  {
    name: 'TR TIBIRICA',
  },
  {
    name: 'RUA RENATO BRAGA',
  },
  {
    name: 'RUA JUZ RENATO SILVA',
  },
  {
    name: 'RUA REPUBLICA DO LIBANO',
  },
  {
    name: 'RUA REPUBLICA DO PERU',
  },
  {
    name: 'RUA RERIUTABA',
  },
  {
    name: 'RUA REX',
  },
  {
    name: 'RUA RIACHUELO',
  },
  {
    name: 'RUA DR RIBAMAR LOBO',
  },
  {
    name: 'RUA RIBEIRAO PRETO',
  },
  {
    name: 'RUA FOT RIBEIRO',
  },
  {
    name: 'RUA CEL RIBEIRO DA SILVA',
  },
  {
    name: 'RUA RIBEIRO LEITAO',
  },
  {
    name: 'TR RINCAO',
  },
  {
    name: 'RUA RIO ARAGUAIA',
  },
  {
    name: 'RUA RIO BRANCO',
  },
  {
    name: 'RUA BAR RIO BRANCO',
  },
  {
    name: 'AV VIS RIO BRANCO',
  },
  {
    name: 'AV PINTO BANDEIRA D56',
  },
  {
    name: 'TR RIO DE JANEIRO',
  },
  {
    name: 'RUA PRO HERIBALDO COSTA',
  },
  {
    name: 'RUA RIO GRANDE DO NORTE',
  },
  {
    name: 'RUA RIO GRANDE DO SUL',
  },
  {
    name: 'RUA RIO MADEIRA',
  },
  {
    name: 'RUA RIO NEGRO',
  },
  {
    name: 'RUA RIO PARNAIBA',
  },
  {
    name: 'RUA RIO SOLIMOES',
  },
  {
    name: 'RUA RIO TAPAJOS',
  },
  {
    name: 'RUA RIO TIETE',
  },
  {
    name: 'RUA RIO TOCANTINS',
  },
  {
    name: 'RUA RISO DO PRADO',
  },
  {
    name: 'RUA STA RITA D30',
  },
  {
    name: 'VL RITA HELENA',
  },
  {
    name: 'RUA SEN ROBERT KENNEDY',
  },
  {
    name: 'RUA ROBERIO TAVORA',
  },
  {
    name: 'TR MON ROCHA',
  },
  {
    name: 'RUA ROCHA LIMA',
  },
  {
    name: 'RUA ROCHA POMBO',
  },
  {
    name: 'RUA PDE RODOLFO',
  },
  {
    name: 'RUA RONDONIA',
  },
  {
    name: 'RUA DR RODRIGO C SANDOVAL',
  },
  {
    name: 'RUA RODRIGUES ANDRADE',
  },
  {
    name: 'RUA RODRIGUES JUNIOR',
  },
  {
    name: 'AV ROGACIANO LEITE',
  },
  {
    name: 'VL SAO RAIMUNDO D26',
  },
  {
    name: 'RUA PDE ROMA',
  },
  {
    name: 'RUA TEN ROMA',
  },
  {
    name: 'RUA ROMENIA',
  },
  {
    name: 'RUA GAL ROMEL',
  },
  {
    name: 'VL ROMERO',
  },
  {
    name: 'RUA ROMEU MARTINS',
  },
  {
    name: 'RUA MAL RONDON',
  },
  {
    name: 'TR RIO SOLIMOES',
  },
  {
    name: 'RUA SAO ROQUE',
  },
  {
    name: 'RUA ROQUET PINTO',
  },
  {
    name: 'RUA RORAIMA',
  },
  {
    name: 'RUA MES ROSA',
  },
  {
    name: 'RUA MON ROSA D20/21',
  },
  {
    name: 'RUA STA ROSA D20/21 (JACARECANGA)',
  },
  {
    name: 'TR STA ROSA D38',
  },
  {
    name: 'RUA ROSA LEITE OLIVEIRA',
  },
  {
    name: 'AL ROSA MARIA',
  },
  {
    name: 'RUA STA ROSALIA',
  },
  {
    name: 'VL ROSINHA D06',
  },
  {
    name: 'AL ROSAS',
  },
  {
    name: 'TR ROSINHA D35',
  },
  {
    name: 'RUA ROSINHA SAMPAIO',
  },
  {
    name: 'TR CAMPOS MOURAO',
  },
  {
    name: 'RUA ROSITA',
  },
  {
    name: 'TR ROSITA',
  },
  {
    name: 'RUA ROTARY',
  },
  {
    name: 'RUA RUBENS MONTE D43',
  },
  {
    name: 'RUA RUBI',
  },
  {
    name: 'RUA ALM RUBIM',
  },
  {
    name: 'RUA ALM RUFINO',
  },
  {
    name: 'VL RUFINO COELHO',
  },
  {
    name: 'RUA RUFINO DE ALENCAR',
  },
  {
    name: 'AV RUI BARBOSA',
  },
  {
    name: 'RUA RUI MONTE',
  },
  {
    name: 'TR RUI MONTE',
  },
  {
    name: 'RUA RUSSAS',
  },
  {
    name: 'RUA RUTILO',
  },
  {
    name: 'RUA SEN SA',
  },
  {
    name: 'RUA PDE SA LEITAO',
  },
  {
    name: 'RUA SABIA',
  },
  {
    name: 'RUA DOS SABIAS',
  },
  {
    name: 'RUA SABINO BATISTA',
  },
  {
    name: 'RUA SABINO BORGES',
  },
  {
    name: 'RUA SABINO MONTE',
  },
  {
    name: 'RUA MON SABINO FEIJAO',
  },
  {
    name: 'RUA SABINO PIRES',
  },
  {
    name: 'TR BASTOS',
  },
  {
    name: 'RUA DR ALOISIO MAMEDE',
  },
  {
    name: 'RUA VIS SABOIA',
  },
  {
    name: 'RUA SAFIRA',
  },
  {
    name: 'RUA MON SALAZAR',
  },
  {
    name: 'RUA SALDANHA MARINHO',
  },
  {
    name: 'TR IGUATU D45',
  },
  {
    name: 'RUA TIP SALES',
  },
  {
    name: 'TR SALGADINHO',
  },
  {
    name: 'RUA SALGADO FILHO',
  },
  {
    name: 'RUA EURICO MEDINA',
  },
  {
    name: 'RUA SALVADOR MENDONCA',
  },
  {
    name: 'AV MON SALVIANO',
  },
  {
    name: 'RUA CEL SALVIANO LOPES',
  },
  {
    name: 'RUA GAL SAMPAIO',
  },
  {
    name: 'RUA GOV SAMPAIO',
  },
  {
    name: 'RUA CAP SAMPAIO ROCHA',
  },
  {
    name: 'RUA SAMUEL UCHOA',
  },
  {
    name: 'AL SANDRA MARA',
  },
  {
    name: 'TR SANTABAIA',
  },
  {
    name: 'RUA SANTANA D48',
  },
  {
    name: 'TR SANTANA D48',
  },
  {
    name: 'RUA SEN SANTANA D22',
  },
  {
    name: 'RUA SANTANA DO CARIRI',
  },
  {
    name: 'RUA SANTANA DO PARNAIBA',
  },
  {
    name: 'AV ENG SANTANA JUNIOR',
  },
  {
    name: 'RUA SANTIAGO',
  },
  {
    name: 'AV SANTOS DUMONT',
  },
  {
    name: 'RUA SATIRO DIAS',
  },
  {
    name: 'RUA CAP JOAO FERREIRA LIMA',
  },
  {
    name: 'RUA DA SAUDADE D04',
  },
  {
    name: 'TR DA SAUDADE D04',
  },
  {
    name: 'RUA SAO SEBASTIAO D62',
  },
  {
    name: 'RUA SAO SEBASTIAO D26',
  },
  {
    name: 'RUA SEBASTIAO DE ABREU',
  },
  {
    name: 'RUA DOM SEBASTIAO LEME',
  },
  {
    name: 'RUA SEIFERT',
  },
  {
    name: 'RUA 6 CJ JOSE WALTER',
  },
  {
    name: 'RUA SEIS COMPANHEIROS',
  },
  {
    name: 'RUA SEIXAS CORREIA',
  },
  {
    name: 'RUA SEMPREVIVA',
  },
  {
    name: 'RUA SENA MADUREIRA',
  },
  {
    name: 'RUA FRE SERAFIM',
  },
  {
    name: 'RUA SERENO',
  },
  {
    name: 'RUA SERGIPE',
  },
  {
    name: 'AV ENG SERRAINE',
  },
  {
    name: 'RUA PRO SERRAINE BEZERRA',
  },
  {
    name: 'RUA 60 CJ JOSE WALTER',
  },
  {
    name: 'RUA 65 CJ JOSE WALTER',
  },
  {
    name: 'RUA 62 CJ JOSE WALTER',
  },
  {
    name: 'RUA 69 CJ JOSE WALTER',
  },
  {
    name: 'RUA 64 CJ JOSE WALTER',
  },
  {
    name: 'RUA 66 CJ JOSE WALTER',
  },
  {
    name: 'RUA 67 CJ JOSE WALTER',
  },
  {
    name: 'RUA 63 CJ JOSE WALTER',
  },
  {
    name: 'RUA 61 CJ JOSE WALTER',
  },
  {
    name: 'RUA 7 CJ JOSE WALTER',
  },
  {
    name: 'RUA 7 DE ABRIL',
  },
  {
    name: 'RUA 7 DE SETEMBRO',
  },
  {
    name: 'RUA 7 DE MAIO',
  },
  {
    name: 'RUA 75 CJ JOSE WALTER',
  },
  {
    name: 'RUA 79 CJ JOSE WALTER',
  },
  {
    name: 'RUA 77 CJ JOSE WALTER',
  },
  {
    name: 'RUA 73 CJ JOSE WALTER',
  },
  {
    name: 'RUA 71 CJ JOSE WALTER',
  },
  {
    name: 'RUA PDE SEVERIANO',
  },
  {
    name: 'RUA SGT SILVA',
  },
  {
    name: 'RUA SILVA BAIMA',
  },
  {
    name: 'RUA SILVA JARDIM',
  },
  {
    name: 'RUA SILVA JATAHY',
  },
  {
    name: 'RUA GAL SILVA JUNIOR',
  },
  {
    name: 'RUA MAE SILVA NOVO',
  },
  {
    name: 'RUA SILVA PAULET',
  },
  {
    name: 'RUA SILVEIRA DA MOTA',
  },
  {
    name: 'RUA SILVEIRA FILHO',
  },
  {
    name: 'RUA SILVIA',
  },
  {
    name: 'RUA SILVIO ROMERO',
  },
  {
    name: 'RUA IRM SIMAS',
  },
  {
    name: 'TR SIMONE',
  },
  {
    name: 'RUA NOSSA SRA DE FATIMA',
  },
  {
    name: 'RUA SINO PINHEIRO',
  },
  {
    name: 'ET SIQUEIRA',
  },
  {
    name: 'RUA SIRIUS',
  },
  {
    name: 'RUA SOARES BULCAO',
  },
  {
    name: 'AV SOARES MORENO',
  },
  {
    name: 'RUA SOBRAL D03',
  },
  {
    name: 'RUA BAR SOBRAL',
  },
  {
    name: 'RUA SOBREIRA FILHO',
  },
  {
    name: 'RUA STA SOFIA',
  },
  {
    name: 'RUA DO SOL (MONDUBIM)',
  },
  {
    name: 'RUA CEL SOLON',
  },
  {
    name: 'RUA SOLON ONOFRE',
  },
  {
    name: 'RUA SOLON PINHEIRO',
  },
  {
    name: 'TR SOLONOPOLIS',
  },
  {
    name: 'TR SONIA MARIA',
  },
  {
    name: 'AV SORIANO ALBUQUERQUE',
  },
  {
    name: 'RUA SORRISO DE MARIA',
  },
  {
    name: 'RUA SOUSA CARVALHO',
  },
  {
    name: 'RUA CRUZ E SOUSA D21',
  },
  {
    name: 'RUA SOUSA GIRAO',
  },
  {
    name: 'RUA SOUSA PINTO',
  },
  {
    name: 'RUA PEDRO ESTANISLAU',
  },
  {
    name: 'TR SORIANO ALBUQUERQUE',
  },
  {
    name: 'RUA DR ESTENIO GOMES',
  },
  {
    name: 'AV BAR STUDART',
  },
  {
    name: 'RUA MAJ SUCUPIRA',
  },
  {
    name: 'RUA SUECIA',
  },
  {
    name: 'RUA SUICA',
  },
  {
    name: 'RUA TABAJARAS',
  },
  {
    name: 'TR MON TABOSA D12',
  },
  {
    name: 'AV MON TABOSA',
  },
  {
    name: 'RUA TABULEIRO DO NORTE',
  },
  {
    name: 'AV ALM TAMANDARE',
  },
  {
    name: 'RUA TAMIARANA',
  },
  {
    name: 'RUA TANGARA',
  },
  {
    name: 'RUA TAQUARI',
  },
  {
    name: 'RUA JOSE ARISTOTELES GONDIM',
  },
  {
    name: 'RUA TAUBATE',
  },
  {
    name: 'RUA TAVARES COUTINHO',
  },
  {
    name: 'RUA TAVARES IRACEMA',
  },
  {
    name: 'RUA TCHECOSLOVAQUIA',
  },
  {
    name: 'RUA TELES DE SOUZA',
  },
  {
    name: 'AL TELMA',
  },
  {
    name: 'RUA FRE TEOBALDO',
  },
  {
    name: 'VL TAVARES',
  },
  {
    name: 'RUA TEODOMIRO DE CASTRO',
  },
  {
    name: 'RUA TEODORETO SOUTO',
  },
  {
    name: 'RUA PRO TEODORICO',
  },
  {
    name: 'RUA TEODORICO BARROSO',
  },
  {
    name: 'RUA TEODORO CABRAL',
  },
  {
    name: 'RUA TEODORO DE CASTRO',
  },
  {
    name: 'RUA TEOFILO CORDEIRO',
  },
  {
    name: 'RUA TEOFILO GURGEL',
  },
  {
    name: 'RUA TEOFREDO GOIANA',
  },
  {
    name: 'RUA TERESINA',
  },
  {
    name: 'RUA TEREZA CRISTINA',
  },
  {
    name: 'RUA TERTULIANO SALES',
  },
  {
    name: 'AV DR THEBERGE',
  },
  {
    name: 'RUA TIANGUA',
  },
  {
    name: 'RUA CEL TIBURCIO',
  },
  {
    name: 'RUA TIBURCIO ALBANO',
  },
  {
    name: 'RUA TIBURCIO CAVALCANTI',
  },
  {
    name: 'VL TIJUCA',
  },
  {
    name: 'RUA CAP TIBURCIO DA FROTA',
  },
  {
    name: 'RUA TIBURCIO PEREIRA',
  },
  {
    name: 'RUA TIBURCIO RODRIGUES',
  },
  {
    name: 'RUA TIJIPIO',
  },
  {
    name: 'RUA TIJUBANA',
  },
  {
    name: 'RUA TIMBAUBA',
  },
  {
    name: 'RUA TIRADENTES',
  },
  {
    name: 'RUA TIROL',
  },
  {
    name: 'RUA TITA',
  },
  {
    name: 'TR TOMAS RODRIGUES',
  },
  {
    name: 'RUA TOBIAS',
  },
  {
    name: 'RUA TOBIAS BARRETO',
  },
  {
    name: 'RUA COSTA MANSO',
  },
  {
    name: 'TR TOCANTINS',
  },
  {
    name: 'RUA TOMAS ACIOLI',
  },
  {
    name: 'TR ADOLFO SIQUEIRA',
  },
  {
    name: 'RUA TOMAS CAVALCANTE',
  },
  {
    name: 'RUA TOMAS EDSON',
  },
  {
    name: 'RUA TOMAS GONZAGA',
  },
  {
    name: 'RUA TOMAS LOPES',
  },
  {
    name: 'RUA TOMAS POMPEU',
  },
  {
    name: 'AV DES FELICIANO DE ATAIDE (JD DAS OLIVEIRAS)',
  },
  {
    name: 'AV JOR THOMAZ COELHO',
  },
  {
    name: 'RUA GAL TOME CORDEIRO',
  },
  {
    name: 'RUA TOME DE SOUZA',
  },
  {
    name: 'RUA TOPAZIO',
  },
  {
    name: 'RUA TORQUATO AGUIAR',
  },
  {
    name: 'RUA BRI TORRES',
  },
  {
    name: 'RUA TORRES CAMARA',
  },
  {
    name: 'RUA TORRES DE MELO',
  },
  {
    name: 'RUA TORRES PORTUGAL',
  },
  {
    name: 'RUA TRAIRI',
  },
  {
    name: 'RUA TRAJANO ALVES DE AGUIAR',
  },
  {
    name: 'RUA TRAJANO DE AGUIAR (JD IRACEMA)',
  },
  {
    name: 'AV TRAJANO DE MEDEIROS',
  },
  {
    name: 'RUA TREMEMBES',
  },
  {
    name: 'AL OGUN',
  },
  {
    name: 'RUA 3 CJ POLAR',
  },
  {
    name: 'RUA 3 DE MAIO',
  },
  {
    name: 'RUA SAMARIA',
  },
  {
    name: 'RUA TRES MARIAS D39 (MONTESE)',
  },
  {
    name: 'RUA 13 CJ JOSE WALTER',
  },
  {
    name: 'RUA 13 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 13 DE ABRIL',
  },
  {
    name: 'AV 13 DE MAIO',
  },
  {
    name: 'AV TREZE ROCHDALE',
  },
  {
    name: 'TR TRILHO',
  },
  {
    name: 'RUA TRILHO',
  },
  {
    name: 'RUA GERSON GRADWOHL',
  },
  {
    name: 'RUA 30 CJ JOSE WALTER',
  },
  {
    name: 'RUA 30 DE MARCO',
  },
  {
    name: 'RUA 30 DE OUTUBRO',
  },
  {
    name: 'TR 30 DE OUTUBRO',
  },
  {
    name: 'RUA JOSE ALVES CAVALCANTE (JOAO XXIII)',
  },
  {
    name: 'RUA JOSE A CAVALCANTE (CID FUNCIONARIOS)',
  },
  {
    name: 'RUA 32 CJ JOSE WALTER',
  },
  {
    name: 'RUA 39 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 38 CJ JOSE WALTER',
  },
  {
    name: 'RUA 34 CJ JOSE WALTER',
  },
  {
    name: 'RUA 36 CJ JOSE WALTER',
  },
  {
    name: 'RUA 37 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 33 CJ JOSE WALTER',
  },
  {
    name: 'RUA 31 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 31 CJ JOSE WALTER',
  },
  {
    name: 'RUA 31 DE DEZEMBRO',
  },
  {
    name: 'TR 31 DE OUTUBRO',
  },
  {
    name: 'RUA COS TRISTAO',
  },
  {
    name: 'AV TRISTAO GONCALVES',
  },
  {
    name: 'RUA TUBARAO',
  },
  {
    name: 'RUA MARTINS CARVALHO',
  },
  {
    name: 'RUA 35 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA TUIUTI',
  },
  {
    name: 'RUA TULIPA',
  },
  {
    name: 'AL TULIPAS',
  },
  {
    name: 'RUA TUPA',
  },
  {
    name: 'RUA TUPI D35',
  },
  {
    name: 'TR ISAURA',
  },
  {
    name: 'RUA BIBIO FROTA',
  },
  {
    name: 'RUA 37 CJ JOSE WALTER',
  },
  {
    name: 'RUA NOVA CONQUISTA (BONSUCESSO)',
  },
  {
    name: 'TR UBAJARA',
  },
  {
    name: 'RUA UBERLANDIA',
  },
  {
    name: 'RUA UIRAPURU',
  },
  {
    name: 'RUA VALERIA',
  },
  {
    name: 'RUA VIRGILIO PAES',
  },
  {
    name: 'RUA 1 CJ POLAR',
  },
  {
    name: 'RUA 1 CJ JOSE WALTER',
  },
  {
    name: 'RUA UMARI',
  },
  {
    name: 'AV DA UNIVERSIDADE',
  },
  {
    name: 'RUA URANIO',
  },
  {
    name: 'RUA URSULA GARCIA',
  },
  {
    name: 'RUA URUBURETAMA',
  },
  {
    name: 'RUA URUGUAI',
  },
  {
    name: 'RUA CAP URUGUAI D46',
  },
  {
    name: 'RUA URUGUAIANA',
  },
  {
    name: 'RUA URUOCA',
  },
  {
    name: 'RUA 33 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA VALDEMAR PAES',
  },
  {
    name: 'RUA VALDEMIRO CAVALCANTE',
  },
  {
    name: 'RUA VERA CRUZ',
  },
  {
    name: 'RUA PDE VALDEVINO',
  },
  {
    name: 'RUA DR VALE COSTA',
  },
  {
    name: 'TR TEN LOURIVAL AGUIAR D29',
  },
  {
    name: 'VL VALENCIA',
  },
  {
    name: 'RUA MARCIA (MONDUBIM)',
  },
  {
    name: 'RUA PRO VALMIR',
  },
  {
    name: 'RUA VALTER DE CASTRO',
  },
  {
    name: 'RUA VALVERDE',
  },
  {
    name: 'RUA VASCO BENICIO',
  },
  {
    name: 'RUA VASCO DA GAMA',
  },
  {
    name: 'RUA VASCO DE ATAIDE',
  },
  {
    name: 'RUA BAR VASCONCELOS D10',
  },
  {
    name: 'TR CAP VASCONCELOS D46',
  },
  {
    name: 'RUA CAP VASCONCELOS D46',
  },
  {
    name: 'RUA MAJ VAZ CLARIM',
  },
  {
    name: 'RUA VENEZA',
  },
  {
    name: 'RUA VENEZUELA',
  },
  {
    name: 'VL VENTURA',
  },
  {
    name: 'RUA VENUS',
  },
  {
    name: 'VL VERA LUCIA',
  },
  {
    name: 'AL VERBENAS',
  },
  {
    name: 'RUA VERBENA',
  },
  {
    name: 'RUA MAJ VERISSIMO',
  },
  {
    name: 'RUA VITORIA (AV. PERIMETRAL)',
  },
  {
    name: 'RUA VIA FERREA',
  },
  {
    name: 'RUA VIA FERREA MUCURIPE',
  },
  {
    name: 'RUA VIADUTO M. DA ROCHA',
  },
  {
    name: 'RUA VIANA DE CARVALHO',
  },
  {
    name: 'RUA REGINOPOLIS',
  },
  {
    name: 'RUA SAO VICENTE D48',
  },
  {
    name: 'RUA SAO VICENTE DE PAULA D29',
  },
  {
    name: 'TR SAO VICENTE DE PAULA D29',
  },
  {
    name: 'RUA VICENTE AGUIAR',
  },
  {
    name: 'RUA VICENTE N BRAGA D14',
  },
  {
    name: 'RUA VICENTE BRAGA D34',
  },
  {
    name: 'AV VICENTE DE CASTRO',
  },
  {
    name: 'RUA VICENTE LEITE',
  },
  {
    name: 'TR VICENTE LEITE',
  },
  {
    name: 'RUA VICENTE LINHARES',
  },
  {
    name: 'TR VICENTE LINHARES',
  },
  {
    name: 'RUA VICENTE LOPES',
  },
  {
    name: 'RUA MON VICENTE MARTINS',
  },
  {
    name: 'RUA VICENTE NOBRE MACEDO',
  },
  {
    name: 'RUA VICENTE PADILHA',
  },
  {
    name: 'RUA VICENTE PINHEIRO',
  },
  {
    name: 'RUA VICENTE DE CASTRO',
  },
  {
    name: 'RUA VICENTE SABOIA',
  },
  {
    name: 'TR JORDANIA',
  },
  {
    name: 'RUA FRE VICENTE SALVADOR',
  },
  {
    name: 'RUA PRO VICENTE SILVEIRA',
  },
  {
    name: 'RUA VICENTE SPINDOLA',
  },
  {
    name: 'RUA VICOSA',
  },
  {
    name: 'VL VIDAL',
  },
  {
    name: 'RUA FRE VIDAL',
  },
  {
    name: 'RUA VIDAL DE NEGREIROS',
  },
  {
    name: 'RUA FIS VIEIRA',
  },
  {
    name: 'RUA PRO VIEIRA',
  },
  {
    name: 'RUA COS VIEIRA DA SILVA',
  },
  {
    name: 'RUA VIENA',
  },
  {
    name: 'RUA 26 BATALHAO',
  },
  {
    name: 'RUA VILA LOBOS',
  },
  {
    name: 'RUA VILA RICA',
  },
  {
    name: 'RUA VILA VELHA',
  },
  {
    name: 'RUA VILEBALDO AGUIAR',
  },
  {
    name: 'RUA BRI VILELA',
  },
  {
    name: 'RUA 20 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 20 CJ JOSE WALTER',
  },
  {
    name: 'RUA 20 DE DEZEMBRO',
  },
  {
    name: 'AV 20 DE JANEIRO',
  },
  {
    name: 'RUA 25 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 25 CJ JOSE WALTER',
  },
  {
    name: 'RUA VINTE E CINCO DE MARCO',
  },
  {
    name: 'TR BOA NOITE',
  },
  {
    name: 'RUA 22 CJ BEIRA RIO',
  },
  {
    name: 'RUA 22 DE AGOSTO',
  },
  {
    name: 'RUA 29 CJ JOSE WALTER',
  },
  {
    name: 'RUA 28 CJ JOSE WALTER',
  },
  {
    name: 'RUA 28 DE MARCO',
  },
  {
    name: 'RUA 24 CJ BEIRA RIO',
  },
  {
    name: 'RUA 24 DE JUNHO',
  },
  {
    name: 'RUA VINTE E QUATRO DE MAIO',
  },
  {
    name: 'RUA 26 CJ BEIRA RIO',
  },
  {
    name: 'RUA 27 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 27 CJ JOSE WALTER',
  },
  {
    name: 'RUA 23 CJ JOSE WALTER',
  },
  {
    name: 'RUA 23 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 23 DE JUNHO',
  },
  {
    name: 'RUA 21 CJ JOSE WALTER',
  },
  {
    name: 'RUA 21 DE ABRIL D27',
  },
  {
    name: 'RUA VIOLETA D21',
  },
  {
    name: 'AL VIOLETAS',
  },
  {
    name: 'RUA VIRGILIO BRANDAO',
  },
  {
    name: 'RUA VIRGILIO BRIGIDO',
  },
  {
    name: 'RUA PRO VIRGILIO DE MORAIS',
  },
  {
    name: 'RUA CEL VIRGILIO NOGUEIRA (BOM JARDIM)',
  },
  {
    name: 'RUA ULISSES BEZERRA',
  },
  {
    name: 'RUA VIRGILIO VASCONCELOS',
  },
  {
    name: 'RUA VIRIATO RIBEIRO',
  },
  {
    name: 'TR DOM VITAL D34',
  },
  {
    name: 'RUA VITAL BRASIL',
  },
  {
    name: 'TR SAPUPARA',
  },
  {
    name: 'RUA LEA POMPEU',
  },
  {
    name: 'RUA VITOR MEIRELES',
  },
  {
    name: 'RUA VITORIA',
  },
  {
    name: 'RUA VITORIANO BORGES',
  },
  {
    name: 'AV CAP WALDEMAR PAULA LIMA',
  },
  {
    name: 'RUA WALDERY UCHOA',
  },
  {
    name: 'RUA DES WALDETARIO P MOTA',
  },
  {
    name: 'RUA WALDIR DIOGO',
  },
  {
    name: 'TR WALDIR DIOGO',
  },
  {
    name: 'RUA PDE TEODORO (QUNTINO CUNHA)',
  },
  {
    name: 'AV DEP WALTER BEZERRA SA',
  },
  {
    name: 'RUA WALTER POMPEU',
  },
  {
    name: 'RUA WALTER SA',
  },
  {
    name: 'AV WASHINGTON LUIS',
  },
  {
    name: 'AV WASHINGTON SOARES',
  },
  {
    name: 'RUA PDE GUILHERME WASSEN',
  },
  {
    name: 'AV WENEFRIDO MELO',
  },
  {
    name: 'RUA MAJ WEYNE',
  },
  {
    name: 'RUA TEN WILSON  D46',
  },
  {
    name: 'RUA WILSON PEREIRA',
  },
  {
    name: 'RUA WILSON PINHEIRO',
  },
  {
    name: 'RUA XAVIER DE CASTRO',
  },
  {
    name: 'RUA XAVIER DE OLIVEIRA',
  },
  {
    name: 'RUA ENG LIMA VERDE (ALVARO WEYNE)',
  },
  {
    name: 'RUA DOM XISTO ALBANO',
  },
  {
    name: 'RUA ZACARIAS FLORINDO',
  },
  {
    name: 'RUA ZACARIAS GONDIM',
  },
  {
    name: 'RUA ZAMENHOF',
  },
  {
    name: 'RUA ZEMARIO MAMEDE',
  },
  {
    name: 'RUA ZECA VALDEVINO',
  },
  {
    name: 'AV ZEZE DIOGO',
  },
  {
    name: 'RUA ZOZIMO BARROSO',
  },
  {
    name: 'RUA NEUDELIA MONTE',
  },
  {
    name: 'RUA 4 CJ JOSE WALTER',
  },
  {
    name: 'ET FERRO PARANGABA',
  },
  {
    name: 'ET FERRO BATURITE',
  },
  {
    name: 'VL SAO FRANCISCO D07',
  },
  {
    name: 'PR MAJ WILSON D22',
  },
  {
    name: 'PR CEL MELQUIADES',
  },
  {
    name: 'RUA CRIANCAS',
  },
  {
    name: 'RUA DO CEU',
  },
  {
    name: 'RUA 4 DE JANEIRO',
  },
  {
    name: 'RUA 23 DE JANEIRO',
  },
  {
    name: 'RUA LIDIA PETRI',
  },
  {
    name: 'RUA ENG WALDIR LEOPERCIO',
  },
  {
    name: 'RUA NOVA',
  },
  {
    name: 'TR VITORIA D22',
  },
  {
    name: 'VL CEL JOAQUIM DE PAULA',
  },
  {
    name: 'RUA CURA DARS',
  },
  {
    name: 'RUA SAO FRANCISCO D21',
  },
  {
    name: 'VL STA ELISA D04',
  },
  {
    name: 'VL JUVENIL',
  },
  {
    name: 'TR VIA FERREA SOBRAL',
  },
  {
    name: 'TR VIS ICO D26',
  },
  {
    name: 'VL PONTES',
  },
  {
    name: 'VL PIONEIRA',
  },
  {
    name: 'RUA RUI GURGEL',
  },
  {
    name: 'TR SAO LUIZ D56',
  },
  {
    name: 'VL MANOEL SIMOES',
  },
  {
    name: 'RUA IRM SHEILA',
  },
  {
    name: 'RUA AUGUSTO CALHEIROS',
  },
  {
    name: 'TR POMBOS D20',
  },
  {
    name: 'RUA IMPERATRIZ D44',
  },
  {
    name: 'TR ALVARO GARRIDO',
  },
  {
    name: 'RUA OTACILIO CARNEIRO',
  },
  {
    name: 'RUA MANUEL CARNEIRO',
  },
  {
    name: 'RUA 701 CJ CEARA',
  },
  {
    name: 'RUA 703 CJ CEARA',
  },
  {
    name: 'RUA 705 CJ CEARA',
  },
  {
    name: 'RUA 707 CJ CEARA',
  },
  {
    name: 'RUA 709 CJ CEARA',
  },
  {
    name: 'RUA 711 CJ CEARA',
  },
  {
    name: 'RUA 713 CJ CEARA',
  },
  {
    name: 'RUA 715 CJ CEARA',
  },
  {
    name: 'RUA 717 CJ CEARA',
  },
  {
    name: 'RUA 719 CJ CEARA',
  },
  {
    name: 'RUA 721 CJ CEARA',
  },
  {
    name: 'RUA 763 CJ CEARA',
  },
  {
    name: 'RUA 761 CJ CEARA',
  },
  {
    name: 'RUA 759 CJ CEARA',
  },
  {
    name: 'RUA 757 CJ CEARA',
  },
  {
    name: 'RUA 755 CJ CEARA',
  },
  {
    name: 'RUA 753 CJ CEARA',
  },
  {
    name: 'RUA 751 CJ CEARA',
  },
  {
    name: 'RUA 765 CJ CEARA',
  },
  {
    name: 'RUA 749 CJ CEARA',
  },
  {
    name: 'RUA 747 CJ CEARA',
  },
  {
    name: 'RUA 745 CJ CEARA',
  },
  {
    name: 'RUA 743 CJ CEARA',
  },
  {
    name: 'RUA 723 CJ CEARA',
  },
  {
    name: 'RUA 725 CJ CEARA',
  },
  {
    name: 'RUA 727 CJ CEARA',
  },
  {
    name: 'RUA 729 CJ CEARA',
  },
  {
    name: 'RUA 731 CJ CEARA',
  },
  {
    name: 'RUA 733 CJ CEARA',
  },
  {
    name: 'RUA 735 CJ CEARA',
  },
  {
    name: 'RUA 737 CJ CEARA',
  },
  {
    name: 'RUA 739 CJ CEARA',
  },
  {
    name: 'RUA 741 CJ CEARA',
  },
  {
    name: 'RUA 802 CJ CEARA',
  },
  {
    name: 'RUA 804 CJ CEARA',
  },
  {
    name: 'RUA 806 CJ CEARA',
  },
  {
    name: 'RUA 808 CJ CEARA',
  },
  {
    name: 'RUA 810 CJ CEARA',
  },
  {
    name: 'RUA 812 CJ CEARA',
  },
  {
    name: 'RUA 814 CJ CEARA',
  },
  {
    name: 'RUA 816 CJ CEARA',
  },
  {
    name: 'RUA 818 CJ CEARA',
  },
  {
    name: 'RUA 820 CJ CEARA',
  },
  {
    name: 'RUA 822 CJ CEARA',
  },
  {
    name: 'RUA 824 CJ CEARA',
  },
  {
    name: 'RUA 826 CJ CEARA',
  },
  {
    name: 'RUA 828 CJ CEARA',
  },
  {
    name: 'RUA 830 CJ CEARA',
  },
  {
    name: 'RUA 832 CJ CEARA',
  },
  {
    name: 'RUA 834 CJ CEARA',
  },
  {
    name: 'RUA 836 CJ CEARA',
  },
  {
    name: 'RUA 838 CJ CEARA',
  },
  {
    name: 'RUA 872 CJ CEARA',
  },
  {
    name: 'RUA 870 CJ CEARA',
  },
  {
    name: 'RUA 868 CJ CEARA',
  },
  {
    name: 'RUA 866 CJ CEARA',
  },
  {
    name: 'RUA 864 CJ CEARA',
  },
  {
    name: 'RUA 862 CJ CEARA',
  },
  {
    name: 'RUA 860 CJ CEARA',
  },
  {
    name: 'RUA 858 CJ CEARA',
  },
  {
    name: 'RUA 856 CJ CEARA',
  },
  {
    name: 'RUA 854 CJ CEARA',
  },
  {
    name: 'RUA 852 CJ CEARA',
  },
  {
    name: 'RUA 850 CJ CEARA',
  },
  {
    name: 'RUA 848 CJ CEARA',
  },
  {
    name: 'RUA 846 CJ CEARA',
  },
  {
    name: 'RUA 844 CJ CEARA',
  },
  {
    name: 'RUA 842 CJ CEARA',
  },
  {
    name: 'RUA 840 CJ CEARA',
  },
  {
    name: 'RUA STO AMARO DO PICI',
  },
  {
    name: 'RUA PDE ANTONIINO D13',
  },
  {
    name: 'AV CENTRAL CJ CEARA',
  },
  {
    name: 'VL ASSIS D20',
  },
  {
    name: 'VL VASCONCELOS D27',
  },
  {
    name: 'TR FRANCISCO CARVALHO',
  },
  {
    name: 'RUA JOSE ALVES CAMPOS',
  },
  {
    name: 'RUA RABBI ELIAS ROMCY',
  },
  {
    name: 'AV CEL GUSTAVO A LIMA',
  },
  {
    name: 'RUA ELIZEU B FILHO',
  },
  {
    name: 'RUA ALBERTO FEITOSA LIMA',
  },
  {
    name: 'RUA FELIPE NERY',
  },
  {
    name: 'RUA ROMEU ALDIGUERI',
  },
  {
    name: 'RUA CEL HELDER BENEVIDES',
  },
  {
    name: 'RUA JAIME PINHEIRO D 56',
  },
  {
    name: 'RUA ATILANO MOURA',
  },
  {
    name: 'AV A CJ CEARA',
  },
  {
    name: 'AV H CJ CEARA',
  },
  {
    name: 'AV I CJ CEARA',
  },
  {
    name: 'RUA OTHON DE NOROES',
  },
  {
    name: 'TR PEDRO DE ARAUJO',
  },
  {
    name: 'TR CUIABA',
  },
  {
    name: 'VL CANUTO',
  },
  {
    name: 'TR BALDUINO FREIRE',
  },
  {
    name: 'RUA PRA RAIMUNDA ADELIA',
  },
  {
    name: 'RUA PRO JOAQUIM NOGUEIRA D29',
  },
  {
    name: 'RUA SERRO CORA',
  },
  {
    name: 'TR MARIA JOSE',
  },
  {
    name: 'RUA SAO SALVADOR',
  },
  {
    name: 'RUA BAR COTEGIBE',
  },
  {
    name: 'TR ANTONIO AUGUSTO',
  },
  {
    name: 'RUA SAO LONGUINHOS',
  },
  {
    name: 'RUA PIRATININGA',
  },
  {
    name: 'RUA SIDERAL',
  },
  {
    name: 'TR UBERABA',
  },
  {
    name: 'TR AUGUSTO DOS ANJOS',
  },
  {
    name: 'RUA BENEDITO SOBRINHO',
  },
  {
    name: 'TR PRIMEIRO DE MAIO D34',
  },
  {
    name: 'RUA MARIA DULCE',
  },
  {
    name: 'TR STO INACIO D04',
  },
  {
    name: 'TR APODIM',
  },
  {
    name: 'RUA SAO PORTEIRAS',
  },
  {
    name: 'VL AMERICA D38',
  },
  {
    name: 'TR JULIO CESAR',
  },
  {
    name: 'RUA EDILSON GOMES',
  },
  {
    name: 'VL CARDOSO',
  },
  {
    name: 'RUA VIRGILIO NOGUEIRA PAES',
  },
  {
    name: 'VL PUMA',
  },
  {
    name: 'RUA BARRA VERMELHA',
  },
  {
    name: 'RUA FRANCISCO PAIVA',
  },
  {
    name: 'RUA MATEUS LEMOS',
  },
  {
    name: 'RUA GUSTAVO BARROSO',
  },
  {
    name: 'RUA BARRA MANSA',
  },
  {
    name: 'RUA DESCARTES BRAGA',
  },
  {
    name: 'RUA TRES CORACOES',
  },
  {
    name: 'RUA OSCAR BRESSANE',
  },
  {
    name: 'RUA MANUEL GALDINO',
  },
  {
    name: 'RUA PARTICULAR',
  },
  {
    name: 'RUA SAO RAIMUNDO D33',
  },
  {
    name: 'RUA SGT BARBOSA',
  },
  {
    name: 'TR FILIPINAS',
  },
  {
    name: 'RUA GUSTAVO CORREIA LIMA',
  },
  {
    name: 'RUA APRENDIZE MARINHEIRO',
  },
  {
    name: 'VL SAO PEDRO D04',
  },
  {
    name: 'RUA 58 CJ JOSE WALTER',
  },
  {
    name: 'RUA 68 CJ JOSE WALTER',
  },
  {
    name: 'VL AZUL D04',
  },
  {
    name: 'RUA ABC',
  },
  {
    name: 'RUA DOS NAVEGANTES',
  },
  {
    name: 'VL CONCEICAO',
  },
  {
    name: 'RUA FRANCISCO ALVES D04',
  },
  {
    name: 'TR TAMOIO',
  },
  {
    name: 'TR TABULEIRO DO NORTE',
  },
  {
    name: 'RUA CASTANHOLA',
  },
  {
    name: 'RUA 4 DE MAIO',
  },
  {
    name: 'RUA AUGUSTO SEVERO',
  },
  {
    name: 'RUA DEOCLECIANO CAVALCANTE',
  },
  {
    name: 'RUA SANTA CRUZ',
  },
  {
    name: 'RUA F LT COLINA C E LTDA',
  },
  {
    name: 'RUA G LT COLINA C E LTDA',
  },
  {
    name: 'RUA H LT COLINA C E LTDA',
  },
  {
    name: 'RUA 19 DE NOVEMBRO',
  },
  {
    name: 'TR ISAIAS BORIS  D39',
  },
  {
    name: 'RUA JOAQUIM MOREIRA D36',
  },
  {
    name: 'TR NOSSA SRA DE FATIMA',
  },
  {
    name: 'TR COSTA RICA',
  },
  {
    name: 'TR PIAUI',
  },
  {
    name: 'RUA ITAJAI',
  },
  {
    name: 'TR OSORIO DE PAIVA',
  },
  {
    name: 'VL IVONE',
  },
  {
    name: 'RUA ALZIRO ZARUR',
  },
  {
    name: 'RUA MANUEL DA NOBREGA',
  },
  {
    name: 'TR JOAO AREAS',
  },
  {
    name: 'TR NOVA LIMA',
  },
  {
    name: 'RUA ISAIAS PEREIRA',
  },
  {
    name: 'RUA BOA ESPERANCA D43',
  },
  {
    name: 'RUA ANTONIO DIVINO',
  },
  {
    name: 'TR UIRAPURU D43',
  },
  {
    name: 'RUA OREGON',
  },
  {
    name: 'RUA MARAJO',
  },
  {
    name: 'RUA GUARUJA',
  },
  {
    name: 'RUA PAZ D45',
  },
  {
    name: 'TR LIBERTADORES',
  },
  {
    name: 'VL MILANO',
  },
  {
    name: 'VL BETHEL',
  },
  {
    name: 'TR PATROCINIO',
  },
  {
    name: 'TR SGT PORTUGAL D46',
  },
  {
    name: 'TR PROGRESSO',
  },
  {
    name: 'TR ALEGRIA',
  },
  {
    name: 'TR ALEGRETE',
  },
  {
    name: 'TR ALECRIM',
  },
  {
    name: 'TR PESSOA',
  },
  {
    name: 'VL PARAJURU D46',
  },
  {
    name: 'TR SOLANGE',
  },
  {
    name: 'TR FORMOSA',
  },
  {
    name: 'TR LISBOA D46',
  },
  {
    name: 'TR SANTOS DUMONT',
  },
  {
    name: 'VL CEL GONCALO D46',
  },
  {
    name: 'RUA LUIZ ALVES TEIXEIRA',
  },
  {
    name: 'RUA LINDOIA',
  },
  {
    name: 'RUA TITAN',
  },
  {
    name: 'RUA NOVA IGUACU',
  },
  {
    name: 'RUA ESPERANTINA',
  },
  {
    name: 'RUA PEDRO TOLEDO',
  },
  {
    name: 'RUA 10 DE SETEMBRO',
  },
  {
    name: 'RUA JOSE SETUBAL PESSOA',
  },
  {
    name: 'RUA 15 DE OUTUBRO',
  },
  {
    name: 'RUA SAO BERNARDO DE CAMPOS',
  },
  {
    name: 'RUA FRANCISCO ALVES PEREIRA',
  },
  {
    name: 'RUA TARCISIO PEIXOTO',
  },
  {
    name: 'RUA MARANGUAPE D50',
  },
  {
    name: 'RUA PEDRO MARTINS',
  },
  {
    name: 'RUA DNA LOURDES D50',
  },
  {
    name: 'RUA TRES MARIAS D50',
  },
  {
    name: 'RUA NOVA FRIBURGO',
  },
  {
    name: 'RUA SAO VICENTE DE PAULA D50',
  },
  {
    name: 'RUA JOAO DAMASCENO',
  },
  {
    name: 'RUA PDE FRANCISCO ARAQUEM',
  },
  {
    name: 'RUA GUAIRA D50',
  },
  {
    name: 'RUA KASEL',
  },
  {
    name: 'RUA IEDA CARVALHO',
  },
  {
    name: 'TR PARIS',
  },
  {
    name: 'RUA RIO PRADO',
  },
  {
    name: 'RUA JOSE BORBA VASCONCELOS',
  },
  {
    name: 'RUA OLIVEIRA MARTINS',
  },
  {
    name: 'TR MIRIM',
  },
  {
    name: 'RUA CABO FRIO',
  },
  {
    name: 'TR SAO JOSE D21',
  },
  {
    name: 'RUA PIN ANTONIO BANDEIRA',
  },
  {
    name: 'RUA DR MANOEL RODRIGUES MONTEIRO',
  },
  {
    name: 'RUA CEL JOAO DE ALENCAR',
  },
  {
    name: 'RUA JULIO SILVA',
  },
  {
    name: 'RUA PAULO MENDES',
  },
  {
    name: 'RUA PRO MOZART SOLON',
  },
  {
    name: 'RUA FRANCISCO TEIXEIRA DE ALCANTARA',
  },
  {
    name: 'RUA DR ELIZEU HOLANDA',
  },
  {
    name: 'AV GERONCIO BRIGIDO',
  },
  {
    name: 'RUA COM FCO FRANCESCO ANGELO',
  },
  {
    name: 'AV PRO MURILO DA SILVEIRA',
  },
  {
    name: 'AV PRO EUCLIDES CESAR',
  },
  {
    name: 'RUA ASSIS VIEIRA',
  },
  {
    name: 'RUA DR FRANCISCO DE ARAUJO',
  },
  {
    name: 'RUA F VEREDA ATLANTICA',
  },
  {
    name: 'RUA MIGUEL CALMON',
  },
  {
    name: 'RUA VIS CAIRU',
  },
  {
    name: 'RUA G CJ SANTA LUZIA',
  },
  {
    name: 'RUA I CJ SANTA LUZIA',
  },
  {
    name: 'RUA F CJ SANTA LUZIA',
  },
  {
    name: 'RUA C CJ SANTA LUZIA',
  },
  {
    name: 'RUA DORALICE COSTA',
  },
  {
    name: 'RUA B CJ SANTA LUZIA',
  },
  {
    name: 'RUA H CJ SANTA LUZIA',
  },
  {
    name: 'RUA L CJ SANTA LUZIA',
  },
  {
    name: 'RUA JAIME LEONEL',
  },
  {
    name: 'RUA M CJ SANTA LUZIA',
  },
  {
    name: 'RUA S CJ SANTA LUZIA',
  },
  {
    name: 'RUA J CJ SANTA LUZIA',
  },
  {
    name: 'RUA N CJ SANTA LUZIA',
  },
  {
    name: 'RUA O CJ SANTA LUZIA',
  },
  {
    name: 'RUA P CJ SANTA LUZIA',
  },
  {
    name: 'RUA REV BOLIVAR P BANDEIRA',
  },
  {
    name: 'RUA DR THOMPSON BULCAO',
  },
  {
    name: 'RUA K CJ SANTA LUZIA',
  },
  {
    name: 'RUA Q CJ SANTA LUZIA',
  },
  {
    name: 'RUA RIO NILO',
  },
  {
    name: 'RUA 27 DE JANEIRO',
  },
  {
    name: 'TR POMPEIA',
  },
  {
    name: 'TR MAJ ELISARIO MENDES',
  },
  {
    name: 'VL CLARA',
  },
  {
    name: 'TR ESPERANCA',
  },
  {
    name: 'TR SINUOSA',
  },
  {
    name: 'AV C CJ CEARA',
  },
  {
    name: 'AV B CJ CEARA',
  },
  {
    name: 'AV G CJ CEARA',
  },
  {
    name: 'RUA 305 CJ CEARA',
  },
  {
    name: 'RUA 307 CJ CEARA',
  },
  {
    name: 'RUA 309 CJ CEARA',
  },
  {
    name: 'RUA 311 CJ CEARA',
  },
  {
    name: 'RUA 313 CJ CEARA',
  },
  {
    name: 'RUA 315 CJ CEARA',
  },
  {
    name: 'RUA 317 CJ CEARA',
  },
  {
    name: 'RUA 319 CJ CEARA',
  },
  {
    name: 'RUA 321 CJ CEARA',
  },
  {
    name: 'RUA 323 CJ CEARA',
  },
  {
    name: 'RUA 325 CJ CEARA',
  },
  {
    name: 'RUA 327 CJ CEARA',
  },
  {
    name: 'RUA 329 CJ CEARA',
  },
  {
    name: 'RUA 331 CJ CEARA',
  },
  {
    name: 'RUA 333 CJ CEARA',
  },
  {
    name: 'RUA 335 CJ CEARA',
  },
  {
    name: 'RUA 337 CONJUNTO CEARA',
  },
  {
    name: 'RUA 339 CJ CEARA',
  },
  {
    name: 'RUA 303 C CJ CEARA',
  },
  {
    name: 'RUA 303 D CJ CEARA',
  },
  {
    name: 'RUA 303 CJ CEARA',
  },
  {
    name: 'RUA 303 B CJ CEARA',
  },
  {
    name: 'RUA 303 A CJ CEARA',
  },
  {
    name: 'RUA 301 CJ CEARA',
  },
  {
    name: 'RUA 301 B CJ CEARA',
  },
  {
    name: 'RUA 301 A CJ CEARA',
  },
  {
    name: 'RUA 341 CJ CEARA',
  },
  {
    name: 'RUA 343 CJ CEARA',
  },
  {
    name: 'RUA 345 CJ CEARA',
  },
  {
    name: 'RUA 123 CJ CEARA',
  },
  {
    name: 'RUA 121 CJ CEARA',
  },
  {
    name: 'RUA 125 CJ CEARA',
  },
  {
    name: 'RUA 127 CJ CEARA',
  },
  {
    name: 'RUA 129 CJ CEARA',
  },
  {
    name: 'RUA 131 CJ CEARA',
  },
  {
    name: 'RUA 133 CJ CEARA',
  },
  {
    name: 'RUA 513 CJ CEARA',
  },
  {
    name: 'RUA 515 CJ CEARA',
  },
  {
    name: 'RUA 517 CJ CEARA',
  },
  {
    name: 'RUA 519 CJ CEARA',
  },
  {
    name: 'RUA 521 CJ CEARA',
  },
  {
    name: 'RUA 523 CJ CEARA',
  },
  {
    name: 'RUA 525 CJ CEARA',
  },
  {
    name: 'RUA 527 CJ CEARA',
  },
  {
    name: 'RUA 529 CJ CEARA',
  },
  {
    name: 'RUA 531 CJ CEARA',
  },
  {
    name: 'RUA 533 CJ CEARA',
  },
  {
    name: 'RUA 535 CJ CEARA',
  },
  {
    name: 'RUA 537 CJ CEARA',
  },
  {
    name: 'RUA 539 CJ CEARA',
  },
  {
    name: 'RUA 541 CJ CEARA',
  },
  {
    name: 'RUA 541 A CJ CEARA',
  },
  {
    name: 'RUA 541 B CJ CEARA',
  },
  {
    name: 'RUA 541 C CJ CEARA',
  },
  {
    name: 'RUA 541 D CJ CEARA',
  },
  {
    name: 'RUA 541 E CJ CEARA',
  },
  {
    name: 'RUA 511 CJ CEARA',
  },
  {
    name: 'RUA 509 CJ CEARA',
  },
  {
    name: 'RUA 507 CJ CEARA',
  },
  {
    name: 'RUA 505 CJ CEARA',
  },
  {
    name: 'RUA 503 CJ CEARA',
  },
  {
    name: 'RUA 501 CJ CEARA',
  },
  {
    name: 'RUA 149 CJ CEARA',
  },
  {
    name: 'RUA 151 CJ CEARA',
  },
  {
    name: 'RUA 147 CJ CEARA',
  },
  {
    name: 'RUA 145 CJ CEARA',
  },
  {
    name: 'RUA 143 CJ CEARA',
  },
  {
    name: 'RUA 141 CJ CEARA',
  },
  {
    name: 'RUA 139 CJ CEARA',
  },
  {
    name: 'RUA 137 CJ CEARA',
  },
  {
    name: 'RUA 135 CJ CEARA',
  },
  {
    name: 'RUA 119 CJ CEARA',
  },
  {
    name: 'RUA 117 CJ CEARA',
  },
  {
    name: 'RUA 115 CJ CEARA',
  },
  {
    name: 'RUA 113 CJ CEARA',
  },
  {
    name: 'RUA 111 CJ CEARA',
  },
  {
    name: 'RUA 109 CJ CEARA',
  },
  {
    name: 'RUA 107 CJ CEARA',
  },
  {
    name: 'AV E CJ CEARA',
  },
  {
    name: 'RUA 418 CJ CEARA',
  },
  {
    name: 'RUA 420 CJ CEARA',
  },
  {
    name: 'RUA 416 CJ CEARA',
  },
  {
    name: 'RUA 448 CJ CEARA',
  },
  {
    name: 'RUA 448 E CJ CEARA',
  },
  {
    name: 'RUA 448 F CJ CEARA',
  },
  {
    name: 'RUA 448 D CJ CEARA',
  },
  {
    name: 'RUA 448 C CJ CEARA',
  },
  {
    name: 'RUA 424 CJ CEARA',
  },
  {
    name: 'RUA 422 CJ CEARA',
  },
  {
    name: 'RUA 426 CJ CEARA',
  },
  {
    name: 'RUA 428 CJ CEARA',
  },
  {
    name: 'RUA 430 CJ CEARA',
  },
  {
    name: 'AV D CJ CEARA',
  },
  {
    name: 'RUA 432 CJ CEARA',
  },
  {
    name: 'RUA 222 CJ CEARA',
  },
  {
    name: 'RUA 224 CJ CEARA',
  },
  {
    name: 'AV F CJ CEARA',
  },
  {
    name: 'RUA 610 CJ CEARA',
  },
  {
    name: 'RUA 608 CJ CEARA',
  },
  {
    name: 'RUA 614 CJ CEARA',
  },
  {
    name: 'RUA 612 CJ CEARA',
  },
  {
    name: 'RUA 444 CJ CEARA',
  },
  {
    name: 'RUA 442 CJ CEARA',
  },
  {
    name: 'RUA 440 CJ CEARA',
  },
  {
    name: 'RUA 438 CJ CEARA',
  },
  {
    name: 'RUA 436 CJ CEARA',
  },
  {
    name: 'RUA 434 CJ CEARA',
  },
  {
    name: 'RUA 446 CJ CEARA',
  },
  {
    name: 'RUA ARARAQUARA',
  },
  {
    name: 'RUA RAUL NABUCO',
  },
  {
    name: 'RUA 448 B CJ CEARA',
  },
  {
    name: 'RUA 105 CJ CEARA',
  },
  {
    name: 'RUA 204 CJ CEARA',
  },
  {
    name: 'RUA 202 CJ CEARA',
  },
  {
    name: 'RUA 206 CJ CEARA',
  },
  {
    name: 'RUA 218 CJ CEARA',
  },
  {
    name: 'RUA 218 B CJ CEARA',
  },
  {
    name: 'RUA 218 C CJ CEARA',
  },
  {
    name: 'RUA 218 A CJ CEARA',
  },
  {
    name: 'RUA 202 A CJ CEARA',
  },
  {
    name: 'RUA 202 B CJ CEARA',
  },
  {
    name: 'RUA 208 CJ CEARA',
  },
  {
    name: 'RUA 226 CJ CEARA',
  },
  {
    name: 'RUA 220 CJ CEARA',
  },
  {
    name: 'RUA 202 C CJ CEARA',
  },
  {
    name: 'RUA 402 CJ CEARA',
  },
  {
    name: 'RUA 404 CJ CEARA',
  },
  {
    name: 'RUA 216 CJ CEARA',
  },
  {
    name: 'RUA 214 CJ CEARA',
  },
  {
    name: 'RUA 228 CJ CEARA',
  },
  {
    name: 'RUA 210 CJ CEARA',
  },
  {
    name: 'RUA 230 CJ CEARA',
  },
  {
    name: 'RUA 232 CJ CEARA',
  },
  {
    name: 'RUA 234 CJ CEARA',
  },
  {
    name: 'RUA 602 CJ CEARA',
  },
  {
    name: 'RUA 103 CJ CEARA',
  },
  {
    name: 'RUA 606 CJ CEARA',
  },
  {
    name: 'RUA 604 CJ CEARA',
  },
  {
    name: 'RUA 101 CJ CEARA',
  },
  {
    name: 'RUA 212 CJ CEARA',
  },
  {
    name: 'RUA 414 CJ CEARA',
  },
  {
    name: 'RUA 412 CJ CEARA',
  },
  {
    name: 'RUA 406 CJ CEARA',
  },
  {
    name: 'RUA 410 CJ CEARA',
  },
  {
    name: 'RUA 408 CJ CEARA',
  },
  {
    name: 'RUA 202 D CJ CEARA',
  },
  {
    name: 'VL CEARA D04',
  },
  {
    name: 'RUA CEL JOSE AURELIO CAMARA',
  },
  {
    name: 'RUA INTERNACIONAL',
  },
  {
    name: 'RUA PITANGA D26',
  },
  {
    name: 'RUA ARI MAIA',
  },
  {
    name: 'RUA PRAIEIRA',
  },
  {
    name: 'VL MACIEL',
  },
  {
    name: 'RUA JOSE ANTONIO',
  },
  {
    name: 'RUA ANA STUDART',
  },
  {
    name: 'TR SAO ROQUE D23',
  },
  {
    name: 'RUA STA HELENA D29',
  },
  {
    name: 'AV LIBERDADE',
  },
  {
    name: 'RUA DOMINGOS BRAGA',
  },
  {
    name: 'RUA MAJ ADELINO',
  },
  {
    name: 'RUA TEN LIRA',
  },
  {
    name: 'TR DR PIO SARAIVA',
  },
  {
    name: 'RUA DR PIO SARAIVA',
  },
  {
    name: 'TR RIACHUELO',
  },
  {
    name: 'RUA MARTINS SALES',
  },
  {
    name: 'VL MUNICIPAL',
  },
  {
    name: 'RUA JOSE CAMELO',
  },
  {
    name: 'RUA PRO GUILHON',
  },
  {
    name: 'TR SANTA CRUZ',
  },
  {
    name: 'RUA BRAGA BASTOS',
  },
  {
    name: 'RUA AUSTRALIA',
  },
  {
    name: 'VL ARTUR SILVEIRA',
  },
  {
    name: 'RUA SIRIA',
  },
  {
    name: 'RUA FINLANDIA',
  },
  {
    name: 'AV COLOMBO DE SOUZA',
  },
  {
    name: 'TR CAPILE',
  },
  {
    name: 'TR SAO PAULO',
  },
  {
    name: 'RUA DANIEL DE MENDONCA',
  },
  {
    name: 'VL SAO PAULO D38',
  },
  {
    name: 'RUA JOANA MOREIRA',
  },
  {
    name: 'RUA JOSE AUGUSTO',
  },
  {
    name: 'TR SOCIAL',
  },
  {
    name: 'RUA BELO HORIZONTE',
  },
  {
    name: 'RUA AMARO BANDEIRA',
  },
  {
    name: 'RUA MANUEL ARRUDA',
  },
  {
    name: 'RUA PORTUGAL D63',
  },
  {
    name: 'RUA GERALDO SOARES',
  },
  {
    name: 'RUA PARAISO',
  },
  {
    name: 'RUA SAO BENTO',
  },
  {
    name: 'RUA DAURA',
  },
  {
    name: 'RUA MANUEL FIGUEIREDO',
  },
  {
    name: 'RUA RAIMUNDO CABRAL',
  },
  {
    name: 'RUA CEL MANUEL ANTONIO LEITE',
  },
  {
    name: 'TR MACAU',
  },
  {
    name: 'RUA MARIA LEITE',
  },
  {
    name: 'VL SAO FRANCISCO D34',
  },
  {
    name: 'RUA ANDRE REBOUCAS',
  },
  {
    name: 'RUA EUCLIDES O DE SOUSA',
  },
  {
    name: 'RUA RAFAEL TOBIAS',
  },
  {
    name: 'RUA MARCELINO LOPES',
  },
  {
    name: 'RUA SALVADOR CORREIA SA',
  },
  {
    name: 'RUA STA LUZIA D50',
  },
  {
    name: 'RUA DEP MANUEL MATOSO FILHO',
  },
  {
    name: 'RUA CRISPIM ALMEIDA',
  },
  {
    name: 'RUA VINICIUS DE MORAES',
  },
  {
    name: 'RUA RUA 4513 D08',
  },
  {
    name: 'RUA PRO MARIO ROCHA',
  },
  {
    name: 'RUA RAIMUNDO RESENDE',
  },
  {
    name: 'RUA WALDEMAR PINHO',
  },
  {
    name: 'RUA SUZETE PINTO',
  },
  {
    name: 'RUA GRITO DE ALERTA',
  },
  {
    name: 'RUA BENJAMIN BARRETO',
  },
  {
    name: 'RUA RIBEIRAO NOVO',
  },
  {
    name: 'RUA VALDEMAR QUEIROZ',
  },
  {
    name: 'RUA LETICIA BRAGA',
  },
  {
    name: 'RUA SAMIR HILUY',
  },
  {
    name: 'RUA K PAPICU',
  },
  {
    name: 'RUA L PAPICU',
  },
  {
    name: 'RUA T PAPICU',
  },
  {
    name: 'RUA JOR NERTAM MACEDO',
  },
  {
    name: 'RUA DEUSDEDIT C SOUZA',
  },
  {
    name: 'RUA M LT PAPICU',
  },
  {
    name: 'RUA LIGIA MONTE',
  },
  {
    name: 'RUA S PAPICU',
  },
  {
    name: 'RUA QUADRA B CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA C CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA D CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA E CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA F CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA G CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA H CJ C BRANCO',
  },
  {
    name: 'RUA PDE QUADRA I CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA L CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA M CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA N CJ C BRANCO',
  },
  {
    name: 'RUA QUADRA O CJ C BRANCO',
  },
  {
    name: 'TR TR ANTENOR ALMEIDA',
  },
  {
    name: 'RUA JOSE RICARDO RAMOS',
  },
  {
    name: 'RUA DIANA ARARIPE CABRAL',
  },
  {
    name: 'RUA 35 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 37 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 18 CJ NOVA ASSUNCAO',
  },
  {
    name: 'RUA 20 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 18 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 41 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 45 CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 43 CJ PLANALTO BARRA',
  },
  {
    name: 'AV D CJ PLANALTO BARRA',
  },
  {
    name: 'AV K CJ PLANALTO BARRA',
  },
  {
    name: 'RUA 35 CJ JOSE WALTER',
  },
  {
    name: 'TR PACHECO',
  },
  {
    name: 'RUA PORTO CALVO',
  },
  {
    name: 'RUA SAO GREGORIO D35',
  },
  {
    name: 'TR VICENTE SALES',
  },
  {
    name: 'RUA ALTO VERMELHO',
  },
  {
    name: 'RUA DO ESCORREGO',
  },
  {
    name: 'RUA STA MARIA D32',
  },
  {
    name: 'RUA MANOEL B DOS SANTOS',
  },
  {
    name: 'RUA SOBRADINHO',
  },
  {
    name: 'RUA PATO BRANCO',
  },
  {
    name: 'RUA ELDORADO',
  },
  {
    name: 'RUA E PQ ADRIANO',
  },
  {
    name: 'RUA PRO MOREIRA DE SOUSA (PASSARE)',
  },
  {
    name: 'RUA I PQ ADRIANO',
  },
  {
    name: 'RUA BELOS PORTOS',
  },
  {
    name: 'RUA M PQ ADRIANO (PASSARE)',
  },
  {
    name: 'RUA SAO TOMAZ DE AQUINO',
  },
  {
    name: 'RUA MARIA AMALIA',
  },
  {
    name: 'ET DO ITAPERI',
  },
  {
    name: 'RUA NENEN GONCALVES',
  },
  {
    name: 'RUA J LT PAPICU',
  },
  {
    name: 'TR GODOFREDO MACIEL',
  },
  {
    name: 'RUA ARARIBOIA',
  },
  {
    name: 'RUA TEN COSTA',
  },
  {
    name: 'RUA FERNANDO FIALHO',
  },
  {
    name: 'RUA AMARILIA DUTRA',
  },
  {
    name: 'RUA BETSAIDA D45',
  },
  {
    name: 'RUA OVIDIO NOGUEIRA',
  },
  {
    name: 'RUA RITA PINTO',
  },
  {
    name: 'TR MAJ LADISLAU LOURENCO',
  },
  {
    name: 'RUA JOAO IVO',
  },
  {
    name: 'TR JULIO PINTO',
  },
  {
    name: 'RUA RUA 4739 D50',
  },
  {
    name: 'RUA RUA 4746 D50',
  },
  {
    name: 'RUA CONRADO MALTA',
  },
  {
    name: 'RUA LUIS ALVES TOMAS',
  },
  {
    name: 'RUA PARAISOPOLES',
  },
  {
    name: 'RUA FRANCISCO L DA SILVA',
  },
  {
    name: 'RUA REGINA CELIA',
  },
  {
    name: 'RUA GAL RABELO',
  },
  {
    name: 'RUA SANTANA DO PARAISO',
  },
  {
    name: 'RUA SAO FRANCISCO D50',
  },
  {
    name: 'RUA RECANTO DAS FLORES',
  },
  {
    name: 'RUA VALPARAISO',
  },
  {
    name: 'RUA RECANTO VERDE',
  },
  {
    name: 'RUA ANTONIO REIS',
  },
  {
    name: 'RUA JUSTINO SOARES',
  },
  {
    name: 'RUA MORADA NOVA',
  },
  {
    name: 'RUA IRM OLIMPIO',
  },
  {
    name: 'RUA LUCIANO ALVES',
  },
  {
    name: 'RUA JOVINO VERISSIMO',
  },
  {
    name: 'RUA PRO TITO MIRANDA',
  },
  {
    name: 'RUA IVANOEL BACCHIEGGA',
  },
  {
    name: 'RUA PRO OCELIO PINHEIRO',
  },
  {
    name: 'TR SILVA FREITAS',
  },
  {
    name: 'RUA DES GERMINIANO JUREMA',
  },
  {
    name: 'RUA ALBERTO MONTEIRO',
  },
  {
    name: 'RUA LIV POLARY MAIA',
  },
  {
    name: 'RUA J.CLAUDIO COSTA LIMA',
  },
  {
    name: 'RUA RUA 4833 D54',
  },
  {
    name: 'RUA RUA 4834 D54',
  },
  {
    name: 'RUA FRANCISCO D PERDIGAO',
  },
  {
    name: 'AV HILDEBRANDO POMPEU',
  },
  {
    name: 'RUA EMBRATEL',
  },
  {
    name: 'RUA RUA 4839 D54',
  },
  {
    name: 'RUA RUA 4840 D54',
  },
  {
    name: 'RUA CEL FRANCISCO MONTENEGRO',
  },
  {
    name: 'RUA CLOVIS ROLIM',
  },
  {
    name: 'AV SALUSTIO DE PINHO',
  },
  {
    name: 'RUA DR TURBAY BARREIRA',
  },
  {
    name: 'RUA OSVALDO ARAUJO',
  },
  {
    name: 'RUA DR ZELITO PAMPLONA',
  },
  {
    name: 'RUA TAMISA',
  },
  {
    name: 'AV ZUCA ACIOLY',
  },
  {
    name: 'RUA DEP ALFREDO BARREIRA FILHO',
  },
  {
    name: 'RUA ANTONIO GOMES GUIMARAES',
  },
  {
    name: 'RUA CESAR CALS',
  },
  {
    name: 'RUA ABREU COSTA',
  },
  {
    name: 'RUA GERARDO FREITAS',
  },
  {
    name: 'RUA PDE PIO',
  },
  {
    name: 'RUA JOSE C DA SILVEIRA',
  },
  {
    name: 'TR DO VALE',
  },
  {
    name: 'RUA DEMOCRATA',
  },
  {
    name: 'RUA CAP ISRAEL PINHEIRO',
  },
  {
    name: 'RUA CARLINDO CRUZ',
  },
  {
    name: 'TR BOATAO',
  },
  {
    name: 'TR ANARIO BRAGA',
  },
  {
    name: 'RUA FRE JOSE MAURICIO',
  },
  {
    name: 'RUA GUARAREMA',
  },
  {
    name: 'RUA PAULINO ROCHA D32',
  },
  {
    name: 'TR TRAJANO DE MEDEIROS',
  },
  {
    name: 'AV NOSSA SRA DAS GRACAS',
  },
  {
    name: 'RUA DOZE',
  },
  {
    name: 'RUA ENG LUIS T DE ALCANTARA',
  },
  {
    name: 'RUA DEP FLAVIO MARCILIO',
  },
  {
    name: 'RUA 2 CJ JOSE WALTER',
  },
  {
    name: 'TR ARARIBOIA',
  },
  {
    name: 'RUA PRIMEIRO DE ABRIL',
  },
  {
    name: 'RUA DAS PEDRINHAS',
  },
  {
    name: 'RUA ERNESTO MONTEIRO',
  },
  {
    name: 'AV SAPIRANGAS D59',
  },
  {
    name: 'RUA BRI HAROLDO VELOSO',
  },
  {
    name: 'RUA GUIOMAR NOVAES',
  },
  {
    name: 'RUA FRANCISCA HELENA',
  },
  {
    name: 'RUA TEODULFO MAGALHAES',
  },
  {
    name: 'VL DO OPERARIO',
  },
  {
    name: 'TR JOSE PEDRO D59',
  },
  {
    name: 'RUA RANGEL PESTANA',
  },
  {
    name: 'RUA JOSE JULIO FEITOSA',
  },
  {
    name: 'RUA POMBOS D59',
  },
  {
    name: 'RUA BILL CARTAXO',
  },
  {
    name: 'TR RAFAEL TOBIAS',
  },
  {
    name: 'RUA ALPINOPOLIS',
  },
  {
    name: 'RUA SALVADOR CORREIA SA',
  },
  {
    name: 'RUA ANGRA DOS REIS',
  },
  {
    name: 'RUA JOAO MARIANO',
  },
  {
    name: 'RUA JOSE SOBREIRA',
  },
  {
    name: 'RUA FRANCISCO MATIAS',
  },
  {
    name: 'RUA CECILIA MEIRELES',
  },
  {
    name: 'RUA JOSE B PARENTE D59',
  },
  {
    name: 'VL PAPI JUNIOR',
  },
  {
    name: 'RUA MAR DEL PLATA',
  },
  {
    name: 'RUA ANTONIO NOGUEIRA',
  },
  {
    name: 'RUA PERY NEGREIROS',
  },
  {
    name: 'RUA GUILHERME LOURENCO',
  },
  {
    name: 'VL SAO PEDRO D49',
  },
  {
    name: 'VL CASTILHO D39',
  },
  {
    name: 'RUA MANUEL BERNARDO',
  },
  {
    name: 'RUA MAXIMINO D59',
  },
  {
    name: 'RUA EGIDIO DE OLIVEIRA',
  },
  {
    name: 'RUA DOS MAIAS D56',
  },
  {
    name: 'RUA TOMAZ POMPILIO',
  },
  {
    name: 'RUA EVARISTO DE CASTRO',
  },
  {
    name: 'RUA ELIAS FRANCISCO',
  },
  {
    name: 'RUA SABARA',
  },
  {
    name: 'RUA RADIAL LESTE',
  },
  {
    name: 'RUA ENG PLACIDO C JUNIOR D56',
  },
  {
    name: 'RUA DOS FARRAPOS',
  },
  {
    name: 'RUA PLINIO MONTEIRO',
  },
  {
    name: 'RUA TEODORO DE PAIVA',
  },
  {
    name: 'RUA LEOPOLDO PERES',
  },
  {
    name: 'RUA FRANCISCO C MENDES',
  },
  {
    name: 'RUA CEL JOAO PAULINO',
  },
  {
    name: 'RUA JORGE RAUPP',
  },
  {
    name: 'RUA VALDEMAR FIGUEIREDO',
  },
  {
    name: 'RUA SEBASTIAO DE FREITAS',
  },
  {
    name: 'RUA GODOFREDO OLIVEIRA',
  },
  {
    name: 'RUA OLIMPIO NORONHA',
  },
  {
    name: 'TR MANUEL BATISTA',
  },
  {
    name: 'RUA CRISTIANO OTONE',
  },
  {
    name: 'RUA FRIEZIO BARROSO',
  },
  {
    name: 'ET PAVUNA',
  },
  {
    name: 'RUA RAIMUNDO MAIA',
  },
  {
    name: 'RUA BELO VALE',
  },
  {
    name: 'RUA ALTO DA SAUDE',
  },
  {
    name: 'RUA JOAO GADELHA',
  },
  {
    name: 'RUA SAO JOSE D44',
  },
  {
    name: 'RUA CLEMENTE',
  },
  {
    name: 'RUA JOAO DE FRANCA (DENDÊ)',
  },
  {
    name: 'RUA CAMPO MAIOR',
  },
  {
    name: 'RUA TIBIRICA',
  },
  {
    name: 'RUA JOSIAS MENDES',
  },
  {
    name: 'RUA NELSON STUDART',
  },
  {
    name: 'RUA MARIANA F LEITE',
  },
  {
    name: 'RUA MARIINHA HOLANDA',
  },
  {
    name: 'RUA FRANCISCO F FILHO',
  },
  {
    name: 'RUA IVO REBOUCAS',
  },
  {
    name: 'RUA PAULO R PINHEIRO',
  },
  {
    name: 'RUA MARTA MARIA',
  },
  {
    name: 'RUA CARLOTA PINHEIRO',
  },
  {
    name: 'RUA FRANCISCO XEREZ',
  },
  {
    name: 'RUA SAMYA KARLA',
  },
  {
    name: 'RUA ALBERT SABIN',
  },
  {
    name: 'RUA MON PAULO D56',
  },
  {
    name: 'TR DOM LUIS',
  },
  {
    name: 'RUA DES CARVALHO LIMA D56',
  },
  {
    name: 'RUA AMADOR BUENO',
  },
  {
    name: 'RUA JULIA SALES',
  },
  {
    name: 'TR AFONSO DE SOUSA',
  },
  {
    name: 'RUA LUIZ GAMA',
  },
  {
    name: 'RUA LUCIANA DO VALE',
  },
  {
    name: 'RUA JUSTINO CAFE NETO',
  },
  {
    name: 'RUA E CJ SANTA LUZIA',
  },
  {
    name: 'RUA FENIX',
  },
  {
    name: 'RUA EX-COMBATENTE',
  },
  {
    name: 'RUA LUCIANA NUNES',
  },
  {
    name: 'RUA F CJ PQ WASHINGTON',
  },
  {
    name: 'RUA E CJ PQ WASHINGTON',
  },
  {
    name: 'RUA MONTALVAO D56',
  },
  {
    name: 'ST CEDRO',
  },
  {
    name: 'RUA MAJ VIRGILIO BORBA D56',
  },
  {
    name: 'RUA SITIO MEL D56',
  },
  {
    name: 'RUA PLINIO CAMARA',
  },
  {
    name: 'RUA JUCA D56',
  },
  {
    name: 'RUA GAL OLAVO OLIVEIRA ALBUQUERQUE',
  },
  {
    name: 'RUA ESAU BENICIO',
  },
  {
    name: 'RUA DR HERMES LIMA',
  },
  {
    name: 'RUA DR EXPEDITO M CHAVES',
  },
  {
    name: 'RUA PRO JURACI DE OLIVEIRA',
  },
  {
    name: 'RUA PRO ELADIO MAGALHAES',
  },
  {
    name: 'RUA PRO ISAIAS GOMES',
  },
  {
    name: 'RUA SIDNEY NETO',
  },
  {
    name: 'RUA IACO FERNANDES',
  },
  {
    name: 'RUA DR GONDIM DE OLIVEIRA',
  },
  {
    name: 'RUA ESTEVAO T DE MIRANDA',
  },
  {
    name: 'RUA FRANCISCO SEGUNDO DA COSTA',
  },
  {
    name: 'RUA EDMAR VILLAR QUEIROZ',
  },
  {
    name: 'RUA ADOLFO M CARVALHO',
  },
  {
    name: 'RUA I CJ DO IPASE',
  },
  {
    name: 'RUA DR CARLOS R PAMPLONA',
  },
  {
    name: 'AV DES FLORIANO BENEVIDES',
  },
  {
    name: 'RUA H CJ DO IPASE',
  },
  {
    name: 'RUA E CJ DO IPASE',
  },
  {
    name: 'RUA VER JOSE BATISTA BARBOSA',
  },
  {
    name: 'RUA ALBERTO JUNIOR',
  },
  {
    name: 'RUA OTAVIO ROCHA',
  },
  {
    name: 'RUA OTAVIO COSTA',
  },
  {
    name: 'RUA UBAITABA',
  },
  {
    name: 'RUA ROBERTO SILVA',
  },
  {
    name: 'RUA LUCAS FRANCISCO ANTONIO',
  },
  {
    name: 'RUA VALDECI LEITE',
  },
  {
    name: 'RUA FRANCISCO DANTAS',
  },
  {
    name: 'TR ADAIL',
  },
  {
    name: 'RUA COMERCIO D57',
  },
  {
    name: 'RUA JAIME ALMEIDA',
  },
  {
    name: 'RUA VALDIR SA',
  },
  {
    name: 'RUA DO GELO',
  },
  {
    name: 'TR MURITIBA',
  },
  {
    name: 'RUA JOAQUIM VITORINO',
  },
  {
    name: 'RUA CELESTE ARRUDA',
  },
  {
    name: 'RUA CLARINDO PEREIRA',
  },
  {
    name: 'RUA MARTINS DE CASTRO',
  },
  {
    name: 'TR LUIS DO CARMO D57',
  },
  {
    name: 'VL DEDE',
  },
  {
    name: 'RUA MARIA IVONE',
  },
  {
    name: 'RUA PETRONIO PORTELA',
  },
  {
    name: 'RUA AGUAS DE PRATA',
  },
  {
    name: 'RUA SGT JOAO PINHEIRO',
  },
  {
    name: 'RUA MARTINS JUNIOR',
  },
  {
    name: 'TR PDE MOACIR',
  },
  {
    name: 'RUA CAP SANTOS D60',
  },
  {
    name: 'RUA BRAS VIDAL',
  },
  {
    name: 'RUA VILA NOVA D60',
  },
  {
    name: 'RUA JOANA SOARES',
  },
  {
    name: 'RUA NENEN ARRUDA',
  },
  {
    name: 'RUA FUGENCIO CRUZ',
  },
  {
    name: 'RUA DR ESMERINDO PARENTE',
  },
  {
    name: 'RUA DR OSVALDO AGUIAR D60',
  },
  {
    name: 'RUA ROBERTO GRADVOHL',
  },
  {
    name: 'RUA MARTINS JUNIOR D60',
  },
  {
    name: 'TR SAO MIGUEL D60',
  },
  {
    name: 'RUA MANUEL TEIXEIRA',
  },
  {
    name: 'RUA STO HIPOLITO',
  },
  {
    name: 'RUA JOSE MARTINIANO DE ALENCAR',
  },
  {
    name: 'RUA CLODOALDO ARRUDA',
  },
  {
    name: 'RUA MOREIRA LEITE',
  },
  {
    name: 'RUA SAO JOAQUIM  D60',
  },
  {
    name: 'TR CAPRICHO',
  },
  {
    name: 'RUA LINDOLFO BRAGA',
  },
  {
    name: 'TR JOAQUIM PESSOA',
  },
  {
    name: 'RUA ALODIA',
  },
  {
    name: 'RUA ARARIPE JUNIOR',
  },
  {
    name: 'TR AMANCIO VALENTE',
  },
  {
    name: 'RUA NIGERIA',
  },
  {
    name: 'RUA SABIAGUABA',
  },
  {
    name: 'RUA SAO MARCOS',
  },
  {
    name: 'RUA SAO MATEUS D58',
  },
  {
    name: 'RUA PE CARLOS DE ALENCAR',
  },
  {
    name: 'TR SGT EXPEDITO',
  },
  {
    name: 'RUA URUCUTUBA',
  },
  {
    name: 'RUA EDUARDO NOVAES',
  },
  {
    name: 'TR BARRETO',
  },
  {
    name: 'RUA MIN ABNER VASCONCELOS',
  },
  {
    name: 'RUA MARIO ALENCAR ARARIPE',
  },
  {
    name: 'RUA PASCOAL MOREIRA',
  },
  {
    name: 'RUA JOSE ANASTACIO DIAS',
  },
  {
    name: 'RUA SABINA AUGUSTA',
  },
  {
    name: 'RUA HERMINIO DE CASTRO',
  },
  {
    name: 'RUA PROCOPIO FERREIRA',
  },
  {
    name: 'RUA LIDIA BRIGIDO',
  },
  {
    name: 'RUA ONOFRE S CAVALCANTE',
  },
  {
    name: 'RUA FCO PARACAMPOS',
  },
  {
    name: 'RUA MARTINS DE JESUS',
  },
  {
    name: 'RUA CAP AVIADOR MARIO PRADO',
  },
  {
    name: 'RUA LINO CONDE D61',
  },
  {
    name: 'RUA SAPIRANGA',
  },
  {
    name: 'RUA LUIS GIRAO',
  },
  {
    name: 'RUA MAL LOTT',
  },
  {
    name: 'RUA REPUBLICA ARMENIA',
  },
  {
    name: 'RUA NUBIA BARROCAS',
  },
  {
    name: 'RUA ROSA REGINA',
  },
  {
    name: 'RUA PRO CARLOS LOBO',
  },
  {
    name: 'RUA JOAO A ALBUQUERQUE',
  },
  {
    name: 'RUA FERNANDO PINHEIRO',
  },
  {
    name: 'RUA ALICE',
  },
  {
    name: 'RUA PINHEIRO MAIA',
  },
  {
    name: 'RUA ROSA FIALHO',
  },
  {
    name: 'RUA JOSE FRAGA NETO',
  },
  {
    name: 'RUA LOURIVAL C PINHO',
  },
  {
    name: 'RUA PRO MARTINS DE AGUIAR',
  },
  {
    name: 'TR HERMES',
  },
  {
    name: 'RUA TEN TITO BARROS',
  },
  {
    name: 'AV SAUDADE D68',
  },
  {
    name: 'RUA MARIA AMELIA ALVES',
  },
  {
    name: 'RUA GIOVANI BATISTA',
  },
  {
    name: 'RUA HERLITO FREIRE',
  },
  {
    name: 'RUA MOURA MATOS',
  },
  {
    name: 'RUA SAO CIPRIANO',
  },
  {
    name: 'RUA AMANCIO PEREIRA',
  },
  {
    name: 'RUA JOSE LITO OLIVEIRA',
  },
  {
    name: 'RUA BARBACENA D68',
  },
  {
    name: 'RUA ACARAPE',
  },
  {
    name: 'RUA IPAUMIRIM D68',
  },
  {
    name: 'RUA ITABORAI D68',
  },
  {
    name: 'RUA DAS OLIVEIRAS',
  },
  {
    name: 'RUA ALENCAR OLIVEIRA',
  },
  {
    name: 'RUA MENOR JERONIMO',
  },
  {
    name: 'RUA POMPILIO GOMES',
  },
  {
    name: 'RUA BEM VINDA',
  },
  {
    name: 'RUA CEL JUSTINO F RAMOS',
  },
  {
    name: 'RUA JOSE BONFIM JUNIOR',
  },
  {
    name: 'RUA 5688 D64',
  },
  {
    name: 'RUA LOURDES VIDAL ALVES',
  },
  {
    name: 'RUA JOAO BEZERRA',
  },
  {
    name: 'RUA JOAO RODRIGUES',
  },
  {
    name: 'RUA ANTONINO BARROS',
  },
  {
    name: 'RUA JOSE COELHO MELO',
  },
  {
    name: 'RUA JOSE CAETANO',
  },
  {
    name: 'RUA CEL JOAQUIM PONTES',
  },
  {
    name: 'RUA JOSE BELCHIOR',
  },
  {
    name: 'RUA FRANCISCO F BAIMA',
  },
  {
    name: 'RUA JOSE PEREIRA BARROS',
  },
  {
    name: 'RUA PRO JOSE HENRIQUE',
  },
  {
    name: 'RUA B CJ LUSTOSA PALMARES',
  },
  {
    name: 'RUA PEDRO LOPES D64',
  },
  {
    name: 'RUA ANTONIO MAGALHAES',
  },
  {
    name: 'RUA JILO (5713 D64)',
  },
  {
    name: 'RUA PORFIRIO COSTA',
  },
  {
    name: 'RUA AMBROSIO DE CARVALHO',
  },
  {
    name: 'RUA FRANCISCO ROCHA',
  },
  {
    name: 'AV IZABEL M ALENCAR',
  },
  {
    name: 'RUA JOAQUIM FERREIRA',
  },
  {
    name: 'RUA FRE GALVAO D64',
  },
  {
    name: 'RUA CAJARANA',
  },
  {
    name: 'RUA CAJAZEIRAS',
  },
  {
    name: 'RUA LARANJEIRA',
  },
  {
    name: 'RUA PEDRO ADRIANO',
  },
  {
    name: 'RUA WASHINGTON DE MORAIS',
  },
  {
    name: 'RUA LUIZA GUIMARAES',
  },
  {
    name: 'RUA FRANCISCO AVELINO',
  },
  {
    name: 'RUA MARIA BEZERRA',
  },
  {
    name: 'RUA SAO FRANCISCO D64',
  },
  {
    name: 'RUA JATOBA D64',
  },
  {
    name: 'RUA CAMPOS GERAIS',
  },
  {
    name: 'RUA PRO ALMINO',
  },
  {
    name: 'RUA TEN NICOLAU',
  },
  {
    name: 'RUA LUIS ANDRE',
  },
  {
    name: 'RUA MARIA BASTOS',
  },
  {
    name: 'TR ENF JOAQUIM PINTO',
  },
  {
    name: 'RUA MONTE ALEGRE',
  },
  {
    name: 'RUA RIO TINTO',
  },
  {
    name: 'RUA JAQUELINE',
  },
  {
    name: 'RUA MARIA PERDIGAO',
  },
  {
    name: 'RUA FRANCISCO IGOR',
  },
  {
    name: 'RUA LOURALBER MONTEIRO',
  },
  {
    name: 'RUA HUMBERTO TEIXEIRA',
  },
  {
    name: 'RUA LEONCIO REBOUCAS D63',
  },
  {
    name: 'RUA JOSE HOLANDA FREITAS',
  },
  {
    name: 'RUA NOEMIA',
  },
  {
    name: 'RUA BEATRIZ',
  },
  {
    name: 'RUA ICARASSU D63',
  },
  {
    name: 'RUA NOSSA SEN DA GLORIA',
  },
  {
    name: 'RUA JOR ANTONIO P TAVARES',
  },
  {
    name: 'RUA DIAGONAL (ANTIGA RUA 11) (BARROSO)',
  },
  {
    name: 'RUA 30 DE MAIO D73',
  },
  {
    name: 'RUA ITAPERONA',
  },
  {
    name: 'RUA SAO FRANCISCO D73',
  },
  {
    name: 'RUA SAO RAIMUNDO D71',
  },
  {
    name: 'AV PENETRACAO OESTE I',
  },
  {
    name: 'RUA STA MONICA',
  },
  {
    name: 'RUA JOSE PARENTE D71',
  },
  {
    name: 'RUA BENTO GONCALVES',
  },
  {
    name: 'TR REJANE',
  },
  {
    name: 'RUA CLUBE',
  },
  {
    name: 'RUA CACHOEIRA ALEGRE',
  },
  {
    name: 'RUA NORDICA',
  },
  {
    name: 'RUA RIO DOCE',
  },
  {
    name: 'RUA CARLOS MAGNO',
  },
  {
    name: 'RUA ALVARES CABRAL',
  },
  {
    name: 'RUA ANTONIO JACO',
  },
  {
    name: 'RUA RAIMUNDO ARISTIDES',
  },
  {
    name: 'RUA FRANCISCO ALMEIDA',
  },
  {
    name: 'RUA VICENTE CELESTINO',
  },
  {
    name: 'RUA PRO CABRAL',
  },
  {
    name: 'RUA FRANCISCO B DA SILVA',
  },
  {
    name: 'RUA VITORIA REGIA',
  },
  {
    name: 'RUA AURELIANO LEAL',
  },
  {
    name: 'RUA GETULIO VARGAS  D-71',
  },
  {
    name: 'RUA CEREJEIRAS',
  },
  {
    name: 'RUA MARGARIDAS',
  },
  {
    name: 'RUA FIS ASSIS SARAIVA',
  },
  {
    name: 'RUA ANTONIO FERREIRA',
  },
  {
    name: 'RUA ANTONIO FARIAS',
  },
  {
    name: 'RUA CORUMBA',
  },
  {
    name: 'RUA TULIPA NEGRA',
  },
  {
    name: 'RUA ANA BRITO',
  },
  {
    name: 'RUA DR PROCOPIO',
  },
  {
    name: 'RUA MARTINS DE LIMA',
  },
  {
    name: 'RUA LICINEIDE GOMES',
  },
  {
    name: 'RUA 20 DE ABRIL',
  },
  {
    name: 'RUA 6 DE JANEIRO',
  },
  {
    name: 'RUA 25 DE DEZEMBRO',
  },
  {
    name: 'RUA PEROLINA DE MORAIS',
  },
  {
    name: 'RUA DNA ZENAIDE SABOIA',
  },
  {
    name: 'RUA JOAQUIM MACHADO',
  },
  {
    name: 'RUA SAO JAIRO',
  },
  {
    name: 'RUA GUARANI D65',
  },
  {
    name: 'RUA JOCENO MONTEIRO',
  },
  {
    name: 'RUA CEL ANTONIO SAMPAIO',
  },
  {
    name: 'TR MANOEL ALEXANDRE',
  },
  {
    name: 'ET GUARANI D65',
  },
  {
    name: 'RUA ANTERO QUENTAL',
  },
  {
    name: 'RUA 2 DE ABRIL',
  },
  {
    name: 'RUA TABEBUIA (5966 D64)',
  },
  {
    name: 'RUA DUARTE COELHO',
  },
  {
    name: 'RUA CEL XAVIER CHAVES',
  },
  {
    name: 'RUA STA ROSA D65 (COAÇU)',
  },
  {
    name: 'RUA HUMBERTO RODRIGUES',
  },
  {
    name: 'RUA SERGIO PORTO',
  },
  {
    name: 'RUA COM ROCHA D72',
  },
  {
    name: 'RUA LUCAS AVELINO',
  },
  {
    name: 'RUA LAGO AZUL',
  },
  {
    name: 'RUA MIGUEL PEREIRA',
  },
  {
    name: 'RUA ROSA PEREIRA',
  },
  {
    name: 'RUA ZULEICA PONTES',
  },
  {
    name: 'RUA ANTONIO BARBOSA',
  },
  {
    name: 'RUA RUA 6000 D72',
  },
  {
    name: 'RUA LEITAO CERQUEIRA',
  },
  {
    name: 'RUA VIRGILIO NETO',
  },
  {
    name: 'RUA CEL QUEIROZ',
  },
  {
    name: 'RUA SAPICUA D64',
  },
  {
    name: 'RUA GAL AFONSO A LIMA',
  },
  {
    name: 'RUA ANTONIO PEREIRA',
  },
  {
    name: 'RUA JOAO SALES',
  },
  {
    name: 'RUA PERO DE GOIS',
  },
  {
    name: 'RUA RETIRO DA FELICIDADE',
  },
  {
    name: 'RUA NOVA FORTALEZA (MONDUBIM)',
  },
  {
    name: 'RUA PARANAI',
  },
  {
    name: 'RUA TEN MATIAS PEIXOTO',
  },
  {
    name: 'RUA AMARAL PEIXOTO',
  },
  {
    name: 'RUA JOAQUIM DOS ANJOS',
  },
  {
    name: 'RUA JOAO ARAUJO LIMA',
  },
  {
    name: 'VL JOAO GUALBERTO',
  },
  {
    name: 'RUA 6040 D64',
  },
  {
    name: 'RUA BREJO SANTO D69',
  },
  {
    name: 'RUA CEL ALIPIO CUNHA',
  },
  {
    name: 'RUA CEL JOSE DE MOURA',
  },
  {
    name: 'RUA CAP PORFIRIO',
  },
  {
    name: 'RUA CAP HERMINIO',
  },
  {
    name: 'RUA PEDRO DE SOUZA',
  },
  {
    name: 'RUA CASTRO VIEIRA',
  },
  {
    name: 'RUA FRANCISCO COSTA',
  },
  {
    name: 'ET DO ANCURI',
  },
  {
    name: 'RUA VALDEMAR SIMOES',
  },
  {
    name: 'RUA IRMAOS FONTENELE',
  },
  {
    name: 'AV ISABEL BEZERRA',
  },
  {
    name: 'RUA HONORATO SILVA',
  },
  {
    name: 'RUA SGT SERPA',
  },
  {
    name: 'RUA GUILHERME ALMEIDA',
  },
  {
    name: 'RUA CRUZEIRO D69',
  },
  {
    name: 'RUA TEODORICO CRUZ',
  },
  {
    name: 'RUA SAO DIOGO D63',
  },
  {
    name: 'RUA ROSA VIRGINIA',
  },
  {
    name: 'RUA FRANCISCA N RAMOS',
  },
  {
    name: 'RUA RIO GRANDENSE',
  },
  {
    name: 'RUA HONORINA MAIA',
  },
  {
    name: 'RUA CEL ZACARIAS J FRANCA',
  },
  {
    name: 'RUA CARLOS PIMENTA',
  },
  {
    name: 'RUA ILHEUS',
  },
  {
    name: 'RUA CRISTO SALVADOR',
  },
  {
    name: 'RUA JULIA VIEIRA',
  },
  {
    name: 'RUA TAQUARA D72',
  },
  {
    name: 'RUA PAULINA ARRUDA',
  },
  {
    name: 'RUA ADELAIDE PAULINO',
  },
  {
    name: 'RUA SHIRLEY',
  },
  {
    name: 'RUA JOAO CRISPIM D65',
  },
  {
    name: 'RUA PENSAMENTO',
  },
  {
    name: 'RUA CAXAMBU',
  },
  {
    name: 'RUA CAMPINENSE',
  },
  {
    name: 'RUA DOURADO D69',
  },
  {
    name: 'RUA BABACU',
  },
  {
    name: 'RUA CODO',
  },
  {
    name: 'RUA SAQUAREMA',
  },
  {
    name: 'RUA AVARE',
  },
  {
    name: 'RUA SERRA AZUL',
  },
  {
    name: 'RUA DIADEMA',
  },
  {
    name: 'AV DO VAQUEIRO',
  },
  {
    name: 'RUA JURANDIR L ALENCAR',
  },
  {
    name: 'RUA DR CONDES SANDOVAL',
  },
  {
    name: 'RUA MODESTA',
  },
  {
    name: 'RUA CABO VERDE',
  },
  {
    name: 'AV IRACEMA (CJ PALMEIRAS)',
  },
  {
    name: 'RUA ANGELA DINIZ',
  },
  {
    name: 'RUA JORGE FIGUEIREDO (ANCURI)',
  },
  {
    name: 'TR BENVINDO AGUIAR',
  },
  {
    name: 'RUA RIO VERDE D71',
  },
  {
    name: 'RUA MARIA GOMES DE SA',
  },
  {
    name: 'RUA PORTO FRANCO',
  },
  {
    name: 'RUA JAIME CALADO',
  },
  {
    name: 'TR CARLOS JATHAY',
  },
  {
    name: 'RUA 616 CJ CEARA',
  },
  {
    name: 'RUA 448 A CJ CEARA',
  },
  {
    name: 'RUA DR WALTER PORTO',
  },
  {
    name: 'RUA EDUARDO ARAUJO',
  },
  {
    name: 'RUA NOGUEIRA DA COSTA',
  },
  {
    name: 'RUA CATOLE',
  },
  {
    name: 'RUA FRANCISCO NOGUEIRA',
  },
  {
    name: 'RUA MOCAMBIQUE',
  },
  {
    name: 'RUA GENTIL CARDOSO',
  },
  {
    name: 'RUA RICARDO PONTES',
  },
  {
    name: 'RUA DA AMIZADE D73',
  },
  {
    name: 'RUA HUMAITA D73',
  },
  {
    name: 'RUA ALVES BATISTA',
  },
  {
    name: 'RUA PERILIO TEIXEIRA',
  },
  {
    name: 'RUA JOSE MENDONCA',
  },
  {
    name: 'RUA ANASTACIO BRAGA',
  },
  {
    name: 'RUA 24 DE OUTUBRO',
  },
  {
    name: 'RUA BOA ESPERANCA D73',
  },
  {
    name: 'TR JOAO BARBOSA LIMA',
  },
  {
    name: 'TR ZORAIDE BARBOSA',
  },
  {
    name: 'RUA JOAO PAULO I',
  },
  {
    name: 'RUA SAMUEL GURGEL D41',
  },
  {
    name: 'RUA POSSIDONIO S CAMPO',
  },
  {
    name: 'RUA MARCELO SANTA FE',
  },
  {
    name: 'ET DO JATOBA',
  },
  {
    name: 'RUA A PQ SAO JOAO',
  },
  {
    name: 'RUA C PQ SAO JOAO',
  },
  {
    name: 'RUA D PQ SAO JOAO',
  },
  {
    name: 'RUA E PQ SAO JOAO',
  },
  {
    name: 'RUA F PQ SAO JOAO',
  },
  {
    name: 'RUA DALAS',
  },
  {
    name: 'RUA LUIZA CAMINHA',
  },
  {
    name: 'RUA CONFIANCA D63',
  },
  {
    name: 'RUA HOMERO C BRANCO',
  },
  {
    name: 'RUA PRO ALDACY BARBOSA',
  },
  {
    name: 'AV VIENA WEYNE',
  },
  {
    name: 'RUA PRO SOLON FARIAS',
  },
  {
    name: 'RUA SEN PAULA PESSOA',
  },
  {
    name: 'RUA DEP FIGUEIREDO CORREIA',
  },
  {
    name: 'AV DEP JOAQUIM F CORREIA',
  },
  {
    name: 'RUA PEDRO LAZAR',
  },
  {
    name: 'RUA CARLOS BRAGA',
  },
  {
    name: 'AV CANDIDO PORTINARI',
  },
  {
    name: 'RUA ALISSON BATISTA DE MEDEIROS',
  },
  {
    name: 'RD QUARTO ANEL VIARIO',
  },
  {
    name: 'RUA ANDREAS',
  },
  {
    name: 'RUA PAP PAULO VI',
  },
  {
    name: 'RUA PASCOAL BARROSO',
  },
  {
    name: 'RUA JURACI MAGALHAES',
  },
  {
    name: 'RUA CLOVIS BEVILAQUA',
  },
  {
    name: 'RUA DOM DELGADO',
  },
  {
    name: 'RUA JOAO BATISTA RIOS',
  },
  {
    name: 'RUA EDUARDO DIAS',
  },
  {
    name: 'RUA TEN BEZERRA D68',
  },
  {
    name: 'RUA ITAREMA',
  },
  {
    name: 'RUA DES OTACILIO PEIXOTO',
  },
  {
    name: 'RUA PRO ODILIO FILHO',
  },
  {
    name: 'RUA ARMANDO LOUZADA',
  },
  {
    name: 'RUA MON OTAVIO SANTIAGO',
  },
  {
    name: 'RUA CANAA',
  },
  {
    name: 'TR ALMOFALA',
  },
  {
    name: 'RUA SAO JOAO JANGURUSSU',
  },
  {
    name: 'RUA ACARI',
  },
  {
    name: 'RUA DR CORREIA LIMA',
  },
  {
    name: 'AV RECREIO D64',
  },
  {
    name: 'RUA DOM SILVERIO D60',
  },
  {
    name: 'RUA DATIVA BARRETO',
  },
  {
    name: 'RUA MATIAS BARBOSA',
  },
  {
    name: 'RUA DR JOSE PERDIGAO',
  },
  {
    name: 'RUA DR JOSE PLUTARCO',
  },
  {
    name: 'RUA VICENTE GURGEL',
  },
  {
    name: 'RUA CRAVILANDIA',
  },
  {
    name: 'RUA AGUA VERDE D30',
  },
  {
    name: 'RUA NUNES FEIJO',
  },
  {
    name: 'RUA PEDRO A SILVA',
  },
  {
    name: 'RUA MANOEL DE L VALENTE',
  },
  {
    name: 'RUA CARRAPICHO',
  },
  {
    name: 'RUA CIRO MONTEIRO',
  },
  {
    name: 'RUA GISELE',
  },
  {
    name: 'RUA JOSE BENIGNO SOARES',
  },
  {
    name: 'RUA GERALDO MAGALHAES',
  },
  {
    name: 'AV TRAIRA',
  },
  {
    name: 'RUA JERXELIM',
  },
  {
    name: 'RUA JAMACARU',
  },
  {
    name: 'RUA DO PEREIRO',
  },
  {
    name: 'RUA MANDACARU D69',
  },
  {
    name: 'RUA MUIRA',
  },
  {
    name: 'RUA JABORANDI',
  },
  {
    name: 'RUA JUA',
  },
  {
    name: 'RUA CAROA CJ A TAMANDARE',
  },
  {
    name: 'RUA MARIA P CAMPELO',
  },
  {
    name: 'RUA GERARDO MAG S FROTA',
  },
  {
    name: 'RUA PRA EMILIA PEREIRA',
  },
  {
    name: 'RUA ALUISIO BARROS LEAL',
  },
  {
    name: 'AV DEP PAULINO ROCHA',
  },
  {
    name: 'RUA JULIO MACIEL (MANUEL SATIRO)',
  },
  {
    name: 'RUA MAGNA',
  },
  {
    name: 'RUA CICERO ALVES SOUZA',
  },
  {
    name: 'RUA MARTINS ARAUJO',
  },
  {
    name: 'RUA ADEMAR DE CASTRO',
  },
  {
    name: 'RUA RIO JORDAO',
  },
  {
    name: 'RUA FRANCISCO RAMOS',
  },
  {
    name: 'RUA OLGA ESPINDOLA',
  },
  {
    name: 'RUA PRO MANDUCA',
  },
  {
    name: 'RUA GISELDA CISNE',
  },
  {
    name: 'RUA UMARIZEIRA',
  },
  {
    name: 'RUA RAIMUNDO MATIAS',
  },
  {
    name: 'RUA IRM AMALIA',
  },
  {
    name: 'VL PDE GONCALVES D60',
  },
  {
    name: 'VL DNA IRENE',
  },
  {
    name: 'VL DNA AMELIA',
  },
  {
    name: 'RUA POCOS DE CALDAS',
  },
  {
    name: 'RUA JOSE EVARISTO',
  },
  {
    name: 'RUA DOS TREVOS',
  },
  {
    name: 'RUA NICACIO PINTO',
  },
  {
    name: 'RUA MARIA QUINTINO',
  },
  {
    name: 'RUA F PQ MORUMBI',
  },
  {
    name: 'RUA G PQ MORUMBI',
  },
  {
    name: 'RUA H PQ MORUMBI',
  },
  {
    name: 'RUA N PQ MORUMBI',
  },
  {
    name: 'RUA K JOAO PAULO II (D63)',
  },
  {
    name: 'RUA E PQ MORUMBI',
  },
  {
    name: 'RUA PAU D ARCO',
  },
  {
    name: 'RUA ELZA  L ALBUQUERQUE',
  },
  {
    name: 'RUA ARAGUARI',
  },
  {
    name: 'RUA AFONSO DE SOUSA',
  },
  {
    name: 'RUA MARIA RIBEIRO',
  },
  {
    name: 'RUA NELSON COELHO',
  },
  {
    name: 'RUA PEDRO H VASCONCELOS',
  },
  {
    name: 'RUA JOSE ANDRE D64',
  },
  {
    name: 'RUA CEL LUIS FIDELIS',
  },
  {
    name: 'RUA OSORIO CORREIA',
  },
  {
    name: 'RUA ZEZA PONTES',
  },
  {
    name: 'RUA VER PAULO MAMEDE',
  },
  {
    name: 'RUA ARMANDO PAIVA D34',
  },
  {
    name: 'RUA SETEMBRINA',
  },
  {
    name: 'RUA PRO EDUARDO BARROS LEAL',
  },
  {
    name: 'RUA ANTONIO PITA',
  },
  {
    name: 'RUA MARIA MIRIAN F  DE SOUZA',
  },
  {
    name: 'RUA 3 LT SINCOL',
  },
  {
    name: 'RUA 2 LT SINCOL',
  },
  {
    name: 'RUA JOSE ADAIL DOS SANTOS',
  },
  {
    name: 'RUA AYMAR RODRIGUES',
  },
  {
    name: 'RUA I CIDADE OESTE',
  },
  {
    name: 'RUA II CIDADE OESTE',
  },
  {
    name: 'RUA III CIDADE OESTE',
  },
  {
    name: 'RUA IV CIDADE OESTE',
  },
  {
    name: 'RUA VI CIDADE OESTE',
  },
  {
    name: 'RUA VII CIDADE OESTE',
  },
  {
    name: 'RUA VIII CIDADE OESTE',
  },
  {
    name: 'RUA GENIPO FERNANDES',
  },
  {
    name: 'RUA LUIS COSTA FILHO',
  },
  {
    name: 'RUA DNA LUCIA PINHEIRO (QUINTINO CUNHA)',
  },
  {
    name: 'RUA XII CIDADE OESTE',
  },
  {
    name: 'RUA EMILIO CHASTINET FILHO',
  },
  {
    name: 'RUA XIV CIDADE OESTE',
  },
  {
    name: 'RUA XV CIDADE OESTE',
  },
  {
    name: 'RUA XVI CIDADE OESTE',
  },
  {
    name: 'RUA XVII CIDADE OESTE',
  },
  {
    name: 'RUA XIX CIDADE OESTE',
  },
  {
    name: 'RUA STA MARIA GORETE',
  },
  {
    name: 'RUA XXIV CIDADE OESTE',
  },
  {
    name: 'RUA XXVI CIDADE OESTE',
  },
  {
    name: 'RUA XXV CIDADE OESTE',
  },
  {
    name: 'RUA IPIRANGA D29',
  },
  {
    name: 'RUA XXVIII CIDADE OESTE',
  },
  {
    name: 'RUA XX CIDADE OESTE',
  },
  {
    name: 'RUA XXI CIDADE OESTE',
  },
  {
    name: 'RUA SULAMITA PORTELA',
  },
  {
    name: 'RUA XXIX CIDADE OESTE',
  },
  {
    name: 'RUA SAO LEOPOLDO D69',
  },
  {
    name: 'RUA CAMPANARIO',
  },
  {
    name: 'RUA RUA 6765 D44',
  },
  {
    name: 'RUA F CJ ITAPERI',
  },
  {
    name: 'RUA E CJ ITAPERI',
  },
  {
    name: 'RUA B CJ ITAPERI',
  },
  {
    name: 'RUA D CJ ITAPERI',
  },
  {
    name: 'RUA C CJ ITAPERI',
  },
  {
    name: 'RUA JOAO BARBOSA LIMA',
  },
  {
    name: 'RUA BRAZ CUBA',
  },
  {
    name: 'RUA ISRAEL ALVES DE LIMA',
  },
  {
    name: 'RUA VIL ADERALDO',
  },
  {
    name: 'RUA JOAO FAUSTINO RIBEIR',
  },
  {
    name: 'RUA PEDRO CARDONIO UCHOA',
  },
  {
    name: 'RUA SAO TEMOTEO',
  },
  {
    name: 'RUA REV OSMAR LIMA',
  },
  {
    name: 'RUA SAO FELIPE D71',
  },
  {
    name: 'RUA STO AGOSTINHO D71',
  },
  {
    name: 'RUA PRA MORENINHA IRENEU',
  },
  {
    name: 'RUA A CJ ITAPERI',
  },
  {
    name: 'RUA EST SILVIO CARNEIRO',
  },
  {
    name: 'RUA PDE ATAIDE',
  },
  {
    name: 'RUA TAB JOAQUIM COELHO',
  },
  {
    name: 'RUA RAIMUNDO ALEXANDRE',
  },
  {
    name: 'RUA ANTONIO RABELO',
  },
  {
    name: 'RUA CAR ALBINO',
  },
  {
    name: 'RUA FRANCISCO LEANDRO',
  },
  {
    name: 'RUA DR SOCORRO AZEVEDO',
  },
  {
    name: 'RUA FRANCISCO JOSE COSTA',
  },
  {
    name: 'RUA MARIANA P BANDEIRA',
  },
  {
    name: 'RUA AUGUSTA AZEVEDO',
  },
  {
    name: 'RUA 1 LT ARVOREDO',
  },
  {
    name: 'RUA 2 LT ARVOREDO',
  },
  {
    name: 'RUA 3 LT ARVOREDO',
  },
  {
    name: 'RUA 6 LT ARVOREDO',
  },
  {
    name: 'AV 1 LOT ARVOREDO',
  },
  {
    name: 'RUA 7 LT ARVOREDO',
  },
  {
    name: 'RUA 8 LT ARVOREDO',
  },
  {
    name: 'AV 2 LT ARVOREDO',
  },
  {
    name: 'RUA 16 LT ARVOREDO',
  },
  {
    name: 'RUA 15 LT ARVOREDO',
  },
  {
    name: 'RUA 5 LT ARVOREDO',
  },
  {
    name: 'RUA 11 LT ARVOREDO',
  },
  {
    name: 'RUA NOVA JERUSALEM',
  },
  {
    name: 'RUA JOSE MOGICA',
  },
  {
    name: 'RUA BRUMADO',
  },
  {
    name: 'RUA MACIEL BRITO',
  },
  {
    name: 'RUA JOAO JACO',
  },
  {
    name: 'RUA D LT CENTRO SUL',
  },
  {
    name: 'RUA F LT CENTRO SUL',
  },
  {
    name: 'RUA G LT CENTRO SUL',
  },
  {
    name: 'RUA MES JERONIMO D48',
  },
  {
    name: 'RUA DAS JAQUEIRAS',
  },
  {
    name: 'RUA JABUTICABA',
  },
  {
    name: 'RUA JACARANDA',
  },
  {
    name: 'TR MUNDIAL',
  },
  {
    name: 'RUA LERISSE PORTO',
  },
  {
    name: 'RUA JARDIM FLUMINENSE',
  },
  {
    name: 'RUA CORACAO DE MARIA',
  },
  {
    name: 'AV I CJ ESPERANCA',
  },
  {
    name: 'AV CONTORNO SUL D71',
  },
  {
    name: 'RUA DIONISIO SERQUEIRA',
  },
  {
    name: 'AV CONTORNO LESTE',
  },
  {
    name: 'RUA LUCIMAR FERNANDES',
  },
  {
    name: 'RUA M ESPLANADA CASTELAO',
  },
  {
    name: 'RUA N ESPLANADA CASTELAO',
  },
  {
    name: 'RUA O ESPLANADA CASTELAO',
  },
  {
    name: 'RUA P ESPLANADA CASTELAO',
  },
  {
    name: 'RUA R ESPLANADA CASTELAO',
  },
  {
    name: 'RUA ADELIA FEIJO',
  },
  {
    name: 'RUA B ESPL CASTELAO',
  },
  {
    name: 'RUA INES BRASIL',
  },
  {
    name: 'RUA D ESPL CASTELAO',
  },
  {
    name: 'RUA E ESPL CASTELAO',
  },
  {
    name: 'RUA F ESPL CASTELAO',
  },
  {
    name: 'RUA G ESPL CASTELAO',
  },
  {
    name: 'RUA H ESPL CASTELAO',
  },
  {
    name: 'RUA I ESPL CASTELAO',
  },
  {
    name: 'RUA 6 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 15 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 5 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 4 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 3 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 2 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 13 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 9 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 10 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 12 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 1 PLANALTO ITAPERI',
  },
  {
    name: 'RUA 11 PLANALTO ITAPERI',
  },
  {
    name: 'TR SUSANA',
  },
  {
    name: 'RUA PRO WILSON AGUIAR',
  },
  {
    name: 'RUA DEP MARTINS RODRIGUES',
  },
  {
    name: 'RUA DR ADHEMAR BRAGA',
  },
  {
    name: 'RUA AMARILIO CARTAXO',
  },
  {
    name: 'RUA TEA SILVANO SERRA',
  },
  {
    name: 'RUA ALEXANDRE A FURTADO',
  },
  {
    name: 'RUA MARIA INACIO GURGEL',
  },
  {
    name: 'RUA DNA JULIETA GURGEL',
  },
  {
    name: 'RUA MIGUEL GURGEL',
  },
  {
    name: 'RUA EFISIO GURGEL',
  },
  {
    name: 'RUA 2 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 3 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 4 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 5 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 6 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 7 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 8 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 9 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA 11 PLANALTO MIRASSOL',
  },
  {
    name: 'RUA JATAI D71',
  },
  {
    name: 'RUA ANGELIM',
  },
  {
    name: 'RUA JEQUITIBA',
  },
  {
    name: 'RUA JANGAL',
  },
  {
    name: 'RUA JANAUBA',
  },
  {
    name: 'RUA JACUNAUBA',
  },
  {
    name: 'RUA JACUPEMBA',
  },
  {
    name: 'RUA MIN JOAQUIM BASTOS D14',
  },
  {
    name: 'RUA CAMPOS NOVOS',
  },
  {
    name: 'AV CONTORNO NORTE D71',
  },
  {
    name: 'RUA MONTREAL',
  },
  {
    name: 'RUA BENEDITO DE SENA',
  },
  {
    name: 'RUA DES BALTAR',
  },
  {
    name: 'RUA DES PINTO TEIXEIRA',
  },
  {
    name: 'RUA 7062 D58',
  },
  {
    name: 'RUA 7064 D58',
  },
  {
    name: 'RUA ANTONIO VIEIRA (SABIAGUABA)',
  },
  {
    name: 'RUA CLARINDA BASTOS',
  },
  {
    name: 'RUA 7067 D58',
  },
  {
    name: 'RUA ROSA BEZERRA',
  },
  {
    name: 'RUA A CJ JD PRIMAVERA',
  },
  {
    name: 'RUA B CJ JD PRIMAVERA',
  },
  {
    name: 'RUA C CJ JD PRIMAVERA',
  },
  {
    name: 'RUA D CJ JD PRIMAVERA',
  },
  {
    name: 'RUA E CJ JD PRIMAVERA',
  },
  {
    name: 'RUA G CJ JD PRIMAVERA',
  },
  {
    name: 'RUA H CJ JD PRIMAVERA',
  },
  {
    name: 'RUA DECIO DE CASTRO',
  },
  {
    name: 'RUA JONAS BEZERRA',
  },
  {
    name: 'RUA IPAUMIRIM D72',
  },
  {
    name: 'RUA CASTRO DE ALENCAR',
  },
  {
    name: 'RUA ALCIDES GERARDO',
  },
  {
    name: 'RUA EVALDO BRAGA',
  },
  {
    name: 'RUA OSCARITO',
  },
  {
    name: 'RUA SILVINHA TELES D69',
  },
  {
    name: 'RUA MAISA',
  },
  {
    name: 'RUA TERNURA (PALMEIRAS)',
  },
  {
    name: 'RUA ISMAEL SILVA',
  },
  {
    name: 'RUA LUIZ FCO XAVIER',
  },
  {
    name: 'RUA OLIMPIO RIBEIRO',
  },
  {
    name: 'RUA PAULO MENDONCA',
  },
  {
    name: 'RUA JOSE FERREIRA PONTES',
  },
  {
    name: 'RUA FRANCISCO HIPOLITO',
  },
  {
    name: 'RUA TEN RENATO AGUIAR',
  },
  {
    name: 'RUA STO ANTONIO D71',
  },
  {
    name: 'RUA JUVENTINO CAETANO',
  },
  {
    name: 'RUA JOSE ALBINO',
  },
  {
    name: 'RUA PINDEREMIRIM',
  },
  {
    name: 'TR DEMOSEL',
  },
  {
    name: 'RUA ARAGOIANIA D34',
  },
  {
    name: 'RUA MANUEL F DE SAMPAIO',
  },
  {
    name: 'RUA 7132 D58',
  },
  {
    name: 'RUA 7133 D58',
  },
  {
    name: 'RUA 7134 D58',
  },
  {
    name: 'RUA RUA 7137 D-58',
  },
  {
    name: 'RUA GERALDO SEPULVEDA',
  },
  {
    name: 'RUA EUFRASIO FEITOSA',
  },
  {
    name: 'RUA DUARTE COUTINHO',
  },
  {
    name: 'RUA MARIA SARAIVA',
  },
  {
    name: 'RUA PRO GERALDA ARRUDA',
  },
  {
    name: 'RUA JOAO GURGEL NOGUEIRA',
  },
  {
    name: 'AV DA ECOLOGIA',
  },
  {
    name: 'RUA PLANALTINA (BONSUCESSO)',
  },
  {
    name: 'RUA JOSE JULIO FROTA',
  },
  {
    name: 'RUA BAIXA DO MILAGRE',
  },
  {
    name: 'RUA VOLTA DO RIO',
  },
  {
    name: 'RUA BARCA VELHA',
  },
  {
    name: 'RUA DA JANGADINHA',
  },
  {
    name: 'RUA DO CARANGUEJO',
  },
  {
    name: 'RUA ILHA DO BOTE',
  },
  {
    name: 'RUA DO CAMARAO',
  },
  {
    name: 'RUA DOS PESCADORES',
  },
  {
    name: 'RUA DA MANGUEIRA',
  },
  {
    name: 'RUA SEMENTE COITE',
  },
  {
    name: 'RUA HUMAITA D29',
  },
  {
    name: 'RUA DO ALTO',
  },
  {
    name: 'RUA RIO NOVO',
  },
  {
    name: 'RUA DOS AMORES',
  },
  {
    name: 'RUA BARRINHA',
  },
  {
    name: 'RUA ARAPUCA',
  },
  {
    name: 'RUA DO MEIO',
  },
  {
    name: 'TR JOSE MARQUES D69',
  },
  {
    name: 'RUA XXVII CIDADE OESTE',
  },
  {
    name: 'RUA MAD ANA COUTO',
  },
  {
    name: 'RUA CANTAREIRA',
  },
  {
    name: 'RUA 902 CJ CEARA',
  },
  {
    name: 'RUA 904 CJ CEARA',
  },
  {
    name: 'RUA 906 CJ CEARA',
  },
  {
    name: 'RUA 908 CJ CEARA',
  },
  {
    name: 'RUA 910 CJ CEARA',
  },
  {
    name: 'RUA 912 CJ CEARA',
  },
  {
    name: 'RUA 914 CJ CEARA',
  },
  {
    name: 'RUA 916 CJ CEARA',
  },
  {
    name: 'RUA 918 CJ CEARA',
  },
  {
    name: 'RUA 920 CJ CEARA',
  },
  {
    name: 'RUA 922 CJ CEARA',
  },
  {
    name: 'RUA 924 CJ CEARA',
  },
  {
    name: 'RUA 926 CJ CEARA',
  },
  {
    name: 'RUA 928 CJ CEARA',
  },
  {
    name: 'RUA 1002 CJ CEARA',
  },
  {
    name: 'RUA 1004 CJ CEARA',
  },
  {
    name: 'RUA 1006 CJ CEARA',
  },
  {
    name: 'RUA 1008 CJ CEARA',
  },
  {
    name: 'RUA 1010 CJ CEARA',
  },
  {
    name: 'RUA 1012 CJ CEARA',
  },
  {
    name: 'RUA 1014 CJ CEARA',
  },
  {
    name: 'RUA 1016 CJ CEARA',
  },
  {
    name: 'RUA 1018 CJ CEARA',
  },
  {
    name: 'RUA 1020 CJ CEARA',
  },
  {
    name: 'RUA 1022 CJ CEARA',
  },
  {
    name: 'RUA 1024 CJ CEARA',
  },
  {
    name: 'RUA 1026 CJ CEARA',
  },
  {
    name: 'RUA 1028 CJ CEARA',
  },
  {
    name: 'RUA 1030 CJ CEARA',
  },
  {
    name: 'RUA 1032 CJ CEARA',
  },
  {
    name: 'RUA 1034 CJ CEARA',
  },
  {
    name: 'RUA 1036 CJ CEARA',
  },
  {
    name: 'RUA 1038 CJ CEARA',
  },
  {
    name: 'RUA 1040 CJ CEARA',
  },
  {
    name: 'RUA 1042 CJ CEARA',
  },
  {
    name: 'RUA 1044 CJ CEARA',
  },
  {
    name: 'RUA 1046 CJ CEARA',
  },
  {
    name: 'RUA 1048 CJ CEARA',
  },
  {
    name: 'RUA 1050 CJ CEARA',
  },
  {
    name: 'RUA 1052 CJ CEARA',
  },
  {
    name: 'RUA 1054 CJ CEARA',
  },
  {
    name: 'RUA 1056 CJ CEARA',
  },
  {
    name: 'RUA 1058 CJ CEARA',
  },
  {
    name: 'RUA 1060 CJ CEARA',
  },
  {
    name: 'RUA 1062 CJ CEARA',
  },
  {
    name: 'RUA 1064 CJ CEARA',
  },
  {
    name: 'RUA 1066 CJ CEARA',
  },
  {
    name: 'RUA 1068 CJ CEARA',
  },
  {
    name: 'RUA 1070 CJ CEARA',
  },
  {
    name: 'RUA 1072 CJ CEARA',
  },
  {
    name: 'RUA 1074 CJ CEARA',
  },
  {
    name: 'RUA 1076 CJ CEARA',
  },
  {
    name: 'RUA 1078 CJ CEARA',
  },
  {
    name: 'RUA 1080 CJ CEARA',
  },
  {
    name: 'RUA 1082 CJ CEARA',
  },
  {
    name: 'RUA 1084 CJ CEARA',
  },
  {
    name: 'RUA 1086 CJ CEARA',
  },
  {
    name: 'RUA 1088 CJ CEARA',
  },
  {
    name: 'RUA 1090 CJ CEARA',
  },
  {
    name: 'RUA 1092 CJ CEARA',
  },
  {
    name: 'RUA 1094 CJ CEARA',
  },
  {
    name: 'RUA 1096 CJ CEARA',
  },
  {
    name: 'AV J CJ CEARA',
  },
  {
    name: 'RUA 1101 CJ CEARA',
  },
  {
    name: 'RUA 1103 CJ CEARA',
  },
  {
    name: 'RUA 1105 CJ CEARA',
  },
  {
    name: 'RUA 1107 CJ CEARA',
  },
  {
    name: 'RUA 1109 CJ CEARA',
  },
  {
    name: 'RUA 1111 CJ CEARA',
  },
  {
    name: 'RUA 1113 CJ CEARA',
  },
  {
    name: 'RUA 1115 CJ CEARA',
  },
  {
    name: 'RUA 1117 CJ CEARA',
  },
  {
    name: 'RUA 1119 CJ CEARA',
  },
  {
    name: 'RUA 1121 CJ CEARA',
  },
  {
    name: 'RUA 1123 CJ CEARA',
  },
  {
    name: 'RUA 1125 CJ CEARA',
  },
  {
    name: 'RUA 1127 CJ CEARA',
  },
  {
    name: 'RUA 1129 CJ CEARA',
  },
  {
    name: 'RUA 1131 CJ CEARA',
  },
  {
    name: 'RUA 1133 CJ CEARA',
  },
  {
    name: 'RUA 1135 CJ CEARA',
  },
  {
    name: 'RUA 1137 CJ CEARA',
  },
  {
    name: 'RUA 1139 CJ CEARA',
  },
  {
    name: 'RUA 1139 A CJ CEARA',
  },
  {
    name: 'RUA 1141 CJ CEARA',
  },
  {
    name: 'RUA 1143 CJ CEARA',
  },
  {
    name: 'RUA 1145 CJ CEARA',
  },
  {
    name: 'RUA 1147 CJ CEARA',
  },
  {
    name: 'RUA 1149 CJ CEARA',
  },
  {
    name: 'RUA 1151 CJ CEARA',
  },
  {
    name: 'RUA 1153 CJ CEARA',
  },
  {
    name: 'RUA 1157 CJ CEARA',
  },
  {
    name: 'RUA 1159 CJ CEARA',
  },
  {
    name: 'RUA 1161 CJ CEARA',
  },
  {
    name: 'RUA 1163 CJ CEARA',
  },
  {
    name: 'RUA 1165 CJ CEARA',
  },
  {
    name: 'RUA 1167 CJ CEARA',
  },
  {
    name: 'RUA DEOLINDO BARRETO',
  },
  {
    name: 'RUA ESIO LIMA VERDE',
  },
  {
    name: 'RUA B CJ COHABECE II',
  },
  {
    name: 'RUA SERVIDAO',
  },
  {
    name: 'VL SAO JOSE D43',
  },
  {
    name: 'RUA SOLON CARVALHO',
  },
  {
    name: 'RUA H PLANALTO MIRASSOL',
  },
  {
    name: 'RUA BOM PASTOR',
  },
  {
    name: 'AV FLAMBOYANTS',
  },
  {
    name: 'RUA LOURENCO PESSOA',
  },
  {
    name: 'RUA CEL CHICO ALVES',
  },
  {
    name: 'RUA JOAQUIM MOTA',
  },
  {
    name: 'RUA A VILA DOS TEN E SGT',
  },
  {
    name: 'RUA SAO JOSE D33',
  },
  {
    name: 'RUA PDE JOAO PIAMARTA',
  },
  {
    name: 'RUA SAO RAIMUNDO D51',
  },
  {
    name: 'RUA ESPERANCA D51',
  },
  {
    name: 'RUA PEDRO RUFINO D51',
  },
  {
    name: 'RUA PESC CHICO BINDA',
  },
  {
    name: 'RUA ESTRELA DO ORIENTE',
  },
  {
    name: 'RUA DA BOLINA',
  },
  {
    name: 'RUA DOS BUZIOS',
  },
  {
    name: 'RUA DO LABIRINTO',
  },
  {
    name: 'RUA DA LAGOSTA',
  },
  {
    name: 'RUA TERRA E MAR',
  },
  {
    name: 'AV DOS JANGADEIROS',
  },
  {
    name: 'RUA DO JERERE',
  },
  {
    name: 'RUA DO SAMBURA',
  },
  {
    name: 'RUA DO MIRANTE',
  },
  {
    name: 'RUA ALTO BONITO',
  },
  {
    name: 'RUA DOS MURICIS',
  },
  {
    name: 'RUA IEMANJA',
  },
  {
    name: 'RUA CAVALO MARINHO',
  },
  {
    name: 'RUA RAIMUNDO G HOLANDA',
  },
  {
    name: 'RUA PIXINGUINHA',
  },
  {
    name: 'AV A CJ ESPERANCA',
  },
  {
    name: 'AV B CJ ESPERANCA',
  },
  {
    name: 'AV C CJ ESPERANCA',
  },
  {
    name: 'AV D CJ ESPERANCA',
  },
  {
    name: 'AV E CJ ESPERANCA',
  },
  {
    name: 'AV F CJ ESPERANCA',
  },
  {
    name: 'AV G CJ ESPERANCA',
  },
  {
    name: 'AV PENETRACAO NORTE 71',
  },
  {
    name: 'RUA 101 CJ ESPERANCA',
  },
  {
    name: 'RUA 102 CJ ESPERANCA',
  },
  {
    name: 'RUA 103 CJ ESPERANCA',
  },
  {
    name: 'RUA 104 CJ ESPERANCA',
  },
  {
    name: 'RUA 105 CJ ESPERANCA',
  },
  {
    name: 'RUA 106 CJ ESPERANCA',
  },
  {
    name: 'RUA 107 CJ ESPERANCA',
  },
  {
    name: 'AV PENETRACAO NORTE SUL',
  },
  {
    name: 'RUA 108 CJ ESPERANCA',
  },
  {
    name: 'RUA 109 CJ ESPERANCA',
  },
  {
    name: 'RUA 110 CJ ESPERANCA',
  },
  {
    name: 'RUA 111 CJ ESPERANCA',
  },
  {
    name: 'RUA 112 CJ ESPERANCA',
  },
  {
    name: 'RUA 113 CJ ESPERANCA',
  },
  {
    name: 'AV CANAL D71',
  },
  {
    name: 'AV CONTORNO OESTE D71',
  },
  {
    name: 'RUA 101 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 102 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 103 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 104 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 105 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 106 CJ NOVO MONDUBIM',
  },
  {
    name: 'RUA 107 CJ NOVO MONDUBIM',
  },
  {
    name: 'AV CONTORNO LESTE D71',
  },
  {
    name: 'RUA JOSE BAIMA',
  },
  {
    name: 'RUA ROQUE MEDEIROS',
  },
  {
    name: 'RUA FRANCFORT',
  },
  {
    name: 'RUA FRANCISCA BEZERRA',
  },
  {
    name: 'RUA JOSE ACIOLY',
  },
  {
    name: 'RUA JOSE AGRIPINO',
  },
  {
    name: 'RUA LUMINOSA',
  },
  {
    name: 'RUA LUCAS PINTO',
  },
  {
    name: 'RUA STA LUZIA',
  },
  {
    name: 'RUA MENINO JESUS DE PRAGA',
  },
  {
    name: 'RUA MISERICORDIA',
  },
  {
    name: 'RUA ODILIO FILHO',
  },
  {
    name: 'RUA AUZIR SAMPAIO',
  },
  {
    name: 'RUA NICARAGUA',
  },
  {
    name: 'RUA SAO SERAFIM',
  },
  {
    name: 'RUA CLAUDIO M DIAS LEITE',
  },
  {
    name: 'RUA COM NATANAEL CORTEZ',
  },
  {
    name: 'VL PINHEIRO',
  },
  {
    name: 'RUA ALAMEDA OXOSSI',
  },
  {
    name: 'RUA 7 JD CASTELAO',
  },
  {
    name: 'RUA AFONSO CALIXTO',
  },
  {
    name: 'RUA A PQ ATLANTICO',
  },
  {
    name: 'RUA C PQ ATLANTICO',
  },
  {
    name: 'RUA E PQ ATLANTICO',
  },
  {
    name: 'RUA MOZART VIANA AMARAL',
  },
  {
    name: 'RUA MARIA G DE MEDEIROS',
  },
  {
    name: 'RUA RUA 7530 D 57',
  },
  {
    name: 'RUA FRANCISCO V FILHO',
  },
  {
    name: 'RUA RUA 7532 D 57',
  },
  {
    name: 'RUA RUA 7533 D 57',
  },
  {
    name: 'AV A VENEZA TROPICAL',
  },
  {
    name: 'RUA 1 VENEZA TROPICAL',
  },
  {
    name: 'RUA 3 VENEZA TROPICAL',
  },
  {
    name: 'RUA 5 VENEZA TROPICAL',
  },
  {
    name: 'RUA 2 VENEZA TROPICAL',
  },
  {
    name: 'RUA 4 VENEZA TROPICAL',
  },
  {
    name: 'RUA 6 VENEZA TROPICAL',
  },
  {
    name: 'RUA C VENEZA TROPICAL',
  },
  {
    name: 'RUA D VENEZA TROPICAL',
  },
  {
    name: 'RUA E VENEZA TROPICAL',
  },
  {
    name: 'RUA 8 VENEZA TROPICAL',
  },
  {
    name: 'RUA 9 VENEZA TROPICAL',
  },
  {
    name: 'RUA 10 VENEZA TROPICAL',
  },
  {
    name: 'RUA F VENEZA TROPICAL',
  },
  {
    name: 'RUA B VENEZA TROPICAL',
  },
  {
    name: 'RUA 1 GLEBA 4S',
  },
  {
    name: 'RUA 3 GLEBA 4S',
  },
  {
    name: 'RUA 5 GLEBA 4S',
  },
  {
    name: 'RUA 6 GLEBA 5S',
  },
  {
    name: 'RUA 7 GLEBA 4S',
  },
  {
    name: 'RUA 8 GLEBA 5S',
  },
  {
    name: 'RUA 9 GLEBA 4S',
  },
  {
    name: 'RUA 10 GLEBA 4S',
  },
  {
    name: 'RUA 11 GLEBA 4S',
  },
  {
    name: 'RUA 13 (BARROSO)',
  },
  {
    name: 'RUA 14 (BARROSO)',
  },
  {
    name: 'RUA 15 (BARROSO)',
  },
  {
    name: 'RUA 16 GLEBA 4S',
  },
  {
    name: 'RUA 17 GLEBA 5S',
  },
  {
    name: 'RUA 18 GLEBA 5S',
  },
  {
    name: 'RUA 19 GLEBA 5S',
  },
  {
    name: 'RUA 20 GLEBA 5S',
  },
  {
    name: 'RUA 1 GLEBA 5S',
  },
  {
    name: 'RUA 2 GLEBA 5S',
  },
  {
    name: 'RUA 3 GLEBA 5S',
  },
  {
    name: 'RUA 5 GLEBA 5S',
  },
  {
    name: 'RUA PDE ANTONIO NUNES GURGEL',
  },
  {
    name: 'RUA GAMA',
  },
  {
    name: 'RUA DES JOSE PASSOS FILHO',
  },
  {
    name: 'RUA MARCELINO MELO',
  },
  {
    name: 'RUA J (VILA VELHA)',
  },
  {
    name: 'RUA I',
  },
  {
    name: 'RUA LUCIANO MAGALHAES',
  },
  {
    name: 'AV ODILON GUIMARAES',
  },
  {
    name: 'AL OXALA',
  },
  {
    name: 'RUA CEL FRANCISCO ALVES RIBEIRO',
  },
  {
    name: 'RUA ARY LOBO D71',
  },
  {
    name: 'RUA PARQUE VILA VELHA II',
  },
  {
    name: 'TR MARIO BARCELO',
  },
  {
    name: 'RUA ADAIL TEIXEIRA',
  },
  {
    name: 'AV CURIO',
  },
  {
    name: 'RUA STO ANTONIO D62',
  },
  {
    name: 'RUA MOACIR A ARARIPE',
  },
  {
    name: 'RUA AIKO MARIA',
  },
  {
    name: 'RUA SGT BARBOSA D70',
  },
  {
    name: 'RUA DA ALBACORA',
  },
  {
    name: 'RUA DA CIOBA',
  },
  {
    name: 'RUA DO DOURADO',
  },
  {
    name: 'RUA MENOR',
  },
  {
    name: 'RUA DA FATEIXA',
  },
  {
    name: 'RUA DA GAROUPA',
  },
  {
    name: 'RUA DA LADEIRA',
  },
  {
    name: 'AV AREIA BRANCA',
  },
  {
    name: 'RUA DO MANZUA',
  },
  {
    name: 'RUA DO ENTARDECER',
  },
  {
    name: 'RUA JOAO SANTANA',
  },
  {
    name: 'RUA JOAO ADOLFO GURGEL',
  },
  {
    name: 'RUA A ESPL MESSEJANA',
  },
  {
    name: 'RUA B ESPL MESSEJANA',
  },
  {
    name: 'RUA C ESPL MESSEJANA',
  },
  {
    name: 'RUA D ESPL MESSEJANA',
  },
  {
    name: 'RUA E ESPL MESSEJANA',
  },
  {
    name: 'RUA F ESPL MESSEJANA',
  },
  {
    name: 'RUA G ESPL MESSEJANA',
  },
  {
    name: 'RUA H ESPL MESSEJANA',
  },
  {
    name: 'RUA I ESPL MESSEJANA',
  },
  {
    name: 'RUA POUSO ALEGRE',
  },
  {
    name: 'RUA JOSE QUEIROZ PORTO',
  },
  {
    name: 'RUA JOSE FELICIO',
  },
  {
    name: 'RUA CERES',
  },
  {
    name: 'RUA CTE JOSE CALS DE OLIVEIRA',
  },
  {
    name: 'RUA ANTONIO CANDEIA',
  },
  {
    name: 'RUA DICO FELICIO',
  },
  {
    name: 'RUA RIBEIRO JUNIOR',
  },
  {
    name: 'RUA CEL JOAO ARRUDA',
  },
  {
    name: 'RUA BRAZ DE FRANCESCO',
  },
  {
    name: 'RUA 2 SUMARE II',
  },
  {
    name: 'RUA 4 SUMARE II',
  },
  {
    name: 'RUA 1 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 2 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 3 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 4 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 5 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 6 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 7 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 8 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 10 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 12 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 14 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 16 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 18 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA 20 CJ PEQ MONDUBIM',
  },
  {
    name: 'RUA A NOVA VL MESSEJANA',
  },
  {
    name: 'RUA B NOVA VL MESSEJANA',
  },
  {
    name: 'RUA JOAO RAMALHO',
  },
  {
    name: 'RUA VIRGILIO B SANTOS',
  },
  {
    name: 'RUA JOAO NONATO COSTA',
  },
  {
    name: 'RUA GENARIO TEIXEIRA',
  },
  {
    name: 'RUA SIGEFREDO PINHEIRO',
  },
  {
    name: 'TR CEL ANTONIO SAMPAIO',
  },
  {
    name: 'RUA STA CECILIA D18',
  },
  {
    name: 'RUA MON ANTONIO SOUTO D18',
  },
  {
    name: 'RUA JOAO PAULO II D18',
  },
  {
    name: 'RUA FELICIDADE D18',
  },
  {
    name: 'RUA DA ALEGRIA',
  },
  {
    name: 'RUA H CJ SANTA CECILIA',
  },
  {
    name: 'RUA STA INES D18 (ALDEOTA)',
  },
  {
    name: 'ST MEL',
  },
  {
    name: 'RUA MAJ TELESFORO',
  },
  {
    name: 'TR PDE MONTEIRO D20',
  },
  {
    name: 'RUA RIO DA PRATA',
  },
  {
    name: 'TR SANGATI',
  },
  {
    name: 'TR SIMAO D62',
  },
  {
    name: 'RUA PIRINEUS',
  },
  {
    name: 'RUA RUFINO GOMES',
  },
  {
    name: 'VL VIRGINIA MARIA',
  },
  {
    name: 'VL ADELIA',
  },
  {
    name: 'RUA JOAO PAULO',
  },
  {
    name: 'RUA FRANCISCA AMELIA',
  },
  {
    name: 'RUA NADJA D72',
  },
  {
    name: 'RUA HELIO BATELAO',
  },
  {
    name: 'RUA AMERICA D72',
  },
  {
    name: 'RUA REINO UNIDO',
  },
  {
    name: 'RUA DA MONGUBA',
  },
  {
    name: 'RUA BARRA NOVA',
  },
  {
    name: 'RUA DOS ARTESAOS',
  },
  {
    name: 'RUA AGUA VERDE D56',
  },
  {
    name: 'RUA DO MARFIM',
  },
  {
    name: 'RUA DO PAU D´ARCO',
  },
  {
    name: 'RUA VALE FORMOSO',
  },
  {
    name: 'RUA HORIZONTE',
  },
  {
    name: 'RUA ASA BRANCA',
  },
  {
    name: 'RUA FRE CANECA',
  },
  {
    name: 'RUA DO ANGICO',
  },
  {
    name: 'RUA DA ARAPIRACA (JD DAS OLIVEIRAS)',
  },
  {
    name: 'RUA DO TRAPIA',
  },
  {
    name: 'RUA DA UMBURANA',
  },
  {
    name: 'RUA DA TIMBAUBA',
  },
  {
    name: 'RUA DA AMIZADE',
  },
  {
    name: 'RUA CARTOLA',
  },
  {
    name: 'RUA CARMEN MIRANDA',
  },
  {
    name: 'RUA BEIJA FLOR',
  },
  {
    name: 'RUA DAS ARARAS',
  },
  {
    name: 'RUA DA PENHA',
  },
  {
    name: 'RUA CACHOEIRA',
  },
  {
    name: 'RUA BOM JESUS (GRANJA LISBOA)',
  },
  {
    name: 'RUA DOS TUBAROES',
  },
  {
    name: 'RUA BOM PRINCIPIO',
  },
  {
    name: 'RUA NOVA VIDA',
  },
  {
    name: 'AV PLACIDO CASTELO',
  },
  {
    name: 'RUA DA COPAIBA',
  },
  {
    name: 'RUA DA UBAIA',
  },
  {
    name: 'RUA DO CORREGO',
  },
  {
    name: 'RUA DA AMBAIBA',
  },
  {
    name: 'RUA DO LAGO',
  },
  {
    name: 'RUA DA CARAUBA',
  },
  {
    name: 'RUA DA SAPUCAIA',
  },
  {
    name: 'RUA DA INGAZEIRA',
  },
  {
    name: 'RUA DA MASSARANDUBA',
  },
  {
    name: 'RUA DA MOLIANA',
  },
  {
    name: 'RUA DA BARAUNA',
  },
  {
    name: 'RUA DO MERCADO',
  },
  {
    name: 'RUA DO GUAJIRU D56',
  },
  {
    name: 'RUA DO PIQUIA',
  },
  {
    name: 'RUA DO MANGUE',
  },
  {
    name: 'RUA LARGO DA PIUBA',
  },
  {
    name: 'AV A LT VILLAGE COLOSSO',
  },
  {
    name: 'AV B LT VILLAGE COLOSSO',
  },
  {
    name: 'AV C LT VILLAGE COLOSSO',
  },
  {
    name: 'AV D LT VILLAGE COLOSSO',
  },
  {
    name: 'AV NORTE SUL',
  },
  {
    name: 'RUA 4 LT VILLAGE COLOSSO',
  },
  {
    name: 'RUA 5 LT VILLAGE COLOSSO',
  },
  {
    name: 'RUA 6 LT VILLAGE COLOSSO',
  },
  {
    name: 'RUA 7 LT VILLAGE COLOSSO',
  },
  {
    name: 'RUA 12 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 13 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 14 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 15 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 16 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 17 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 18 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 19 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 20 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 21 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 22 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 23 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 24 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 25 VILLAGE COLOSSO',
  },
  {
    name: 'RUA 26 VILLAGE COLOSSO',
  },
  {
    name: 'RUA ROSA CORDEIRO',
  },
  {
    name: 'RUA 4 LT CIDADE LESTE',
  },
  {
    name: 'RUA 6 LT CIDADE LESTE',
  },
  {
    name: 'RUA 8 LT CIDADE LESTE',
  },
  {
    name: 'RUA 9 LT CIDADE LESTE',
  },
  {
    name: 'RUA 11 LT CIDADE LESTE',
  },
  {
    name: 'RUA 14 LT CIDADE LESTE',
  },
  {
    name: 'RUA 15 LT CIDADE LESTE',
  },
  {
    name: 'RUA TANCREDO S CARVALHO',
  },
  {
    name: 'RUA 19 LT CIDADE LESTE',
  },
  {
    name: 'RUA FRANCISCO NEIVA (ED. QUEIROZ)',
  },
  {
    name: 'RUA 21 LT CIDADE LESTE',
  },
  {
    name: 'RUA 22 LT CIDADE LESTE',
  },
  {
    name: 'TR ARACU D57',
  },
  {
    name: 'RUA 4 ARVOREDO R CENTER',
  },
  {
    name: 'RUA NOVA PETROPOLES',
  },
  {
    name: 'RUA AURELIO BEZERRA D71',
  },
  {
    name: 'RUA C JD MESSEJANA',
  },
  {
    name: 'RUA D JD MESSEJANA',
  },
  {
    name: 'RUA ALINE VIEIRA COLARES',
  },
  {
    name: 'RUA DR CARVALHO PEREIRA',
  },
  {
    name: 'RUA CEL DIONISIO ALENCAR',
  },
  {
    name: 'RUA PAULINO ROCHA D56',
  },
  {
    name: 'RUA DA PICARRA',
  },
  {
    name: 'RUA SAGRADA FAMILIA D-46',
  },
  {
    name: 'RUA SETE ESTTRELAS',
  },
  {
    name: 'RUA CINDERELA',
  },
  {
    name: 'RUA DO LIVRAMENTO',
  },
  {
    name: 'RUA TODOS OS SANTOS',
  },
  {
    name: 'RUA CLAUDIO COUTINHO',
  },
  {
    name: 'RUA DA PONTE GRANDE',
  },
  {
    name: 'RUA MONTE CRISTO',
  },
  {
    name: 'RUA PEDRO MEIRELES D26',
  },
  {
    name: 'RUA 1 D71',
  },
  {
    name: 'RUA 2 D71',
  },
  {
    name: 'RUA 3 D71',
  },
  {
    name: 'RUA TEREZA HINKO',
  },
  {
    name: 'RUA A PQ AMARALINA',
  },
  {
    name: 'RUA 4 CJ DA AERONAUTICA',
  },
  {
    name: 'RUA MIGUEL PONTES',
  },
  {
    name: 'RUA PUEBLA',
  },
  {
    name: 'RUA PAULO MORAIS',
  },
  {
    name: 'RUA JAICOIS',
  },
  {
    name: 'RUA CAP PINTO MESQUITA',
  },
  {
    name: 'RUA HUMBERTO DE ALMEIDA',
  },
  {
    name: 'RUA DOM LUSTOSA',
  },
  {
    name: 'AV SUL SITIO TUNGA',
  },
  {
    name: 'RUA 1 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 2 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 3 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 4 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 5 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 6 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 7 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 8 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 9 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 10 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 11 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 12 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 13 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 17 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 19 CJ ALTO ALEGRE',
  },
  {
    name: 'RUA 1 PQ BOATAN',
  },
  {
    name: 'VL JOAIMA D23',
  },
  {
    name: 'RUA ALZIBERTO MIRANDA',
  },
  {
    name: 'RUA RICARDO A BRAGA',
  },
  {
    name: 'RUA XI LT VILA VERDE',
  },
  {
    name: 'RUA I LT VILA VERDE',
  },
  {
    name: 'RUA JOAO PEDRO SANTIAGO',
  },
  {
    name: 'RUA PRA STELLA COCHRANE',
  },
  {
    name: 'RUA SAO FIDELIS D71',
  },
  {
    name: 'TR CABRAL',
  },
  {
    name: 'RUA DR JOSE FURTADO',
  },
  {
    name: 'RUA STA ESMERALDA D56',
  },
  {
    name: 'RUA SAO FRANCISCO D71',
  },
  {
    name: 'RUA NESTOR F VASCONCELOS',
  },
  {
    name: 'RUA 2 CJ SIQUEIRA',
  },
  {
    name: 'RUA 3 CJ SIQUEIRA',
  },
  {
    name: 'RUA PERNAMBUCO D65',
  },
  {
    name: 'RUA HORACIO NUNES',
  },
  {
    name: 'RUA SANDRA GENTIL',
  },
  {
    name: 'RUA DONATO',
  },
  {
    name: 'RUA 1 CJ NAPOLEAO VIANA',
  },
  {
    name: 'RUA 3 CJ NAPOLEAO VIANA',
  },
  {
    name: 'RUA BAR DE LUCENA D64',
  },
  {
    name: 'RUA PEDRO C SALES D71',
  },
  {
    name: 'RUA DOS MAIAS D61',
  },
  {
    name: 'RUA 1 PQ SAO LUCAS',
  },
  {
    name: 'RUA MARGINAL VERDE OESTE',
  },
  {
    name: 'RUA CEL MATOS DOURADO',
  },
  {
    name: 'RUA 5 PQ BUATAN',
  },
  {
    name: 'RUA 6 CJ POLAR',
  },
  {
    name: 'TR GUILHERME PERDIGAO',
  },
  {
    name: 'AL JAIME AUGUSTO D22',
  },
  {
    name: 'RUA ANTONIO MONTEIRO',
  },
  {
    name: 'RUA 100 CJ PASSARE',
  },
  {
    name: 'RUA 102 CJ PASSARE',
  },
  {
    name: 'RUA 103 CJ PASSARE',
  },
  {
    name: 'RUA 104 CJ PASSARE',
  },
  {
    name: 'RUA JOSE MARIO MAMEDE (EDSON QUEIROZ)',
  },
  {
    name: 'RUA RUA 8 PQ ITAIGUARA',
  },
  {
    name: 'RUA ERNESTO IGEL',
  },
  {
    name: 'RUA ENG JOSE HENRIQUE FROTA',
  },
  {
    name: 'RUA LAURA BEZERRA',
  },
  {
    name: 'RUA MILTON LAVOR',
  },
  {
    name: 'RUA BOM JESUS AFLITOS',
  },
  {
    name: 'RUA ADARIAS DE LIMA',
  },
  {
    name: 'RUA MARQ SANTOS',
  },
  {
    name: 'RUA OLAVO LIMA SILVA',
  },
  {
    name: 'RUA NS 01 RES CAJAZEIRAS',
  },
  {
    name: 'RUA NS 02 RES CAJAZEIRAS',
  },
  {
    name: 'RUA NS 03 RES CAJAZEIRAS',
  },
  {
    name: 'RUA NS 04 RES CAJAZEIRAS',
  },
  {
    name: 'RUA NS 05 RES CAJAZEIRAS',
  },
  {
    name: 'RUA JOAOZITO ARRUDA',
  },
  {
    name: 'RUA ACAPULCO',
  },
  {
    name: 'TR BRASIL D29',
  },
  {
    name: 'TR BRASILIA D40',
  },
  {
    name: 'RUA MARIO A ARARIPE',
  },
  {
    name: 'RUA ELIZEU C BRANCO',
  },
  {
    name: 'RUA DR JURANDYR NUNES',
  },
  {
    name: 'RUA 03 JD DE MESSEJANA',
  },
  {
    name: 'RUA 08 JD DE MESSEJANA',
  },
  {
    name: 'RUA 06 JD DE MESSEJANA',
  },
  {
    name: 'RUA 04 JD DE MESSEJANA',
  },
  {
    name: 'RUA 02 JD DE MESSEJANA',
  },
  {
    name: 'RUA FIRMO A CARDOSO',
  },
  {
    name: 'VL FORTALEZA D04',
  },
  {
    name: 'RUA MAURITANIA',
  },
  {
    name: 'RUA G CJ VILA VELHA',
  },
  {
    name: 'RUA H CJ RESD ITAPARICA',
  },
  {
    name: 'RUA K CJ RESD ITAPARICA',
  },
  {
    name: 'RUA N CJ RESD ITAPARICA',
  },
  {
    name: 'RUA DR SEIXAS',
  },
  {
    name: 'RUA SIMAO SANTOS',
  },
  {
    name: 'RUA GUADALAJARA D62',
  },
  {
    name: 'AV E CJ JOSE WALTER',
  },
  {
    name: 'RUA RENATO VIANA MORAIS',
  },
  {
    name: 'TR FRANCISCO CORDEIRO',
  },
  {
    name: 'TR SAO JOAO D26',
  },
  {
    name: 'RUA JOSE MONTEIRO DOS SANTOS',
  },
  {
    name: 'RUA SAO JOSE D20',
  },
  {
    name: 'RUA JOSE ALEXANDRE D06',
  },
  {
    name: 'TR JOSE BASTOS D12',
  },
  {
    name: 'RUA JULIO ALCIDES',
  },
  {
    name: 'AL CLARA DE ASSIS',
  },
  {
    name: 'RUA CHICO XAVIER',
  },
  {
    name: 'RUA PRS FRANCISCO SIMAO',
  },
  {
    name: 'RUA DAS CANOAS',
  },
  {
    name: 'RUA VENTO LESTE',
  },
  {
    name: 'RUA ENCANTO DA BARRA',
  },
  {
    name: 'RUA BARRA VENTO',
  },
  {
    name: 'RUA EDU DA GAITA',
  },
  {
    name: 'RUA MORRO BRANCO',
  },
  {
    name: 'RUA DO LEME',
  },
  {
    name: 'RUA DA ZAMBAIA',
  },
  {
    name: 'RUA DAS PALMAS',
  },
  {
    name: 'RUA JACO DO BANDOLIM',
  },
  {
    name: 'RUA ALTO MAR',
  },
  {
    name: 'RUA DOS HOLANDESES',
  },
  {
    name: 'RUA DA SALEMA',
  },
  {
    name: 'RUA DAS FLORES D22',
  },
  {
    name: 'RUA DO BAMBU',
  },
  {
    name: 'RUA DA ARABAIANA',
  },
  {
    name: 'RUA DAS CARAVELAS',
  },
  {
    name: 'RUA LAGOA DO ABAETE',
  },
  {
    name: 'RUA COQUEIRO VERDE',
  },
  {
    name: 'RUA DOS SEIXAS',
  },
  {
    name: 'RUA ARAUNA',
  },
  {
    name: 'RUA DAS TARRAFAS',
  },
  {
    name: 'RUA DOS ABOLICIONISTAS',
  },
  {
    name: 'RUA POR DO SOL',
  },
  {
    name: 'RUA ABEL FERREIRA',
  },
  {
    name: 'RUA DO POENTE',
  },
  {
    name: 'RUA JACKSON DO PANDEIRO',
  },
  {
    name: 'RUA OLEGARIO MARIANO',
  },
  {
    name: 'RUA 13 CJ POLAR',
  },
  {
    name: 'RUA JOAO PRIMEIRO D43',
  },
  {
    name: 'RUA NAPOLEAO QUEZADO',
  },
  {
    name: 'VL SOLIMAR',
  },
  {
    name: 'RUA GOIANESA',
  },
  {
    name: 'RUA CANAMARIM',
  },
  {
    name: 'RUA RUA SEM DEN OFICIAL',
  },
  {
    name: 'RUA COS DA SILVA',
  },
  {
    name: 'RUA 6 PQ BOATAN',
  },
  {
    name: 'RUA 3 PQ BOATAN',
  },
  {
    name: 'RUA 4 PQ BOATAN',
  },
  {
    name: 'TR REGIONAL D25',
  },
  {
    name: 'RUA RIO DAS BALCAS',
  },
  {
    name: 'RUA LUIZ MARIANO',
  },
  {
    name: 'AV GENIBAU',
  },
  {
    name: 'RUA STA ADELIA',
  },
  {
    name: 'RUA SERTAO DOS INHAMUNS',
  },
  {
    name: 'RUA RENATO VIANA',
  },
  {
    name: 'RUA NOSSA SRA APARECIDA',
  },
  {
    name: 'RUA MENDES JUNIOR',
  },
  {
    name: 'RUA PETRONILHA BEZERRA',
  },
  {
    name: 'VL AMERICO D22',
  },
  {
    name: 'RUA D CJ SANTA LUZIA',
  },
  {
    name: 'RUA ENG HENRIQUE MORIZE',
  },
  {
    name: 'RUA 11 CJ POLAR',
  },
  {
    name: 'RUA LAURO RODRIGUES',
  },
  {
    name: 'RUA 3 CJ JOSE WALTER',
  },
  {
    name: 'RUA ROSALVO QUINDERE',
  },
  {
    name: 'RUA 102 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 103 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 104 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 101 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 105 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 107 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 109 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 110 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 111 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 112 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 113 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 114 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 115 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 116 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 117 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 118 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 120 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 122 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 124 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 128 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 130 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 132 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 134 CJ TUPAN MIRIM',
  },
  {
    name: 'RUA 136 CJ TUPAN MIRIM',
  },
  {
    name: 'AV COLETORA NORTE/SUL',
  },
  {
    name: 'RUA JULIO MACIEL D35',
  },
  {
    name: 'RUA 16 CJ JOSE WALTER',
  },
  {
    name: 'RUA 23 CJ BEIRA RIO',
  },
  {
    name: 'RUA 22 CJ JOSE WALTER',
  },
  {
    name: 'RUA 24 CJ JOSE WALTER',
  },
  {
    name: 'RUA 26 CJ JOSE WALTER',
  },
  {
    name: 'RUA MURITINGA',
  },
  {
    name: 'RUA 27 CJ BEIRA RIO',
  },
  {
    name: 'RUA 39 CJ JOSE WALTER',
  },
  {
    name: 'RUA 31 CJ BEIRA RIO',
  },
  {
    name: 'RUA 33 CJ BEIRA RIO',
  },
  {
    name: 'RUA 1 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 2 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 3 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 4 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 5 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 6 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 7 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 8 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 9 CAMPO DOS INGLESES',
  },
  {
    name: 'RUA 10 CAMPO DOS INGLESE',
  },
  {
    name: 'RUA 11 CJ CAMPO DOS INGLESES',
  },
  {
    name: 'RUA TUPI D05 (P.IRACEMA)',
  },
  {
    name: 'RUA 17 CJ BEIRA RIO',
  },
  {
    name: 'AV DOMINGOS SAVIO',
  },
  {
    name: 'AV MON HELIO CAMPOS D22',
  },
  {
    name: 'RUA MON JOAO DANTAS',
  },
  {
    name: 'RUA MONTE PASCOAL',
  },
  {
    name: 'RUA CONTONEIDE',
  },
  {
    name: 'RUA SAO MANUEL',
  },
  {
    name: 'RUA MANUEL CRUZ DE LIMA',
  },
  {
    name: 'RUA JARDIM PARUARA',
  },
  {
    name: 'RUA GONCALA A RODRIGUES',
  },
  {
    name: 'RUA SELENE',
  },
  {
    name: 'RUA 35 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 37 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 41 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 43 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 45 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 47 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 49 CJ DOS BANCARIOS',
  },
  {
    name: 'AV L CJ DOS BANCARIOS',
  },
  {
    name: 'AV E CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 28 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 26 CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 24 CJ DOS BANCARIOS',
  },
  {
    name: 'AV D CJ DOS BANCARIOS',
  },
  {
    name: 'RUA 39 CJ DOS BANCARIOS',
  },
  {
    name: 'TR STA TEREZINHA',
  },
  {
    name: 'TR HELENA DE MARIA',
  },
  {
    name: 'RUA 13 CJ BEIRA RIO',
  },
  {
    name: 'AV J CJ POLAR',
  },
  {
    name: 'AV L CJ POLAR',
  },
  {
    name: 'RUA 9 CJ POLAR',
  },
  {
    name: 'RUA 17 CJ POLAR',
  },
  {
    name: 'RUA 23 CJ POLAR',
  },
  {
    name: 'RUA 27 CJ POLAR',
  },
  {
    name: 'RUA 31 CJ POLAR',
  },
  {
    name: 'RUA 33 CJ POLAR',
  },
  {
    name: 'RUA 35 CONJUNTO POLAR',
  },
  {
    name: 'RUA 37 CONJUNTO POLAR',
  },
  {
    name: 'RUA 41 CJ POLAR',
  },
  {
    name: 'RUA 5 CJ POLAR',
  },
  {
    name: 'RUA 1 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA VERDE 2 CJ ST S.JOAO',
  },
  {
    name: 'RUA VERDE 3  ST SAO JOAO',
  },
  {
    name: 'RUA VERDE 4 CJ ST S.JOAO',
  },
  {
    name: 'RUA 5 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA 6 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA 7 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA 8 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA 9 CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA 10 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 11 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 12 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA VERDE13 CJ ST S JOAO',
  },
  {
    name: 'RUA 14 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 15 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 16 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 17 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 19 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 21 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 22 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 23 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 24 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 25 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 26 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 27 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 28 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 29 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 30 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 31 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 32 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 33 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 34 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 35 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 37 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 39 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 40 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 41 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 42 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 43 CJ HAB ST S JOAO',
  },
  {
    name: 'RUA 44 CJ HAB ST S JOAO',
  },
  {
    name: 'AV A CJ HAB ST SAO JOAO',
  },
  {
    name: 'AV B CJ HAB ST SAO JOAO',
  },
  {
    name: 'AV C CJ HAB ST SAO JOAO',
  },
  {
    name: 'RUA SAO JOAO DEL REY',
  },
  {
    name: 'RUA A RES F DE NORONHA',
  },
  {
    name: 'RUA B RES F DE NORONHA',
  },
  {
    name: 'RUA C RESD F DE NORONHA',
  },
  {
    name: 'RUA D RESD F DE NORONHA',
  },
  {
    name: 'RUA E RESD F DE NORONHA',
  },
  {
    name: 'RUA 1 CJ RESD CURIO',
  },
  {
    name: 'RUA 2 CJ RESD CURIO',
  },
  {
    name: 'RUA 3 CJ RESID CURIO',
  },
  {
    name: 'RUA 4 CJ RESID CURIO',
  },
  {
    name: 'RUA 5 CJ RESID CURIO',
  },
  {
    name: 'RUA 6 CJ RESID CURIO',
  },
  {
    name: 'RUA 7 CJ RESD CURIO',
  },
  {
    name: 'RUA 8 CJ RESD CURIO',
  },
  {
    name: 'RUA A CJ RESD CURIO',
  },
  {
    name: 'RUA B CJ RESD CURIO',
  },
  {
    name: 'RUA C CJ RESD CURIO',
  },
  {
    name: 'RUA D CJ RESID CURIO',
  },
  {
    name: 'RUA E CJ RESD CURIO',
  },
  {
    name: 'RUA I CJ RESD CURIO',
  },
  {
    name: 'RUA J CJ RESID CURIO',
  },
  {
    name: 'RUA 1 CJ ANTONIO CORREIA',
  },
  {
    name: 'RUA 2 CJ ANTONIO CORREIA',
  },
  {
    name: 'RUA 3 CJ ANTONIO CORREIA',
  },
  {
    name: 'RUA 4 CJ ANTONIO CORREIA',
  },
  {
    name: 'RUA VIA DE PEDESTRES A',
  },
  {
    name: 'TR DR JOSE GUILARDO',
  },
  {
    name: 'RUA VALDEMAR HOLANDA',
  },
  {
    name: 'RUA BRUNO E. DE OLIVEIRA',
  },
  {
    name: 'RUA COLOMBO',
  },
  {
    name: 'AV CASTELO DE CASTRO',
  },
  {
    name: 'RUA 103 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 105 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 107 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 109 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 111 CJ SAO CRISTOVAO',
  },
  {
    name: 'AV CONTORNO NORTE (SAO CRSITOVAO)',
  },
  {
    name: 'RUA 202 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 204 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 206 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 208 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 210 CJ SAO CRISTOVAO',
  },
  {
    name: 'AV MON AMARILIO RODRIGUES',
  },
  {
    name: 'RUA 301 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 303 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 305 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 307 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 309 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 313 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 315 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 317 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 319 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 321 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 323 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 212 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 214 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 216 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 402 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 404 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 406 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 408 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 412 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 414 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 416 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 418 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 420 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 422 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 424 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 426 CJ SAO CRISTOVAO',
  },
  {
    name: 'AV BULEVAR I',
  },
  {
    name: 'AV BULEVAR II',
  },
  {
    name: 'AV BULEVAR III',
  },
  {
    name: 'AV PAISAGISTICA',
  },
  {
    name: 'AV CONTORNO SUL',
  },
  {
    name: 'RUA 101 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 501 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 503 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 505 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 507 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 509 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 511 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA 513 CJ SAO CRISTOVAO',
  },
  {
    name: 'RUA STA CLARA DE ASSIS',
  },
  {
    name: 'RUA JOSE OTOCH',
  },
  {
    name: 'TR SAO RAIMUNDO D21',
  },
  {
    name: 'TR PDE JOSIMO',
  },
  {
    name: 'TR CHICO MENDES D64',
  },
  {
    name: 'TR BUARQUE MACEDO',
  },
  {
    name: 'RUA LUIS BENTO',
  },
  {
    name: 'RUA PEDESTRE',
  },
  {
    name: 'RUA 343 A CJ CEARA',
  },
  {
    name: 'RUA VINTE QUATRO DE MAIO',
  },
  {
    name: 'RUA OSVALDO CRUZ',
  },
  {
    name: 'AV EXPEDICIONARIOS (INVALIDA)',
  },
  {
    name: 'RUA JOSE VILAR',
  },
  {
    name: 'RUA NADIR SABOYA (EDSON QUEIROZ/SAPIRANGA)',
  },
  {
    name: 'RUA A PLANALTO COACU',
  },
  {
    name: 'RUA B PLANALTO COACU',
  },
  {
    name: 'RUA C PLANALTO COACU',
  },
  {
    name: 'RUA D PLANALTO COACU',
  },
  {
    name: 'RUA 8 JD CASTELAO',
  },
  {
    name: 'RUA 9 JD CASTELAO',
  },
  {
    name: 'RUA 10 JD CASTELAO',
  },
  {
    name: 'RUA ALBERTO SALES',
  },
  {
    name: 'RUA B CJ RESD GUAJERU',
  },
  {
    name: 'RUA C CJ RESD GUAJERU',
  },
  {
    name: 'RUA D CJ RESD GUAJERU',
  },
  {
    name: 'RUA E CJ RESD GUAJERU',
  },
  {
    name: 'RUA 1 RESD NOVA ASSUNCAO',
  },
  {
    name: 'RUA 2 RES NOVA ASSUNCAO',
  },
  {
    name: 'RUA 3 RESD NOVA ASSUNCAO',
  },
  {
    name: 'RUA 4 RESD NOVA ASSUNCAO',
  },
  {
    name: 'RUA 5 RESD NOVA ASSUNCAO',
  },
  {
    name: 'RUA 7 RESD NOVA ASSUNCAO',
  },
  {
    name: 'AV GOV RAUL BARBOSA',
  },
  {
    name: 'RUA A RES FLUMINENSE',
  },
  {
    name: 'RUA B RES FLUMINENSE',
  },
  {
    name: 'RUA C RES FLUMINENSE',
  },
  {
    name: 'RUA ACESSO A',
  },
  {
    name: 'RUA ACESSO B',
  },
  {
    name: 'RUA ACESSO C',
  },
  {
    name: 'RUA D RES FLUMINENSE',
  },
  {
    name: 'RUA PEDESTRE II',
  },
  {
    name: 'RUA H RES FLUMINENSE',
  },
  {
    name: 'RUA J RES FLUMINENSE',
  },
  {
    name: 'RUA PEDESTRE I',
  },
  {
    name: 'RUA PEDESTRE II',
  },
  {
    name: 'RUA PEDESTRE III',
  },
  {
    name: 'RUA PEDESTRE IV',
  },
  {
    name: 'RUA PEDESTRE V',
  },
  {
    name: 'RUA PEDESTRE VI',
  },
  {
    name: 'RUA PEDESTRE VII',
  },
  {
    name: 'RUA PEDESTRE VIII',
  },
  {
    name: 'RUA PEDESTRE IX',
  },
  {
    name: 'RUA PEDESTRE X',
  },
  {
    name: 'RUA PEDESTRE XI',
  },
  {
    name: 'RUA PEDESTRE XII',
  },
  {
    name: 'RUA PEDESTRE XIV',
  },
  {
    name: 'RUA ACESSO D',
  },
  {
    name: 'RUA ACESSO E',
  },
  {
    name: 'RUA 1 CJ SITIO CORREGO',
  },
  {
    name: 'RUA 4 CJ SITIO CORREGO',
  },
  {
    name: 'RUA 6 CJ SITIO CORREGO',
  },
  {
    name: 'RUA 9 CJ SITIO CORREGO',
  },
  {
    name: 'AL VERDE 1',
  },
  {
    name: 'AL VERDE 2',
  },
  {
    name: 'AL VERDE 3',
  },
  {
    name: 'AL VERDE 5',
  },
  {
    name: 'AL VERDE 6',
  },
  {
    name: 'AL VERDE 7',
  },
  {
    name: 'AL VERDE 8',
  },
  {
    name: 'AL VERDE 9',
  },
  {
    name: 'RUA 11 CJ ST CORREGO',
  },
  {
    name: 'RUA 12 CJ ST CORREGO',
  },
  {
    name: 'RUA GURGEL DO AMARAL',
  },
  {
    name: 'RUA 12 LT TERRANOVA',
  },
  {
    name: 'RUA 13 LT TERRANOVA',
  },
  {
    name: 'RUA A LT IMPER MONDUBIN',
  },
  {
    name: 'RUA NS 1     SITIO TUNGA',
  },
  {
    name: 'RUA NS 2     SITIO TUNGA',
  },
  {
    name: 'RUA NS 3     SITIO TUNGA',
  },
  {
    name: 'RUA NS 4     SITIO TUNGA',
  },
  {
    name: 'RUA NS 5     SITIO TUNGA',
  },
  {
    name: 'RUA NS 7     SITIO TUNGA',
  },
  {
    name: 'RUA NS 8     SITIO TUNGA',
  },
  {
    name: 'RUA 5 LT NOVA FORTALEZA',
  },
  {
    name: 'RUA 11 LT NOVA FORTALEZA',
  },
  {
    name: 'RUA 12 LT NOVA FORTALEZA',
  },
  {
    name: 'RUA A CJ NOVA FORTALEZA',
  },
  {
    name: 'RUA RJ 3     SIITO TUNGA',
  },
  {
    name: 'RUA NS 10    SITIO TUNGA',
  },
  {
    name: 'RUA NS 11    SITIO TUNGA',
  },
  {
    name: 'RUA L 1      SITIO TUNGA',
  },
  {
    name: 'RUA JOSE CLAUDIO MEDINA',
  },
  {
    name: 'RUA CEL ALUISIO BORBA',
  },
  {
    name: 'RUA RJ 1     SITIO TUNGA',
  },
  {
    name: 'RUA RJ 1A    SITIO TUNGA',
  },
  {
    name: 'AV CENTRAL OESTE',
  },
  {
    name: 'AV CEL FRANCISCO FLAVIO CARNEIRO',
  },
  {
    name: 'RUA DIAGONAL 1 ST TUNGA',
  },
  {
    name: 'RUA SL 2     SITIO TUNGA',
  },
  {
    name: 'RUA SILVINO',
  },
  {
    name: 'RUA L 07     SITIO TUNGA',
  },
  {
    name: 'RUA GONCALO COELHO D73',
  },
  {
    name: 'RUA 8 RES ABELARDO ROCHA',
  },
  {
    name: 'RUA JOAO FRANCA (PQ. 2 IRMÃOS)',
  },
  {
    name: 'RUA FRANCISCO XAVIER',
  },
  {
    name: 'RUA CARLOTA R DA CUNHA (L.CAVALCANTE)',
  },
  {
    name: 'RUA ADOLFO SOARES',
  },
  {
    name: 'RUA MIN ALBUQUERQUE LIMA',
  },
  {
    name: 'AV MAE MANOEL MAVIGNIER',
  },
  {
    name: 'RUA 5 PARAISO MESSEJANA',
  },
  {
    name: 'RUA 6 PARAISO MESSEJANA',
  },
  {
    name: 'RUA 9 PARAISO MESSEJANA',
  },
  {
    name: 'RUA JOSE GASPAR',
  },
  {
    name: 'RUA VICENTE DOMINGOS',
  },
  {
    name: 'RUA FRANCISCO ANDRE',
  },
  {
    name: 'RUA SINGELA',
  },
  {
    name: 'RUA MARIO LANZA',
  },
  {
    name: 'RUA SOCORRO GOMES',
  },
  {
    name: 'RUA ENG ANTONIO F ANTERO',
  },
  {
    name: 'RUA JOSE OLIMPIO',
  },
  {
    name: 'TR VITALINO',
  },
  {
    name: 'RUA MANUEL COSTA',
  },
  {
    name: 'RUA ITAJEU',
  },
  {
    name: 'AV DOS FRANCESES',
  },
  {
    name: 'RUA ULISSES',
  },
  {
    name: 'RUA DR MIRANDA LEAO',
  },
  {
    name: 'TR IRACEMA',
  },
  {
    name: 'RUA JOHN LENNON',
  },
  {
    name: 'RUA SAO JOAO D34 (BONSUCESSO)',
  },
  {
    name: 'RUA PORTO FELIZ',
  },
  {
    name: 'TR MONTE CLARO',
  },
  {
    name: 'RUA 30 DE ABRIL',
  },
  {
    name: 'RUA JOSE AMAURI MOREIRA',
  },
  {
    name: 'LOGRADOURO SEM NOME',
  },
  {
    name: 'RUA MOZART ANSELMO (D65)',
  },
  {
    name: 'RUA BEATRIZ ZEZA TIJOLO DIST 62',
  },
  {
    name: 'RUA PEDESTRE 04(ZEZA/TIJOLO)',
  },
  {
    name: 'RUA ALFA VILE (MUTIRÃO CAJAZEIRAS)',
  },
  {
    name: 'RUA BETA (ZEZA/TIJOLO)',
  },
  {
    name: 'RUA CONTORNO (ZEZA/TIJOLO)',
  },
  {
    name: 'RUA CRISTAIS PAULISTA',
  },
  {
    name: 'RUA TRES CORACOES (PASSARÉ)',
  },
  {
    name: 'TR CORES',
  },
  {
    name: 'TR AVANERIS',
  },
  {
    name: 'TR MATADOUROS',
  },
  {
    name: 'RUA MARILEIDE',
  },
  {
    name: 'RUA ALVES DE SOUZA',
  },
  {
    name: 'RUA 05 UI 705',
  },
  {
    name: 'RUA 04 UI 705',
  },
  {
    name: 'RUA DAS PITANGUEIRAS',
  },
  {
    name: 'RUA RAIMUNDO MARQUES',
  },
  {
    name: 'RUA TATIANA',
  },
  {
    name: 'AV 1 CANINDEZINHO',
  },
  {
    name: 'TR MONTE',
  },
  {
    name: 'RUA RODRIGUES MEDEIROS',
  },
  {
    name: 'TR 15 UI 705',
  },
  {
    name: 'RUA SAO ANASTACIO',
  },
  {
    name: 'RUA A CONJ. JARDIM FLUMINENSE',
  },
  {
    name: 'RUA RENE DESCARTES',
  },
  {
    name: 'RUA DAS GAIVOTAS',
  },
  {
    name: 'RUA TRAJANO DE MORAES',
  },
  {
    name: 'AV 02 DE MAIO UI 503',
  },
  {
    name: 'RUA 28 DE AGOSTO UI 503',
  },
  {
    name: 'RUA MARIA MIRTES PEREIRA',
  },
  {
    name: 'RUA A UI 503',
  },
  {
    name: 'RUA C UI 503',
  },
  {
    name: 'RUA D UI 503',
  },
  {
    name: 'RUA E UI 503',
  },
  {
    name: 'RUA F UI 503',
  },
  {
    name: 'RUA G UI 503',
  },
  {
    name: 'AV CENTRAL UI 503',
  },
  {
    name: 'RUA H UI 503',
  },
  {
    name: 'RUA I UI 503',
  },
  {
    name: 'TR FRE GASPAR',
  },
  {
    name: 'TR VIANA WEYNE',
  },
  {
    name: 'RUA KELLY',
  },
  {
    name: 'TR KELLY',
  },
  {
    name: 'RUA JOSE LEONIDAS',
  },
  {
    name: 'TR ALICE III',
  },
  {
    name: 'TR JOSE CAVALCANTE (CID FUNCIONARIOS)',
  },
  {
    name: 'RUA JOAO ANDRADE',
  },
  {
    name: 'RUA 4 UI 307',
  },
  {
    name: 'RUA 3 UI 307',
  },
  {
    name: 'RUA 2 UI 307',
  },
  {
    name: 'AV A UI 307',
  },
  {
    name: 'RUA AIRTON JORGE',
  },
  {
    name: 'TR MAJ MONTENEGRO',
  },
  {
    name: 'TR PERLA',
  },
  {
    name: 'TR HAVANA',
  },
  {
    name: 'RUA PARNAMIRIM',
  },
  {
    name: 'RUA RECANTO DO PASSARE',
  },
  {
    name: 'RUA DR ANTONIO LUSTOSA',
  },
  {
    name: 'RUA COELHO GARCIA',
  },
  {
    name: 'RUA STA MADALENA',
  },
  {
    name: 'RUA CAETANO SILVA (PASSARÉ)',
  },
  {
    name: 'RUA FREITAS NASCIMENTO',
  },
  {
    name: 'RUA ADOLFO MARINHO (MESSEJANA)',
  },
  {
    name: 'RUA ADOLFO MARINHO (PASSARÉ)',
  },
  {
    name: 'TR MENOR JERONIMO',
  },
  {
    name: 'RUA ANTONIO JURACY RICARTY',
  },
  {
    name: 'RUA 11 BARROSO',
  },
  {
    name: 'TR SAGRES',
  },
  {
    name: 'RUA FRANCISCO NEPOMUCENO',
  },
  {
    name: 'RUA DOS MARINHEIROS',
  },
  {
    name: 'TR LADY LAURA',
  },
  {
    name: 'RUA E CJ VILA VELHA',
  },
  {
    name: 'RUA EDILENE',
  },
  {
    name: 'TR CREUZA ROQUE',
  },
  {
    name: 'RUA STA MARLUCIA',
  },
  {
    name: 'RUA PEDRO JULIAO',
  },
  {
    name: 'TR JARDIM SILVEIRA',
  },
  {
    name: 'TR DA LAGOA',
  },
  {
    name: 'TR ROSANGELA',
  },
  {
    name: 'RUA JOSE LINHARES',
  },
  {
    name: 'RUA PANTANAL',
  },
  {
    name: 'RUA GENGUS PINHEIRO',
  },
  {
    name: 'RUA OZELIA PONTES',
  },
  {
    name: 'RUA DALVA DE OLIVEIRA',
  },
  {
    name: 'RUA MARQUES DE SUCUPIRA',
  },
  {
    name: 'RUA SITIO GRAVITO',
  },
  {
    name: 'RUA JOSE MARIA ARAUJO',
  },
  {
    name: 'RUA JOSE DE RIBAMAR',
  },
  {
    name: 'RUA STA MARTHA',
  },
  {
    name: 'RUA 8',
  },
  {
    name: 'RUA MEDELIM',
  },
  {
    name: 'RUA JOAO VITOR',
  },
  {
    name: 'RUA CAJAMAR',
  },
  {
    name: 'RUA HENRIQUE VIANA',
  },
  {
    name: 'RUA 08 UI 509',
  },
  {
    name: 'RUA 07 UI 509',
  },
  {
    name: 'RUA 05 UI 509',
  },
  {
    name: 'RUA 02 UI 509',
  },
  {
    name: 'RUA JOAO CAETANO',
  },
  {
    name: 'RUA 06 UI 509',
  },
  {
    name: 'RUA JOSE ONOFRE',
  },
  {
    name: 'TR SAO FRANCISCO',
  },
  {
    name: 'RUA VICENTE CORREIA',
  },
  {
    name: 'RUA PRO ANTONIO VIDAL',
  },
  {
    name: 'RUA BENTA GURGEL',
  },
  {
    name: 'RUA ATAUBA',
  },
  {
    name: 'RUA RUA BARROS CASSAL',
  },
  {
    name: 'RUA TUCUNDURA',
  },
  {
    name: 'RUA ROQUE DE FREITAS',
  },
  {
    name: 'RUA TROPICAL',
  },
  {
    name: 'RUA STA LUCRECIA',
  },
  {
    name: 'TR TRATUI',
  },
  {
    name: 'RUA ENOQUE FALCAO',
  },
  {
    name: 'VL CELIA',
  },
  {
    name: 'VL SAO VICENTE',
  },
  {
    name: 'VL DEDE',
  },
  {
    name: 'TR DOS CAVALOS',
  },
  {
    name: 'TR DO COCO',
  },
  {
    name: 'RUA LUIS FIRMINO',
  },
  {
    name: 'RUA LARA',
  },
  {
    name: 'TR LEVIS',
  },
  {
    name: 'RUA JOAO XIMENES',
  },
  {
    name: 'RUA NASSAU',
  },
  {
    name: 'AV JOR JOAO RAMOS',
  },
  {
    name: 'RUA DIREITA',
  },
  {
    name: 'TR LUCI',
  },
  {
    name: 'RUA FRANCISCA MARIA DA CONCEICAO',
  },
  {
    name: 'RUA ROSANA REIS',
  },
  {
    name: 'RUA FREDERICO FELIX',
  },
  {
    name: 'RUA STA ARIANE',
  },
  {
    name: 'RUA ESCRAVA ANASTACIA',
  },
  {
    name: 'RUA SALETE QUEIROZ',
  },
  {
    name: 'RUA SALETE ARAGAO',
  },
  {
    name: 'RUA NELSON MANDELA',
  },
  {
    name: 'RUA LUIZA NOBRE',
  },
  {
    name: 'RUA ARTUR DE SOUZA',
  },
  {
    name: 'RUA CAIO FACO',
  },
  {
    name: 'RUA ARACATUBA',
  },
  {
    name: 'TR ARACATUBA',
  },
  {
    name: 'TR ELIEL I',
  },
  {
    name: 'TR ELIEL II',
  },
  {
    name: 'TR ELIEL',
  },
  {
    name: 'RUA COSME DE ALMEIDA',
  },
  {
    name: 'ET DO GUAJERU',
  },
  {
    name: 'RUA ROSARIO DO SUL',
  },
  {
    name: 'TR RAIMUNDO MACIEL',
  },
  {
    name: 'TR SAO FRANCISCO',
  },
  {
    name: 'TR SAO JOAO',
  },
  {
    name: 'RUA ROBERTO DE CARVALHO',
  },
  {
    name: 'TR SOBRAL (PASSARE)',
  },
  {
    name: 'RUA BOLEVAR',
  },
  {
    name: 'RUA ALAN CASTELO',
  },
  {
    name: 'RUA STA MADALENA',
  },
  {
    name: 'RUA STO TIBURCIO',
  },
  {
    name: 'RUA F UI 512',
  },
  {
    name: 'RUA JUVENCIO PORFIRIO SALES',
  },
  {
    name: 'TR SAO JOAO BATISTA',
  },
  {
    name: 'RUA N UI 512',
  },
  {
    name: 'RUA GOMES CARNEIRO',
  },
  {
    name: 'RUA LUIZ PORFIRIO SALES',
  },
  {
    name: 'TR SAO DOMINGOS',
  },
  {
    name: 'RUA ALVARO CHAVES',
  },
  {
    name: 'RUA M UI 512',
  },
  {
    name: 'RUA SGT NERI',
  },
  {
    name: 'TR MENINO JESUS',
  },
  {
    name: 'TR JOAO MORAIS',
  },
  {
    name: 'TR JACUNAUBA',
  },
  {
    name: 'RUA CARLOS ESTEVO',
  },
  {
    name: 'TR VIRGOLANDIA',
  },
  {
    name: 'RUA HERCULES DE MIRANDA',
  },
  {
    name: 'RUA AMELIA CONDE',
  },
  {
    name: 'RUA A UI 512',
  },
  {
    name: 'TR STO AMARO UI 208',
  },
  {
    name: 'RUA D UI 512',
  },
  {
    name: 'RUA E UI 512',
  },
  {
    name: 'RUA ESTEVAO DE MELO',
  },
  {
    name: 'RUA STA TEREZA',
  },
  {
    name: 'RUA UM (MONDUBIM)',
  },
  {
    name: 'RUA CRISTOVAO MELO',
  },
  {
    name: 'RUA MONTE FLOR',
  },
  {
    name: 'RUA GASPAR DUTRA',
  },
  {
    name: 'RUA BELA VISTA',
  },
  {
    name: 'TR IMPAR',
  },
  {
    name: 'RUA STA LUZIA UI 505',
  },
  {
    name: 'RUA RENATO MAGALHAES',
  },
  {
    name: 'RUA MANUEL PEIXOTO',
  },
  {
    name: 'RUA DELMIRO JUNIOR',
  },
  {
    name: 'RUA JOAO HENRIQUE',
  },
  {
    name: 'RUA EDESIO MONTEIRO',
  },
  {
    name: 'RUA FILIPINAS',
  },
  {
    name: 'RUA CONCEICAO',
  },
  {
    name: 'RUA MON BEZERRA',
  },
  {
    name: 'RUA RAFAEL LIRA PEREIRA',
  },
  {
    name: 'RUA ESPINOSA',
  },
  {
    name: 'RUA MIRIAM ROCHA',
  },
  {
    name: 'RUA BABILONIA',
  },
  {
    name: 'RUA LUIZ FERNANDES',
  },
  {
    name: 'RUA MARIA DE NAZARE',
  },
  {
    name: 'RUA LUCIANO SILVA',
  },
  {
    name: 'RUA TIBICUERAS',
  },
  {
    name: 'RUA 25 DE MAIO',
  },
  {
    name: 'TR 25 DE MAIO',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'TR GUILHERME ROCHA',
  },
  {
    name: 'TR CANINDE',
  },
  {
    name: 'TR PEREIRA DE SOUZA',
  },
  {
    name: 'TR ANDERSON',
  },
  {
    name: 'TR ANTONIO BOTELHO',
  },
  {
    name: 'RUA LUIZ LOURENCO DE SOUSA',
  },
  {
    name: 'TR LUIZ LOURENCO DE SOUSA',
  },
  {
    name: 'TR RIO JORDAO',
  },
  {
    name: 'TR LOURENCO DE SOUZA',
  },
  {
    name: 'TR CEL PATRICIO',
  },
  {
    name: 'TR HONORATO SILVA',
  },
  {
    name: 'RUA FLORESTA',
  },
  {
    name: 'TR CAPUCHINHO',
  },
  {
    name: 'TR MENINO JESUS',
  },
  {
    name: 'TR PDE CICERO',
  },
  {
    name: 'TR JOSE DE ASSIS',
  },
  {
    name: 'RUA JOSE ORLEANS',
  },
  {
    name: 'RUA SANTANA',
  },
  {
    name: 'RUA ERIBERTO NOBRE',
  },
  {
    name: 'RUA PAULO ANDRE',
  },
  {
    name: 'TR STA CASSIANA',
  },
  {
    name: 'RUA MONTE ROSADO',
  },
  {
    name: 'RUA 2 IRMAOS',
  },
  {
    name: 'RUA ANGELINA MUNIZ',
  },
  {
    name: 'TR MANOEL PEREIRA',
  },
  {
    name: 'RUA PEDRO SILVA NETO',
  },
  {
    name: 'RUA ALFREDO WEYNE (A. WEYNE)',
  },
  {
    name: 'BC TEODOMIRO DE CASTRO',
  },
  {
    name: 'RUA CRAVINA',
  },
  {
    name: 'VL PRAXEDES',
  },
  {
    name: 'VL MESQUITA',
  },
  {
    name: 'TR CONDOR',
  },
  {
    name: 'RUA G. UI 505',
  },
  {
    name: 'RUA 5B UI 512',
  },
  {
    name: 'RUA PEQUENA',
  },
  {
    name: 'RUA 7B UI 512',
  },
  {
    name: 'RUA 7A UI 512',
  },
  {
    name: 'RUA 12 UI 512',
  },
  {
    name: 'VL SAO VICENTE',
  },
  {
    name: 'RUA 6 UI 512',
  },
  {
    name: 'RUA 5 UI 512',
  },
  {
    name: 'RUA ALVORADA',
  },
  {
    name: 'RUA 9 UI 512',
  },
  {
    name: 'RUA ITAJUIPE',
  },
  {
    name: 'RUA SOUSA MOTA',
  },
  {
    name: 'RUA JUVENTUDE',
  },
  {
    name: 'RUA 3 UI 512',
  },
  {
    name: 'TR 15 DE JULHO',
  },
  {
    name: 'TR SAO JOSE UI 113',
  },
  {
    name: 'RUA ANDRE DALL OLIO',
  },
  {
    name: 'RUA JOAQUIM CORREIA',
  },
  {
    name: 'RUA MARIA DOS SANTOS',
  },
  {
    name: 'RUA CELESTINO VASCONCELOS',
  },
  {
    name: 'TR VISTA VERDE',
  },
  {
    name: 'TR SETUBAL',
  },
  {
    name: 'RUA OSCAR ROMERO',
  },
  {
    name: 'RUA JOAO CAMPOS',
  },
  {
    name: 'RUA WAGNER MARINHO',
  },
  {
    name: 'RUA APOCALIPSE (MONDUBIM)',
  },
  {
    name: 'TR NOVA CONQUISTA I UI 706',
  },
  {
    name: 'TR NOVA CONQUISTA II UI 706',
  },
  {
    name: 'TR NOVA CONQUISTA III UI 706',
  },
  {
    name: 'RUA B 1 UI 706',
  },
  {
    name: 'RUA B 2 UI 706',
  },
  {
    name: 'RUA B 3 UI 706',
  },
  {
    name: 'RUA CRISTOVAO NUNES',
  },
  {
    name: 'TR VARZELANDIA',
  },
  {
    name: 'TR SAPUCAI',
  },
  {
    name: 'RUA D UI 505',
  },
  {
    name: 'RUA C UI 505',
  },
  {
    name: 'RUA 13 B UI 706',
  },
  {
    name: 'RUA A UI 706',
  },
  {
    name: 'RUA SAO LUCAS',
  },
  {
    name: 'RUA UNIFLOR',
  },
  {
    name: 'TR STA HELENA',
  },
  {
    name: 'TR ALVORADA',
  },
  {
    name: 'RUA ROSA MISTICA',
  },
  {
    name: 'TR EDWIRGES UI 706',
  },
  {
    name: 'RUA FRE TEODORO',
  },
  {
    name: 'RUA L06 UI 706',
  },
  {
    name: 'RUA L05 UI 706',
  },
  {
    name: 'RUA L04 UI 706',
  },
  {
    name: 'RUA L01 UI 706',
  },
  {
    name: 'RUA NS08 UI 706',
  },
  {
    name: 'RUA NS07 UI 706',
  },
  {
    name: 'RUA NS06 UI 706',
  },
  {
    name: 'RUA NS05 UI 706',
  },
  {
    name: 'RUA Y UI 206',
  },
  {
    name: 'TR P UI 206',
  },
  {
    name: 'RUA MASCARENHAS DE MORAES',
  },
  {
    name: 'AL SOARES DUTRA',
  },
  {
    name: 'TR GUARANI',
  },
  {
    name: 'RUA VLADIMIR DIOGENES',
  },
  {
    name: 'RUA H UI 206',
  },
  {
    name: 'RUA PACAEMBU',
  },
  {
    name: 'RUA CLAUDIA ARRUDA ALCANTARA',
  },
  {
    name: 'VL GOIAS',
  },
  {
    name: 'VL MADEIRA',
  },
  {
    name: 'VL SANTOS',
  },
  {
    name: 'VL REBOUCAS',
  },
  {
    name: 'VL JOAO FURTADO DE MACEDO',
  },
  {
    name: 'VL HELENA',
  },
  {
    name: 'VL ESTEIRAS',
  },
  {
    name: 'VL AZUL',
  },
  {
    name: 'VL STO ANTONIO',
  },
  {
    name: 'TR AMANCIO CAVALCANTE',
  },
  {
    name: 'RUA ESC PEDRO FRANCISCO DE ASSIS',
  },
  {
    name: 'RUA PIO RODRIGUES',
  },
  {
    name: 'TR PARANA',
  },
  {
    name: 'TR MARIPA',
  },
  {
    name: 'RUA PAULO I',
  },
  {
    name: 'RUA NS2 UI 706',
  },
  {
    name: 'RUA NS3 UI 706',
  },
  {
    name: 'RUA PAISAGISTA',
  },
  {
    name: 'RUA L03 UI 706',
  },
  {
    name: 'RUA NS9 UI 706',
  },
  {
    name: 'TR AZEVEDO MONTAURI',
  },
  {
    name: 'TR FRE ALEMAO',
  },
  {
    name: 'TR RAIMUNDO PINHEIRO',
  },
  {
    name: 'TR NOVA FRIBURGO',
  },
  {
    name: 'TR STA CLARA',
  },
  {
    name: 'TR STA RITA',
  },
  {
    name: 'RUA 4 UI 805',
  },
  {
    name: 'RUA 3 UI 805',
  },
  {
    name: 'RUA 2 UI 805',
  },
  {
    name: 'RUA 1 UI 805',
  },
  {
    name: 'VL BEZERRA',
  },
  {
    name: 'BC BALDUINO FREIRE',
  },
  {
    name: 'TR ENILDA',
  },
  {
    name: 'RUA 5 UI 805',
  },
  {
    name: 'RUA 6 UI 805',
  },
  {
    name: 'TR IRM DULCE',
  },
  {
    name: 'RUA SALVADOR',
  },
  {
    name: 'TR HAITI',
  },
  {
    name: 'RUA PRO EUGENIO ARRUDA',
  },
  {
    name: 'VL CRISTINA',
  },
  {
    name: 'TR BELO HORIZONTE',
  },
  {
    name: 'VL BERTOLO',
  },
  {
    name: 'VL DAS FLORES',
  },
  {
    name: 'TR RODRIGO MEDINA',
  },
  {
    name: 'RUA DONZELA',
  },
  {
    name: 'RUA BUENO',
  },
  {
    name: 'RUA PDE CICERO UI 809',
  },
  {
    name: 'VL JOAO XXIII',
  },
  {
    name: 'VL JOAO ONTENA',
  },
  {
    name: 'RUA CONSTANCIA',
  },
  {
    name: 'TR CENTRAL UI 611',
  },
  {
    name: 'TR ITU',
  },
  {
    name: 'TR DAS GRACAS',
  },
  {
    name: 'VL DAS VIRGENS',
  },
  {
    name: 'VL ALERTA',
  },
  {
    name: 'TR BOA VIAGEM',
  },
  {
    name: 'TR EPIFANIO LEITE',
  },
  {
    name: 'TR LARGA',
  },
  {
    name: 'RUA LIVREIRO ARLINDO',
  },
  {
    name: 'VL COLOMBO',
  },
  {
    name: 'TR VILA AZUL',
  },
  {
    name: 'VL TUPINAMBA',
  },
  {
    name: 'TR BRI TORRES',
  },
  {
    name: 'TR SEN FERNANDES TAVORA',
  },
  {
    name: 'TR LUCIANO QUEIROZ',
  },
  {
    name: 'TR SAO RAIMUNDO',
  },
  {
    name: 'TR NOGUEIRA',
  },
  {
    name: 'RUA MILTON E. PINHEIRO',
  },
  {
    name: 'TR SOARES BULCAO',
  },
  {
    name: 'AL GIRASSOL',
  },
  {
    name: 'AL VITORIA',
  },
  {
    name: 'AL MANDACARU',
  },
  {
    name: 'AL SERTANEJO',
  },
  {
    name: 'TR DONA TICHA CARVALHO',
  },
  {
    name: 'RUA PATRICIA',
  },
  {
    name: 'RUA SOLON NETO',
  },
  {
    name: 'RUA OTACILIO AMARAL',
  },
  {
    name: 'TR SAO JOSE',
  },
  {
    name: 'RUA SETAMA',
  },
  {
    name: 'RUA ALTAIR FARIAS',
  },
  {
    name: 'TR BRUSQUE',
  },
  {
    name: 'VL LAERCIO',
  },
  {
    name: 'VL ULISSES',
  },
  {
    name: 'TR ALTAS',
  },
  {
    name: 'RUA PIRAJUI',
  },
  {
    name: 'VL ZILDA',
  },
  {
    name: 'VL LEONIRA',
  },
  {
    name: 'VL PDE MAXIMILIANO',
  },
  {
    name: 'RUA EDMUNDO RODRIGUES',
  },
  {
    name: 'RUA DO ANJO BRANCO',
  },
  {
    name: 'TR IDELFONSO',
  },
  {
    name: 'RUA VILA FAISAO',
  },
  {
    name: 'RUA JONAS T. CARNEIRO',
  },
  {
    name: 'RUA 06 UI 310',
  },
  {
    name: 'TR SAO JORGE',
  },
  {
    name: 'TR QUENIA',
  },
  {
    name: 'TR GUINE',
  },
  {
    name: 'TR CONGO',
  },
  {
    name: 'RUA LUIZ CARLOS FELIX',
  },
  {
    name: 'TR SAO CONRADO',
  },
  {
    name: 'TR HOLANDESA',
  },
  {
    name: 'TR JOSE DE MORAES',
  },
  {
    name: 'TR VILA DENISE',
  },
  {
    name: 'RUA AGOSTINHO MOTA',
  },
  {
    name: 'TR MANUEL DE MEDEIROS',
  },
  {
    name: 'TR DJLIII UI 116',
  },
  {
    name: 'TR CIRANDINHA',
  },
  {
    name: 'VL MODERNA',
  },
  {
    name: 'TR DJLIV UI 116',
  },
  {
    name: 'TR AZEVEDO BOLAO',
  },
  {
    name: 'RUA MARIA FELIX RODRIGUES',
  },
  {
    name: 'TR EURICO MOTA',
  },
  {
    name: 'RUA PRP NASSAU',
  },
  {
    name: 'TR ARTUR DE CARVALHO',
  },
  {
    name: 'VL GARDENIA GIRAO',
  },
  {
    name: 'TR VALADO',
  },
  {
    name: 'TR ACURCIO',
  },
  {
    name: 'RUA OTONII LOPES DE OLIVEIRA',
  },
  {
    name: 'RUA SAO PANTALEAO',
  },
  {
    name: 'VL DOURINA',
  },
  {
    name: 'VL DA GAVETA',
  },
  {
    name: 'VL SANTA FE',
  },
  {
    name: 'TR NEVES',
  },
  {
    name: 'TR DOLORES DURAN',
  },
  {
    name: 'TR CLELIA',
  },
  {
    name: 'TR ANA CINTIA',
  },
  {
    name: 'RUA SEBASTIAO DE SOUZA',
  },
  {
    name: 'TR FRANCISCO BATISTA',
  },
  {
    name: 'RUA 02 UI 508',
  },
  {
    name: 'RUA 03 UI 508',
  },
  {
    name: 'RUA LAGO DO TANQUE',
  },
  {
    name: 'TR NAZARE',
  },
  {
    name: 'RUA 1 UI 902',
  },
  {
    name: 'TR SOBERANA',
  },
  {
    name: 'RUA LIBERAL',
  },
  {
    name: 'RUA 02 UI',
  },
  {
    name: 'RUA 06 UI',
  },
  {
    name: 'TR PEDESTRE E UI 407',
  },
  {
    name: 'TR ANTONIO MARCOS',
  },
  {
    name: 'TR SILMAR',
  },
  {
    name: 'RUA CICERO HERMINIO',
  },
  {
    name: 'RUA 04 UI',
  },
  {
    name: 'RUA ZUMBI',
  },
  {
    name: 'RUA 05 UI',
  },
  {
    name: 'RUA IRMA DULCE',
  },
  {
    name: 'RUA 03 UI',
  },
  {
    name: 'TR JOSIAS SIMOES',
  },
  {
    name: 'RUA A UI 407',
  },
  {
    name: 'RUA B UI 407',
  },
  {
    name: 'TR 03 UI',
  },
  {
    name: 'RUA LINO AUGUSTINHO',
  },
  {
    name: 'TR CICERO HERMINIO',
  },
  {
    name: 'RUA V BERNA',
  },
  {
    name: 'TR POPULAR',
  },
  {
    name: 'VL MACIEIRA',
  },
  {
    name: 'TR MIRAINA',
  },
  {
    name: 'TR MARIA ALZEMIR',
  },
  {
    name: 'TR CEMEC',
  },
  {
    name: 'TR FRANSQUINHA',
  },
  {
    name: 'VL MANOEL PASSOS',
  },
  {
    name: 'TR SOLAR',
  },
  {
    name: 'TR N.S. DAS DORES',
  },
  {
    name: 'TR BAEPENDI',
  },
  {
    name: 'BC DOS CAVALOS',
  },
  {
    name: 'RUA STO ESTEVAO',
  },
  {
    name: 'TR SAO FRANCISCO',
  },
  {
    name: 'TR ROSENO',
  },
  {
    name: 'TR MARTAN',
  },
  {
    name: 'TR ZULEICA',
  },
  {
    name: 'TR COLCNIA',
  },
  {
    name: 'VL ROMCY',
  },
  {
    name: 'TR PDE SAMUEL F DE BARROS',
  },
  {
    name: 'RUA PRO ONELIO PORTO',
  },
  {
    name: 'TR I ALBANO',
  },
  {
    name: 'TR ANTONIO ALENCAR',
  },
  {
    name: 'TR DELMIRO GOLVEIA',
  },
  {
    name: 'RUA DOUGLAS MARSHALL',
  },
  {
    name: 'RUA LIMA BARRETO',
  },
  {
    name: 'RUA LOUZANO',
  },
  {
    name: 'RUA AIRTON SENNA',
  },
  {
    name: 'RUA LOUSANA',
  },
  {
    name: 'RUA B UI 204',
  },
  {
    name: 'TR BOA VISAO',
  },
  {
    name: 'TR DARCY',
  },
  {
    name: 'ET DA CAGECE',
  },
  {
    name: 'RUA BEIJUPIRA',
  },
  {
    name: 'RUA ISABEL',
  },
  {
    name: 'RUA ENXOUVA',
  },
  {
    name: 'RUA MON A. SOBREIRAS',
  },
  {
    name: 'RUA JONAS GOMES',
  },
  {
    name: 'RUA DM GONDIM',
  },
  {
    name: 'TR CONTINENTAL',
  },
  {
    name: 'RUA S DO BONFIM',
  },
  {
    name: 'TR BERNARDO PORTO',
  },
  {
    name: 'TR GONCALO DE LAGO',
  },
  {
    name: 'RUA ANCHOVA',
  },
  {
    name: 'RUA STO AMARO (MUCURIPE)',
  },
  {
    name: 'TR GRACA ARANHA',
  },
  {
    name: 'RUA DOS PARLAMENTARES',
  },
  {
    name: 'RUA JOSIAS PAULA DE SOUZA',
  },
  {
    name: 'RUA B C CAMARA',
  },
  {
    name: 'TR DO LUAR',
  },
  {
    name: 'TR LUCIANO CARDOSO',
  },
  {
    name: 'RUA M UI 204',
  },
  {
    name: 'TR STA INES',
  },
  {
    name: 'RUA IMALAQUIAS',
  },
  {
    name: 'TR SOLAR UI 911',
  },
  {
    name: 'TR TEIXEIRA CAVALCANTE',
  },
  {
    name: 'RUA BOA VISAO',
  },
  {
    name: 'TR LUIZ TEIXEIRA',
  },
  {
    name: 'TR CASSIA',
  },
  {
    name: 'TR COR BONITO',
  },
  {
    name: 'RUA JOAO EVANGELISTA',
  },
  {
    name: 'RUA ESTRELINHA',
  },
  {
    name: 'TR OSMUNCO CAVALCANTE',
  },
  {
    name: 'RUA ROBERTO PEDROSA',
  },
  {
    name: 'TR ALBERTO QUEIROZ',
  },
  {
    name: 'TR C MATOS',
  },
  {
    name: 'TR VILA DO SOL',
  },
  {
    name: 'TR PC ABERLADO',
  },
  {
    name: 'TR JUQUERI',
  },
  {
    name: 'RUA Q UI 204',
  },
  {
    name: 'RUA DAS FLORES',
  },
  {
    name: 'RUA VISTA PARA O MAR',
  },
  {
    name: 'RUA X UI 204',
  },
  {
    name: 'RUA BRISA DO MAR',
  },
  {
    name: 'RUA JONAS GOMES',
  },
  {
    name: 'TR CAVALO MARINHO',
  },
  {
    name: 'TR MON AMAURICIO',
  },
  {
    name: 'RUA V UI 204',
  },
  {
    name: 'TR ALTAMIRA',
  },
  {
    name: 'RUA C UI 204',
  },
  {
    name: 'TR DOUGLAS MARSHALL I',
  },
  {
    name: 'RUA R UI 204',
  },
  {
    name: 'RUA DO LABIRINTO',
  },
  {
    name: 'TR M CARVALHO',
  },
  {
    name: 'RUA O UI 204',
  },
  {
    name: 'RUA DOUGLAS MARSHALL II',
  },
  {
    name: 'BC ANCURI',
  },
  {
    name: 'TR ELIZIANE',
  },
  {
    name: 'RUA CUMBICA',
  },
  {
    name: 'ET DOS EXPEDICIONARIOS',
  },
  {
    name: 'TR KELLY MELO',
  },
  {
    name: 'RUA SAO JOSE DE RIBAMAR',
  },
  {
    name: 'TR DEOCLECIANO CAVALCANTE',
  },
  {
    name: 'RUA FRANCISCO JOSE FERREIRA',
  },
  {
    name: 'RUA N.S. AUXILIADORA',
  },
  {
    name: 'TR GUARARAPES',
  },
  {
    name: 'RUA A UI 608',
  },
  {
    name: 'RUA E UI 608',
  },
  {
    name: 'RUA CENCYS PINHEIRO',
  },
  {
    name: 'RUA BOM RETIRO',
  },
  {
    name: 'RUA CIRCULACAO',
  },
  {
    name: 'RUA OMAR CARDOSO',
  },
  {
    name: 'TR EDSON QUEIROZ',
  },
  {
    name: 'RUA 01 UI 901',
  },
  {
    name: 'RUA ABELARDO BARBOSA',
  },
  {
    name: 'TR SEN VIRGILIO TAVORA',
  },
  {
    name: 'BC VILA CATU',
  },
  {
    name: 'RUA MAR E SOL',
  },
  {
    name: 'TR PRO JUREMA',
  },
  {
    name: 'RUA ALTO DA BALANCA',
  },
  {
    name: 'RUA PAZ UI 901',
  },
  {
    name: 'RUA 21 DE DEZEMBRO UI 901',
  },
  {
    name: 'RUA G UI 901',
  },
  {
    name: 'RUA DR JOSE ROBERTO SALES',
  },
  {
    name: 'RUA ADRIANISTA',
  },
  {
    name: 'RUA 09 UI 901',
  },
  {
    name: 'RUA D UI 901',
  },
  {
    name: 'RUA POE NAPOLEAO MENEZES',
  },
  {
    name: 'TR DO ROSARIO',
  },
  {
    name: 'BC DA PAIZINHA',
  },
  {
    name: 'TR AMORA',
  },
  {
    name: 'BC SAO VICENTE',
  },
  {
    name: 'TR DES PRAXEDES',
  },
  {
    name: 'RUA GRAO PARA',
  },
  {
    name: 'RUA RIO VENTURA',
  },
  {
    name: 'TR BOTAFOGO',
  },
  {
    name: 'RUA PANORAMA',
  },
  {
    name: 'TR DA JUVENTUDE',
  },
  {
    name: 'TR DA AMIZADE',
  },
  {
    name: 'RUA MES ANDRE',
  },
  {
    name: 'TR VITORIA DA CONQUISTA',
  },
  {
    name: 'RUA DA LIBERDADE',
  },
  {
    name: 'RUA DA FRATERNIDADE',
  },
  {
    name: 'RUA ALTO DAS PEDRINHAS',
  },
  {
    name: 'TR FRANCISCO RAMOS',
  },
  {
    name: 'TR VICENTE PAULINO',
  },
  {
    name: 'RUA TRES LAGOAS',
  },
  {
    name: 'RUA DA SAUDADE',
  },
  {
    name: 'RUA PANFILIA',
  },
  {
    name: 'TR STO ANTONIO',
  },
  {
    name: 'TR LUIS UCHOA',
  },
  {
    name: 'TR GOIANEZA',
  },
  {
    name: 'VL SAO JORGE',
  },
  {
    name: 'VL VERDE',
  },
  {
    name: 'TR GENOVA',
  },
  {
    name: 'VL RAMOS',
  },
  {
    name: 'TR AREIA BRANCA',
  },
  {
    name: 'RUA FRANCA MARTINS',
  },
  {
    name: 'TR DA PAZ',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA BARRA VERDE',
  },
  {
    name: 'RUA CAMPO VERDE',
  },
  {
    name: 'RUA POPULAR',
  },
  {
    name: 'RUA POLAR',
  },
  {
    name: 'RUA PASSO FUNDO',
  },
  {
    name: 'RUA PORTO DAS ROSAS',
  },
  {
    name: 'TR PASSO FUNDO',
  },
  {
    name: 'TR CHICO MENDES',
  },
  {
    name: 'TR JOSE MENDONCA',
  },
  {
    name: 'TR SUCUPIRA',
  },
  {
    name: 'RUA BEIRA RIO',
  },
  {
    name: 'TR VIANA',
  },
  {
    name: 'VL ALICE DINIZ',
  },
  {
    name: 'RUA VALDEMAR ROSA',
  },
  {
    name: 'RUA CAZUZA FERREIRA',
  },
  {
    name: 'RUA MENDES PIMENTEL',
  },
  {
    name: 'BC 16 DE SETEMBRO',
  },
  {
    name: 'VL NAUTILUS',
  },
  {
    name: 'TR VIRGILIO TAVORA',
  },
  {
    name: 'TR 24 DE OUTUBRO',
  },
  {
    name: 'RUA TAILANDIA',
  },
  {
    name: 'TR NOVA',
  },
  {
    name: 'RUA NAUTILUS',
  },
  {
    name: 'TR NAUTILUS',
  },
  {
    name: 'RUA SETE BARRA',
  },
  {
    name: 'RUA BARRA DO TURNO',
  },
  {
    name: 'RUA DAMASCO',
  },
  {
    name: 'TR MESQUITA',
  },
  {
    name: 'RUA GRADIENTE',
  },
  {
    name: 'TR FRANCISCO RAMOS',
  },
  {
    name: 'RUA PEDRO RODRIGUES',
  },
  {
    name: 'RUA TAMBAU',
  },
  {
    name: 'RUA CENTRAL UI 901',
  },
  {
    name: 'RUA IMPERATRIZ',
  },
  {
    name: 'RUA PROFETA ISAIAS',
  },
  {
    name: 'RUA D UI 901',
  },
  {
    name: 'TR WESUVIO',
  },
  {
    name: 'RUA RAIMUNDO BARBOSA',
  },
  {
    name: 'GL SAO LUIZ',
  },
  {
    name: 'RUA 3 UI 901',
  },
  {
    name: 'RUA ENIDE MENEZES',
  },
  {
    name: 'RUA CAETANO JOSE',
  },
  {
    name: 'TR PAD DRALINA',
  },
  {
    name: 'RUA CIRCULACAO 2 UI 901',
  },
  {
    name: 'TR CANDIDO CASTELO BRANCO',
  },
  {
    name: 'RUA DA UNIAO',
  },
  {
    name: 'VL CLAUDEIR',
  },
  {
    name: 'RUA 6 UI 901',
  },
  {
    name: 'TR GOV FAUSTINO',
  },
  {
    name: 'RUA STA HELENA UI 901',
  },
  {
    name: 'TR NOVA',
  },
  {
    name: 'RUA ALVORADA',
  },
  {
    name: 'TR SAO JORGE',
  },
  {
    name: 'RUA CRISTIANO DE ABREU',
  },
  {
    name: 'VL PINHEIRO PEIXOTO',
  },
  {
    name: 'VL JOANA',
  },
  {
    name: 'TR PAULO ARAGAO',
  },
  {
    name: 'VL RIBEIRO',
  },
  {
    name: 'TR ESTRELA DO MAR',
  },
  {
    name: 'TR PROFETA ISAIAS',
  },
  {
    name: 'RUA 4 UI 901',
  },
  {
    name: 'RUA TOCANDERA',
  },
  {
    name: 'RUA ITEMBIARA',
  },
  {
    name: 'RUA A UI 807',
  },
  {
    name: 'RUA C UI 901',
  },
  {
    name: 'RUA 69 UI 807',
  },
  {
    name: 'TR ANTONIO MOREIRA',
  },
  {
    name: 'TR MARA',
  },
  {
    name: 'VL SILVIA MONTEIRO',
  },
  {
    name: 'RUA ROSA DA FONSECA',
  },
  {
    name: 'TR ROBERTO CABRAL',
  },
  {
    name: 'VL MORADA JOSE DIDIMO',
  },
  {
    name: 'RUA SILVA ROCHA',
  },
  {
    name: 'RUA 8 UI 901',
  },
  {
    name: 'RUA 2 UI 901',
  },
  {
    name: 'RUA PRS SILVA',
  },
  {
    name: 'RUA PDE GUILHERMINO',
  },
  {
    name: 'RUA SAO PEDRO',
  },
  {
    name: 'RUA PEDRO FORTUNATO',
  },
  {
    name: 'AV CENTRAL IU 309',
  },
  {
    name: 'RUA A IU 309',
  },
  {
    name: 'RUA MARIA ZANETE M PEREIRA',
  },
  {
    name: 'RUA PENHA MENDES',
  },
  {
    name: 'RUA NS 14 SITIO TUNGA',
  },
  {
    name: 'RUA NS 13 SITIO TUNGA',
  },
  {
    name: 'RUA A UI 309',
  },
  {
    name: 'RUA RJ 6 UI 309',
  },
  {
    name: 'RUA BAMBUI',
  },
  {
    name: 'RUA TRANSVERSAL UI 309',
  },
  {
    name: 'RUA MARQUES DE PINHO',
  },
  {
    name: 'RUA WE 2 UI 309',
  },
  {
    name: 'RUA VIA PARQUE VL VELHA I',
  },
  {
    name: 'TR DOS BANDEIRANTES',
  },
  {
    name: 'RUA OSMANI',
  },
  {
    name: 'RUA 6 UI 901',
  },
  {
    name: 'RUA NOVO LAR',
  },
  {
    name: 'RUA 7 UI 901',
  },
  {
    name: 'RUA 2 UI 901',
  },
  {
    name: 'RUA 3 UI 901',
  },
  {
    name: 'RUA 5 UI 901',
  },
  {
    name: 'AV I UI 309',
  },
  {
    name: 'RUA A UI 309',
  },
  {
    name: 'RUA B UI 309',
  },
  {
    name: 'RUA C UI 309',
  },
  {
    name: 'RUA D UI 309',
  },
  {
    name: 'RUA E UI 309',
  },
  {
    name: 'RUA F UI 309',
  },
  {
    name: 'RUA A UI 901',
  },
  {
    name: 'RUA E UI 901',
  },
  {
    name: 'RUA PAZ E PROSPERIDADE',
  },
  {
    name: 'TR PASTA',
  },
  {
    name: 'RUA G UI 309',
  },
  {
    name: 'RUA H UI 309',
  },
  {
    name: 'RUA L UI 309 (LOT. EXPEDICIONARIOS)',
  },
  {
    name: 'RUA M UI 309',
  },
  {
    name: 'RUA N UI 309',
  },
  {
    name: 'RUA P UI 309',
  },
  {
    name: 'RUA DA BEIRA',
  },
  {
    name: 'RUA Q UI 309',
  },
  {
    name: 'AV II LOT EXPEDICIONARIOS II',
  },
  {
    name: 'RUA I UI 309',
  },
  {
    name: 'RUA IRATI',
  },
  {
    name: 'RUA 5 DE MAIO',
  },
  {
    name: 'RUA PEREIRA JUNIOR',
  },
  {
    name: 'RUA TAPARICA',
  },
  {
    name: 'RUA 4 UI 901',
  },
  {
    name: 'RUA FRANCANA',
  },
  {
    name: 'RUA 1 UI 901',
  },
  {
    name: 'RUA 2 UI 901',
  },
  {
    name: 'TR AIRTON RODRIGUES',
  },
  {
    name: 'TR DA SEDE',
  },
  {
    name: 'RUA M. BRANCO',
  },
  {
    name: 'RUA PDE HAROLDO COELHO',
  },
  {
    name: 'RUA A UI 901',
  },
  {
    name: 'TR PDE SANTANA',
  },
  {
    name: 'TR HILDEBRANDO DE MELO',
  },
  {
    name: 'RUA 5 UI 901',
  },
  {
    name: 'RUA 13 DE ROCHEDALE',
  },
  {
    name: 'RUA CHICO MENDES',
  },
  {
    name: 'RUA SAO BASILIO',
  },
  {
    name: 'RUA C UI 901',
  },
  {
    name: 'RUA ANTONIO MOREIRA',
  },
  {
    name: 'BC CANARIO',
  },
  {
    name: 'RUA ARAKEN',
  },
  {
    name: 'RUA 20 DE JANEIRO',
  },
  {
    name: 'RUA 10 UI 506',
  },
  {
    name: 'TR LARA 2',
  },
  {
    name: 'TR ANTONIO CHACON',
  },
  {
    name: 'RUA CIRCULACAO 3',
  },
  {
    name: 'RUA ARGIA BRANCA',
  },
  {
    name: 'TR CARLOS TERTULIANO',
  },
  {
    name: 'TR CAROL',
  },
  {
    name: 'RUA LIMA CAMPOS',
  },
  {
    name: 'RUA FRANCISCO INACIO',
  },
  {
    name: 'TR H. MELO',
  },
  {
    name: 'RUA VICENTE FERRETE',
  },
  {
    name: 'RUA CARLOS TERTULIANO',
  },
  {
    name: 'TR D. M. GADELHA',
  },
  {
    name: 'RUA GRACAS ALCANCADAS',
  },
  {
    name: 'RUA ANTONIO CHACON',
  },
  {
    name: 'RUA 3 UI 901',
  },
  {
    name: 'RUA RUCHINO',
  },
  {
    name: 'RUA ELIZETE CARDOSO',
  },
  {
    name: 'TR ELIZETE CARDOSO',
  },
  {
    name: 'RUA RODRIGO',
  },
  {
    name: 'RUA 4 UI 901',
  },
  {
    name: 'TR STO ANTONIO',
  },
  {
    name: 'RUA RECANTO',
  },
  {
    name: 'TR JERUSALEM',
  },
  {
    name: 'RUA NITEROI (B. DO CEARA)',
  },
  {
    name: 'TR DAS FLORES',
  },
  {
    name: 'RUA 2 UI 901',
  },
  {
    name: 'RUA PDE HENRIQUE',
  },
  {
    name: 'TR LINEU MACHADO',
  },
  {
    name: 'VL SALIM',
  },
  {
    name: 'RUA ALBERTO MONTE',
  },
  {
    name: 'RUA 1 UI 901',
  },
  {
    name: 'RUA 5 UI 901',
  },
  {
    name: 'TR LORENA',
  },
  {
    name: 'TR RAUL BARBOSA',
  },
  {
    name: 'RUA PURIFICACAO',
  },
  {
    name: 'RUA L UI 610',
  },
  {
    name: 'RUA H UI 610',
  },
  {
    name: 'RUA DA ASSEMBLEIA',
  },
  {
    name: 'RUA F UI 610',
  },
  {
    name: 'RUA E UI 610',
  },
  {
    name: 'RUA C UI 610',
  },
  {
    name: 'RUA B UI 610',
  },
  {
    name: 'RUA A UI 610',
  },
  {
    name: 'RUA TRINDADE',
  },
  {
    name: 'RUA 1 UI 610',
  },
  {
    name: 'RUA 2 UI 610',
  },
  {
    name: 'RUA 3 UI 610',
  },
  {
    name: 'RUA 4 UI 610',
  },
  {
    name: 'RUA 5 UI 610',
  },
  {
    name: 'RUA 6 UI 610',
  },
  {
    name: 'RUA I UI 610',
  },
  {
    name: 'RUA J UI 610',
  },
  {
    name: 'RUA XII UI 611',
  },
  {
    name: 'RUA II UI 611',
  },
  {
    name: 'RUA XIII UI 611',
  },
  {
    name: 'RUA IV UI 611',
  },
  {
    name: 'RUA V UI 611',
  },
  {
    name: 'RUA XIV UI 611',
  },
  {
    name: 'RUA XV UI 611',
  },
  {
    name: 'RUA FERREIRA LIMA',
  },
  {
    name: 'TR FERREIRA LIMA',
  },
  {
    name: 'TR BEIRA RIO',
  },
  {
    name: 'TR SIDRIAO UI 611',
  },
  {
    name: 'RUA H UI 611',
  },
  {
    name: 'RUA I UI 611',
  },
  {
    name: 'RUA J UI 611',
  },
  {
    name: 'RUA L UI 611',
  },
  {
    name: 'RUA AMSTERDA',
  },
  {
    name: 'F UI 611',
  },
  {
    name: 'G UI 611',
  },
  {
    name: 'RUA A UI 611',
  },
  {
    name: 'RUA B UI 611',
  },
  {
    name: 'RUA C UI 611',
  },
  {
    name: 'RUA D UI 611',
  },
  {
    name: 'RUA E UI 611',
  },
  {
    name: 'RUA 05 UI 611',
  },
  {
    name: 'AL 125 UI 611',
  },
  {
    name: 'TR CENTRAL UI 611',
  },
  {
    name: 'TR 04 DE MAIO UI 611',
  },
  {
    name: 'TR SATURNO',
  },
  {
    name: 'RUA JOAO FAGUNDES LOPES',
  },
  {
    name: 'TR MAJ MOREIRA',
  },
  {
    name: 'AL 165 UI 611',
  },
  {
    name: 'AL 205 UI 611',
  },
  {
    name: 'VL RABBELO',
  },
  {
    name: 'RUA B UI 901',
  },
  {
    name: 'BC ALBERTO MONTE',
  },
  {
    name: 'RUA 07 UI 901',
  },
  {
    name: 'RUA E UI 901',
  },
  {
    name: 'RUA F UI 901',
  },
  {
    name: 'RUA IRM ANA MARIA',
  },
  {
    name: 'RUA FREITAS LIMA',
  },
  {
    name: 'RUA MACAU',
  },
  {
    name: 'TR LARA I',
  },
  {
    name: 'RUA HENRIQUE CALLES',
  },
  {
    name: 'RUA JOAO AGOSTINHO',
  },
  {
    name: 'RUA ALTO DO PIMENTA',
  },
  {
    name: 'RUA ADAHIL BARRETO',
  },
  {
    name: 'TR MIRASSOL',
  },
  {
    name: 'AV MACIEL BEZERRA',
  },
  {
    name: 'RUA MANOEL DE CASTRO (SIQUEIRA)',
  },
  {
    name: 'TR SAO VICENTE',
  },
  {
    name: 'RUA JULIO COLF',
  },
  {
    name: 'RUA DOIS IRMAOS UI 707',
  },
  {
    name: 'RUA SABINO FILHO',
  },
  {
    name: 'RUA VALETA',
  },
  {
    name: 'RUA CESARINA BATISTA',
  },
  {
    name: 'RUA DIVINA',
  },
  {
    name: 'RUA ICAPUY',
  },
  {
    name: 'RUA ALEXSANDRA',
  },
  {
    name: 'RUA FRANCISCO MACHADO',
  },
  {
    name: 'RUA SAO FRANCISCO UI 707',
  },
  {
    name: 'VL MANGUEIRA',
  },
  {
    name: 'TR ANTONIO DOS SANTOS',
  },
  {
    name: 'TR COROELO',
  },
  {
    name: 'AV JUSCELINO KUBITSCHEK (CANINDEZINHO)',
  },
  {
    name: 'RUA DA MATA',
  },
  {
    name: 'RUA MANOEL CORDEIRO',
  },
  {
    name: 'RUA STA RITA',
  },
  {
    name: 'RUA JARDIM DO EDEN',
  },
  {
    name: 'RUA SAO FRANCISCO UI 702',
  },
  {
    name: 'RUA PARAISO VERDE',
  },
  {
    name: 'RUA TEBAS',
  },
  {
    name: 'RUA ITAPOA',
  },
  {
    name: 'RUA SOL',
  },
  {
    name: 'TR CHICO MENDES',
  },
  {
    name: 'TR TANCREDO NEVES',
  },
  {
    name: 'TR SAO CARLOS',
  },
  {
    name: 'TR SAO FRANCISCO UI 702',
  },
  {
    name: 'TR POMAR CARIOCA',
  },
  {
    name: 'RUA STA MARINA',
  },
  {
    name: 'RUA ITAPOA II',
  },
  {
    name: 'RUA ITU',
  },
  {
    name: 'RUA MARIA DE JESUS',
  },
  {
    name: 'RUA DAS FLORES UI 707',
  },
  {
    name: 'RUA FRANCISCO CRUZ',
  },
  {
    name: 'VL 14 UI 209',
  },
  {
    name: 'RUA 06 UI 209',
  },
  {
    name: 'VL 02 UI 209',
  },
  {
    name: 'VL 03 UI 209',
  },
  {
    name: 'VL 12 UI 209',
  },
  {
    name: 'VL 04 UI 209',
  },
  {
    name: 'VL 21 UI 209',
  },
  {
    name: 'AV VIA ARTERIAL',
  },
  {
    name: 'RUA ILHA DOURADA',
  },
  {
    name: 'VL 05 UI 209',
  },
  {
    name: 'TR SAO JOSE UI 803',
  },
  {
    name: 'VL 17 UI 209',
  },
  {
    name: 'VL 24 UI 209',
  },
  {
    name: 'TR DA FELICIDADE',
  },
  {
    name: 'RUA SAO JOAO UI 803',
  },
  {
    name: 'RUA J UI 209',
  },
  {
    name: 'RUA SAO LUCAS UI 803',
  },
  {
    name: 'RUA K UI 209',
  },
  {
    name: 'VL 06 UI 209',
  },
  {
    name: 'VL 18 UI 209',
  },
  {
    name: 'VL 10 UI 209',
  },
  {
    name: 'RUA MOISES',
  },
  {
    name: 'VL 20 UI 209',
  },
  {
    name: 'RUA BARTOLOMEU',
  },
  {
    name: 'VL 19 UI 209',
  },
  {
    name: 'RUA APOCALIPSE (Q.CUNHA)',
  },
  {
    name: 'VL 22 UI 209',
  },
  {
    name: 'VL 09 UI 209',
  },
  {
    name: 'VL 08 UI 209',
  },
  {
    name: 'VL 07 UI 209',
  },
  {
    name: 'VL 23 UI 209',
  },
  {
    name: 'VL 25 UI 209',
  },
  {
    name: 'RUA STA EDVIRGENS UI 803',
  },
  {
    name: 'RUA PRO VIEIRINHA',
  },
  {
    name: 'RUA JOSE A.',
  },
  {
    name: 'TR OLGA CAVALCANTE',
  },
  {
    name: 'RUA ISABEL MADEIRA',
  },
  {
    name: 'RUA ILHA DA PRATA',
  },
  {
    name: 'RUA MOURA SILVA',
  },
  {
    name: 'RUA NAPOLES',
  },
  {
    name: 'RUA SAO GABRIEL (COCO)',
  },
  {
    name: 'RUA H UI 205',
  },
  {
    name: 'RUA ALUYSIO SORIANO ADERALDO',
  },
  {
    name: 'TR M. ISABEL',
  },
  {
    name: 'RUA F UI 205',
  },
  {
    name: 'BC TRAVINA',
  },
  {
    name: 'RUA FELISTEU',
  },
  {
    name: 'TR COITE',
  },
  {
    name: 'RUA LINCON',
  },
  {
    name: 'TR DANUBIAS',
  },
  {
    name: 'BC DO MELAO',
  },
  {
    name: 'TR ARISTOCRATAS',
  },
  {
    name: 'TR DEUZIMAR',
  },
  {
    name: 'TR SAO LUIZ',
  },
  {
    name: 'VL JOANA',
  },
  {
    name: 'RUA 30 DE DEZEMBRO UI 413',
  },
  {
    name: 'RUA DOS REIS',
  },
  {
    name: 'RUA SAO LUIZ UI 413',
  },
  {
    name: 'RUA EDILSON CANDEIAS',
  },
  {
    name: 'TR POTIGUARAS',
  },
  {
    name: 'RUA CANTINNHO VERDE',
  },
  {
    name: 'TR GANDOLA',
  },
  {
    name: 'RUA TUCUPI',
  },
  {
    name: 'RUA 02 UI 413',
  },
  {
    name: 'RUA PRO M. CARNEIRO',
  },
  {
    name: 'RUA MARGARIDA ALVES (PALMEIRAS)',
  },
  {
    name: 'RUA IPAMERIM',
  },
  {
    name: 'RUA DOZE UI 211',
  },
  {
    name: 'ET DO CAJUEIRO',
  },
  {
    name: 'RUA SAO SEBASTIAO UI 413',
  },
  {
    name: 'RUA STO ANTONIO UI 413',
  },
  {
    name: 'TR GRITO DO IPIRANGA',
  },
  {
    name: 'RUA JAMAICA',
  },
  {
    name: 'RUA NOVE UI 211',
  },
  {
    name: 'RUA 03 UI 211',
  },
  {
    name: 'RUA 02 UI 211',
  },
  {
    name: 'RUA ALVARO DIAS',
  },
  {
    name: 'RUA 05 UI 211',
  },
  {
    name: 'RUA DO CRATO',
  },
  {
    name: 'TR JOSE CLAUDIO COSTA LIMA',
  },
  {
    name: 'RUA SANTOS DIAS UI 413',
  },
  {
    name: 'RUA HELLIO BARREIRA',
  },
  {
    name: 'RUA CHICO DIAS',
  },
  {
    name: 'RUA 04 UI 211',
  },
  {
    name: 'TR CURUMBI',
  },
  {
    name: 'RUA 01 UI 211',
  },
  {
    name: 'RUA 4 UI 211',
  },
  {
    name: 'RUA 09 UI 211',
  },
  {
    name: 'TR ALBERTO MONTEIRO',
  },
  {
    name: 'RUA IPALMERIM',
  },
  {
    name: 'RUA SALUSTIANO DE AGUIAR',
  },
  {
    name: 'RUA TEN LAURO',
  },
  {
    name: 'RUA PRO ARMANDO FARIAS',
  },
  {
    name: 'RUA PRO DAVID FELINO',
  },
  {
    name: 'RUA PRO JAIME NASCIMENTO',
  },
  {
    name: 'RUA CHAVAL',
  },
  {
    name: 'RUA ENTRADA DA LUA',
  },
  {
    name: 'RUA ABILIO FARIAS',
  },
  {
    name: 'TR SANTANA',
  },
  {
    name: 'RUA 314 UI 411',
  },
  {
    name: 'TR GROATA',
  },
  {
    name: 'RUA GREGORIO RODRIGUES',
  },
  {
    name: 'RUA DOS MONARCAS',
  },
  {
    name: 'RUA PIAULINO',
  },
  {
    name: 'TR G.A RODRIGUES',
  },
  {
    name: 'RUA RODOLFO TOME',
  },
  {
    name: 'BC TRANQUILOS',
  },
  {
    name: 'RUA TACIANA MARTINS',
  },
  {
    name: 'TR M. REIS',
  },
  {
    name: 'TR CLAUDIO MANOEL',
  },
  {
    name: 'RUA FLOR DO CAMPO',
  },
  {
    name: 'RUA 04 UI 601',
  },
  {
    name: 'RUA 05 UI 601',
  },
  {
    name: 'TR B UI 411',
  },
  {
    name: 'TR C UI 411',
  },
  {
    name: 'RUA 02 UI 601',
  },
  {
    name: 'RUA CAMPO DAS FLORES',
  },
  {
    name: 'RUA AURELIO CAMARA (PICI)',
  },
  {
    name: 'TR PARAISO',
  },
  {
    name: 'RUA 01 UI 601',
  },
  {
    name: 'TR DOS MONARCAS',
  },
  {
    name: 'RUA VISCONDE DA BAHIA',
  },
  {
    name: 'RUA LUIZ GONZAGA',
  },
  {
    name: 'RUA MISSIONARIO OLIVEIRA',
  },
  {
    name: 'RUA RENATO ROCHA',
  },
  {
    name: 'TR D UI 411',
  },
  {
    name: 'TR T.E. PAC UI 601',
  },
  {
    name: 'TR CENARIO',
  },
  {
    name: 'RUA FRANCISCO ASSIS',
  },
  {
    name: 'RUA GREGORIO DONIZETE FREIRE',
  },
  {
    name: 'RUA PRO DARIO LOPES',
  },
  {
    name: 'TR CASTELO BRANCO',
  },
  {
    name: 'RUA 8 DE JUNHO UI 601',
  },
  {
    name: 'TR THIAGO',
  },
  {
    name: 'TR A SANTOS',
  },
  {
    name: 'RUA PIRACICABA',
  },
  {
    name: 'RUA PRO ANTONIO PINHEIRO',
  },
  {
    name: 'RUA CASTELO DE CASTRO (PICI)',
  },
  {
    name: 'RUA 04 DE DEZEMBRO UI 601',
  },
  {
    name: 'TR N.S. APARECIDA',
  },
  {
    name: 'TR BONS AMIGOS',
  },
  {
    name: 'RUA MARIA ALVES RIBEIRO',
  },
  {
    name: 'TR SEVERINO ROMANO',
  },
  {
    name: 'RUA DOS LINOS',
  },
  {
    name: 'RUA SAO SEBASTIAO UI 208',
  },
  {
    name: 'RUA J UI 208',
  },
  {
    name: 'RUA I UI 208',
  },
  {
    name: 'RUA H UI 208',
  },
  {
    name: 'RUA G UI 208',
  },
  {
    name: 'RUA F UI 208',
  },
  {
    name: 'RUA STO ANTONIO UI 208',
  },
  {
    name: 'VL STA RITA UI 208',
  },
  {
    name: 'TR STO AMARO UI 208',
  },
  {
    name: 'VL PONTA MAR',
  },
  {
    name: 'RUA B DA VILALBA',
  },
  {
    name: 'RUA PONTA MAR',
  },
  {
    name: 'TR PONTA MAR',
  },
  {
    name: 'RUA ERNESTO GURGEL',
  },
  {
    name: 'TR FRANCISCO ALVES PEREIRA',
  },
  {
    name: 'VL ELIANA',
  },
  {
    name: 'RUA 22 DE ABRIL UI 208',
  },
  {
    name: 'AL PEREIRA',
  },
  {
    name: 'TR VARZEA NOVA',
  },
  {
    name: 'TR ATLANTICA',
  },
  {
    name: 'RUA SAO JOSE UI 208',
  },
  {
    name: 'RUA SAO FRANCISCO UI 208',
  },
  {
    name: 'VL COOPER',
  },
  {
    name: 'RUA TININHA',
  },
  {
    name: 'TR LUIS ROLIM',
  },
  {
    name: 'TR DIOGHINHO',
  },
  {
    name: 'RUA RIACHAO',
  },
  {
    name: 'TR RIACHAO',
  },
  {
    name: 'RUA REGINA BRANDAO',
  },
  {
    name: 'RUA LUIS TEIXEIRA',
  },
  {
    name: 'RUA PREAMAR',
  },
  {
    name: 'TR TANCREDO NEVES',
  },
  {
    name: 'RUA SAO FRANCISCO UI 601',
  },
  {
    name: 'RUA PRO ROMULO PROENCA',
  },
  {
    name: 'RUA 2 UI 601',
  },
  {
    name: 'RUA BRASILIA',
  },
  {
    name: 'TR CONSELHEIRO',
  },
  {
    name: 'RUA SAO BENEDITO UI 601',
  },
  {
    name: 'RUA 29 DE MAIO UI 601',
  },
  {
    name: 'RUA PDE GALVAO',
  },
  {
    name: 'TR PICI',
  },
  {
    name: 'TR SAO SALDANHA',
  },
  {
    name: 'TR PARANA UI 601',
  },
  {
    name: 'TR ELCLIDES WILCAR',
  },
  {
    name: 'RUA SERRA DOURADA',
  },
  {
    name: 'RUA JOSE VELOSO JUCA',
  },
  {
    name: 'RUA URUCAIANA',
  },
  {
    name: 'AV PRO A CAMARA',
  },
  {
    name: 'TR CATUENSE',
  },
  {
    name: 'TR LAURENTINA',
  },
  {
    name: 'RUA S MARCOS',
  },
  {
    name: 'RUA STO ANTONIO',
  },
  {
    name: 'RUA DEP JOEL MARQUES',
  },
  {
    name: 'TR SOROCABA',
  },
  {
    name: 'TR SAMUEL',
  },
  {
    name: 'TR BASILICA',
  },
  {
    name: 'TR SAO LUIS UI 601',
  },
  {
    name: 'RUA SAO GABRIEL',
  },
  {
    name: 'TR PANTANAL UI 601',
  },
  {
    name: 'TR SAO JOAO',
  },
  {
    name: 'RUA MANOEL BESSA',
  },
  {
    name: 'RUA 7 DE NOVEMBRO UI 601',
  },
  {
    name: 'TR SAO CARLOS',
  },
  {
    name: 'RUA N S DA CONCEICAO (PICI)',
  },
  {
    name: 'TR E GOMES I UI 601',
  },
  {
    name: 'RUA DOM GERONIMO',
  },
  {
    name: 'TR DOM GERONIMO',
  },
  {
    name: 'RUA SAO BRAZ UI 801',
  },
  {
    name: 'RUA 4 UI 308',
  },
  {
    name: 'RUA CRISTINA UI 801',
  },
  {
    name: 'RUA C UI 801',
  },
  {
    name: 'TR VALDIR AZEVEDO',
  },
  {
    name: 'RUA J UI 801',
  },
  {
    name: 'TR 3 UI 801',
  },
  {
    name: 'RUA D CJ VILA VELHA',
  },
  {
    name: 'TR 2 UI 801',
  },
  {
    name: 'RUA L UI 801',
  },
  {
    name: 'RUA A CJ VILA VELHA',
  },
  {
    name: 'TR 4 UI 801',
  },
  {
    name: 'RUA C CJ VILA VELHA',
  },
  {
    name: 'TR 1 UI 801',
  },
  {
    name: 'RUA I UI 801',
  },
  {
    name: 'RUA DO ACO',
  },
  {
    name: 'RUA E UI 801',
  },
  {
    name: 'RUA KALU',
  },
  {
    name: 'RUA D UI 801',
  },
  {
    name: 'TR GEORGINA',
  },
  {
    name: 'RUA RAIMUNDO CIDON',
  },
  {
    name: 'RUA PI UI 801',
  },
  {
    name: 'TR JOINVILE',
  },
  {
    name: 'TR T P V NASSEN',
  },
  {
    name: 'RUA GAL CORDEIRO NETO',
  },
  {
    name: 'RUA TANCREDO NEVES UI 505',
  },
  {
    name: 'RUA LUIS GONZAGA',
  },
  {
    name: 'RUA D BORGES',
  },
  {
    name: 'RUA CHICO MENDES (MONDUBIM)',
  },
  {
    name: 'RUA A UI 505',
  },
  {
    name: 'RUA E UI 505',
  },
  {
    name: 'RUA 1 UI 505',
  },
  {
    name: 'RUA 2 UI 505',
  },
  {
    name: 'RUA 3 UI 505',
  },
  {
    name: 'RUA 4 UI 505',
  },
  {
    name: 'RUA 5 UI 505',
  },
  {
    name: 'RUA 6 UI 505',
  },
  {
    name: 'RUA 7 UI 505',
  },
  {
    name: 'RUA 8 UI 505',
  },
  {
    name: 'AV 4 UI 505',
  },
  {
    name: 'RUA 6 UI 505',
  },
  {
    name: 'TR DO DRAGAO',
  },
  {
    name: 'RUA APOSTOLO PAULO',
  },
  {
    name: 'RUA JOSE VICENTE',
  },
  {
    name: 'RUA NETUNO',
  },
  {
    name: 'RUA ANTONIO ALEXANDRE',
  },
  {
    name: 'RUA SAO JORGE UI 505',
  },
  {
    name: 'RUA MARCELO COSTA',
  },
  {
    name: 'RUA QUIXADA UI 505',
  },
  {
    name: 'RUA BATISTA LIMA',
  },
  {
    name: 'RUA CHICO MENDES UI 505',
  },
  {
    name: 'RUA DA AMIZADE UI 505',
  },
  {
    name: 'RUA MILTON GONCALVES',
  },
  {
    name: 'RUA MONIQUE ALVES',
  },
  {
    name: 'RUA GERONICO',
  },
  {
    name: 'RUA PAULINO DAICAN',
  },
  {
    name: 'RUA ORQUIDEA VERDE',
  },
  {
    name: 'RUA ANDRE LUIS UI 505',
  },
  {
    name: 'RUA ACRE UI 505',
  },
  {
    name: 'RUA FRANCISCO ANTONIO DE ARAUJO',
  },
  {
    name: 'AV SAO FRANCISCO UI 505',
  },
  {
    name: 'RUA DALIA UI 505',
  },
  {
    name: 'TR SAO CLEMENTE UI 505',
  },
  {
    name: 'TR ALBERTO MONTE UI 505',
  },
  {
    name: 'TR MARAMBAIA',
  },
  {
    name: 'TR FRANCISCO VASCONCELOS',
  },
  {
    name: 'RUA DOS COELHOS',
  },
  {
    name: 'RUA OUTEIRO',
  },
  {
    name: 'RUA DA GLORIA',
  },
  {
    name: 'RUA DAS BELAS',
  },
  {
    name: 'RUA VILA MARCIA',
  },
  {
    name: 'RUA VILA HERMINIO',
  },
  {
    name: 'RUA FROTA',
  },
  {
    name: 'RUA SILVIA SANTOS',
  },
  {
    name: 'RUA TRINDADE',
  },
  {
    name: 'RUA BOA HORA',
  },
  {
    name: 'TR TIANGUA',
  },
  {
    name: 'RUA N S MONTE CARMELO',
  },
  {
    name: 'TR GABRIEL AGUIAR',
  },
  {
    name: 'RUA AMARO JOSE DE SOUZA',
  },
  {
    name: 'RUA ANTONIO AUGUSTO UI 505',
  },
  {
    name: 'RUA GERALDINA M DA SILVA',
  },
  {
    name: 'TR SAO FRANCISCO UI 505',
  },
  {
    name: 'RUA 31 DE JANEIRO UI 505',
  },
  {
    name: 'RUA AYRTON',
  },
  {
    name: 'TR JORGE GADELHA',
  },
  {
    name: 'RUA 4 UI 505',
  },
  {
    name: 'RUA IRMA SILVIA SANTOS',
  },
  {
    name: 'RUA ORQUIDEA',
  },
  {
    name: 'RUA BONS AMIGOS',
  },
  {
    name: 'RUA SAO PEDRO UI 505',
  },
  {
    name: 'RUA VILA NOVA UI 505',
  },
  {
    name: 'RUA FRE CASSIANO',
  },
  {
    name: 'RUA 1 UI 308',
  },
  {
    name: 'RUA 3 UI 308',
  },
  {
    name: 'RUA 5 UI 308',
  },
  {
    name: 'RUA 7 UI 308',
  },
  {
    name: 'RUA 9 UI 308',
  },
  {
    name: 'AV 1 UI 308',
  },
  {
    name: 'RUA 4 UI 308',
  },
  {
    name: 'RUA LARGO 1 UI 308',
  },
  {
    name: 'RUA 6 UI 308',
  },
  {
    name: 'RUA 8 UI 308',
  },
  {
    name: 'RUA CANUDO',
  },
  {
    name: 'RUA DO CEU',
  },
  {
    name: 'RUA CLARINDO',
  },
  {
    name: 'TR JOANA DARC',
  },
  {
    name: 'RUA LARGO 3 UI 308',
  },
  {
    name: 'RUA LARGO 2 UI 308',
  },
  {
    name: 'RUA LARGO 4 UI 308',
  },
  {
    name: 'RUA LARGO 6 UI 308',
  },
  {
    name: 'RUA LARGO 5 UI 308',
  },
  {
    name: 'TR MARIA FRANCISCA DA CONCEICAO',
  },
  {
    name: 'RUA 12 UI 308',
  },
  {
    name: 'RUA LARGO 7 UI 308',
  },
  {
    name: 'RUA LARGO 8 UI 308',
  },
  {
    name: 'RUA FORTALEZA UI 505',
  },
  {
    name: 'RUA R DA PRACA UI 308',
  },
  {
    name: 'RUA LARGO 9 UI 308',
  },
  {
    name: 'RUA LARGO 10 UI 308',
  },
  {
    name: 'RUA LARGO 11 UI 308',
  },
  {
    name: 'RUA LARGO 12 UI 308',
  },
  {
    name: 'RUA AUGUSTO DANIEL',
  },
  {
    name: 'RUA 3 UI 308',
  },
  {
    name: 'RUA 10 UI 308',
  },
  {
    name: 'RUA 13 UI 308',
  },
  {
    name: 'RUA 10 DE JANEIRO UI 308',
  },
  {
    name: 'TR JOAO CASTELO',
  },
  {
    name: 'RUA 11 UI 503',
  },
  {
    name: 'RUA SAO FRANCISCO UI 503',
  },
  {
    name: 'RUA SAO JOSE UI 503',
  },
  {
    name: 'RUA 4 UI 503',
  },
  {
    name: 'RUA 18 UI 503',
  },
  {
    name: 'RUA DOS ANCIOES',
  },
  {
    name: 'RUA 19 UI 503',
  },
  {
    name: 'RUA 16 DE NOVEMBRO UI 505',
  },
  {
    name: 'TR JATOBA',
  },
  {
    name: 'RUA PEDRO CICERO',
  },
  {
    name: 'RUA PRO PEDRO JORGE',
  },
  {
    name: 'RUA PINHEIRO TORRES',
  },
  {
    name: 'RUA SILVANDRADE DE JESUS',
  },
  {
    name: 'RUA APUCARANA',
  },
  {
    name: 'RUA 29 DE NOVEMBRO',
  },
  {
    name: 'RUA 27 DE SETEMBRO',
  },
  {
    name: 'RUA DANIEL FURTUOSO DE PAULA',
  },
  {
    name: 'TR MONTALVANIA',
  },
  {
    name: 'RUA VITORIA REGIA',
  },
  {
    name: 'TR ITAPERY UI 505',
  },
  {
    name: 'TR P G  NASSEN',
  },
  {
    name: 'TR ITAPERI',
  },
  {
    name: 'RUA DR ALMEIDA LUSTOSA (MONDUBIM)',
  },
  {
    name: 'RUA PRO MARCOS VINICIUS',
  },
  {
    name: 'RUA PALMEIRA UI 505',
  },
  {
    name: 'RUA RIBEIRAO BONITO',
  },
  {
    name: 'RUA FRANCISCO PALICIO',
  },
  {
    name: 'TR JOAO MEDEIROS',
  },
  {
    name: 'TR ANDRE LUIS UI 505',
  },
  {
    name: 'TR APOCALIPSE (MONDUBIM)',
  },
  {
    name: 'RUA 13 UI 303',
  },
  {
    name: 'RUA DR ITAMAR ESPINDOLA',
  },
  {
    name: 'RUA DALTON ARRUDA',
  },
  {
    name: 'RUA PRO IRINEU',
  },
  {
    name: 'TR C UI 303',
  },
  {
    name: 'TR A UI 303',
  },
  {
    name: 'TR COMUNITARIA UI 303',
  },
  {
    name: 'TR CECILIA MEIRELES UI 303',
  },
  {
    name: 'RUA CEARIM',
  },
  {
    name: 'TR JOSE ALBERTO UI 303',
  },
  {
    name: 'TR DO COQUEIRO UI 303',
  },
  {
    name: 'TR DO CAMPO UI 303',
  },
  {
    name: 'TR AFONSO PENA UI 303',
  },
  {
    name: 'TR EUNICE WEAVER',
  },
  {
    name: 'TR SAO LUCAS UI 303',
  },
  {
    name: 'RUA VALDEMAR TAVARES',
  },
  {
    name: 'TR LUIS GONZAGA',
  },
  {
    name: 'TR TABAIBA',
  },
  {
    name: 'TR CASTELO BRANCO UI 303',
  },
  {
    name: 'RUA JOAO ELMIRO DE SOUZA',
  },
  {
    name: 'TR RITA DE CASSIA UI 303',
  },
  {
    name: 'TR SHALON',
  },
  {
    name: 'TR SIDIO MARCONDES',
  },
  {
    name: 'TR TORRES DE MELO UI 303',
  },
  {
    name: 'RUA RAIMUNDA GALDINO',
  },
  {
    name: 'RUA MARIA GALDINO',
  },
  {
    name: 'RUA JOSE BORGES',
  },
  {
    name: 'TR MARGARIDA',
  },
  {
    name: 'TR VINOLIA',
  },
  {
    name: 'TR MAGNOLIA',
  },
  {
    name: 'RUA 24 DE NOVEMBRO UI 403',
  },
  {
    name: 'TR E PRESLEY',
  },
  {
    name: 'TR CHACRINHA',
  },
  {
    name: 'RUA CANDIDO SABINO',
  },
  {
    name: 'RUA ROQUE FREITAS',
  },
  {
    name: 'RUA MANOEL VIRINO',
  },
  {
    name: 'RUA WILSON',
  },
  {
    name: 'TR CRISTO REDENTOR',
  },
  {
    name: 'ET RIACHO DO OURO',
  },
  {
    name: 'RUA MANOEL PEREIRA',
  },
  {
    name: 'RUA 1 DE ABRIL UI 408',
  },
  {
    name: 'TR JOSE PEREIRA',
  },
  {
    name: 'RUA RECANTO DA SAUDADE',
  },
  {
    name: 'TR STA RITA',
  },
  {
    name: 'RUA SAMAMBAIA',
  },
  {
    name: 'TR 21 DE ABRIL UI 408',
  },
  {
    name: 'RUA 21 DE ABRIL UI 408',
  },
  {
    name: 'TR SAO FRANCISCO UI 408',
  },
  {
    name: 'RUA FREITAS PIMENTEL',
  },
  {
    name: 'RUA AMERICO BRASILIENSE',
  },
  {
    name: 'RUA SANTA FE',
  },
  {
    name: 'RUA PAULO RIBEIRO',
  },
  {
    name: 'RUA AUGUSTA UI 408',
  },
  {
    name: 'TR MONTES VERDES UI 408',
  },
  {
    name: 'RUA ARTUR BARCELAR',
  },
  {
    name: 'TR STO ANTONIO UI 408',
  },
  {
    name: 'TR ENOQUE FALCAO',
  },
  {
    name: 'RUA JOAO SALDANHA',
  },
  {
    name: 'RUA TELES GIRAO',
  },
  {
    name: 'RUA 12 DE MARCO UI 408',
  },
  {
    name: 'RUA DOIS IRMAOS UI 408',
  },
  {
    name: 'TR LIBERDADE',
  },
  {
    name: 'RUA ANA PATRICIA',
  },
  {
    name: 'ET ANTIGA PARA AQUIRAZ',
  },
  {
    name: 'TR BARBOSA',
  },
  {
    name: 'TR CLARA NUNES',
  },
  {
    name: 'TR PDE EZEQUIEL',
  },
  {
    name: 'RUA PDE EZEQUIEL',
  },
  {
    name: 'TR L GEMA',
  },
  {
    name: 'TR ASA BRANCA',
  },
  {
    name: 'RUA COM RIPPER',
  },
  {
    name: 'VL SABRINA',
  },
  {
    name: 'BC ELIZIA MENDES',
  },
  {
    name: 'TR JARDIM TRIUNFO',
  },
  {
    name: 'TR ZENIR VITOR',
  },
  {
    name: 'TR JURITI',
  },
  {
    name: 'TR DEP PAULO BENEVIDES',
  },
  {
    name: 'RUA JOSE IVO',
  },
  {
    name: 'TR STA GERTRUDES',
  },
  {
    name: 'RUA MONTE VERDE',
  },
  {
    name: 'RUA ASA BRANCA',
  },
  {
    name: 'RUA PRO FRANCISCO CARLOS',
  },
  {
    name: 'RUA JOAO LEITE',
  },
  {
    name: 'TR BENEDITO SOBRINHO',
  },
  {
    name: 'VL SALGUEIRO LARA',
  },
  {
    name: 'RUA NILOPOLIS',
  },
  {
    name: 'TR SAO BALBINO',
  },
  {
    name: 'RUA F UI 618',
  },
  {
    name: 'RUA E UI 618',
  },
  {
    name: 'BC CON CASTRO (VL. PERY)',
  },
  {
    name: 'RUA 6  LOTE SINCOL UI 908',
  },
  {
    name: 'RUA 5  LOTE SINCOL UI 908',
  },
  {
    name: 'RUA 2 UI 618',
  },
  {
    name: 'RUA 1 UI 618',
  },
  {
    name: 'TR CAMPOS',
  },
  {
    name: 'TR PIRAI',
  },
  {
    name: 'VL SAO JERONIMO',
  },
  {
    name: 'TR MARIA LENICE',
  },
  {
    name: 'RUA A UI 301',
  },
  {
    name: 'RUA B UI 301',
  },
  {
    name: 'BC DA PITOMBA',
  },
  {
    name: 'VL URUBATAU',
  },
  {
    name: 'VL MARIA JOSE',
  },
  {
    name: 'VL SAO JOSE',
  },
  {
    name: 'TR P ONTILANDIA',
  },
  {
    name: 'RUA SALGUEIRO',
  },
  {
    name: 'TR ZULANI',
  },
  {
    name: 'RUA FIRMINDO ANANIAS CARDOSO',
  },
  {
    name: 'RUA 10 DE AGOSTO UI 908',
  },
  {
    name: 'RUA INTERNA',
  },
  {
    name: 'RUA 16 UI 301',
  },
  {
    name: 'RUA DR MONTEIRO',
  },
  {
    name: 'TR FRAMBOESA',
  },
  {
    name: 'TR DAS CRIANCAS',
  },
  {
    name: 'RUA PRO CONSUELO ALMEIDA',
  },
  {
    name: 'BC BAR DE COTEGIPE',
  },
  {
    name: 'RUA CARDEAL',
  },
  {
    name: 'RUA 30 DE JUNHO UI 301',
  },
  {
    name: 'TR VILA SINHA',
  },
  {
    name: 'RUA ANTONIO JOSE CESTEIRA',
  },
  {
    name: 'TR NOVA VENEZA',
  },
  {
    name: 'TR NOVA TRINDADE',
  },
  {
    name: 'TR CANANDI',
  },
  {
    name: 'TR CORITIBA',
  },
  {
    name: 'RUA STA TEREZINHA UI 806',
  },
  {
    name: 'RUA JOSE AUGUSTO CARVALHO',
  },
  {
    name: 'TR AUGUSTINHO SOARES',
  },
  {
    name: 'TR DES F  ATAIDE',
  },
  {
    name: 'RUA CRISTINA DE FREITAS',
  },
  {
    name: 'RUA DANIEL DE CASTRO',
  },
  {
    name: 'TR GENIBAU',
  },
  {
    name: 'RUA ADELAIDE BARBOSA VIANA',
  },
  {
    name: 'RUA DOS PINHAIS',
  },
  {
    name: 'RUA 4 DE MARCO UI 806',
  },
  {
    name: 'RUA A C DA SILVA',
  },
  {
    name: 'RUA CHUI',
  },
  {
    name: 'RUA RESISTENCIA',
  },
  {
    name: 'RUA MOSCOU',
  },
  {
    name: 'RUA DR PAULO SANFORD',
  },
  {
    name: 'RUA CAETANO SILVA (A. NUNES)',
  },
  {
    name: 'BC SAO LUDOVICO',
  },
  {
    name: 'RUA TEN MACEDO',
  },
  {
    name: 'TR ORIENTE',
  },
  {
    name: 'TR 25 DE MARCO UI 806',
  },
  {
    name: 'RUA ORIENTE',
  },
  {
    name: 'RUA 23 UI 301',
  },
  {
    name: 'RUA INACIO ROMAO',
  },
  {
    name: 'RUA PIGALI',
  },
  {
    name: 'RUA MONTERREY',
  },
  {
    name: 'RUA DNA CELESTE',
  },
  {
    name: 'TR STO AMANCIO',
  },
  {
    name: 'TR MICHELE',
  },
  {
    name: 'TR G UI 301',
  },
  {
    name: 'TR NOVO ORIENTE',
  },
  {
    name: 'TR LAVRAS DO SUL',
  },
  {
    name: 'RUA GLORIA DE DOURADOS',
  },
  {
    name: 'TR MICHELANGELO',
  },
  {
    name: 'TR TOMAS BRANDAO',
  },
  {
    name: 'RUA PAULO MOTA',
  },
  {
    name: 'RUA VALMIR PONTES',
  },
  {
    name: 'TR CORVINA',
  },
  {
    name: 'TR ANTARCTICA',
  },
  {
    name: 'TR VILA SINHA',
  },
  {
    name: 'TR VILA CADETE',
  },
  {
    name: 'RUA 13 UI 301',
  },
  {
    name: 'RUA 12 UI 301',
  },
  {
    name: 'RUA ALPINOPOLIS',
  },
  {
    name: 'RUA PRUDENTE DE MORAES',
  },
  {
    name: 'RUA CLAUDINA MARIA',
  },
  {
    name: 'RUA ERIVALTO MARTINS',
  },
  {
    name: 'RUA ANTONIO RAIMUNDO',
  },
  {
    name: 'RUA ANTONIO ALMEIDA',
  },
  {
    name: 'RUA TRES ESTRELAS',
  },
  {
    name: 'RUA LANDEL DE MOURA',
  },
  {
    name: 'RUA HAROLDO BARBOSA',
  },
  {
    name: 'RUA PDE VALDIR DANTAS',
  },
  {
    name: 'RUA PEREIRA COUTINHO',
  },
  {
    name: 'AV PALMEIRAS DOS INDIOS',
  },
  {
    name: 'RUA MONTE REAL',
  },
  {
    name: 'RUA MATIZ',
  },
  {
    name: 'RUA JOAO BORGES',
  },
  {
    name: 'RUA LANDIL DE MOURA',
  },
  {
    name: 'RUA ANTONIO CONRADO',
  },
  {
    name: 'RUA ADONIRAN BARBOSA',
  },
  {
    name: 'RUA SIGISMUNDO FEITOSA',
  },
  {
    name: 'RUA JARDILINO',
  },
  {
    name: 'RUA RAIMUNDO NONATO BRUNO',
  },
  {
    name: 'RUA 4 UI 302',
  },
  {
    name: 'RUA LAURO BENTO',
  },
  {
    name: 'RUA 3 UI 302',
  },
  {
    name: 'RUA PRO MARIA HILARIA',
  },
  {
    name: 'TR COTELCE',
  },
  {
    name: 'RUA 1 UI 302',
  },
  {
    name: 'RUA HUMBERTO ALBUQUERQUE',
  },
  {
    name: 'RUA DR BERNARDO DE CASTRO FEITOSA',
  },
  {
    name: 'RUA ISAURA FROTA',
  },
  {
    name: 'RUA MIGUEL ALVES DE SOUZA',
  },
  {
    name: 'RUA MANUEL DE CASTRO FEITOSA',
  },
  {
    name: 'RUA W BEZERRA',
  },
  {
    name: 'RUA PRO VALDEVINO',
  },
  {
    name: 'RUA DO CONTORNO UI 302',
  },
  {
    name: 'RUA 3 UI 302',
  },
  {
    name: 'AV PRAIA DE SABIAGUABA',
  },
  {
    name: 'RUA MARIO VIEIRA',
  },
  {
    name: 'RUA TERRA DAS FLORES',
  },
  {
    name: 'TR DAS FLORES',
  },
  {
    name: 'RUA MARIETA BARREIRA',
  },
  {
    name: 'RUA DO AMIANTO',
  },
  {
    name: 'ET DO GEREBERABA',
  },
  {
    name: 'RUA TERRAL',
  },
  {
    name: 'RUA ITAMBE',
  },
  {
    name: 'RUA ANNA LUCIA DIAS',
  },
  {
    name: 'TR TORINO',
  },
  {
    name: 'RUA TRES MARIAS',
  },
  {
    name: 'RUA RECANTO DO MAR',
  },
  {
    name: 'RUA ALFA GRANJA',
  },
  {
    name: 'TR CONTORNO UI 405',
  },
  {
    name: 'TR AMANHA',
  },
  {
    name: 'RUA DINA SFAT',
  },
  {
    name: 'TR ANTONIO MAGALHAES',
  },
  {
    name: 'RUA SAO JOSE DO MUTIRAO',
  },
  {
    name: 'RUA SAO CARLOS UI 405',
  },
  {
    name: 'RUA ALFREDO CORREIA',
  },
  {
    name: 'RUA PAULO DE CASTRO',
  },
  {
    name: 'TR PARAISO',
  },
  {
    name: 'TR SAO JOSE UI 405',
  },
  {
    name: 'TR ANTONIO POMPIL',
  },
  {
    name: 'RUA MIGUEL PIO',
  },
  {
    name: 'RUA VICENTE PIO',
  },
  {
    name: 'RUA GERARDO MARINHO',
  },
  {
    name: 'RUA DA FAZENDINHA',
  },
  {
    name: 'RUA SAMUEL WAYNE',
  },
  {
    name: 'RUA HERCULANO SILVA',
  },
  {
    name: 'RUA PAULO PARENTE',
  },
  {
    name: 'RUA GRANJA REGINA',
  },
  {
    name: 'RUA ALEXANDRINA',
  },
  {
    name: 'RUA PARRA',
  },
  {
    name: 'RUA RAQUEL FLORENCIO',
  },
  {
    name: 'RUA CAP XIMENES',
  },
  {
    name: 'RUA DAS PALMEIRAS',
  },
  {
    name: 'TR JOAQUIM AURELINO',
  },
  {
    name: 'RUA RAMIRO FERREIRA',
  },
  {
    name: 'RUA DNA IZABEL',
  },
  {
    name: 'TR SIMIAO',
  },
  {
    name: 'RUA JOAO AVELINO',
  },
  {
    name: 'RUA EDUARDO GUIMARAES',
  },
  {
    name: 'TR MOTA MACHADO',
  },
  {
    name: 'TR MARROCOS',
  },
  {
    name: 'RUA ROSA BATISTA',
  },
  {
    name: 'RUA MARIA PINHEIRO',
  },
  {
    name: 'RUA PEDRO KUBI',
  },
  {
    name: 'RUA AMUARAMA',
  },
  {
    name: 'TR AGOSTINHO MOTA',
  },
  {
    name: 'VL AURINA',
  },
  {
    name: 'TR LUCIANO DE QUEIROS',
  },
  {
    name: 'TR EDISON',
  },
  {
    name: 'RUA 01 UI 617',
  },
  {
    name: 'RUA 02 UI 617',
  },
  {
    name: 'RUA 04 UI 617',
  },
  {
    name: 'TR JOSE MERGULHAO',
  },
  {
    name: 'RUA 03 UI 617',
  },
  {
    name: 'TR EXPEDITO SILVA',
  },
  {
    name: 'TR OSWALDO ARANHA',
  },
  {
    name: 'RUA TURURU',
  },
  {
    name: 'RUA IRANI',
  },
  {
    name: 'RUA DOM AUBERGIO',
  },
  {
    name: 'TR EVANGELISTA LEITAO',
  },
  {
    name: 'RUA PITAGUARI',
  },
  {
    name: 'TR MINERVA',
  },
  {
    name: 'RUA IRACY DE SOUZA',
  },
  {
    name: 'AL RITA FARIAS',
  },
  {
    name: 'TR HELIO CAMPOS',
  },
  {
    name: 'RUA ISIDORO PARENTE',
  },
  {
    name: 'AV H UI 508',
  },
  {
    name: 'RUA 114 UI 508',
  },
  {
    name: 'TR ARAPONGA',
  },
  {
    name: 'RUA DOM PEDRO II UI 618',
  },
  {
    name: 'RUA A UI 412',
  },
  {
    name: 'RUA Q UI 412',
  },
  {
    name: 'RUA 21 UI 412',
  },
  {
    name: 'TR PORTO FRANCO',
  },
  {
    name: 'RUA 30 UI 412',
  },
  {
    name: 'RUA IDALINA MURINELY',
  },
  {
    name: 'TR THOMPSON BULCAO',
  },
  {
    name: 'RUA PAIS DE GALES',
  },
  {
    name: 'TR SUICA',
  },
  {
    name: 'RUA 1 UI 510',
  },
  {
    name: 'RUA 5 UI 510',
  },
  {
    name: 'RUA 6 UI 510',
  },
  {
    name: 'RUA 3 UI 510',
  },
  {
    name: 'RUA 4 UI 510',
  },
  {
    name: 'TR TESALIA',
  },
  {
    name: 'TR AURIFAMA',
  },
  {
    name: 'TR ABRIGO',
  },
  {
    name: 'TR ALVIN',
  },
  {
    name: 'TR NOTRIDAME',
  },
  {
    name: 'TR SENA',
  },
  {
    name: 'TR MORIENCE',
  },
  {
    name: 'RUA TILIA',
  },
  {
    name: 'TR ANA',
  },
  {
    name: 'TR TIMBUCA',
  },
  {
    name: 'RUA SAO GUIMARAES',
  },
  {
    name: 'VL VALDIVIA',
  },
  {
    name: 'RUA STO ANTONIO',
  },
  {
    name: 'RUA STA ROSA (Q. CUNHA)',
  },
  {
    name: 'TR DAS TRAVES',
  },
  {
    name: 'RUA STA RITA',
  },
  {
    name: 'TR SAO JOAO DO OESTE',
  },
  {
    name: 'TR 15 DE JANEIRO',
  },
  {
    name: 'TR OLARIA',
  },
  {
    name: 'TR JUVENTOS',
  },
  {
    name: 'RUA M NOGUEIRA DE FRANCA',
  },
  {
    name: 'TR FERNAO MAGALHAES',
  },
  {
    name: 'ACESSO F UI 401',
  },
  {
    name: 'ACESSO G UI 401',
  },
  {
    name: 'ACESSO H UI 401',
  },
  {
    name: 'AV 1000 UI 709',
  },
  {
    name: 'RUA BENEDITO ALVES',
  },
  {
    name: 'RUA TEREZA BERNARDO',
  },
  {
    name: 'RUA MARCELO REIS',
  },
  {
    name: 'RUA SALGADINHO',
  },
  {
    name: 'TR EMERSON FITIPALDI',
  },
  {
    name: 'TR NELSON PIQUET',
  },
  {
    name: 'RUA FREDERICO PAIVA',
  },
  {
    name: 'TR AYRTON SENNA',
  },
  {
    name: 'RUA 106 CJ TIMBO',
  },
  {
    name: 'RUA JOSE S AGUIAR',
  },
  {
    name: 'RUA ANTONIO TEIXEIRA LEITE',
  },
  {
    name: 'AV ALM MAXIMIANO DA FONSECA',
  },
  {
    name: 'RUA 111 CJ ACARACUZINHO',
  },
  {
    name: 'RUA G CJ JARDIM DAS OLIVEIRAS',
  },
  {
    name: 'RUA B CJ JARDIM DAS OLIVEIRAS',
  },
  {
    name: 'AV NOVE',
  },
  {
    name: 'AV JEREISSATI',
  },
  {
    name: 'AV N CJ CEARA',
  },
  {
    name: 'RUA CAMPO DO DRAGAO',
  },
  {
    name: 'RUA ULLISSES GUIMARAES',
  },
  {
    name: 'AV CENTRAL',
  },
  {
    name: 'RUA CENTO E CINCO',
  },
  {
    name: 'AV SOL NASCENTE',
  },
  {
    name: 'RUA DANIEL BRUNO',
  },
  {
    name: 'RUA LAGO VERDE',
  },
  {
    name: 'RUA OLAVO MAIA',
  },
  {
    name: 'RUA PEREIRA BARBOSA',
  },
  {
    name: 'RUA FIUZA MONTES',
  },
  {
    name: 'RUA PRO HOLANDA LIMA',
  },
  {
    name: 'RUA 4 CJ DOS INGLESES',
  },
  {
    name: 'AV B',
  },
  {
    name: 'AV B CJ TIMBO',
  },
  {
    name: 'RUA 110 CJ TIMBO',
  },
  {
    name: 'ESTAC ESTACIONAMENTO DO MERCADO CENTRAL',
  },
  {
    name: 'RUA CLEDINA PEREIRA',
  },
  {
    name: 'RUA DOS PRACINHAS',
  },
  {
    name: 'RUA DR FRANCISCO MOTA',
  },
  {
    name: 'RUA GAL POTIGUARA',
  },
  {
    name: 'ET ESTRADA DA CAPONGA',
  },
  {
    name: 'RUA MARIA JOSE DE SOUSA',
  },
  {
    name: 'RUA MARIA JULIA ROCHA',
  },
  {
    name: 'AV PRO ANDRADE ROCHA',
  },
  {
    name: 'AV 06 CJ JEREISSATI',
  },
  {
    name: 'RUA CAPISTRANO DE ABREU',
  },
  {
    name: 'RD ESTRADA DA LAGOA FUNDA',
  },
  {
    name: 'RD ESTRADA DA PAJUCARA',
  },
  {
    name: 'AV JORGE CAVALCANTE',
  },
  {
    name: 'PR PRACA DA MESSEJANA',
  },
  {
    name: 'RUA CEL JOSE FILOMENO GOMES',
  },
  {
    name: 'RUA MARIA DE ALENCAR',
  },
  {
    name: 'ESTACIONAMENTO DA UNIFOR',
  },
  {
    name: 'RUA 2',
  },
  {
    name: 'RUA DES ALENCAR',
  },
  {
    name: 'RUA SANTIAGO VASQUES FILHO',
  },
  {
    name: 'RUA PAULO AFONSO',
  },
  {
    name: 'RUA RAIMUNDO BASILIO',
  },
  {
    name: 'RUA DOIS',
  },
  {
    name: 'TERM TERMINAL DA LAGOA',
  },
  {
    name: 'TERM TERMINAL DA PARANGABA',
  },
  {
    name: 'RUA CANADA',
  },
  {
    name: 'TERM TERMINAL DO ANTONIO BEZERRA',
  },
  {
    name: 'RD DR MENDEL STEINBRUCH',
  },
  {
    name: 'RUA ANTONIO DE ALENCAR',
  },
  {
    name: 'RUA 10 CJ DOS INGLESES',
  },
  {
    name: 'VL LOPES',
  },
  {
    name: 'RUA JURIBEBA',
  },
  {
    name: 'RUA DR JOAO MOTA',
  },
  {
    name: 'RUA JOR DANIEL CARNEIRO',
  },
  {
    name: 'RUA 16 DE JULHO',
  },
  {
    name: 'AV CICERO SA',
  },
  {
    name: 'RUA PRO OSÓRIO UCHOA SOARES',
  },
  {
    name: 'RUA ROBERTO BRAQUEAS',
  },
  {
    name: 'RUA OUTUBRO',
  },
  {
    name: 'RUA MOCA BONITA',
  },
  {
    name: 'RUA ENG JAIME ROLEMBERG',
  },
  {
    name: 'RUA LUIZ AZEVEDO',
  },
  {
    name: 'PRACINHA DO HENRIQUE JORGE',
  },
  {
    name: 'RUA SAO MIGUEL D60',
  },
  {
    name: 'RUA GERALDO MARGELA S. FROTA',
  },
  {
    name: 'RUA MARIA ALICE FERRAZ',
  },
  {
    name: 'RUA FIRMINO ROCHA AGUIAR',
  },
  {
    name: 'RUA GILBERTO ALBUQUERQUE',
  },
  {
    name: 'RUA PITIGUARA',
  },
  {
    name: 'RUA NE DEZOITO',
  },
  {
    name: 'RUA FRANCISCO LOPES',
  },
  {
    name: 'RUA ONZE 69 CJMIRASSOL',
  },
  {
    name: 'RUA JOSE DE ALENCAR RAMOS',
  },
  {
    name: 'RUA FERNANDO FARIAS DE MELO (MANUEL SÁTIRO)',
  },
  {
    name: 'RUA 2 CJ OMEGA',
  },
  {
    name: 'RUA BELARMINO MAIA',
  },
  {
    name: 'RUA PLACIDO COELHO',
  },
  {
    name: 'RUA TOBIAS CORREIA',
  },
  {
    name: 'RUA GOMES DA ROCHA',
  },
  {
    name: 'RUA CANGURU',
  },
  {
    name: 'RUA PEDRO FURTADO',
  },
  {
    name: 'AV PRO JOSE ARTHUR CARVALHO',
  },
  {
    name: 'AV INTEGRACAO PQ. ARATURI',
  },
  {
    name: 'RUA L CJ VILA VELHA',
  },
  {
    name: 'RUA EDGAR PINHO FILHO',
  },
  {
    name: 'RUA B CJ VILA VELHA',
  },
  {
    name: 'TR DEMOISELE (INVÁLIDA)',
  },
  {
    name: 'RUA ENG NEREU BARREIRA (JD. OLIVEIRAS)',
  },
  {
    name: 'RUA MAG RAUL DE SOUSA GIRAO',
  },
  {
    name: 'RUA MIGUEL DIBE',
  },
  {
    name: 'RUA DESCONHECIDA',
  },
  {
    name: 'RUA CACHOEIRA DOURADA',
  },
  {
    name: 'RUA DR PONTES NETO',
  },
  {
    name: 'RUA RICARDO  CASTRO MACEDO',
  },
  {
    name: 'RUA MANGABEIRA',
  },
  {
    name: 'RUA TAMPICO',
  },
  {
    name: 'RUA SACY',
  },
  {
    name: 'RUA SEN MENEZES PIMENTEL',
  },
  {
    name: 'RUA SAO DOMENCIO',
  },
  {
    name: 'RUA COPACABANA',
  },
  {
    name: 'RUA BARROSO',
  },
  {
    name: 'TR NOVA ASSUNCAO',
  },
  {
    name: 'RUA PERPETUO SOCORRO',
  },
  {
    name: 'RUA EDMILSON BARROS DE OLIVEIRA',
  },
  {
    name: 'RUA HIL MORAES',
  },
  {
    name: 'RUA MAG POMPEU',
  },
  {
    name: 'RUA 14 CJ SITIO CORREGO',
  },
  {
    name: 'RUA DIVA TAVARES',
  },
  {
    name: 'RUA ANTONIO COSTA MENDES',
  },
  {
    name: 'RUA TABATINGA',
  },
  {
    name: 'RUA 8 CJ T JEREISSATI',
  },
  {
    name: 'RUA DO MORRO',
  },
  {
    name: 'RUA J CJ JARDIM FLUMINENSE',
  },
  {
    name: 'RUA DIAMANTE(CARLITO PAMPLONA)',
  },
  {
    name: 'RUA TOMAS ILDEFONSO',
  },
  {
    name: 'RUA 17 RIACHO DOCE',
  },
  {
    name: 'RUA CONGRESSO',
  },
  {
    name: 'RUA MIMOSA COELHO',
  },
  {
    name: 'RUA CARPINA',
  },
  {
    name: 'RUA JOSE TRINDADE',
  },
  {
    name: 'RUA ANA BATISTA',
  },
  {
    name: 'RUA COLINA',
  },
  {
    name: 'AV SIQUEIRA CAMPOS',
  },
  {
    name: 'RUA GALIENTE',
  },
  {
    name: 'RUA CARNAUBAL',
  },
  {
    name: 'RUA JONAS SAMPAIO',
  },
  {
    name: 'RUA ANTONIO MESQUITA',
  },
  {
    name: 'RUA PRINCIPADO',
  },
  {
    name: 'TR BARAUNA',
  },
  {
    name: 'RUA 04 CJ TUPINAMBA FROTA',
  },
  {
    name: 'RUA MARIO MENDES',
  },
  {
    name: 'RUA ZE DO CRATO',
  },
  {
    name: 'RUA CRUZEIRO VELHO',
  },
  {
    name: 'AV NORTE',
  },
  {
    name: 'RUA EUGENIO PORTO',
  },
  {
    name: 'AV NOVA ALVORADA',
  },
  {
    name: 'RUA DJALMA BENEVIDES',
  },
  {
    name: 'RUA ITAQUERA',
  },
  {
    name: 'RUA VINTE E TRES DE OUTUBRO',
  },
  {
    name: 'RUA GOV 05 CJ TASSO JEREISSATI',
  },
  {
    name: 'TR CARLOS CESAR',
  },
  {
    name: 'RUA JOAQUIM PEREIRA',
  },
  {
    name: 'RUA JULIO BRIGIDO',
  },
  {
    name: 'RUA ALTO DA PAZ',
  },
  {
    name: 'RUA DOM EXPEDITO LOPES',
  },
  {
    name: 'AV CENTRAL',
  },
  {
    name: 'RD CE-065',
  },
  {
    name: 'AV ALM HENRIQUE SABOIA',
  },
  {
    name: 'RD CE-251',
  },
  {
    name: 'RD CE-241',
  },
  {
    name: 'RUA 6',
  },
  {
    name: 'RUA MIGUEL ARAGAO',
  },
  {
    name: 'RD CE-060',
  },
  {
    name: 'RD CE-025',
  },
  {
    name: 'RD CE-040',
  },
  {
    name: 'RUA 1 UI 512',
  },
  {
    name: 'VL FREIRE',
  },
  {
    name: 'TR STA TEREZINHA',
  },
  {
    name: 'RUA TOMAS ILDEFONSO',
  },
  {
    name: 'RUA SEN CARLOS JEREISSATI (PAPICU)',
  },
  {
    name: 'TR CARLOS ARAUJO',
  },
  {
    name: 'RUA SAO SEBASTIAO',
  },
  {
    name: 'RUA BOM JESUS (JD DAS OLIVEIRAS)',
  },
  {
    name: 'RUA PDE CICERO (BARRA DO CEARÁ)',
  },
  {
    name: 'RUA PDE CICERO',
  },
  {
    name: 'TR PDE CICERO',
  },
  {
    name: 'RUA DA PAZ (PIRAMBU)',
  },
  {
    name: 'TR IRACEMA',
  },
  {
    name: 'TR IRACEMA',
  },
  {
    name: 'RUA JOAQUIM AVELINO',
  },
  {
    name: 'RUA CONSOLADA',
  },
  {
    name: 'RUA JOSE CAVALCANTE SOBR',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'RUA SAO JORGE',
  },
  {
    name: 'TR MAGALHAES',
  },
  {
    name: 'TR MAGALHAES',
  },
  {
    name: 'RUA NOSSA SRA DAS GRACAS (PAUPINA)',
  },
  {
    name: 'RUA VITORIA',
  },
  {
    name: 'RUA SOL',
  },
  {
    name: 'RUA ALVORADA',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA CARLOS JEREISSATI (PICI)',
  },
  {
    name: 'TR SANTANA',
  },
  {
    name: 'RUA FRANCISCO RAMOS',
  },
  {
    name: 'RUA PARAISO (V. PINZON)',
  },
  {
    name: 'RUA PARAISO',
  },
  {
    name: 'RUA PARAISO',
  },
  {
    name: 'RUA H UI 901',
  },
  {
    name: 'RUA URUBECA',
  },
  {
    name: 'RUA STA ISABEL',
  },
  {
    name: 'RUA BAURU',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA DA PAZ',
  },
  {
    name: 'RUA JOSE VELOSO JUCA',
  },
  {
    name: 'RUA LETICIA',
  },
  {
    name: 'AV F CJ DOS BANCARIOS',
  },
  {
    name: 'RUA JOAQUIM MARQUES',
  },
  {
    name: 'TR PARACURU',
  },
  {
    name: 'RUA DO HORIZONTE',
  },
  {
    name: 'RUA RAMAL GUARANI',
  },
  {
    name: 'RUA JONAS SAMPAIO',
  },
  {
    name: 'RUA CAP GUTEMBERG',
  },
  {
    name: 'RUA B',
  },
  {
    name: 'RUA MANGUESAIS',
  },
  {
    name: 'TR SELETA',
  },
  {
    name: 'RUA ALMERINDA MONTENEGRO',
  },
  {
    name: 'RUA PRISCO BEZERRA',
  },
  {
    name: 'TR IPE (BAIRRO PICI)',
  },
  {
    name: 'RUA JOAQUIM DE FIGUEIREDO FILHO',
  },
  {
    name: 'RUA DR SULIANO',
  },
  {
    name: 'RUA DO MATADOURO',
  },
  {
    name: 'TR MANUELITO COSTA',
  },
  {
    name: 'RUA BERNADETE MARIA LEAL',
  },
  {
    name: 'RUA JULIO JORGE VIEIRA',
  },
  {
    name: 'RUA DES WALDEMAR ALVES PEREIRA',
  },
  {
    name: 'RUA LIV LUIZ MAIA',
  },
  {
    name: 'RUA LIBANES JOSE LOPES',
  },
  {
    name: 'RUA GUIMARAES PASSOS',
  },
  {
    name: 'RUA SANTIAGO (QUINTINO CUNHA)',
  },
  {
    name: 'RUA DA SAUDADE (MONTESE)',
  },
  {
    name: 'RUA ANTENOR ROCHA ALEXANDRE',
  },
  {
    name: 'RUA CARLOS JEREISSATI (JD DAS OLIVEIRAS)',
  },
  {
    name: 'RUA RAMIRES MARANHAO VALLE',
  },
  {
    name: 'RUA ANTONIO ALEXANDRINO DOS REIS',
  },
  {
    name: 'RUA FRANCISCO PEREIRA (JD DAS OLIVEIRAS)',
  },
  {
    name: 'RUA RECANTO TRANQUILO',
  },
  {
    name: 'RUA MARINHO E SILVA',
  },
  {
    name: 'RUA MANOEL AGUIAR PONTES',
  },
  {
    name: 'RUA INVALIDA',
  },
  {
    name: 'RUA ISAIAS BEVILAQUA',
  },
  {
    name: 'RUA ISABEL FERREIRA',
  },
  {
    name: 'RUA LEIRIA DE ANDRADE',
  },
  {
    name: 'RUA PRO PEDRO DE MORAIS BORGES',
  },
  {
    name: 'RUA CECILIA BEZERRA',
  },
  {
    name: 'RUA ANA MACEDO',
  },
  {
    name: 'RUA 11 CJ SITIO CORREGO',
  },
  {
    name: 'RUA ENG HEITOR DE O. ALBUQUERQUE',
  },
  {
    name: 'RUA 620 CJ CEARA',
  },
  {
    name: 'RUA CAETANO XIMENES ARAGAO',
  },
  {
    name: 'RUA ARMANDO DALL OLIO',
  },
  {
    name: 'RUA VICENTE DE CASTRO FILHO',
  },
  {
    name: 'RUA PAULO FAUSTINO',
  },
  {
    name: 'RUA P CJ VILA VELHA',
  },
  {
    name: 'RUA MIGUEL GUIMARAES',
  },
  {
    name: 'RUA MIN EDUARDO ELERY BARREIRA',
  },
  {
    name: 'AL DOS TRICOLORES',
  },
  {
    name: 'RUA 14 CJ JOSE WALTER',
  },
  {
    name: 'RUA HIS GUARINO ALVES',
  },
  {
    name: 'AV COSTA OESTE',
  },
  {
    name: 'RUA 8 PLANALTO ITAPERI',
  },
  {
    name: 'RUA VITORIA (QUINTINO CUNHA)',
  },
  {
    name: 'AV ENG JOSÉ GUIMARÃES',
  },
  {
    name: 'RUA PAULO H OLIVEIRA',
  },
  {
    name: 'RUA ZAIRE',
  },
  {
    name: 'RUA 21 CJ BEIRA RIO',
  },
  {
    name: 'TR GETULIO VARGAS',
  },
  {
    name: 'RUA DIAMANTE(PASSARE)',
  },
  {
    name: 'RUA QUADRA A CJ C. BRANCO',
  },
  {
    name: 'RUA RUBI (MONDUBIM)',
  },
  {
    name: 'RUA DIAMANTE (MONDUBIM)',
  },
  {
    name: 'RUA 3 CJ SITIO CORREGO',
  },
  {
    name: 'RUA PDE JOSE MARIA FROTA',
  },
  {
    name: 'AV DES FELICIANO DE ATAIDE (EDSON QUEIROZ)',
  },
  {
    name: 'RUA MENINO JESUS DE PRAGA (PASSARÉ)',
  },
  {
    name: 'RUA REGINA SA (LAGOA REDONDA)',
  },
  {
    name: 'RUA ANTONIO FELICIO',
  },
  {
    name: 'RUA JUCA (EDSON QUEIROZ)',
  },
  {
    name: 'RUA PEDRO WILSON (ITAPERI)',
  },
  {
    name: 'RUA PDE NELSON FARIAS',
  },
  {
    name: 'RUA FRANCISCO JOSINO DA COSTA',
  },
  {
    name: 'RUA VITORIA DA CONQUISTA',
  },
  {
    name: 'RUA NASCIMENTO (CANINDEZINHO)',
  },
  {
    name: 'RUA COLETORA A (MONDUBIM)',
  },
  {
    name: 'TR STA CATARINA',
  },
  {
    name: 'RUA JARDIM PAROARAS',
  },
  {
    name: 'RUA G VENEZA TROPICAL',
  },
  {
    name: 'RUA SAPORE',
  },
  {
    name: 'RUA RITA ARRUDA',
  },
  {
    name: 'RUA ENG DIOGO VITAL CRUZ',
  },
  {
    name: 'RUA AURINO COLARES',
  },
  {
    name: 'RUA GUILHERME TELL',
  },
  {
    name: 'RUA BENEDITO MACEDO',
  },
  {
    name: 'RUA TAINA PIRES',
  },
  {
    name: 'RUA F PASSARE',
  },
  {
    name: 'RUA CEL VIRGILIO TAVORA (BARROSO)',
  },
  {
    name: 'RUA RAIMUNDO CUNHA',
  },
  {
    name: 'RUA ADOLFO MARINHO (VILA VELHA)',
  },
  {
    name: 'RUA RUA SABINO LORETO (BARROSO)',
  },
  {
    name: 'RUA MARGARIDA ALVES (COAÇU)',
  },
  {
    name: 'RUA DOS COQUEIROS (EDSON QUEIROZ)',
  },
  {
    name: 'RUA MORONI B TORGAN',
  },
  {
    name: 'RUA PRO ANDRADE FURTADO (PICI)',
  },
  {
    name: 'RUA MIRES MARINHO',
  },
  {
    name: 'RUA DOM HELDER CAMARA (LAGOA REDONDA)',
  },
  {
    name: 'AV CENTRAL (JANGURUSSU)',
  },
  {
    name: 'RUA CACHOEIRINHA',
  },
  {
    name: 'RUA MARTINS CAMELO',
  },
  {
    name: 'RUA JACANA (SABIAGUABA)',
  },
  {
    name: 'TERM TERMINAL PAPICU',
  },
  {
    name: 'RUA K CJ JANA BARROSO',
  },
  {
    name: 'RUA UMUARAMA (GRANJA PORTUGAL)',
  },
  {
    name: 'RUA 3 LOT ALFA PARK (LAGOA REDONDA)',
  },
  {
    name: 'RUA 2 LOT ALFA PARK (LAGOA REDONDA)',
  },
  {
    name: 'TERM SIQUEIRA',
  },
  {
    name: 'RUA ZILDETE DA COSTA',
  },
  {
    name: 'RUA TIM MAIA',
  },
  {
    name: 'RUA JOSE MOACIR BEZERRA',
  },
  {
    name: 'RUA E CJ COHABECE II (EDSON QUEIROZ)',
  },
  {
    name: 'RUA VIA LACTEA',
  },
  {
    name: 'RUA NETUNO (VILA UNIÃO)',
  },
  {
    name: 'RUA CAMPO ALEGRE',
  },
  {
    name: 'RUA JOAQUIM CANDIDO DE LIMA',
  },
  {
    name: 'AL ITALIANA',
  },
  {
    name: 'RUA FRANCISCO MARTINIANO BARBOSA',
  },
  {
    name: 'TR DAS MUDANCAS',
  },
  {
    name: 'RUA FRANCISCO NEIVA (PAUPINA)',
  },
  {
    name: 'RUA DES FRANCISCO BARROS FONTENELE',
  },
  {
    name: 'RUA MARCO POLO (MONDUBIM)',
  },
  {
    name: 'RUA RUA 1 (MONDUBIM)',
  },
  {
    name: 'RUA DNA LIBANIA R. MELO NUNES',
  },
  {
    name: 'TR SAO GERARDO (MUCURIPE)',
  },
  {
    name: 'RUA ANTONIO FORTES',
  },
  {
    name: 'RUA PAU BRANCO',
  },
  {
    name: 'RUA ANTONIO MENDES (JD AMERICA)',
  },
  {
    name: 'RUA H (MONDUBIM II)',
  },
  {
    name: 'RUA A (CJ JANA BARROSO)',
  },
  {
    name: 'RUA ETA (VILA VELHA)',
  },
  {
    name: 'RUA ARQ REGINALDO RANGEL',
  },
  {
    name: 'RUA POE MARIO LINHARES (J.WALTER)',
  },
  {
    name: 'RUA SEBASTIAO DE ABREU (MONDUBIM)',
  },
  {
    name: 'TR SAO JOAO UI 505',
  },
  {
    name: 'RUA D CJ BARROSO II',
  },
  {
    name: 'RUA MATEUS TAVARES',
  },
  {
    name: 'RUA DR WANDA SIDOU',
  },
  {
    name: 'RUA GILBERTO ALVES',
  },
  {
    name: 'RUA VICENTE LUIS ROCHA (QUNTINO CUNHA)',
  },
  {
    name: 'RUA F CJ RES GUAJERU',
  },
  {
    name: 'RUA GERALDO BARROS OLIVEIRA',
  },
  {
    name: 'RUA N. S. DO CONSOLO (PALMEIRAS)',
  },
  {
    name: 'RUA AUGUSTO J BENEVIDES',
  },
  {
    name: 'RUA PAULO RUBENS',
  },
  {
    name: 'RUA L CJ JOAO PAULO II',
  },
  {
    name: 'RUA JOSE ALBERTO ARAUJO',
  },
  {
    name: 'RUA JOSE EUCLIDES F GOMES',
  },
  {
    name: 'TERM TERMINAL CJ CEARA',
  },
  {
    name: 'RUA DOS ENCONTROS',
  },
  {
    name: 'RUA WILSON PEIXOTO',
  },
  {
    name: 'RUA JOANA BATISTA',
  },
  {
    name: 'RUA A CJ PALMARES (G. LISBOA)',
  },
  {
    name: 'RUA MIN SERGIO MOTA',
  },
  {
    name: 'RUA ENG LUIS MONTENEGRO',
  },
  {
    name: 'RUA PRA FRANCISCA ALMEIDA DE SOUSA',
  },
  {
    name: 'RUA DR ADJEMIR PARAHYBA',
  },
  {
    name: 'RUA A LOT PLANALTO ALTO SUL',
  },
  {
    name: 'RUA B LOT PLANALTO ALTO SUL',
  },
  {
    name: 'RUA SHIRLEY GIRAO',
  },
  {
    name: 'RUA ELISA DE OLIVEIRA (CANINDEZINHO)',
  },
  {
    name: 'RUA ERBENIA ARAUJO (BARROSO)',
  },
  {
    name: 'RUA PLUTAO (VILA UNIAO)',
  },
  {
    name: 'RUA TURMALINA (MONDUBIM)',
  },
  {
    name: 'RUA SAO ROQUE (ALVARO WEYNE)',
  },
  {
    name: 'RUA EMILIANO DE ALMEIDA BRAGA',
  },
  {
    name: 'RUA A (CJ RES UBIRATAN AGUIAR)',
  },
  {
    name: 'RUA B (CJ RESIDENCIAL UBIRATAN AGUIAR)',
  },
  {
    name: 'RUA C (CJ RESIDENCIAL UBIRATAN AGUIAR)',
  },
  {
    name: 'RUA MARTE (VILA UNIAO)',
  },
  {
    name: 'RUA ULISSES MAGALHAES',
  },
  {
    name: 'RUA RUBI (CJ HAB NOVO BARROSO)',
  },
  {
    name: 'RUA ESMERALDA (CJ HAB NOVO BARROSO)',
  },
  {
    name: 'RUA DIAMANTE (CJ HAB NOVO BARROSO)',
  },
  {
    name: 'RUA DO CANAL (CJ ESPERANCA)',
  },
  {
    name: 'RUA D LOT PLANALTO ALTO SUL',
  },
  {
    name: 'RUA M LOT EXPEDICIONARIOS III',
  },
  {
    name: 'RUA N LOT EXPEDICIONARIOS III',
  },
  {
    name: 'RUA P LOT EXPEDICIONARIOS III',
  },
  {
    name: 'RUA Q LOT EXPEDICIONARIOS III',
  },
  {
    name: 'RUA IPE AMARELO',
  },
  {
    name: 'RUA CASTANHEIRA',
  },
  {
    name: 'RUA TAGUATINGA',
  },
  {
    name: 'RUA J CJ JANA BARROSO',
  },
  {
    name: 'RUA NOVA CONQUISTA (PASSARE)',
  },
  {
    name: 'RUA JOAO BOSCO (AEROPORTO)',
  },
  {
    name: 'RUA ANIBAL F BONAVIDES',
  },
  {
    name: 'RUA JOAO FERREIRA (L.REDONDA)',
  },
  {
    name: 'RUA SAO FRANCISCO DO PICI',
  },
  {
    name: 'RUA LUIS SA (PARANGABA)',
  },
  {
    name: 'RUA PRC ISABEL (V. PINZON)',
  },
  {
    name: 'RUA MARQ DE ABRANTES',
  },
  {
    name: 'RUA RUA ANTONIO HOLANDA DE OLIVEIRA',
  },
  {
    name: 'RUA EUCLIDES PAULINO BARROSO',
  },
  {
    name: 'RUA CARNEIRO DA CUNHA (JACARECANGA)',
  },
  {
    name: 'RUA 13 CJ RIACHO DOCE (PASSARE)',
  },
  {
    name: 'RUA BELO RIO (D. LUSTOSA)',
  },
  {
    name: 'RUA STENIO GOMES (JD OLIVEIRAS)',
  },
  {
    name: 'RUA MARIA ZENOBIA CARNEIRO',
  },
  {
    name: 'RUA STA CECILIA (VILA VELHA)',
  },
  {
    name: 'RUA DA PAZ (VARJOTA)',
  },
  {
    name: 'RUA BAR GRAJAU',
  },
  {
    name: 'RUA DR ABDENAGO',
  },
  {
    name: 'RUA SAO FRANCISCO XAVIER',
  },
  {
    name: 'RUA SERIDIAO MONTENEGRO',
  },
  {
    name: 'RUA SD-2 (CJ ROSALINA)',
  },
  {
    name: 'RUA MANUEL FREITAS',
  },
  {
    name: 'RUA VINTE E UM DE ABRIL',
  },
  {
    name: 'RUA MARIA FERREIRA DOS SANTOS',
  },
  {
    name: 'RUA GERARDO BARROS TEIXEIRA',
  },
  {
    name: 'VISC PCA PELOTAS',
  },
  {
    name: 'RUA I CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA II CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA IV CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA V CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA VI CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA VII CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA VIII CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA IX CJ OITO DE SETEMBRO',
  },
  {
    name: 'RUA 1 (CJ MIRASSOL)',
  },
  {
    name: 'RUA JOSE AMAURY MOREIRA',
  },
  {
    name: 'RUA COSME BENEVIDES DE FREITAS',
  },
  {
    name: 'RUA DURVALINA G. DE ALMEIDA',
  },
  {
    name: 'RUA LEDA PORTO FREIRE',
  },
  {
    name: 'RUA BRUNO PORTO',
  },
  {
    name: 'RUA MAURO FREIRE',
  },
  {
    name: 'RUA CONSUELO FREIRE',
  },
  {
    name: 'RUA JOSE NOGUEIRA FREIRE',
  },
  {
    name: 'RUA UCRANIA (PASSARÉ)',
  },
  {
    name: 'RUA DR PEDRO AUGUSTO',
  },
  {
    name: 'RUA BEATRIZ GURGEL',
  },
  {
    name: 'RUA PRO MARCUS VINICIUS (V. VELHA)',
  },
  {
    name: 'RUA BENTO (V.VELHA)',
  },
  {
    name: 'AL MENINO JESUS (GUAJIRU)',
  },
  {
    name: 'RUA ARAGUAIA (PL. ARITON SENNA)',
  },
  {
    name: 'RUA FERNANDO BARROS ALENCAR',
  },
  {
    name: 'RUA 10 (CJ JOAO PAULO II)',
  },
  {
    name: 'RUA 19 (CJ JOAO PAULO II)',
  },
  {
    name: 'RUA L (CJ JOAO PAULO II)',
  },
  {
    name: 'RUA LAGO DAS ORQUIDEAS',
  },
  {
    name: 'RUA RAD JOAO RAMOS (DUNAS)',
  },
  {
    name: 'RUA TRES IRMAOS',
  },
  {
    name: 'RUA PRO JOSE MILTON',
  },
  {
    name: 'RUA TIAGO G DA SILVA',
  },
  {
    name: 'RUA PAULO XENOFONTE',
  },
  {
    name: 'AV JOSE JATAHY',
  },
  {
    name: 'RUA SD-3 (CJ ROSALINA)',
  },
  {
    name: 'RUA C (LOT PRQ ARACAPE)',
  },
  {
    name: 'RUA DOS AMIGOS (CAMBEBA)',
  },
  {
    name: 'RUA EST ANA KELLY (CAJAZEIRAS)',
  },
  {
    name: 'RUA ARTUR BORGES',
  },
  {
    name: 'RUA LIRIOS DO CAMPO',
  },
  {
    name: 'RUA GERARDO MENDES (PL. AYRTON SENNA)',
  },
  {
    name: 'RUA SAO CRISTOVAO (PL A. SENNA)',
  },
  {
    name: 'RUA JORGE F DA SILVA',
  },
  {
    name: 'RUA SD-1 (CJ ROSALINA)',
  },
  {
    name: 'RUA 12 (CJ JOAO PAULO II)',
  },
  {
    name: 'RUA N S DA  CONCEICAO (MONDUBIM)',
  },
  {
    name: 'RUA CENTRAL (CAJAZEIRAS)',
  },
  {
    name: 'TR PEDRO LOPES (D64)',
  },
  {
    name: 'RUA JOSE TEIXEIRA COSTA',
  },
  {
    name: 'SAO TOMAS',
  },
  {
    name: 'RUA MARIA CANDIDA',
  },
  {
    name: 'RUA UNIDOS VENCEREMOS',
  },
  {
    name: 'RUA JOSE ARAO',
  },
  {
    name: 'RUA VANESSA BRITO',
  },
  {
    name: 'RUA LUANA',
  },
  {
    name: 'RD CE 522',
  },
  {
    name: 'RUA H CJ MONTENEGRO I',
  },
  {
    name: 'RUA G CJ MONTENEGRO I',
  },
];
